import React, { useCallback, useEffect, useRef, useState } from "react";
import {Container, Modal, Row, Col, Button, Form, Tooltip} from "react-bootstrap";
import { useSelector } from "react-redux";
import APICom from "../utils/helpers/APICom.js";
import {Icon} from '@iconify/react';
import * as XLSX from 'xlsx';
import GridControl from "../components/Controls/gridControl.js";
import CCProfile from "../components/Controls/CCProfile.js";
import PhoneInput from "react-phone-number-input/input";
import MapControlSkeleton from "../components/Controls/mapControlSkeleton.js";
import PersistStorage from "../utils/helpers/PersistStorage.js";
import ARBResponseListener from "../components/Controls/ARBResponseListener.js";
import ExportIcon from "../assets/Images/CommonImages/save.png";
import ClearFilterIcon from "../assets/Images/CommonImages/clearFilter.png";
import ITCLogo from '../assets/Images/CommonImages/ITClogo.png';
import MultiSelectDropdown from '../components/Controls/multiselectdropdown.js';
import MultiSchedule from "../components/Dispatch/MultiSchedule.js";
import CallerIDNotifierListener from "../components/Controls/CallerIDNotifier";
import 'react-phone-number-input/style.css';

const CallTaker = (props) => {

  const [showAlert, setAlert] = useState(false);
  const [conditionMet, setConditionMet] = useState(false);
  const [showSideBar, setShowSideBar] = useState(false);
  const [showChatBot, setShowChatBot] = useState(false);
  const [specificLinkRequirement, setSpecificLinkRequirement] = useState([]);
  const [tempArr, setTempArr] = useState(["firstDialog"]);
  const [isHandleResetCalled, setIsHandleResetAll] = useState(false);
  const iAppID = 26;
  const [isSchTimeFieldDisabled, setIsSchTimeFieldDisabled] = useState(true);
  const [isVSSelectionDisabled, setIsVSSelectionDisabled] = useState(false);
  const [isTimeValidated, setIsTimeValidated] = useState(true);
  const isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
  const { loginData }  = useSelector((store) => store.login);
  const { GlobalASCSData, ASCSSettingData, DispatchVehicleData, AffiliateData, FundingSourceData, ZoneVerticesData, 
    VirtualStopsData, RCZZoneVerticesData, PaymentTypesData, ClassOfServiceData, AttributeData, DispatchDriverData,
    MvRouteSettingData
  } = useSelector((store) => store.combinedata);
  const [showDynamicModal, setShowDynamicModal] = useState(false);
  const [modalClass, setModalClass] = useState("");
  const [modalBodyHTML, setModalBodyHTML] = useState(null);
  const [handlePageProgressBar, sethandlePageProgressBar] = useState(null); 
  const [modalFooterHTML, setModalFooterHTML] = useState(
    <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
      OK
    </Button>
  );
  const [modalHeaderText, setModalHeaderText] = useState("");
  const [clientInfoDisplay, setClientInfoDisplay] = useState(true);
  const [schPUTimeDisplay, setSchPUTimeDisplay] = useState(false);
  const [returnTripDisplay, setReturnTripDisplay] = useState(false);
  const [driverVehInfoDisplay, setDriverVehInfoDisplay] = useState(false);
  const [additionalDetailsDisplay, setAdditionalDetailsDisplay] = useState(false);
  const [paymentDetailsDisplay, setPaymentDetailsDisplay] = useState(false);
  const [insuranceInfoDisplay, setInsuranceInfoDisplay] = useState(false);
  const [stopOrderDisplay, setStopOrderDisplay] = useState(true);
  const [agentTripsDisplay, setAgentTripsDisplay] = useState(false);
  const [manifestDetailsDisplay, setManifestDetailsDisplay] = useState(false);
  const [manualFareDisplay, setManualFareDisplay] = useState(false);
  const [manualDataOverwrite, setManualDataOverwrite] = useState({fare:0, price: 0, miles: 0});
  const [selectedSummaryHeader, setSelectedSummaryHeader] = useState("stopOrder");
  const [affiliateDropDownHTML, setAffiliateDropDownHTML] = useState(null);
  const [virtualStopDropDownHTML, setVirtualStopDropDownHTML] = useState(null);
  const [submitBtnTitle, setSubmitBtnTitle] = useState("");
  const [submitParatransitBtnTitle, setSubmitParatransitBtnTitle] = useState("Book");
  const [inputSuggestionListClientName, setInputSuggestionListClientName] = useState("");
  const [inputSuggestionListClientPhone, setInputSuggestionListClientPhone] = useState("");
  const [inputSuggestionListPU, setInputSuggestionListPU] = useState(null);
  const [inputSuggestionListDO, setInputSuggestionListDO] = useState(null);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const [highlightedIndexDO, setHightlightedIndexDO] = useState(-1);
  const [showStopBlock, setShowStopBlock] = useState(false);
  const [returnTripCheckBox, setReturnTripCheckBox] = useState(false);
  const [stopSaveBtnTitle, setStopSaveBtnTitle] = useState("Save");
  const [stopEditInfo, setStopEditInfo] = useState({data:{}, index:0});
  const [showStopsInput, setShowStopsInput] = useState(true);
  
  const [riderNameCheck, setRiderNameCheck] = useState("");
  const [microtransit, setMicrotransit] = useState(true);
  const [ShowAPILoader, setShowAPILoader] = useState(false);
  const [MTSMTableHTML, setMTSMTableHTML] = useState(null);
  const [mapVsSelected, setMapVSSelected] = useState([]);
  const [mapPointSelection, setMapPointSelection] = useState([]);

  const [rczVerifData, setRczVerifData] = useState([]);
  const [showClientActiveTripsModal, setShowClientActiveTripsModal] = useState(false);
  const [searchButtonValidation, setSearchButtonValidation] = useState("");
  const [activeTripConfirmation, setActiveTripConfirmation] = useState("");
  const [activeTripSelected, setActiveTripSelected] = useState(false);
  const [dynamicModeStyle, setDynamicModeStyle] = useState({});
  const [dynamicModeRowStyle, setDynamicModeRowStyle] = useState({});
  const [screenWidthSize, setScreenWidthSize] = useState(window.innerWidth);
  const [mapScreenHeightSize, setMapScreenHeightSize] = useState((window.innerHeight - 530 < 200 ? 200 : window.innerHeight - 530));
  const [summaryViewScreenHeightSize, setSummaryViewScreenHeightSize] = useState((window.innerHeight - (275 + mapScreenHeightSize)));
  const [TotalMTSMRecords, setTotalMTSMRecords] = useState(0);

  const puVSCallValidation = useRef(false);
  const doVSCallValidation = useRef(false);
  const puVSValueChanged = useRef("");
  const doVSValueChanged = useRef("");
  const isValidateRCZCalledFromReset = useRef(false);
  const addStopErrorFlag = useRef(false);
  const iframeRef = useRef(null);
  const showChatBotRef = useRef(false);
  const liRefRecentDropoffAddressComponenet = useRef([]); // Array to hold refs for each <li> DO
  const liRefRecentPickupAddressComponenet = useRef([]); // Array to hold refs for each <li> PU
  const liRefPickupAddressComponenet = useRef([]); // Array to hold refs for each <li> PU
  const liRefDropoffAddressComponenet = useRef([]); // Array to hold refs for each <li> DO
  const liRefReturnAddressComponent = useRef([]); // Array to hold refs for each <li> Return
  const liRefs = useRef([]); // Array to hold refs for each <li> PU
  const liRefsDO = useRef([]); // Array to hold refs for each <li> DO
  const xCancelSourceForGrid = useRef(null);
  const bookBtnRef = useRef(null);
  const paratransitBookBtnRef = useRef(null);
  const resetBtnRef = useRef(null);
  const agentNotesBtnRef = useRef(null);
  const phoneRef = useRef(null);
  const clientNameCheckRef = useRef(null);
  const riderNameRef = useRef(null);
  const focusedSuggestionCheckPU = useRef(false);
  const focusedSuggestionCheckDO = useRef(false);
  const timeValidateCheck = useRef(false);
  const vsChangeRef = useRef({type:""});
  const affiliateSelRef = useRef(null);
  const searchClientBtnRef = useRef(null);
  const vsSelectedRef = useRef([]);
  const clientIndexRef = useRef({index:0, data:{}});
  const transitTypeRef = useRef([]);
  const addressSwitchBtnRef = useRef(null);
  const calculatedTimeCheck = useRef(0);
  const addressInfoDetails = useRef({pick: {state:"", city: "", zip: ""}, drop: {state:"", city:"", zip:""}});
  const mapPointPickupSelection = useRef([]);
  const mapPointDropoffSelection = useRef([]);
  const mapPointReturnSelection = useRef([]);
  const apptTimeCheckValsRef = useRef({ServiceTime:0, ApptWindow:0, TimeWindow: 0});
  //-------------------------------------------------------------Client Info Active Trips Modal
  const [showLoader, setShowLoader] = useState(false);
  const [showAddLegLoader, setShowAddLegLoader] = useState(false);
  const [AgentTripRecordsTableHTML, setAgentTripRecordsTableHTML] = useState(null);
  const [ActiveTripsTableData, setActiveTripsTableData] = useState([]);
  const [stopLoadRiderName, setStopLoadRiderName] = useState("");
  const [stopUnloadRiderName, setStopUnloadRiderName] = useState("RN");
  const [activeTripsGridOptions, setActiveTripsGridOptions] = useState({
    height: 300,
    heightoffset: 600,
    calculateHeight: false,
    pagination: true,
    sortCondition: true,
    paginationMode: "local",
    paginationSize: [500, 1000, 2000],
    selectable: 1,
    reactiveData:false, //enable data reactivity
    layout: "fitDataStretch",
    placeholder:"No Data Available",
    clipboard: false,
    selectableRangeMode: "click",
    GridName:"clientInfoActiveTripsTable",
    paginationCounter:"rows",
    intervalTimer: GlobalASCSData.find(dict => dict.SubTitle === "Tb01") === undefined? 60000:GlobalASCSData.find(dict => dict.SubTitle === "Tb01").value*2000,
    movableColumns:true,
    vDefaultGridName: "SelectedGridRouteSRQARQPRQ_New",
    index: "iRefId",
    autoColumns: true,
    bSysUser: 1,
    intervalEnable: false,
    persistence: false,
    bWebApplySettingToAll: true,
    GridReturnOnlyIDColumnInRowData: false,
    containerClass: "col position-relative",
    Containerstyle: {},
    footerElement: '<button class="tabulator_btns" title="Export Excel" id="'
    +"clientInfoActiveTripsTable"+'_Export"></button><button class="tabulator_btns lastTabulator-btn" '
    +' title="Clear Filters" id="'+"clientInfoActiveTripsTable"+'_ClearFilters"></button>',
    tableDoubleClickFunc: function(table, row) {
      try{
        
      }
      catch(err){console.log(err);}
    },
    footerElementHandles: function (table) {
        activeTripsTableObjRef.current = table;
        // activeTripsTableObjRef.current.selectRow( activeTripsTableObjRef.current.getData()[0].iManifestNumber);
        let img = document.createElement("img");
          img.style.cssText = "width:16px; height:16px"; 
          img.src = ExportIcon;
          document.getElementById("clientInfoActiveTripsTable_Export").appendChild(img);

        img = document.createElement("img");
          img.style.cssText = "width:16px; height:16px"; 
          img.src = ClearFilterIcon;
          document.getElementById("clientInfoActiveTripsTable_ClearFilters").appendChild(img);

        document.getElementById("clientInfoActiveTripsTable_Export").addEventListener("click", function() {
          try{
            const data = table.getData('active');
            const columnsToIgnore = ['id'];
            let filteredData = data.map(row =>{
              const filteredRow = {...row};
              columnsToIgnore.forEach(column => delete filteredRow[column]);
              return filteredRow;
            });
            
            const sheet = XLSX.utils.json_to_sheet(filteredData);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, sheet, "MRMS Data");
            XLSX.writeFile(wb, "ActiveTrips_data.xlsx");
          }
          catch(err){console.log(err);}
        });
        document.getElementById('clientInfoActiveTripsTable_ClearFilters').addEventListener("click", function(){
            table.clearHeaderFilter();
        });
    },
    rowSelectionChangeHandle: function(data){
      try{

      }
      catch(err){console.log(err);}
    },
    ActionList: true,
    listofCheckBoxCols : [],
    AlwaysHiddenColumns: []
  });
  const activeTripsTableObjRef = useRef(null);
  //-------------------------------------------------------------
  //-------------------------------------------------------------Client Info
  const [addLegBtnTitle, setAddLegBtnTitle] = useState("Add Leg");
  const [verifiedInfoUpdateIndex, setVerifiedInfoUpdateIndex] = useState(0);
  const [stopLoadType, setStopLoadType] = useState({none:true, load:false, unload:false});
  const [passengerTypeCountStop, setPassengerTypeCountStop] = useState({ambPass:1,totalWC:0,totalSA:0, total:1});
  const [clientStops, setClientStops] = useState([]);
  const [FSDropdown, setFSDropdown] = useState([]);
  const [COSDropdown, setCOSDropdown] = useState([]);
  const [PayDropdown, setPayDropdown] = useState([]);
  const [CopayFSDropdown, setCopayFSDropdown] = useState([]);
  const [COSSelected, setCOSSelected] = useState(1);
  const [PaySelected, setPaySelected] = useState(1);
  const [FSSelected, setFSSelected] = useState("");
  const [FSTargetID, setFSTargetID] = useState("");
  const [PayTargetID, setPayTargetID] = useState("");
  const [clientInfo, setClientInfo] = useState([]);
  const [clientIDInfo, setClientIDInfo] = useState([]);
  const [riderVerification, setRiderVerification] = useState("");
  const [brokerModes, setBrokerModes] = useState({brokerMode:0, globalBrokerMode:0});
  const [schTime, setSchTime] = useState("");
  const [recentAddresses, setRecentAddresses] = useState([]);
  const [phone, setPhone] = useState(null);
  const [srcUrl, setSrcUrl] = useState('');
  const [chatBotPhone, setChatBotPhone] = useState('');
  const [callBackPhone, setCallBackPhone] = useState(null);
  const [callBackActual, setCallBackActual] = useState("");
  const [riderName, setRiderName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [isPhoneUpdateFromFunction, setIsPhoneUpdateFromFunction] = useState(false);
  const [historyTrips, setHistoryTrips] = useState(()=>{
    const savedTrips = PersistStorage.retrieve("agentTrips", true);
    if(savedTrips === null)  // Check if "agentTrips" key exists in localStorage
    {
      PersistStorage.save("agentTrips", [], true);
      return []; // Return an empty array as initial state
    }
    return savedTrips;
  });
  const [selectedAff, setSelectedAff] = useState(()=>{
    let storedSelection = PersistStorage.retrieve("affSelectedCallAgent", true);
    if(storedSelection) {
      if(storedSelection.includes(","))
      {
        return (AffiliateData.find(item => parseInt(item.iTransType) === 2))?.AffiliateID || 125;
      }
      else
      {
        return storedSelection;
      }
    }
    else {
      return (AffiliateData.find(item => parseInt(item.iTransType) === 2))?.AffiliateID || 125;
    }
  });
  const ITCMapURL = (selectedAff && ASCSSettingData[selectedAff] ? (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "ITCMapServiceURL")).value+"autocomplete?address=": "https://itcmap.itcurves.us/api/Map/autocomplete?address=");
  const ITCMapDirections = (selectedAff && ASCSSettingData[selectedAff] ? (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "ITCMapServiceURL")).value+"directions": "https://itcmap.itcurves.us/api/Map/directions");
  const ITCMapRawURL = (selectedAff && ASCSSettingData[selectedAff] ? (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "ITCMapServiceURL")).value : "https://itcmap.itcurves.us/api/map/");
  const ITCMapAutCode = "Basic QkFSV09PRDpiYXJ3b29kcGFzcw==";
  const OSRM_Username = (selectedAff && ASCSSettingData[selectedAff] ? (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "ITCMapServiceUserName")).value : "REGENCY");
  const OSRM_Password = (selectedAff && ASCSSettingData[selectedAff] ? (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "ITCMapServicePassword")).value : "barwoodpass");
  const [confirmationNo, setConfirmationNo] = useState("");
  const [schPUTime, setSchPUTime] = useState("");
  const [tripStatus, setTripStatus] = useState("");
  const [clientStatus, setClientStatus] = useState("");
  const [passengerTypeCount, setPassengerTypeCount] = useState({ambPass:1,totalWC:0,totalSA:0, total:1});
  const stopPassengerLoadTrackerRef = useRef(0);
  const [clientSummary, setClientSummary] = useState({totalCalls:0, totalNS:0, totalCancels:0, 
    lastCall:"", tripDistance:0.0, TripDuration:0.0, TripFare:0.0, TripCopay:0.0}
  );
  const [zones, setZones] = useState("");
  const [fareZones, setFareZones] = useState({pick:"", drop:""});
  const [dispatchZones, setDispatchZones] = useState({pickZone:"", dropZone:""});
  const [agentNotes, setAgentNotes] = useState("");
  const [pickupAddr, setPickupAddr] = useState("");
  const [dropAddr, setDropAddr] = useState("");
  const [pickupVirtualStop, setPickupVirtualStop] = useState({name:"", value:"PU VS"});
  const [dropAddrVirtualStop, setDropAddrVirtualStop] = useState({name:"", value:"DO VS"});
  const [walkDistance, setWalkDistance] = useState({PUWalk:0, DOWalk:0, PUDuration:0, DODuration:0});
  const [pickExtraInfo, setPickExtraInfo] = useState("");
  const [dropExtraInfo, setDropExtraInfo] = useState("");
  const [clientNameList, setClientNameList] = useState([]);
  const [pickPOI, setPickPOI] = useState("");
  const [dropPOI, setDropPOI] = useState("");
  const [stopPOI, setStopPOI] = useState("");
  const poiInputRef = useRef(null);
  const [showCCInfoDialog, setShowCCInfoDialog] = useState(false);
  const pickExtraInfoRef = useRef(null);
  const dropLatLng = useRef("");
  const pickLatLng = useRef("");
  const fareZonesRef = useRef({pickFareZone:"", dropFareZone:""});
  const searchedClientID = useRef("");
  const liClientNameRefs = useRef([]); // Array to hold refs for each <li> Client Names
  const liClientPhoneRefs = useRef([]); // Array to hold refs for each <li> Client Numbers
  const focusedSuggestionCheckClientName = useRef(false);
  const focusedSuggestionCheckClientPhone = useRef(false);
  const StopNameSelectionRef = useRef(null);
  const rowData = useRef([]);
  const clientInfoDisplayRef = useRef(null);
  const passengerCountPassengerRef = useRef(null);
  const addLegBtnRef = useRef(null);
  const apptTimeRef = useRef(null);
  const riderIDtimeoutRef = useRef(null); // Ref to store the timeout ID
  //-------------------------------------------------------------
  //-------------------------------------------------------------Schedule PU Info
  const [selectedDateSchTime, setSelectedDateSchTime] = useState("");
  const [systemDateTime, setSystemDateTime] = useState({time:"", date:""});
  const [appointmentTime, setAppointmentTime] = useState("");
  const [willCall, setWillCall] = useState(false);
  const [multischModalShow, setMultischModalShow] = useState(false);
  const [scheduleJSON, setScheduleJSON] = useState({mainData: "", multiSchData:"", range:"", neverExpire:false});
  const systemDateTimeRef = useRef({time:"", date:"", givenDate:"", givenTime:"", timeWithSettingAdded:0});
  const addedMinutesSystemSetting = useRef((selectedAff && ASCSSettingData[selectedAff] ? 
    parseInt((JSON.parse(ASCSSettingData[selectedAff]).find((item) => item.SubTitle === "Ta01")).value) / 60 : 0)
  );
  //-------------------------------------------------------------
  //-------------------------------------------------------------Return Addr Info
  const [returnAddr, setReturnAddr] = useState("");
  const [returnAddrZone, setReturnAddrZone] = useState("");
  const [returnAddrExtra, setReturnAddrExtra] = useState("");
  const [returnWillCall, setReturnWillCall] = useState(false);
  const [returnWaitTimeInput, setReturnWaitTimeInput] = useState(0);
  const [returnPhone, setReturnPhone] = useState(null);
  const [returnDate, setReturnDate] = useState("");
  const [returnTime, setReturnTime] = useState("");
  const [returnWaitTime, setReturnWaitTime] = useState(null);
  const [returnApptTime, setReturnApptTime] = useState(null);
  const [highlightedIndexReturn, setHightlightedIndexReturn] = useState(-1);
  const [inputSuggestionListReturn, setInputSuggestionListReturn] = useState(null);
  const returnLatLng = useRef("");
  const liRefsReturn = useRef([]); // Array to hold refs for each <li> Return
  const focusedSuggestionCheckReturn = useRef(false);
  const addReturnStopBtnRef = useRef(null);
  //-------------------------------------------------------------
  //-------------------------------------------------------------Mobility Info
  const [mobilityDetails, setMobilityDetails] = useState({totalVeh:1, vehTypeMin:0, vehNumMin:0, driverNumMin:0, genderMin:0, languageMin:0});
  const [mobilityChecks, setMobilityChecks] = useState({vehTypeCheck:false, vehNumCheck:false, driverNumCheck:false, genderCheck:false, languageCheck:false});
  const [selectedTripAttr, setSelectedTripAttr] = useState([]);
  const [vehNumberOptionsHTML, setVehNumberOptionsHTML] = useState([]);
  const [vehTypeOptionsHTML, setVehTypeOptionsManageHTML] = useState([]);
  const [driverNumberOptionsHTML, setDriverNumberOptionsHTML] = useState([]);
  const [languageOptionsHTML, setLanguageOptionsHTML] = useState([]);
  const [selectedVehNum, setSelectedVehNum] = useState("VN");
  const [selectedVehType, setSelectedVehType] = useState("VT");
  const [selectedDriverNum, setSelectedDriverNum] = useState("DN");
  const [selectedGender, setSelectedGender] = useState("Gender");
  const [selectedLanguage, setSelectedLanguage] = useState("Language");
  const [AttributesFilterMultiSelect, SetAttributesFilterMultiSelect] = useState({options: [], selectedValues:selectedTripAttr, placeholder:"Trip Attributes",
    displayValue:"name", emptyRecordMsg:"N/A", id:"DispatchGridAttributesSelect", className:"callAgentInputStyle border-0 text-nowrap", 
    AllItemsSelectedPlaceHolder:"All Attributes", SelectAllPlaceHolder:"",
    styles:{ width:"100%", maxHeight:"30px", display:"block", minWidth:"120px", marginLeft:"0.5rem", height:"30px", backgroundColor:"#e6eef1", border:0, borderRadius:"5px"}});
  const mobilityInfoDisplayRef = useRef(null);
  const languageOptionsSelRef = useRef(null);
  //-------------------------------------------------------------
  //-------------------------------------------------------------Insurance Info
  const [medID, setMedID] = useState("");
  const [insuranceName, setInsuranceName] = useState("");
  const [insuranceDOB, setInsuranceDOB] = useState("");
  const [insuranceSSN, setInsuranceSSN] = useState("");
  const [SSNDisplayValue, setSSNDisplayValue] = useState("");
  const [insuranceAuthCode, setInsuranceAuthCode] = useState("");
  const [insuranceType, setInsuranceType] = useState("");
  const [insuranceServiceCode, setInsuranceServiceCode] = useState("");
  const [insuranceAgency, setInsuranceAgency] = useState("");
  const [insuranceCaseWorker, setInsuranceCaseWorker] = useState("");
  const [insuranceRide, setInsuranceRide] = useState("");
  const insuranceRideSelRef = useRef(null);
  const insuranceInfoDisplayRef = useRef(null);
  //-------------------------------------------------------------
  //-------------------------------------------------------------Payment Info
  const [copayAmount, setCopayAmount] = useState(0);
  const [fareEstimateAPISummary, setFareEstimateAPISummary] = useState({copay: 0, walletID: 0, promo: "", eaasJSON: "", displayMessage: "", verifyStatus: ""});
  const [minMonth, setMinMonth] = useState('');
  const [maxMonth, setMaxMonth] = useState('');
  const [cardNumber, setCardNumber] = useState("");
  const [cardType, setCardType] = useState("");
  const [cardInfo, setCardInfo] = useState({cardNumber:"", expiry: "", selectedCard: "", selectedExpiry: "", selectedCardType: "", uniqueID: 0, gateID: "", response: ""});
  const [showCCBtn, setShowCCBtn] = useState(false);
  const [cardExpiration, setCardExpiration] = useState("");
  const [clientEmail, setClientEmail] = useState("");
  const [copayFSSelected, setCopayFSSelected] = useState("");
  const [copayPayTypeSelected, setCopayPayTypeSelected] = useState("CPT");
  const [RCType, setRCType] = useState({phoneType:false, emailType:false, SMSType:false});
  const [clientJob, setClientJob] = useState("");
  const [paymentAdditionalInfo, setPaymentAdditionalInfo] = useState("");
  const [selectedTripType, setSelectedTripType] = useState(3);
  const [selectedTripPriority, setSelectedTripPriority] = useState(5);
  const [tripTypeOptionsHTML, setTripTypeOptionsHTML] = useState([]);
  const [fareMethod, setFareMethod] = useState(0);
  const [fareDataArr, setFareDataArr] = useState([]);
  const [CheckCCParams, setCheckCCParams] = useState("");
  const fareMethodRef = useRef(0);
  const paymentCardIDInfoRef = useRef({uniqueID: -1, payStatusID: -1, invalidForSave: 0, retCCUniqueID: -1, CCPaidAmount: 0, CCRetPaidAmount: 0});
  //-------------------------------------------------------------
  //-------------------------------------------------------------Stop Order
  const [verifiedAddr, setVerifiedAddr] = useState([]);
  const [tripDetails, setTripDetails] = useState({pickAddr: "", dropAddr: "", date: "", 
    time: "", distance: 0, duration: 0, fare: 0, copay: 0, willCall: false, apptTime: "", notes:"", phone:"",
    puNotes:"", doNotes:"", riderName:"", passCount: 0, waitTime: "", clientCity: "", clientState: "",
    id: 0, clientMedID: 0, clientAddr: "", FundingSource: 0, PaymentSelected: 0, AffiliateSelected: 0, COS: 0, copay:0.0, 
    cardNum: "", cardExp: "", RC: RCType, driverNum: "", driverNumCheck: false,
    driverMins: 0, gender: "", genderMins: 0, vehNum: "", vehType:"", vehTypeCheck: false, vehTypeMins: 0,
    vehNumCheck: false, vehMins: 0, language: "", languageMins: 0,
    tripAttribute: "", insurance: {Agency: 0, Type: 0, CaseWorker: 0, AuthCode: 0, ServiceCode: 0}
  });
  //-------------------------------------------------------------
  //------------------------------------------------------------- Map
  const [mapData, setMapData] = useState([]);
  const [mapOptionsCallAgent, setMapOptionsCallAgent] = useState({
    mapPolylines:{single:true,multiple:false},
    mapZoomOpts: {zoomControl: false, draggable: true, scrollWheel: true, disableDoubleClickZoom: false},
    mapDefaultBtns: false,
    mapOptions: {tilt: 47.5, zoom: 12, zone:true, aff: selectedAff},
    GridName:"callAgent",
  });
  //-------------------------------------------------------------

  useEffect(() => {
    try{
      document.title = "Call Agent 2.0";
      const URL = GlobalASCSData.find(dict => dict.SubTitle.toLowerCase() === "chatboturl") ? GlobalASCSData.find(dict => dict.SubTitle.toLowerCase() === "chatboturl").value : [];

      setSpecificLinkRequirement(URL); //If chatbot URL exists in setting, it is set here for use in iframe of chatbot
        
      const queryParams = new URLSearchParams(window.location.search);
      const tripSelected = queryParams.get('TripSelected')? true:false;
      if(bookBtnRef.current) //If microtransit, disable booking until addresses are populated
      {
        bookBtnRef.current.disabled = true;
      }
      rowData.current = (PersistStorage.retrieve("rowDataCallAgent", true)  && tripSelected? PersistStorage.retrieve("rowDataCallAgent", true):[]); //Get rowData from selected row on D2.0
      let editRowData = (PersistStorage.retrieve("rowDataEditTrip", true)  && tripSelected? PersistStorage.retrieve("rowDataEditTrip", true):""); //Get edit data from API called on D2.0
      let affCheck = PersistStorage.retrieve("affSelectedCallAgent", true); //Get selected aff if any
      let editRowDataFlag = (editRowData && editRowData !== "" && editRowData !== "No data found" && typeof editRowData === 'object'); //Making a flag for edit data if available

      if(editRowData && editRowData !== "" && typeof editRowData === 'object') //Check if edit data from selected trip exists
      {
        if(editRowData === "No data found") //If API returns nothing, inform user in a modal that edit is not possible
        {
          getCurrentSystemDateTime("date", true); //Get server date & time
          setSubmitBtnTitle("Book");
          setModalHeaderText("No Data Found");
          setModalBodyHTML("There is no record in system for the selected trip, please select another or contact the administrator.");
          setModalFooterHTML(
            <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
          setShowDynamicModal(true);
          
        }
        else //Data exists for edit
        {
          getCurrentSystemDateTime("date", false); //Get server date & time
          handleEditTrip(editRowData, ""); //Call main function for handling population of existing trip data on call taker
          
          if(bookBtnRef.current) //Change book btn titles according to type of affiliate (micro vs para)
          {
            setSubmitBtnTitle("Update");
          }
          else
          {
            setSubmitParatransitBtnTitle("Update");
          }
        }
        
      }
      else //New reservation is being made
      {
        getCurrentSystemDateTime("date", true); //Get server date & time
        if(bookBtnRef.current) //Change book btn titles according to type of affiliate (micro vs para)
        {
          setSubmitBtnTitle("Book");
        }
        else
        {
          setSubmitParatransitBtnTitle("Book");
        }
      }

      let selectedAffVS = [];
      let tripData = null;
      let affiliateID = (affCheck && !affCheck.includes(",")? affCheck : ((AffiliateData.find(item => parseInt(item.iTransType) === 2))?.AffiliateID || AffiliateData[0].AffiliateID)); //Finding the correct affiliate ID selection
      let tripTypeArr = [{name:"Corporate", val:1}, {name:"Airport", val:2}, {name:"Normal", val:3} , 
        {name:"Corporate/Airport", val:5} , {name:"WheelChair", val:8}, {name:"Break Trip", val:9}, {name:"Depot Trip", val:10}
      ];
      let tripTypeHTML = tripTypeArr.map(function(item, index){
        return(
          <option key={index} value={item.val}>{item.name}</option>
        );
      });
      let attrSelection = AttributeData ? AttributeData.filter((item,index)=> {return parseInt(item.iAttrATSPID) === parseInt(affiliateID)}) : [];
      let attrOptionsMultiSel = attrSelection && attrSelection.length > 0 ? attrSelection.map((item)=>{
        let dict = {};
        dict.id = item.ID;
        dict.name = item.Title;
        return dict;
      }).sort((a, b) => a.name.localeCompare(b.name)) : [];

      setTripTypeOptionsHTML(tripTypeHTML); //Set trip type dropdown options
      
      if(editRowDataFlag) //Condition block to find correct trip to show for edit
      {
        for(let k = 0; k < editRowData.addressInfo.trips.length; k++)
        {
          if(parseInt(rowData.current[0].iRefID) === parseInt(editRowData.addressInfo.trips[k].details[0].tripInfo.refID))
          {
            tripData = editRowData.addressInfo.trips[k];
          }
        }
        if(!tripData)
        {
          tripData = editRowData.addressInfo.trips[0];
        }
        if(tripData.details[0].tripInfo.entityAttributes !== "") //Setting up the attribute dropdown with appropriate options and selected options (if any)
        {
          let providedAttrArr = [];
          let groupSelected = [];
          if(tripData.details[0].tripInfo.entityAttributes.includes(","))
          {
            providedAttrArr = tripData.details[0].tripInfo.entityAttributes.split(",");
            setSelectedTripAttr(providedAttrArr);
          }
          else
          {
            providedAttrArr.push(tripData.details[0].tripInfo.entityAttributes);        
            setSelectedTripAttr(providedAttrArr);    
          }
          
          for(let k = 0; k < attrOptionsMultiSel.length; k++)
          {
            if(providedAttrArr.includes(String(attrOptionsMultiSel[k].id)))
            {
              groupSelected.push({id:attrOptionsMultiSel[k].id, name:attrOptionsMultiSel[k].name});
            }
          }
  
          SetAttributesFilterMultiSelect({ ...AttributesFilterMultiSelect, ...{options: attrOptionsMultiSel,
            selectedValues:(editRowData && tripData.details[0].tripInfo.entityAttributes !== "" ? groupSelected : [])}}
          );
        }
      }
      else
      {
        SetAttributesFilterMultiSelect({ ...AttributesFilterMultiSelect, ...{options: attrOptionsMultiSel,
          selectedValues:[]}}
        );
      }
      
      //Finding transit type info to use for distinguishing between micro vs para
      transitTypeRef.current = AffiliateData.filter((item,index) => {
        try{
          return parseInt(item.AffiliateID) === parseInt(affiliateID);
        }
        catch(err){console.log(err);}
      });
      //Creating dynamic style for main two columns/rows on call taker to avoid repetition
      const dynamicCallAgentHeight = (transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2)
      ? { height: "396px", maxHeight: "396px" }
      : { height: `calc(100vh - 125px)` };
      const rowContainerDynamicHeight = (transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2)
      ? { marginLeft: "10%", marginRight:"10%", boxShadow:"-2px 0px 3px #999, 2px 0px 3px #999" }
      : { height: `calc(100vh - 125px)`, marginLeft: "10%", marginRight:"10%", boxShadow:"-2px 0px 3px #999, 2px 0px 3px #999" };
      setDynamicModeStyle(dynamicCallAgentHeight); 
      setDynamicModeRowStyle(rowContainerDynamicHeight);

      //vehicle number, vehicle type, driver number, funding source, class of service, attribute data, and broker mode found from settings in combinedDataAPI
      let vehData = (DispatchVehicleData[parseInt(affiliateID)] && DispatchVehicleData[parseInt(affiliateID)] !== "" ? DispatchVehicleData[parseInt(affiliateID)] : []);
      let vehNum = (vehData.length !== 0 ? handleDuplicates(JSON.parse(vehData), "VehicleNumber") : []);
      let vehType = (vehData.length !== 0 ? handleDuplicates(JSON.parse(vehData), "VehicleType") : []);
      let driverNum = DispatchDriverData[parseInt(affiliateID)] ? JSON.parse(DispatchDriverData[parseInt(affiliateID)]) : [];
      const sortedVehNum = vehNum.sort((a, b) => a.VehicleNumber - b.VehicleNumber);
      const sortedDriverNum = driverNum.sort((a, b) => a.DriverNumber - b.DriverNumber);
      let languageTypes = ["English", "Spanish", "Chinese", "Tagalog", "Vietnamese", "Arabic", "French", "Korean", "Russian", "Haitian Creole",
        "Hindi", "Portuguese", "Italian", "Polish", "Urdu", "Japanese", "Persian", "Gujarati", "Telugu", "Bengali", "Greek", "Punjabi", "Tamil", 
        "Armenian", "Serbo-Croatian", "Hebrew"];
      let fsSelection = FundingSourceData[parseInt(affiliateID)] && FundingSourceData[parseInt(affiliateID)] !== undefined ? JSON.parse(FundingSourceData[parseInt(affiliateID)]) : [];
      let cosSelection = ClassOfServiceData[parseInt(affiliateID)] && ClassOfServiceData[parseInt(affiliateID)] !== undefined ? JSON.parse(ClassOfServiceData[parseInt(affiliateID)]) : [];
      let paySelection = PaymentTypesData[parseInt(affiliateID)] && PaymentTypesData[parseInt(affiliateID)] !== undefined ? JSON.parse(PaymentTypesData[parseInt(affiliateID)]) : [];
      let copayFSSetting = (ASCSSettingData[parseInt(affiliateID)] ? (JSON.parse(ASCSSettingData[parseInt(affiliateID)]).find((item) => item.SubTitle === "CopayFSID_List")).value : "");
      let fundingSourceSelected = "";
      let copayFSSelectedTemp = "";
      let ASCSGlobalBrokerMode = (ASCSSettingData[parseInt(affiliateID)] ? (JSON.parse(ASCSSettingData[parseInt(affiliateID)]).find((item) => item.SubTitle === "BrokerMode")).value : 0);
      let languageOptions = languageTypes.map(function(item, index){
        return(
          <option key={index} value={(index+1)}>{item}</option>
        );
      });
      let vehicleNumOptionsHTML = sortedVehNum.map(function(item, index){
        return(
            <option key={index} value={item.VehicleID+"_"+item.VehicleNumber}>{item.VehicleNumber}</option>
        );
      });
      let driverNumberOptionsHTML = sortedDriverNum.map(function(item, index){
        return(
          <option key={index} value={item.DriverID+"_"+item.DriverNumber}>{item.DriverNumber}</option>
        );
      });
      let cosOptionsHTML = cosSelection.map((item, index)=>{
        return(
          <option key={index} value={item.iClassOfServiceID}>
            {item.vClassName}
          </option>
        );
      });
      let payOptionsHTML = paySelection.map((item, index)=>{
        if(index === 0) //Auto select the initial index for payment type of pay and copay
        {
          setPayTargetID(item.iID);
          setCopayPayTypeSelected(item.iID);
          setPaySelected(item.iID);
        }
        if(item.vName !== "" && item.vName !== "-" && !item.vName.toLowerCase().includes("unused") && !item.vName.toLowerCase().includes("wallet") && item.bActive) //Ignore payment types with no names, '-', or unused included
        {
          return(
            <option key={index} value={item.iID}>
              {item.vName}
            </option>
          );
        }
      });
      let vehicleTypeOptionsHTML = vehType.map(function(item, index){
        if(item.VehicleType && item.VehicleType.toUpperCase() !== "TESTTYPE")
        {
          return(
            <option key={index} value={item.iVTypeID} data-virtual={item.MaxWheelChairs}>{item.VehicleType}</option>
          );
        }
      });
      let fsOptionsHTML = fsSelection.map((item, index)=>{
        if((item.AccountID.toLowerCase().includes("self") || item.AccountID.toLowerCase().includes("cash")) || parseInt(item.FID) === 1) //Set target FS ID and broker mode for first time to self/cash default
        {
          setBrokerModes({globalBrokerMode: ASCSGlobalBrokerMode, brokerMode: item.BrokerMode});
          setFSSelected(item.FID);
          setFSTargetID(item.FID); 
          fundingSourceSelected = item.FID;
        }
        return(
          <option key={index} value={item.FID} data-virtual={item.FPayTypeID} label={item.AccountID}>
            {item.AccountID}
          </option>
        );
      });
      let copayFSOptionsHTML = fsSelection.map((item, index)=>{
        if(copayFSSetting === "") //In case there is no FS setting for copay in ASCS
        {
          if((item.AccountID.toLowerCase().includes("self") || item.AccountID.toLowerCase().includes("cash")) || parseInt(item.FID) === 1) //Set target FS ID and broker mode for first time to self/cash default
          {
            setCopayFSSelected(item.FID);
            copayFSSelectedTemp = item.FID;
          }
          
          return(
            <option key={index} value={item.FID} data-virtual={item.FPayTypeID} label={item.AccountID}>
              {item.AccountID}
            </option>
          );
        }
        else //If there is a setting in ASCS for copay
        {
          setCopayFSSelected(1);
          copayFSSelectedTemp = 1;
          let tempSettingIDs = copayFSSetting.includes(",")? copayFSSetting.split(",") : copayFSSetting;
          if(Array.isArray(tempSettingIDs))  //If setting is an array
          {
            if(tempSettingIDs.includes(String(item.FID))) //Find and save only the FID which is included in settings list
            {
              return(
                <option key={index} value={item.FID} data-virtual={item.FPayTypeID} label={item.AccountID}>
                  {item.AccountID}
                </option>
              );
            }
          }
          else //Setting is a single value
          {
            if(parseInt(tempSettingIDs) === parseInt(item.FID)) //Find and save only the FID which is included in settings list
            {
              return(
                <option key={index} value={item.FID} data-virtual={item.FPayTypeID} label={item.AccountID}>
                  {item.AccountID}
                </option>
              );
            }
          }
        } 
      });

      for(let k = 0; k < VirtualStopsData.length; k++)
      {
        if(parseInt(affiliateID) === parseInt(VirtualStopsData[k].iSATSPID) && VirtualStopsData[k].ZoneID && parseInt(VirtualStopsData[k].ZoneID) > 0)
        {
          selectedAffVS.push(VirtualStopsData[k]);
        }
      }

      if(fundingSourceSelected === "" && fsSelection.length > 0) //In case the self/cash FS ID does not exist set to initial element's value
      {
        setBrokerModes({globalBrokerMode: ASCSGlobalBrokerMode, brokerMode: fsSelection[0].BrokerMode});
        setFSSelected(fsSelection[0].FID);
        setFSTargetID(fsSelection[0].FID); 
        fundingSourceSelected = fsSelection[0].FID;
      }
      if(copayFSSelectedTemp === "") //In case no copay funding source was selected, set it again
      {
        setCopayFSSelected(fundingSourceSelected);
      }

      if(editRowDataFlag)
      {
        const matchingTripTypeOption = tripTypeHTML.find(option=>{
          if(tripData.details[0].tripInfo.callType !== -1)
            return option.props.value === tripData.details[0].tripInfo.callType;
        });
        setSelectedTripType((matchingTripTypeOption !== undefined ? matchingTripTypeOption.props.value : 3)); //Finding the correct option of trip type from dropdown
        
        const matchingDriverOption = driverNumberOptionsHTML.find(option=>{
          const [driverID, driverNum] = option.props.value.split("_");
          if(tripData.details[0].driverInfo.specialDriverId !== -1)
            return parseInt(driverID) === parseInt(tripData.details[0].driverInfo.specialDriverId); 
        });
        try{
          setSelectedDriverNum((matchingDriverOption !== undefined ? matchingDriverOption.props.value : "DN")); //Finding the correct option of driver number from dropdown
        }catch(err){console.log(err);}

        const matchingVehOption = vehicleNumOptionsHTML.find(option=>{
          const [vehID, vehNum] = option.props.value.split("_");
          if(!tripData.details[0].vehicleInfo.specialVehicleId !== -1)
            return parseInt(vehID) === parseInt(tripData.details[0].vehicleInfo.specialVehicleId);
        });
        setSelectedVehNum((matchingVehOption !== undefined ? matchingVehOption.props.value : "VN")); //Finding the correct option of vehicle number from dropdown
      }

      vehicleTypeOptionsHTML.unshift(<option key={333} value={"VT"}>{"None"}</option>); //Adding option to mobility info to unselect values if user wants to reset
      vehicleNumOptionsHTML.unshift(<option key={444} value={"VN"}>{"None"}</option>);
      driverNumberOptionsHTML.unshift(<option key={555} value={"DN"}>{"None"}</option>);
      languageOptions.unshift(<option key={666} value={"Language"}>{"None"}</option>);
      setLanguageOptionsHTML(languageOptions);
      setVehNumberOptionsHTML(vehicleNumOptionsHTML);
      setVehTypeOptionsManageHTML(vehicleTypeOptionsHTML);
      setDriverNumberOptionsHTML(driverNumberOptionsHTML);

      setPayDropdown(payOptionsHTML); //Appending the FS and copay options HTML
      setCOSDropdown(cosOptionsHTML); 
      setFSDropdown(fsOptionsHTML);
      setCopayFSDropdown(copayFSOptionsHTML);
      
      handleInitialFareAPIs(fundingSourceSelected, affiliateID, COSSelected); //Handling all fare APIs for initial load of the page

      startAffSelectionDropDown(selectedAffVS, (editRowDataFlag? parseInt(editRowData.generalInfo.requestAffiliateID): 0)); //Get affiliate dropdown function
      
      let interval = "";
      let resizeTimeout = 0;
      const handleResize = () =>{
        try{
          clearTimeout(resizeTimeout); //clear if resizing continues
          resizeTimeout = setTimeout(() => {
            let mapHeight = ((window.innerHeight - 530) < 200 ? 200 : (window.innerHeight - 530));
            let summaryWindowHeight = (window.innerHeight - (mapHeight + 275));
            setShowSideBar(false);
            setScreenWidthSize(window.innerWidth);
            setMapScreenHeightSize(mapHeight);
            setSummaryViewScreenHeightSize(summaryWindowHeight);
          }, 100);
        }
        catch(err){console.log(err);}
      };
      
      window.addEventListener('resize', handleResize); //For dynamic width adjustment of the call taker
      window.addEventListener('keydown', handleKeyPress); //keypress event for chatbot dialog close and other functions if needed
        
      if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2)) //If affiliate is microtransit...
      {
        //Set timer to check for ARBListener event if response is returned for booked trips status, delete old bookings if row # is higher than 4
        interval = setInterval(() => {
          try{
            let mtsmConfirmationNumList = PersistStorage.retrieve("confirmationsData", false);
            if(mtsmConfirmationNumList && mtsmConfirmationNumList.length > 0)
            {
              setTotalMTSMRecords(mtsmConfirmationNumList.length);
              if(mtsmConfirmationNumList.length > 4)
              {
                const currDate = new Date();
                const timeDiff = Math.abs(currDate - new Date(mtsmConfirmationNumList[0].creationTime));
                if(timeDiff >= 900000) //If time is 15 min since creation for 5th and below trip, remove them from table
                {
                  mtsmConfirmationNumList.shift();
                }
              }
              PersistStorage.save('confirmationsData', mtsmConfirmationNumList, 999, false);
              //Get trips table in order (newest-oldest)
              let MTMSNegotiationHTML = mtsmConfirmationNumList.reverse().map(function(item, index){
                const currDate = new Date();
                const timeDiff = Math.abs(currDate - new Date(item.creationTime));
                if(timeDiff >= 90000 && (item.msg === "" || item.msg.toLowerCase().includes("failed")))
                {
                  return(
                    <tr key={index} className="text-center border-bottom border-dark">
                      <td className="border border-dark user-select-none small">{item.Confirmation}</td>
                      <td className="border border-dark user-select-none small overflow-hidden text-nowrap" title={"N/A"} style={{textOverflow:"ellipsis"}}>
                        {"N/A"}
                      </td>
                      <td className="border border-dark user-select-none small overflow-hidden text-nowrap" title={"N/A"} style={{textOverflow:"ellipsis"}}>
                        {"N/A"}
                      </td>
                      <td className="border border-dark user-select-none text-nowrap small overflow-hidden" 
                        style={{textOverflow:"ellipsis"}} title={item.name} 
                      >{item.name}</td>
                      <td className="border border-dark user-select-none text-nowrap small overflow-hidden" title={"Routing system timed out"} 
                        style={{textOverflow:"ellipsis"}}
                      >{"Routing system timed out"}</td>
                      <td className="border-dark border-bottom user-select-none text-center justify-content-center">
                        <div className="d-flex justify-content-center">
                          <Button variant="secondary" tabIndex={-1} className="d-inline-block p-1 py-0" title={"Remove trip from view"} 
                            onClick={handleRemoveRecord} name={item.Confirmation}>
                            X
                          </Button>
                          <Button variant="danger" tabIndex={-1} className="mx-1 d-inline-block p-1 py-0"
                            name={item.Confirmation} onClick={handleRejectConfirmation} data-name={"cancel"}
                          > 
                            Cancel
                          </Button>
                        </div>
                      </td>
                    </tr>
                  );
                  
                }
                else if(item.msg === "" || item.msg.toLowerCase().includes("failed"))
                {
                  return(
                    <tr key={index} className="text-center border-bottom border-dark">
                      <td className="border border-dark user-select-none small">{item.Confirmation}</td>
                      <td className="border border-dark user-select-none small overflow-hidden text-nowrap" title={"N/A"} style={{textOverflow:"ellipsis"}}>
                        {"N/A"}
                      </td>
                      <td className="border border-dark user-select-none small overflow-hidden text-nowrap" title={"N/A"} style={{textOverflow:"ellipsis"}}>
                        {"N/A"}
                      </td>
                      <td className="border border-dark user-select-none text-nowrap small overflow-hidden" 
                        style={{textOverflow:"ellipsis"}} title={item.name} 
                      >{item.name}</td>
                      <td className="border border-dark user-select-none text-nowrap small overflow-hidden" title={"Processing request..."} 
                        style={{textOverflow:"ellipsis"}}
                      >{"Processing request..."}</td>
                      <td className="border-dark border-bottom user-select-none text-center justify-content-center">
                        <div className="d-flex justify-content-center">
                          <Button variant="secondary" className="d-inline-block p-1 py-0" title={"Remove trip from view"} 
                            onClick={handleRemoveRecord} tabIndex={-1} name={item.Confirmation}>
                            X
                          </Button>
                          <Button variant="danger" className="mx-1 d-inline-block p-1 py-0"
                            name={item.Confirmation} tabIndex={-1} onClick={handleRejectConfirmation} data-name={"cancel"}
                          > 
                            Cancel
                          </Button>
                        </div>
                      </td>
                    </tr>
                  );
                }
                else
                {
                  return(
                    <tr key={index} className="text-center border-bottom border-dark">
                      <td className="border border-dark user-select-none small">{item.Confirmation}</td>
                      <td className="border border-dark user-select-none small overflow-hidden text-nowrap" title={item.time} style={{textOverflow:"ellipsis"}}>
                        {item.time}
                      </td>
                      <td className="border border-dark user-select-none small overflow-hidden text-nowrap" title={item.dropTime} style={{textOverflow:"ellipsis"}}>
                        {item.dropTime}
                      </td>
                      <td className="border border-dark user-select-none text-nowrap small overflow-hidden" 
                        style={{textOverflow:"ellipsis"}} title={item.name} 
                      >{item.name}</td>
                      <td className="border border-dark user-select-none text-nowrap small overflow-hidden" title={item.msg} 
                        style={{textOverflow:"ellipsis"}}
                      >{item.msg}</td>
                      <td className="border-dark border-bottom user-select-none text-center justify-content-center">
                        <div className="d-flex justify-content-center">
                          <Button variant="secondary" className="d-inline-block p-1 py-0" disabled={item.msg === ""} title={"Remove trip from view"} 
                            onClick={handleRemoveRecord} tabIndex={-1} name={item.Confirmation}>
                            X
                          </Button>
                          {(item.time !== "N/A" || item.msg.toLowerCase().includes("failed")) && timeDiff < 240000?
                          <Button variant="danger" className="mx-1 d-inline-block p-1 py-0" disabled={item.msg === ""} title={"Reject scheduled trip"} 
                            onClick={handleRejectConfirmation} tabIndex={-1} name={item.Confirmation} data-name={"reject"}>
                            Reject
                          </Button>:
                          <Button variant="danger" className="mx-1 d-inline-block p-1 py-0 opacity-0" disabled={item.time === "N/A"} 
                            name={item.Confirmation} tabIndex={-1}>
                            Reject
                          </Button>}
                        </div>
                      </td>
                    </tr>
                  )
                }
                
              });
              setMTSMTableHTML(
                <>
                  {MTMSNegotiationHTML}
                </>
              );
              // console.log(mtsmConfirmationNumList);
              if(mtsmConfirmationNumList && mtsmConfirmationNumList.length > 0)
              {
                setConfirmationNo(mtsmConfirmationNumList[0].Confirmation);
              }
            }
            else
            {
              setTotalMTSMRecords(0); //Default case where no trips are booked
              
              setMTSMTableHTML(
                <>
                  <tr className="text-center">
                    <td className="border border-dark user-select-none">{""}</td>
                    <td className="border border-dark user-select-none">{""}</td>
                    <td className="border border-dark user-select-none">{""}</td>
                    <td className="border border-dark user-select-none text-nowrap small overflow-hidden" 
                      style={{textOverflow:"ellipsis", maxWidth:"65px", minWidth:"50px"}} title={""} 
                    >{""}</td>
                    <td className="border border-dark user-select-none text-nowrap small overflow-hidden" title={""} 
                      style={{textOverflow:"ellipsis", maxWidth:"80px", minWidth:"60px"}}
                    >
                      {""}
                    </td>
                    <td className="user-select-none text-center justify-content-center">
                      {""}
                    </td>
                  </tr>
                </>
              );
              if(!editRowDataFlag) 
              {
                setConfirmationNo("");
              }
            }
          }
          catch(err){console.log(err);}
          
        }, 1000);
        
      }
      return()=>{
        if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2))
        {
          clearInterval(interval);
        }
        clearTimeout(resizeTimeout); //clearing screen resize timer
        // Clean up the event listener on component unmount
        window.removeEventListener('keydown', handleKeyPress);
        window.removeEventListener('resize', handleResize);
      };
    }
    catch(err){console.log(err);}

  }, []);

  useEffect(() => {
    try{

      if(activeTripConfirmation !== "") //If user selects an action on active trips of client...
      {
        if(activeTripConfirmation.includes("_copy")) //Copy action; copying data onto call taker for booking 
        {
          let tripInfo = ActiveTripsTableData.filter((item)=>{
            try{
              if(String(item.iRefId) === String(activeTripConfirmation.replace("_copy","")))
              {
                return true;
              }
            }
            catch(err){console.log(err);}
          });

          handleEditTrip(tripInfo, "API", true);
          setActiveTripConfirmation("");
          setShowClientActiveTripsModal(false);
        }
        else if(activeTripConfirmation.includes("_edit")) //Edit action; editing data for updating active trip
        {
          let tripInfo = ActiveTripsTableData.filter((item)=>{
            try{
              if(String(item.iRefId) === String(activeTripConfirmation.replace("_edit","")))
              {
                return true;
              }
            }
            catch(err){console.log(err);}
          });
          handleEditTrip(tripInfo, "API");
          setActiveTripConfirmation("");
          setShowClientActiveTripsModal(false);
        }
        else if(activeTripConfirmation.includes("_remove")) //Remove action; not available for active trips
        {
          setActiveTripConfirmation("");
        }
        else //Cancel action; canceling active trips from the dialog
        {
          handleCancelTrip(activeTripConfirmation, "active");
          setActiveTripConfirmation("");
        }
      }
    }
    catch(err){console.log(err);}

  }, [activeTripConfirmation]);

  useEffect(() => {
    try{
      let UserID = parseInt(loginData.iUserIDActual); //Getting the accurate source URL for chatbot iframe
      let FamilyID = (AffiliateData.find((item) => {if(parseInt(item.AffiliateID) === parseInt(selectedAff)){return item}})).iPartnerAffiliateID;
      let AffiliateID = parseInt(selectedAff);
      let clientID = typeof clientInfo === 'object' && clientInfo.Id && String(clientInfo.Id) !== "-1"? clientInfo.Id : "-1";
      let manualPhone = "";
      if (!showChatBotRef.current && phone && phone.length >= 12) {
        let areaCode = phone.replace("+1", "").substring(0, 3);
        let firstPart = phone.replace("+1", "").substring(3, 6);
        let secondPart = phone.replace("+1", "").substring(6, 10);
        manualPhone = areaCode + "-" + firstPart + "-" + secondPart;
      }
      else if (showChatBotRef.current && chatBotPhone && chatBotPhone.length >= 12){
        let areaCode = chatBotPhone.replace("+1", "").substring(0, 3);
        let firstPart = chatBotPhone.replace("+1", "").substring(3, 6);
        let secondPart = chatBotPhone.replace("+1", "").substring(6, 10);
        manualPhone = areaCode + "-" + firstPart + "-" + secondPart;
      }
  
      const PhoneNo = typeof clientInfo === 'object' && clientInfo.HomePhone ? clientInfo.HomePhone : (manualPhone !== "" ? manualPhone : "");
      let sourceUrl = `${specificLinkRequirement}?PhoneNo=${PhoneNo}&iAffiliateID=${AffiliateID}&iFamilyID=${FamilyID}&iUserID=${UserID}&clientID=${clientID}`
      setSrcUrl(sourceUrl);
    }
    catch(err){console.log(err);}
  }, [specificLinkRequirement, phone, chatBotPhone]);

  useEffect(() => {
    try{
      if(mapVsSelected && mapVsSelected.length > 0) //function for virtual stop selection on map (microtransit)
      {
        let correctDate = formatDate(selectedDateSchTime + " 00:00:00"); //Get selected date with correct format
        if(mapVsSelected[0].type === "PU")
        {
          setPickupAddr(mapVsSelected[0].data.Street); //Setting pickup address of virtual stop, and pins on the map for the location PU
          pickLatLng.current = mapVsSelected[0].data.vLatitude+","+mapVsSelected[0].data.vLongitude;
          setPickupVirtualStop({...pickupVirtualStop, value:mapVsSelected[0].data.ID, name:mapVsSelected[0].data.Location});
          let stopMarkersArr = [{lat:parseFloat(pickLatLng.current.split(",")[0]),
            lng: parseFloat(pickLatLng.current.split(",")[1]), Type:"PU", 
            name:(riderName === "" ? "N/A" : riderName.trim()), address: mapVsSelected[0].data.Street
          }];
          let filteredMapMarkers = mapData.filter((item)=>{
            if(item.Type === "Stop")
            {
              stopMarkersArr.push(item);
            }
            return item.Type === "DO";
          });
          filteredMapMarkers.unshift(...stopMarkersArr);
          setMapData(filteredMapMarkers);

          if(dropLatLng.current !== "")
          {
            setIsSchTimeFieldDisabled(false);
            setIsVSSelectionDisabled(true);
            if(pickupVirtualStop?.name !== undefined && pickupVirtualStop?.name !== null){
              pickupVirtualStop.name = mapVsSelected[0].data.Location;
            }
            puVSValueChanged.current = mapVsSelected[0].data.Location;
            mapPointPickupSelection.current = mapVsSelected[0].data;
            
            wrapperHandleAddressDetails("PU", mapVsSelected[0].data.Street, mapVsSelected[0].data.Street, dropAddr, correctDate, schTime); //Get distance between markers
            if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2))
            {
              wrapperHandleRCZVerification("PU", mapVsSelected[0].data.Street); //Validate and find walking distance from selected locations to closest VS
            }
            setIsVSSelectionDisabled(false);
          }
        }
        else
        {
          setDropAddr(mapVsSelected[0].data.Street); //Setting drop address of virtual stop, and pins on the map for the location DO
          dropLatLng.current = mapVsSelected[0].data.vLatitude+","+mapVsSelected[0].data.vLongitude;
          setDropAddrVirtualStop({...dropAddrVirtualStop, value:mapVsSelected[0].data.ID, name:mapVsSelected[0].data.Location});
          let stopMarkersArr = [];
          let filteredMapMarkers = mapData.filter((item)=>{
            if(item.Type === "Stop")
            {
              stopMarkersArr.push(item);
            }
            return item.Type === "PU";
          });
          stopMarkersArr.push({lat:parseFloat(dropLatLng.current.split(",")[0]),
            lng: parseFloat(dropLatLng.current.split(",")[1]), Type:"DO", 
            name:(riderName === "" ? "N/A" : riderName.trim()), address: mapVsSelected[0].data.Street
          });
          filteredMapMarkers.push(...stopMarkersArr);
          setMapData(filteredMapMarkers);

          if(pickLatLng.current !== "")
          {
            setIsSchTimeFieldDisabled(false);
            setIsVSSelectionDisabled(true);
            if(dropAddrVirtualStop?.name !== undefined && dropAddrVirtualStop?.name){
              dropAddrVirtualStop.name = mapVsSelected[0].data.Location;
            }
            doVSValueChanged.current = mapVsSelected[0].data.Location;
            mapPointDropoffSelection.current = mapVsSelected[0].data;

            wrapperHandleAddressDetails("DO", mapVsSelected[0].data.Street, pickupAddr, mapVsSelected[0].data.Street, correctDate, schTime); //Get distance between markers
            if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2))
            {
              wrapperHandleRCZVerification("DO", mapVsSelected[0].data.Street); //Validate and find walking distance from selected locations to closest VS
            }
            setIsVSSelectionDisabled(false);
          }
          
        }
      }
    }
    catch(err){console.log(err); setIsVSSelectionDisabled(false);}

  }, [mapVsSelected]);

  useEffect(() => {
    try{
      if(mapPointSelection && mapPointSelection.length > 0) //Map point selection for non-VS locations (micro & para)
      {
        const FetchData = async () => {
          if (mapPointSelection[0].type === "PU") {
            pickLatLng.current = mapPointSelection[0].latlng;
            if ((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2)) {
              if (fareMethodRef.current === 1) {

                await getFareZone(FSSelected, selectedAff, COSSelected, pickLatLng.current, "pick");
              }
              await getDispatchZone(selectedAff, pickLatLng.current, "pick");
              addLegBtnRef.current.disabled = false;
            }
          } else if (mapPointSelection[0].type === "DO") {
            dropLatLng.current = mapPointSelection[0].latlng;
            if ((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2)) {
              if (fareMethodRef.current === 1) {
                await getFareZone(FSSelected, selectedAff, COSSelected, dropLatLng.current, "drop");
              }
              await getDispatchZone(selectedAff, dropLatLng.current, "drop");
              addLegBtnRef.current.disabled = false;
            }
          }
        }
        FetchData()
        let correctDate = formatDate(selectedDateSchTime); //Get date for functions as needed
        if(mapPointSelection[0].type === "PU")
        {
          setInputSuggestionListPU("");
          setPickupAddr(mapPointSelection[0].address);
          addressInfoDetails.current.pick = {
            city: mapPointSelection[0].addressParsedObject.City, 
            state: mapPointSelection[0].addressParsedObject.State, 
            zip: mapPointSelection[0].addressParsedObject.Zip
          };

          let stopMarkersArr = [{lat:parseFloat(pickLatLng.current.split(",")[0]),
            lng: parseFloat(pickLatLng.current.split(",")[1]), Type:"PU", 
            name:(riderName === "" ? "N/A" : riderName.trim()), address: mapPointSelection[0].address}
          ];
          let filteredMapMarkers = mapData.filter((item)=>{
            if(item.Type === "Stop")
            {
              stopMarkersArr.push(item);
            }
            return item.Type === "DO";
          });
          filteredMapMarkers.unshift(...stopMarkersArr);
          setMapData(filteredMapMarkers); //Adding markers to map in order
          if(dropLatLng.current !== "")
          {
            setIsVSSelectionDisabled(true);
            setIsSchTimeFieldDisabled(false);
            wrapperHandleAddressDetails("PU", mapPointSelection[0].address, mapPointSelection[0].address, dropAddr, correctDate, schTime);
            if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2))
            {
              wrapperHandleRCZVerification("PU", mapPointSelection[0].address);
            }
            setIsVSSelectionDisabled(false);
          }
        }
        else if(mapPointSelection[0].type === "DO")
        {
          setInputSuggestionListDO("");
          setDropAddr(mapPointSelection[0].address);
          addressInfoDetails.current.drop = {
            city: mapPointSelection[0].addressParsedObject.City, 
            state: mapPointSelection[0].addressParsedObject.State, 
            zip: mapPointSelection[0].addressParsedObject.Zip
          };

          let stopMarkersArr = [];
          let filteredMapMarkers = mapData.filter((item)=>{
            if(item.Type === "Stop")
            {
              stopMarkersArr.push(item);
            }
            return item.Type === "PU";
          });
          stopMarkersArr.push({lat:parseFloat(dropLatLng.current.split(",")[0]),
            lng: parseFloat(dropLatLng.current.split(",")[1]), Type:"DO", 
            name:(riderName === "" ? "N/A" : riderName.trim()), address: mapPointSelection[0].address
          }); 
          filteredMapMarkers.push(...stopMarkersArr);
          setMapData(filteredMapMarkers); //Adding markers to map in order

          if(pickLatLng.current !== "")
          {
            setIsVSSelectionDisabled(true);
            setIsSchTimeFieldDisabled(false);
            wrapperHandleAddressDetails("DO", mapPointSelection[0].address, pickupAddr, mapPointSelection[0].address, correctDate, schTime);
            if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2))
            {
              wrapperHandleRCZVerification("DO", mapPointSelection[0].address);
            }
            setIsVSSelectionDisabled(false);
          }
        }
        else if(mapPointSelection[0].type === "Stop")
        {
          setInputSuggestionListReturn(""); //initializing/adding stop to the list of stops lists for the addresses
          setShowStopBlock(true);
          setShowStopsInput(true);
          setReturnAddr(mapPointSelection[0].address);
          returnLatLng.current = mapPointSelection[0].latlng;
        }
        setIsVSSelectionDisabled(false);
      }
    }
    catch(err){console.log(err); setIsVSSelectionDisabled(false);}

  }, [mapPointSelection]);

  useEffect(() => {
    try{
      if(bookBtnRef.current) //If microtransit...
      {
        if(schTime === "" && bookBtnRef.current.disabled && pickLatLng.current !== "" && dropLatLng.current !== "") //If time is empty and addresses are populated, enable booking
        {
          bookBtnRef.current.disabled = false;
        }
        if (schTime === "") {
          if (isValidateRCZCalledFromReset.current === false && pickLatLng.current !== "" && dropLatLng.current !== "") {
            handleValidationMsg(); //Validate RCZ
          }
        }
      }
      else if(paratransitBookBtnRef.current) //If paratransit...
      {
        if(schTime === "" && paratransitBookBtnRef.current.disabled && pickLatLng.current !== "" && dropLatLng.current !== "")
        {
          paratransitBookBtnRef.current.disabled = false; //If time is empty and addresses are populated, enable add leg/booking
          addLegBtnRef.current.disabled = false;
        }
      }
    }
    catch(err){console.log(err);}
    
  }, [schTime]);

  useEffect(() =>{
    try{
      let correctDate = formatDate(selectedDateSchTime); //If value of Virtual Stop DO changed, update the reference for stop name
      if(doVSValueChanged.current !== dropAddrVirtualStop.name){
        doVSValueChanged.current = dropAddrVirtualStop.name;
      }
      if(pickLatLng.current !== "" && doVSCallValidation.current === true)
      {
        async function CallFunctionsForDOValidations() {
          setIsVSSelectionDisabled(true);
          await handleAddressDetails("DO", dropAddrVirtualStop.name, pickupAddr, dropAddrVirtualStop.name, correctDate, schTime);
          await handleRCZVerification("DO", dropAddrVirtualStop.name, " ");
          doVSCallValidation.current = false;
          setIsVSSelectionDisabled(false);
        };
        CallFunctionsForDOValidations(); //Get verified status of RCZ for DO address change
      }
    }
    catch(err){console.log(err);}

  }, [dropAddrVirtualStop]);

  useEffect(() =>{
    try{
      let correctDate = formatDate(selectedDateSchTime); //If value of Virtual Stop PU changed, update the reference for stop name
      if(puVSValueChanged.current !== pickupVirtualStop.name){
        puVSValueChanged.current = pickupVirtualStop.name
      }
      if(dropLatLng.current !== "" && puVSCallValidation.current === true)
      {
        async function CallFunctionsForValidation() {
          setIsVSSelectionDisabled(true);
          await handleAddressDetails("PU", pickupVirtualStop.name, pickupVirtualStop.name, dropAddr, correctDate, schTime);
          await handleRCZVerification("PU", pickupVirtualStop.name, " ");
          puVSCallValidation.current = false;
          setIsVSSelectionDisabled(false);
        };
        CallFunctionsForValidation(); //Get verified status of RCZ for PU address change
      }
    }
    catch(err){console.log(err);}

  }, [pickupVirtualStop]);

  useEffect(() => {
    try{
      if(historyTrips && historyTrips.length > 0) //Setting history table rows for recently booked paratransit trips (latest-earliest)
      {
        let historyTripsHTML = historyTrips.reverse().map(function(item, index){
          return(
            <tr key={index} className="text-center">
              <td className="text-nowrap small overflow-hidden bg-light p-1" style={{borderRight:"1px solid #ccc", borderBottomLeftRadius:"5px"}}>
                {item.confirmation}
              </td>
              <td className="text-nowrap small overflow-hidden bg-light px-1" style={{borderRight:"1px solid #ccc"}}>
                {item.type}
              </td>
              <td className="text-nowrap small overflow-hidden bg-light px-1" style={{borderRight:"1px solid #ccc"}}>
                {item.tripData.addressInfo.Trips[0].Details[0].estimatedInfo.EstimatedCost}
              </td>
              <td className="text-nowrap small overflow-hidden bg-light px-1" style={{borderRight:"1px solid #ccc"}}>
                {item.tripData.addressInfo.Trips[0].Details[0].estimatedInfo.EstimatedDistance}
              </td>
              <td className="text-nowrap small overflow-hidden bg-light p-1" style={{ borderBottomRightRadius:"5px"}}>
                {item.tripData.addressInfo.Trips[0].Details[0].estimatedInfo.EstimatedTime}
              </td>
            </tr>
          );
        });
        setAgentTripRecordsTableHTML(
          <>
            {historyTripsHTML}
          </>
        );
        if(confirmationNo === "")
        {
          setConfirmationNo(historyTrips[0].confirmation); //Set confirmation number to latest trip confirmation if none exist
        }
      } 
    }
    catch(err){console.log(err);}
    
  }, [historyTrips]);

  const renderMultiScheduleComponent = () => { //Multischedule render function for JSX to avoid repeatition
    return(
      <span className="d-flex mx-1 justify-content-start">
        <span title={"Multischedule"} className="my-auto" 
          onKeyDown={(e)=>{if(e.key === "Enter" && (verifiedAddr.length < 1 || 
            (verifiedAddr.length === 1 && pickLatLng.current === "" && dropLatLng.current === "")))
            {handleMultischeduleOpen(e);}
          }} 
          onClick={(e)=>{
            if(verifiedAddr.length < 1 || 
              (verifiedAddr.length === 1 && pickLatLng.current === "" && dropLatLng.current === ""))
            {handleMultischeduleOpen(e);}
          }}
        >
          <Icon icon="mingcute:calendar-add-line" className="my-auto text-info" style={{cursor:(verifiedAddr.length < 1 
              || (verifiedAddr.length === 1 && pickLatLng.current === "" && dropLatLng.current === "")? "pointer":"not-allowed"), 
              width:"25px", height:"25px"
            }} tabIndex={0}
          />
        </span>
        <label className="small m-0 p-0 my-auto text-nowrap user-select-none ms-3" title={"Will Call?"}>{"WC"}</label>
        <input type="checkbox" style={{cursor:"pointer"}} className="m-1" checked={willCall} 
          disabled={(scheduleJSON.mainData !== "" && scheduleJSON.mainData.Schedule.ScheduleItem.length > 0)}
          onChange={(e)=>{setWillCall(e.target.checked);}} onKeyDown={(e)=>{if(e.key === "Enter"){setWillCall(!(e.target.checked));}}}
        />
        {scheduleJSON.mainData !== "" && scheduleJSON.mainData.Schedule.ScheduleItem.length > 0 ? 
          <p className='m-0 mx-1 d-inline-flex user-select-none my-auto small text-start' style={{minWidth:"40px"}} 
            title={((scheduleJSON.mainData.Schedule.ScheduleItem.length) +" Day(s) Scheduled on Multischedule")}
          >
            {(scheduleJSON.mainData.Schedule.ScheduleItem.length) + " day(s)"}
          </p>
        : ""}
      </span>
    );
  };

  const handleKeyPress = useCallback((event) =>{ //keyPress callback handler for varied uses
    try{
      if(event.key === "Escape" && showChatBotRef.current) //If chatbot is shown and esc key is pressed, close chatbot iframe
      {
        setShowChatBot(false);
        showChatBotRef.current = false;
      }
    }
    catch(err){console.log(err);}
  }, []);
  
  useEffect(()=>{
    try{
      if(scheduleJSON.mainData !== "") //If multischedule data is not empty, disable add leg btn
      {
        addLegBtnRef.current.disabled = true;
      }
      else //Otherwise, check and enable it if disabled
      {
        if(addLegBtnRef.current)
          addLegBtnRef.current.disabled = false;
      }
    }
    catch(err){console.log(err);}

  }, [scheduleJSON]);

  useEffect(() => {
      try{
        //Function to catch and remove selected card chosen by user
        if(cardInfo.selectedCard !== "")
        {
          setCardNumber(cardInfo.selectedCard);
          setCardExpiration(cardInfo.selectedExpiry);
          setCardType(cardInfo.selectedCardType);
          if(parseInt(paymentCardIDInfoRef.current.uniqueID) !== parseInt(cardInfo.uniqueID))
            paymentCardIDInfoRef.current.invalidForSave = 0;
          paymentCardIDInfoRef.current.uniqueID = cardInfo.uniqueID;
          if(cardInfo.response !== "")
          {
            let parsedResponse = JSON.parse(cardInfo.response);
            CheckCCAmountResponseHandler(parsedResponse);
          }
        }
      }
      catch(err){console.log(err);}
  }, [cardInfo]);

  useEffect(() => {
    // only to be called after signal r response caller ID population
    if (isPhoneUpdateFromFunction && phone !== "") {
      const event = new KeyboardEvent("keydown", {
        key: "Enter",
        code: "Enter",
        keyCode: 13,
        bubbles: true,
        cancelable: true,
      });
      phoneRef.current.dispatchEvent(event);

      // Reset the flag to prevent unintended triggering
      setIsPhoneUpdateFromFunction(false);
    }
  }, [phone, isPhoneUpdateFromFunction]);

  const handleInitialFareAPIs = async (FSID, AffID, COSID, additionalData = [], tripDataInfo = null) => {
    try{
      if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2)) //Making sure aff is paratransit...
      {
        await handleGetFareCalcMethod((FSID === "" ? "0":FSID), AffID, COSID); //Get fare calculation method at beginning of page load
        const queryParams = new URLSearchParams(window.location.search);
        const tripSelected = queryParams.get('TripSelected') || activeTripSelected? true:false; //Checking for query on URL of call taker webpage
        let editRowData = (additionalData.length > 0 ? additionalData[0] : (PersistStorage.retrieve("rowDataEditTrip", true) && 
          tripSelected? PersistStorage.retrieve("rowDataEditTrip", true):"")
        );
        if(editRowData && editRowData !== "" && editRowData !== "No data found" && typeof editRowData === 'object') //Making sure edit trip data is not invalid
        {
          if(pickLatLng.current !== "" && dropLatLng.current !== "")
          {
            let tripData = null;
            if(tripDataInfo) //If trip edit addressInfo data already given, use that
            {
              tripData = tripDataInfo;
            }
            else //Otherwise look for correct addressInfo based on D2.0 iRefID selected
            {
              for(let k = 0; k < editRowData.addressInfo.trips.length; k++)
              {
                if(parseInt(rowData.current[0].iRefID) === parseInt(editRowData.addressInfo.trips[k].details[0].tripInfo.refID))
                {
                  tripData = editRowData.addressInfo.trips[k];
                }
              }
              if(!tripData)
              {
                tripData = editRowData.addressInfo.trips[0];
              }
            }
            
            setShowAPILoader(true);
            resetBtnRef.current.disabled = true;
            paratransitBookBtnRef.current.disabled = true;
            let tripTypes = [{type:"pick", mapInfo:pickLatLng.current}, {type:"drop", mapInfo:dropLatLng.current}];
            for(let k = 0; k < tripTypes.length; k ++) //Check for fare zone if fare method is 1, get dispatch zone of PU & DO
            {
              if(fareMethodRef.current === 1)
              {
                await getFareZone(tripData.details[0].paymentInfo.fundingSourceID, editRowData.generalInfo.requestAffiliateID, tripData.details[0].tripInfo.classOfServiceID, tripTypes[k].mapInfo, tripTypes[k].type);
              }
              await getDispatchZone(editRowData.generalInfo.requestAffiliateID, tripTypes[k].mapInfo, tripTypes[k].type);
            }
            await wrapperHandleFareCalc(tripData.details[0].estimatedInfo.estimatedDistance, tripData.details[0].estimatedInfo.estimatedTime, 
              tripData.details[0].paymentInfo.fundingSourceID, tripData.details[0].paymentInfo.iCopayFundingSourceID, tripData.details[0].passengerInfo.totalWheelChairs, 
              tripData.details[0].passengerInfo.totalPassengers, tripData.details[0].tripInfo.classOfServiceID, editRowData.generalInfo.requestAffiliateID, 
              pickLatLng.current, tripData.details[0].estimatedInfo.coPay, "initial", editRowData.riderInfo.riderID); //Get fare estimate for eligibility & distance fare
            setShowAPILoader(false);
            resetBtnRef.current.disabled = false; //Enable add leg, reset, and book after all APIs are finished
            paratransitBookBtnRef.current.disabled = false;
            addLegBtnRef.current.disabled = false;
          }
          else //All errors following invalid addresses
          {
            if(pickLatLng.current === "" && dropLatLng.current === "")
            {
              setModalHeaderText("Invalid Address Info");
              setModalBodyHTML("Trip addresses are invalid, please enter new addresses.");
              setModalFooterHTML(
                <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                  OK
                </Button>
              );
              setShowDynamicModal(true);
            }
            else if(pickLatLng.current === "")
            {
              setModalHeaderText("Invalid Address Info");
              setModalBodyHTML("Trip's pickup address is invalid, please enter a new address.");
              setModalFooterHTML(
                <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                  OK
                </Button>
              );
              setShowDynamicModal(true);
            }
            else if(dropLatLng.current === "")
            {
              setModalHeaderText("Invalid Address Info");
              setModalBodyHTML("Trip's dropoff address is invalid, please enter a new address.");
              setModalFooterHTML(
                <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                  OK
                </Button>
              );
              setShowDynamicModal(true);
            }
          }
        }  
      }
    }
    catch(err){console.log(err);}
  };

  const handleSchTimeBlur = async(e)=>{ //Triggered when user clicks/tabs out of schedule PU time/date
    try{
      let eventObj = e;
      if (eventObj.target.value !== "" && eventObj.target.value.includes(":")) { //If value is not empty, begin to validate time
        await validateMinScheduleTimeDifference(null, true);
      }
      else if(eventObj.target.name === "dateGiven" || (eventObj.target.value !== "" && eventObj.target.value.includes("-"))) //If date is changed...
      {
        if(eventObj.target.value === "") //...If it is reset to empty, show error and disable add leg/book 
        {
          setModalHeaderText("Schedule Date & Time Alert");
          setModalBodyHTML("Please enter a valid date before continuing.");
          setModalFooterHTML(
            <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
          setShowDynamicModal(true);
          addLegBtnRef.current.disabled = true;
          paratransitBookBtnRef.current.disabled = true;
          setIsTimeValidated(false);
        }
        else
        {
          //...If date is given, proceed to validation...
          let currDate = new Date(systemDateTimeRef.current.date+" 00:00:00");
          let selectedDate = new Date(eventObj.target.value + " 00:00:00");
          if((selectedDate < currDate) || (selectedDate === currDate && schTime !== "")) //...Only when given date is in the past / same as server date with time not empty
          {
            await validateMinScheduleTimeDifference(null, true);
          }
          else
          {
            if(!isTimeValidated) //If date is equal to server date and time is empty / given date is in future, skip validation
            {
              setIsTimeValidated(true);
              if(paratransitBookBtnRef.current)
              {
                addLegBtnRef.current.disabled = false;
                paratransitBookBtnRef.current.disabled = false;
              }
            }
          }
        }
      }
      else{

        if(bookBtnRef.current) //In case of microtransit time blur
        {
          if(schTime === "")
          {
            setIsTimeValidated(true);
            bookBtnRef.current.disabled = false;
          }
          else
          {
            bookBtnRef.current.disabled = true;
          }
        }
        else if(paratransitBookBtnRef.current) //In paratransit, only if certain conditions are met, skip validation
        {
          let currDate = new Date(systemDateTimeRef.current.date+" 00:00:00");
          let selectedDate = new Date(selectedDateSchTime + " 00:00:00");
          if(eventObj.target.value === "" && pickLatLng.current !== "" && dropLatLng.current !== "" && selectedDate >= currDate)
          {
            setIsTimeValidated(true);
            addLegBtnRef.current.disabled = false;
            paratransitBookBtnRef.current.disabled = false;
          }
        }
      }
    }
    catch(err){console.log(err);}
  };

  const schTimeOnClick = () => {
    try {
      if(bookBtnRef.current) //In microtransit trip, disable scheduled time if clicked until blur happens
      {
        if (!bookBtnRef.current.disabled) {
          bookBtnRef.current.disabled = true;
        }
      }
    } catch (error) {}
  };

  const schTimeOnFocus = () => {
    try {
      isValidateRCZCalledFromReset.current = false; //In microtransit trip, disable booking if PU time is focused 
      if(bookBtnRef.current)
      {
        if (!bookBtnRef.current.disabled) {
          bookBtnRef.current.disabled = true;
        }
      }
    } catch (error) { }
  };

  const clearSchTime = () => {
    try{
      setSchTime(""); //Function to reset PU time and enable booking if triggered
      let currDate = new Date(systemDateTimeRef.current.date+" 00:00:00");
      let selectedDate = (selectedDateSchTime === "" ? "" : new Date(selectedDateSchTime + " 00:00:00"));
      if(selectedDate !== "" && selectedDate >= currDate)
        setIsTimeValidated(true);
      if(bookBtnRef.current)
      {
        if(bookBtnRef.current.disabled && pickLatLng.current !== "" && dropLatLng.current !== "")
        {
          bookBtnRef.current.disabled = false;
        }
      }
      else if(paratransitBookBtnRef.current)
      {
        if(paratransitBookBtnRef.current.disabled && pickLatLng.current !== "" && dropLatLng.current !== "" && selectedDate !== "" && selectedDate >= currDate)
        {
          paratransitBookBtnRef.current.disabled = false;
          addLegBtnRef.current.disabled = false;
        }
      }
    }
    catch(err){console.log(err);}
  };

  function militaryToStandardTime(militaryTime) {
    try{
      // Split the military time into hours and minutes
      let [hour, minute] = militaryTime.split(":").map(Number);
        
      // Determine AM or PM based on the hour
      const period = hour >= 12 ? "PM" : "AM";

      // Round minutes to nearest integer
      minute = Math.round(parseInt(minute));

      // Convert hour to 12-hour format
      hour = hour % 12 || 12; // Changes 0 to 12 for midnight, keeps 12 as 12 for noon

      // Format the time as HH:MM AM/PM
      return `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")} ${period}`;
    }
    catch(err){return militaryTime;}
  };

  function toMilitaryTime(timeString) {
    try{
      // Split the time string into time and period (AM/PM)
      let [time, period] = timeString.split(" ");
      let [hours, minutes] = time.split(":").map(num => parseInt(num));
    
      // Convert to 24-hour time format
      if (period === "PM" && hours !== 12) {
        hours += 12; // Convert PM to 24-hour format
      }
      if (period === "AM" && hours === 12) {
        hours = 0; // Convert 12 AM to 00:00
      }
      let totalMinutes = hours * 60 + minutes + addedMinutesSystemSetting.current; //Adding system setting time in minutes to current time
      let newHours = Math.floor(totalMinutes/60) % 24;
      let newMinutes = totalMinutes % 60;
      // Format hours and minutes to two digits (e.g., 1:5 becomes 01:05)
      let militaryTime = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
      let timeSetting = `${String(newHours).padStart(2, "0")}:${String(newMinutes).padStart(2, "0")}`;
      return {military:militaryTime, timeWithSetting:timeSetting};
    }
    catch(err){console.log(err); return timeString;}
  };

  const getCurrentSystemDateTime = async (type = "", bChange = false) => {
    try{
      xCancelSourceForGrid.current = APICom.GenerateSource();
      let response = await APICom.fetchData("main","TripActions/GetServerDBDateTime", "post", 
        {'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
        'mode': 'no-cors'}, {}, xCancelSourceForGrid.current
      );
      // Regex to capture time and AM/PM
      const regex = /(\d{2}:\d{2})(AM|PM)$/;
      // Match the time and AM/PM
      const match = response.data.match(regex);
      if(response && response.error.length === 0 && match)
      { //server date and time is given from the API
        let systemTime = toMilitaryTime(match[1]+" "+match[2]);
        let [month, day, year] = (response.data.split(" ")[0]?.split("/") || ['','','']);
        let systemDate = year+"-"+month+"-"+day;
        if(type.toLowerCase() === "time") //Updating only time on useState systemDateTime
        {
          setSystemDateTime(prevState=>({...prevState, time:(systemTime.military)}));
          systemDateTimeRef.current = {time:(systemTime.military), date:systemDate, givenDate: response.data.split(" ")[0], 
            givenTime: response.data.split(" ")[1], timeWithSettingAdded: systemTime.timeWithSetting
          };
          if(bChange) //Only change PU time when asked in bChange
          {
            setSchTime((systemTime.military));
          }
        }
        else if(type.toLowerCase() === "date") //Updating only date on useState systemDateTime
        {
          setSystemDateTime(prevState=>({...prevState, date:systemDate}));
          systemDateTimeRef.current = {time:(systemTime.military), date:systemDate, givenDate: response.data.split(" ")[0], givenTime: response.data.split(" ")[1],
            timeWithSettingAdded: systemTime.timeWithSetting
          };
          // Get the current date
          const currentDate = new Date(systemDate+ " 00:00:00");
          // Get current year and month (formatted as YYYY-MM)
          const currentYear = currentDate.getFullYear();
          const currentMonth = String(currentDate.getMonth() + 1).padStart(2, '0'); // pad single digit months with 0
          setMinMonth(`${currentYear}-${currentMonth}`);
          // Get 5 years from now
          const futureDate = new Date();
          futureDate.setFullYear(currentDate.getFullYear() + 5);
          const futureYear = futureDate.getFullYear();
          const futureMonth = String(futureDate.getMonth() + 1).padStart(2, '0');
          setMaxMonth(`${futureYear}-${futureMonth}`);
          
          if(bChange) //Only change PU date when asked in bChange
          {
            let date = PersistStorage.retrieve("selectedDate", true);
            let [year, month, day] = (date && date.includes("-")? date.split("-").map(num => parseInt(num)) : ["", "", ""]);
            let newDate = "";
            if(year !== "")
            {
              month = String(month).padStart(2, "0");
              day = String(day).padStart(2, "0");
              newDate = `${year}-${month}-${day}`;
            }
            
            if(newDate && newDate !== "") //If stored date from D2.0 exists, replace with that, otherwise replace with server date
            {
              setSelectedDateSchTime(newDate);
            }
            else
            {
              setSelectedDateSchTime(systemDate);
            }
          }
        }
        else
        {
          setSystemDateTime({time:(systemTime.military), date:systemDate}); //Setting both date and time
          systemDateTimeRef.current = {time:(systemTime.military), date:systemDate, givenDate: response.data.split(" ")[0], givenTime: response.data.split(" ")[1]
            , timeWithSettingAdded: systemTime.timeWithSetting
          };
          if(bChange)
          {
            setSchTime((systemTime.military));
            setSelectedDateSchTime(systemDate);
          }
        }
      }
    }
    catch(err){console.log(err);}
  };

  const handleMapVSSelected = (data)=>{ //Get and set the selected VS from map into call taker data (microtransit)
    setMapVSSelected(data);
  };

  const handleMapPointSelection = (data)=>{
    if(data !== undefined && data){ //Used to get the latest address details depending on type when map is right clicked
      try {
        if(data[0].type === "PU"){
          mapPointPickupSelection.current = data;
        }
        else if(data[0].type === "DO"){
          mapPointDropoffSelection.current = data;
        }
        
      } catch (error) {}
    }
    setMapPointSelection(data);
  };

  const handleCancelTrip = async(confirmation, type="dispatchTrip")=>{
    try{
      setShowAPILoader(true); //Cancel a trip based on certain conditions and given data
      let data = {
        "ConfirmatinoNo": String(confirmation),
        "TripID": "-1",
        "Status": "Cancelled",
        "Message": "Cancelled by Agent",
        "iModifiedbyAppId": 26,
        "iModifiedByUID": parseInt(loginData.iUserID)
      };
      let response = await APICom.fetchData("ReservationCoreURL","SubmitTripConfirmation", "post", {}, data, xCancelSourceForGrid.current);
      setShowAPILoader(false);
      if(!type.toLowerCase().includes("active"))
      {
        if(response && parseInt(response.data.responseCode) !== 200) //For any other trip besides active, only show error if exists
        {
          handleResetAll("func");
          setModalHeaderText("Cancel Trip Error");
          setModalBodyHTML("An issue occured while cancelling the trip, please try again later.");
          setModalFooterHTML(
            <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
          setShowDynamicModal(true);
        }
      }
      else
      { //Active trip cancellation confirmation along with errors if any
        if(response && parseInt(response.data.responseCode) !== 200)
        {
          setModalHeaderText("Cancel Trip Error");
          setModalBodyHTML("An issue occured while cancelling the trip, please try again later.");
          setModalFooterHTML(
            <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
          setShowDynamicModal(true);
        }
        else if(parseInt(response.data.responseCode) === 200)
        {
          setModalHeaderText("Trip Cancelled Successfully");
          setModalBodyHTML("Trip #"+confirmation+" is cancelled.");
          setModalFooterHTML(
            <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
          let filteredData = ActiveTripsTableData.filter((item)=>{
            return String(item.iRefId) !== String(confirmation);
          }); //Removing cancelled trip from active trips table

          setActiveTripsTableData(filteredData);
          setShowDynamicModal(true);
          setActiveTripConfirmation("");
        }
      }
    }
    catch(err){console.log(err);}
  };

  const handleRemoveRecord = (e)=>{
    try{
      let mtsmConfirmationNumList = PersistStorage.retrieve("confirmationsData", false);
      
      const updatedList = mtsmConfirmationNumList.filter(item=>{
        return item.Confirmation !== e.target.name;
      }); //Removes microtransit record from the MTSM, essentially hiding it from view of agents but not cancelling
      PersistStorage.save("confirmationsData", updatedList, 999, false);
    }
    catch(err){console.log(err);}
  };

  const handleRejectConfirmation = (e)=>{
    try{
      let eventType = e.target.getAttribute('data-name');
      let Type = "";
      if(eventType && eventType.toLowerCase() === 'cancel') //Determining the type of cancellation before initiating API
      {
        Type = "Cancel";
      }
      else
      {
        Type = "Reject";
      }
      setModalHeaderText(Type+" Trip Confirmation"); //Asking for confirmation before proceeding
      setModalBodyHTML(
        <>
          <p className="m-0 user-select-none">
            {"Are you sure to "}{Type.toLowerCase()}{" the trip with following confirmation#?"} 
          </p>
          <p className="m-0 w-100 fw-bold text-center user-select-none">{e.target.name}</p>
        </>
      );
      setModalFooterHTML(
        <>
          <Button variant='dark' name={e.target.name} data-name={eventType} className="border-0" onClick={handleRejectTrip}>
            Yes
          </Button>
          <Button variant='secondary' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
            No
          </Button>
        </>
      );
      setShowDynamicModal(true);
    }
    catch(err){console.log(err);}
  };

  const handleRejectTrip = async(e)=>{
    try{
      setShowDynamicModal(false); //Performing cancellation/rejection depending on the type
      setShowAPILoader(true);
      let mtsmConfirmationNumList = PersistStorage.retrieve("confirmationsData", false);
      let cancelType = e.target.getAttribute('data-name');
      let data = {
        "ConfirmatinoNo": String((e.target.name)),
        "TripID": "-1",
        "Status": "Cancelled",
        "Message": (cancelType && cancelType.toLowerCase() === "cancel") ? "Cancelled while booking" : "Cancelled by Agent",
        "iModifiedbyAppId": 26,
        "iModifiedByUID": parseInt(loginData.iUserID)
      };
      let response = await APICom.fetchData("ReservationCoreURL","SubmitTripConfirmation", "post", {}, data, xCancelSourceForGrid.current);

      setShowAPILoader(false);
      if(response && parseInt(response.data.responseCode) === 200)
      {
        if(cancelType && cancelType.toLowerCase() === "cancel")
        {
          for(let l = 0; l < mtsmConfirmationNumList.length; l++)
          {
            if(String(mtsmConfirmationNumList[l].Confirmation) === String(e.target.name))
            {
              mtsmConfirmationNumList[l].time = "N/A";
              mtsmConfirmationNumList[l].dropTime = "N/A";
              mtsmConfirmationNumList[l].msg = "Cancelled by Agent";
            }
          }
          PersistStorage.save('confirmationsData', mtsmConfirmationNumList, 999, false);
        }
        else if(cancelType.toLowerCase() === "reject")
        {
          for(let l = 0; l < mtsmConfirmationNumList.length; l++)
          {
            if(String(mtsmConfirmationNumList[l].Confirmation) === String(e.target.name))
            {
              mtsmConfirmationNumList[l].time = "N/A";
              mtsmConfirmationNumList[l].dropTime = "N/A";
              mtsmConfirmationNumList[l].msg = "Proposed time rejected by the customer";
            }
          }
          PersistStorage.save('confirmationsData', mtsmConfirmationNumList, 999, false);
        }
      }
      else
      {
        for(let l = 0; l < mtsmConfirmationNumList.length; l++)
        {
          if(String(mtsmConfirmationNumList[l].Confirmation) === String((e.target.name)))
          {
            mtsmConfirmationNumList[l].time = "N/A";
            mtsmConfirmationNumList[l].dropTime = "N/A";
            mtsmConfirmationNumList[l].msg = "Cancellation has failed, please try again";
          }
        }
        PersistStorage.save('confirmationsData', mtsmConfirmationNumList, 999, false);
      }
    }
    catch(err){console.log(err);}
  };

  function findDaysInRange(from, to, dayIndex) {
    try{
      const startDate = new Date(from+"T00:00:00"); //Function related to update trip, gets all days in given range of edit API data
      const endDate = new Date(to+"T00:00:00");
      const daysInRange = [];
    
      // Adjust for time portion, setting both to the start of their respective days
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(0, 0, 0, 0);
      let alignedDateStart = new Date(startDate)
      while (alignedDateStart.getDay() !== dayIndex) {
        alignedDateStart.setDate(alignedDateStart.getDate() + 1); // Move one day forward
      }
      // Iterate through the date range
      for (let currentDate = new Date(alignedDateStart); currentDate <= endDate; currentDate.setDate(currentDate.getDate() + 7)) {
        const formattedDate = 
          ((currentDate.getMonth() + 1).toString().padStart(2, '0') + '/' + 
          currentDate.getDate().toString().padStart(2, '0') + '/' + 
          currentDate.getFullYear()
        );
        daysInRange.push(formattedDate);
      }
    
      return daysInRange;
    }
    catch(err){console.log(err); return "N/A"}
  }

  const handleEditTrip = async(rowDataEdit, type = "", copy = false) => {
    try{
      let tempData = [];
      if(type === "API")
      { //If taken from active trips instead of D2.0 edit trip API, request for edit needs to run again
        let data = {
          "refID": (parseInt(rowDataEdit[0].iRefId)),
          "serviceID": (parseInt(rowDataEdit[0].iServiceID) ?  parseInt(rowDataEdit[0].iServiceID) : 0),
          "scheduleID": (parseInt(rowDataEdit[0].ScheduleID) ?  parseInt(rowDataEdit[0].ScheduleID) : 0),
          "isSchedule": (rowDataEdit[0].TableSource.toLowerCase().includes("ondemand") ? true:false),
          "requestType": (rowDataEdit[0].TableSource.toLowerCase().includes("ondemand") ? "On Demand":"Time Call")
        };
        let response = await APICom.fetchData("ReservationCoreURL","api/ParatransitCT/GetRequestForEdit", "post", { "Content-Type": "application/json" }, data, null);

        if(response && response.error === "")
        {
          if(response.data && response.data !== "No data found")
          {
            tempData = response.data;
            setActiveTripSelected(true);
          }
          else
          {
            setModalHeaderText("Edit Info Error");
            setModalBodyHTML("No data was found for the selected trip. Please contact the administrator for additional details.");
            setModalFooterHTML(
              <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}> 
                OK
              </Button>
            );
            setShowDynamicModal(true);
            PersistStorage.save("rowDataEditTrip", "", 999, true);
            tempData = "";
            return 0;
          }
        }
        else
        {
          setModalHeaderText("Edit Info Error");
          setModalBodyHTML(<b>{response.error}</b>);
          setModalFooterHTML(
            <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
          setShowDynamicModal(true);
          PersistStorage.save("rowDataEditTrip", "", 999, true);
          return 0;
        }
      }
      let editRowData = (type === "API" ? tempData : rowDataEdit); //Set accurate data to be used for populated fields on call taker 2.0
      if(editRowData && editRowData !== "" && typeof editRowData === 'object') //Proceed only when data is not invalid
      {
        PersistStorage.save("rowDataEditTrip", editRowData, 999, true);
        if(bookBtnRef.current)
        {
          if(copy)
            setSubmitBtnTitle("Book"); //If an active trip is being copied, dont make it update
          else
            setSubmitBtnTitle("Update");
        }
        else
        {
          if(copy)
            setSubmitParatransitBtnTitle("Book");
          else
            setSubmitParatransitBtnTitle("Update");
        }
        PersistStorage.save("clientInfo", editRowData, 99, true);
        let tripData = null;
        let selectedConfirmationNo = ""
        if(Array.isArray(rowDataEdit)) //if from active trips
        {
          selectedConfirmationNo = parseInt(rowDataEdit[0].iRefId);
          for(let k = 0; k < editRowData.addressInfo.trips.length; k++)
          {
            if(parseInt(rowDataEdit[0].iRefId) === parseInt(editRowData.addressInfo.trips[k].details[0].tripInfo.refID))
            {
              tripData = editRowData.addressInfo.trips[k];
            }
          }
        }
        else //from main grid trips d 2.0
        {
          selectedConfirmationNo = parseInt(rowData.current[0].iRefID);
          for(let k = 0; k < editRowData.addressInfo.trips.length; k++)
          {
            if(parseInt(rowData.current[0].iRefID) === parseInt(editRowData.addressInfo.trips[k].details[0].tripInfo.refID))
            {
              tripData = editRowData.addressInfo.trips[k];
            }
          }
        }

        tripData = (tripData ? tripData : editRowData.addressInfo.trips[0]); //Getting accurate addressInfo details for populating data
        // handleCancelTrip(rowData.current[0].ConfirmationNo); //Cancel commented out 9/17/24
        setConfirmationNo(tripData.details[0].tripInfo.refID);
        if(editRowData.scheduleInfo && editRowData.scheduleInfo.scheduleItem && editRowData.scheduleInfo.scheduleItem.length > 0) //In case of multischedule trips...
        { //Building main data dict of multischedule along with displayed data dict
          let mainDataDict = { 
            MultiScheduleIdentifier: null, 
            vPreSch: (tripData.details[0].tripInfo.preSchedule ? tripData.details[0].tripInfo.preSchedule : ""),
            Exclusions: (editRowData.exclusions ? editRowData.exclusions : [])
          };
          let scheduleItemsArr = [];
          let daysArr = ["N/A", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
          let displayedDataArr = [];
          // Use a Set to track added dates
          const uniqueDates = new Set();
          for(let j = 0; j < editRowData.scheduleInfo.scheduleItem.length; j++)
          {
            let scheduleInfo = editRowData.scheduleInfo.scheduleItem[j];
            scheduleItemsArr.push({
              dayName: (scheduleInfo.dayName !== ""? scheduleInfo.dayName : daysArr[(scheduleInfo.dayNumber)]),
              dayNumber: scheduleInfo.dayNumber,
              startTime: scheduleInfo.startTime,
              apptTime: scheduleInfo.apptTime,
              endTime: scheduleInfo.endTime,
              bApptTime: scheduleInfo.bApptTime,
              willcall: scheduleInfo.willcall,
              breturnleg: scheduleInfo.breturnleg,
              _returnmultischedule: {
                dayName: scheduleInfo["_returnmultischedule"].dayName,
                dayNumber: scheduleInfo["_returnmultischedule"].dayNumber,
                startTime: scheduleInfo["_returnmultischedule"].startTime,
                endTime: scheduleInfo["_returnmultischedule"].endTime,
                apptTime: scheduleInfo["_returnmultischedule"].apptTime,
                bApptTime: scheduleInfo["_returnmultischedule"].bApptTime,
                willcall: scheduleInfo["_returnmultischedule"].willcall,
                _returnmultischedule: scheduleInfo["_returnmultischedule"]._returnmultischedule,
                breturnleg: scheduleInfo.breturnleg,
              }
            });
            let dateVal = (scheduleInfo.breturnleg ? 
              (scheduleInfo["_returnmultischedule"].startTime.includes("1900") ? scheduleInfo.startTime.split("T")[0] : 
              scheduleInfo["_returnmultischedule"].startTime.split("T")[0]) : scheduleInfo.startTime.split("T")[0]
            );
            let newDateVal = dateVal.split("-")[1]+"/"+dateVal.split("-")[2]+"/"+dateVal.split("-")[0];
            let PUtimeVal = (scheduleInfo.startTime && scheduleInfo.startTime.split("T")[1] !== "00:00:00"? scheduleInfo.startTime.split("T")[1]:"09:00");
            let apptTime = (scheduleInfo.apptTime && scheduleInfo.apptTime.split("T")[1] !== "00:00:00"? scheduleInfo.apptTime.split("T")[1]:"");
            let returnApptTime = (scheduleInfo._returnmultischedule.apptTime && scheduleInfo._returnmultischedule.apptTime.split("T")[1] !== "00:00:00"? 
              scheduleInfo._returnmultischedule.apptTime.split("T")[1]:"");
            let returnTime = (scheduleInfo._returnmultischedule.startTime && scheduleInfo._returnmultischedule.startTime.split("T")[1] !== "00:00:00"? 
            scheduleInfo._returnmultischedule.startTime.split("T")[1]:"09:00");
            let isDateExcluded = (editRowData.exclusions && editRowData.exclusions.length > 0 ? 
              editRowData.exclusions.some(item=>{return item.exclusionDate.includes(dateVal);}) : false);

            let dayIndex = 0;
            if(daysArr[scheduleInfo.dayNumber] === "Sunday")
            {
              dayIndex = 0;
            }
            else if(daysArr[scheduleInfo.dayNumber] === "Monday")
            {
              dayIndex = 1;
            }
            else if(daysArr[scheduleInfo.dayNumber] === "Tuesday")
            {
              dayIndex = 2;
            }
            else if(daysArr[scheduleInfo.dayNumber] === "Wednesday")
            {
              dayIndex = 3;
            }
            else if(daysArr[scheduleInfo.dayNumber] === "Thursday")
            {
              dayIndex = 4;
            }
            else if(daysArr[scheduleInfo.dayNumber] === "Friday")
            {
              dayIndex = 5;
            }
            else if(daysArr[scheduleInfo.dayNumber] === "Saturday")
            {
              dayIndex = 6;
            }
            let days = (editRowData.scheduleInfo.to && editRowData.scheduleInfo.to.includes("1900") ? 
              findDaysInRange(editRowData.scheduleInfo.from.split("T")[0], editRowData.scheduleInfo.infinitetodate.split("T")[0], dayIndex) : 
              findDaysInRange(editRowData.scheduleInfo.from.split("T")[0], editRowData.scheduleInfo.to.split("T")[0], dayIndex)
            );

            if(days.length > 0)
            {
             
              days.forEach(day => {
                let tempDate = day.split("/")[2]+"-"+day.split("/")[0]+"-"+day.split("/")[1];
                if(!uniqueDates.has(day))
                {
                  uniqueDates.add(day);
                  isDateExcluded = (editRowData.exclusions && editRowData.exclusions.length > 0 ? 
                    editRowData.exclusions.some(item=>{return item.exclusionDate.includes(tempDate);}) 
                    : false
                  );
                  displayedDataArr.push({
                    Day: daysArr[scheduleInfo.dayNumber], // Assuming `day` is the index of the day in `daysArr`
                    Date: day, // Use appropriate date format for each `day` from `days` array
                    Checked: true,
                    WillCall: scheduleInfo.willcall,
                    Appt: apptTime,
                    PUTime: PUtimeVal,
                    isReturnTrip: scheduleInfo.breturnleg ? scheduleInfo.breturnleg : false,
                    ReturnWillCall: scheduleInfo._returnmultischedule.willcall ? scheduleInfo._returnmultischedule.willcall : false,
                    ReturnAppt: returnApptTime,
                    ReturnTime: returnTime,
                    schType: isDateExcluded ? "exc" : "sch",
                    isHoliday: false
                  });
                }
              });
              
            }
            else
            {
              displayedDataArr.push({
                Day:daysArr[scheduleInfo.dayNumber], Date:newDateVal, Checked:true, WillCall:scheduleInfo.willcall, Appt:apptTime, PUTime:PUtimeVal, 
                isReturnTrip:(scheduleInfo.breturnleg? scheduleInfo.breturnleg: false), 
                ReturnWillCall:(scheduleInfo._returnmultischedule.willcall? scheduleInfo._returnmultischedule.willcall: false), 
                ReturnAppt:returnApptTime, ReturnTime:returnTime, schType:(isDateExcluded ? "exc":"sch"), 
                isHoliday:false
              });
            }
            
          }
          displayedDataArr.sort((a, b) => {
            let correctDateA = (a.Date.split('/')[2] +"-"+ a.Date.split('/')[0] +"-"+ a.Date.split('/')[1]);
            let correctDateB = (b.Date.split('/')[2] +"-"+ b.Date.split('/')[0] +"-"+ b.Date.split('/')[1]);
            const dateA = new Date(correctDateA+" 00:00:00"); 
            const dateB = new Date(correctDateB+" 00:00:00");
            return dateB - dateA; // Sort latest to earliest
          });
          mainDataDict = {...mainDataDict, Schedule:{
            from: editRowData.scheduleInfo.from, 
            to: editRowData.scheduleInfo.to, 
            infinitetodate: editRowData.scheduleInfo.infinitetodate,
            ScheduleItem: scheduleItemsArr}
          };
          
          let managedData = [
            {Day:"Sunday", Date:"", Checked:false, WillCall:false, Appt:"", PUTime:"09:00", isReturnTrip:false, ReturnWillCall:false, ReturnAppt:"", ReturnTime:"09:00", schType:"sch", isHoliday:false},
            {Day:"Monday", Date:"", Checked:false, WillCall:false, Appt:"", PUTime:"09:00", isReturnTrip:false, ReturnWillCall:false, ReturnAppt:"", ReturnTime:"09:00", schType:"sch", isHoliday:false},
            {Day:"Tuesday", Date:"", Checked:false, WillCall:false, Appt:"", PUTime:"09:00", isReturnTrip:false, ReturnWillCall:false, ReturnAppt:"", ReturnTime:"09:00", schType:"sch", isHoliday:false},
            {Day:"Wednesday", Date:"", Checked:false, WillCall:false, Appt:"", PUTime:"09:00", isReturnTrip:false, ReturnWillCall:false, ReturnAppt:"", ReturnTime:"09:00", schType:"sch", isHoliday:false},
            {Day:"Thursday", Date:"", Checked:false, WillCall:false, Appt:"", PUTime:"09:00", isReturnTrip:false, ReturnWillCall:false, ReturnAppt:"", ReturnTime:"09:00", schType:"sch", isHoliday:false},
            {Day:"Friday", Date:"", Checked:false, WillCall:false, Appt:"", PUTime:"09:00", isReturnTrip:false, ReturnWillCall:false, ReturnAppt:"", ReturnTime:"09:00", schType:"sch", isHoliday:false},
            {Day:"Saturday", Date:"", Checked:false, WillCall:false, Appt:"", PUTime:"09:00", isReturnTrip:false, ReturnWillCall:false, ReturnAppt:"", ReturnTime:"09:00", schType:"sch", isHoliday:false}
          ];
          
          let updatedManagedData = managedData.map(item => {
            const matchedDay = displayedDataArr.find(displayedDay => displayedDay.Day === item.Day);
            return (matchedDay ? matchedDay : item)
          });
          
          if(editRowData.scheduleInfo.to && editRowData.scheduleInfo.to.includes("1900")) //never expire = true
          {
            setScheduleJSON(
              { 
                mainData: mainDataDict, 
                multiSchData:{managed:updatedManagedData, displayed:displayedDataArr}, 
                range: {
                  from: editRowData.scheduleInfo.from.split("T")[0], 
                  to: editRowData.scheduleInfo.infinitetodate.split("T")[0]
                }, 
                neverExpire:true
              }
            );
          }
          else //never expire = false
          {
            setScheduleJSON(
              {
                mainData: mainDataDict, 
                multiSchData: {managed:updatedManagedData, displayed:displayedDataArr}, 
                range: {
                  from: editRowData.scheduleInfo.from.split("T")[0], 
                  to: editRowData.scheduleInfo.to.split("T")[0]
                }, 
                neverExpire:false
              }
            );
          }
          
        }

        let attrSelection = AttributeData ? AttributeData.filter((item,index)=> {return parseInt(item.iAttrATSPID) === parseInt(editRowData.generalInfo.requestAffiliateID)}) : [];
        let attrOptionsMultiSel = attrSelection && attrSelection.length > 0 ? attrSelection.map((item)=>{
          let dict = {};
          dict.id = item.ID;
          dict.name = item.Title;
          return dict;
        }).sort((a, b) => a.name.localeCompare(b.name)) : [];
        let providedAttrArray = tripData.details[0].tripInfo.entityAttributes;
        let groupSelected = [];
        for(let k = 0; k < attrOptionsMultiSel.length; k++)
        {
          if(providedAttrArray.includes(String(attrOptionsMultiSel[k].id)))
          {
            groupSelected.push({id:attrOptionsMultiSel[k].id, name:attrOptionsMultiSel[k].name});
          }
        }
        SetAttributesFilterMultiSelect({ ...AttributesFilterMultiSelect, ...{options: attrOptionsMultiSel,
          selectedValues:(tripData.details[0].tripInfo.entityAttributes.length !== 0 ? groupSelected : [])}}
        ); //Getting the correct attributes auto-selected (if any) 
        let attributesDesc = (tripData.details[0].tripInfo.entityAttributes ? (tripData.details[0].tripInfo.entityAttributes.split(",").map((num) => parseInt(num.trim(), 10)).filter((num) => !isNaN(num)) ) : []);
        setSelectedTripAttr(attributesDesc);
        setSelectedTripType(tripData.details[0].tripInfo.callType);
        addressInfoDetails.current.pick = {city: tripData.details[0].addressDetails.city, state: tripData.details[0].addressDetails.state, zip: tripData.details[0].addressDetails.zip};
        if(tripData.details.length === 2)
        {
          addressInfoDetails.current.drop = {city: tripData.details[1].addressDetails.city, state: tripData.details[1].addressDetails.state, zip: tripData.details[1].addressDetails.zip};
        }
        else
        {
          let dataLength = tripData.details.length;
          let dropData = tripData.details[(dataLength - 1)];
          addressInfoDetails.current.drop = {city: dropData.addressDetails.city, state: dropData.addressDetails.state, zip: dropData.addressDetails.zip};
        }
        if(tripData.details[0].dateInfo.pickupDate.toLowerCase() !== "will call")
        {
          let timeTemp = ((typeof tripData.details[0].dateInfo.pickupDate === 'string' && 
            tripData.details[0].dateInfo.pickupDate.includes("T") && 
            tripData.details[0].dateInfo.pickupDate.split("T")[1] !== "00:00:00") ?
            tripData.details[0].dateInfo.pickupDate.split("T")[1] : ""
          );
          let timeParts = (timeTemp !== "" ? timeTemp.split(":") : "");

          setSchTime((timeParts !== ""? `${timeParts[0]}:${timeParts[1]}`:""));
        }
        //Method to identify if the trip is will call from given data:
        const date1 = (tripData.details[0].dateInfo.isWillCall && 
          tripData.details[0].dateInfo.willCallDay !== ""? 
          new Date(tripData.details[0].dateInfo.willCallDay) : new Date("1900-01-01T00:00:00"));
        const date2 = new Date("2000-01-01T00:00:00"); 
        if(date1 > date2 && (tripData.details[0].dateInfo.pickupDate && tripData.details[0].dateInfo.pickupDate === "1900-01-01T00:00:00"))
        {
          setWillCall(true);
        }
        else
        {
          setWillCall(false);
        }
        let date = (tripData.details[0].dateInfo.isWillCall ? (tripData.details[0].dateInfo.willCallDay.includes("T") 
        ? tripData.details[0].dateInfo.willCallDay.split("T")[0] : tripData.details[0].dateInfo.willCallDay.split(" ")[0])
        :(tripData.details[0].dateInfo.pickupDate.includes("1900") ? editRowData.scheduleInfo.from.split("T")[0]:(tripData.details[0].dateInfo.pickupDate.includes("T") ? 
        tripData.details[0].dateInfo.pickupDate.split("T")[0] : tripData.details[0].dateInfo.pickupDate.split(" ")[0])));
        setSelectedDateSchTime(date);
        setAppointmentTime((typeof tripData.details[0].dateInfo.apptTime === 'string' 
          && tripData.details[0].dateInfo.apptTime.includes("T") && 
          tripData.details[0].dateInfo.apptTime.split("T")[1] !== "00:00:00" ? 
          tripData.details[0].dateInfo.apptTime.split("T")[1]:""));
        setTripStatus((tripData.details[0].tripInfo.virtualRoute === ""?"Un-Routed":"Routed"));
        setSelectedVehType((tripData.details[0].vehicleInfo.vehicleTypeId === -1 || 
          tripData.details[0].vehicleInfo.vehicleTypeId === 0 ? "VT" : 
          parseInt(tripData.details[0].vehicleInfo.vehicleTypeId))
        );
        //Setting the insurance and additional details and communication methods
        setClientSummary(prevState=>({...prevState, totalCalls:0, totalNS:0, 
          totalCancels:0, lastCall:"",
          tripDistance:tripData.details[0].estimatedInfo.estimatedDistance, TripDuration:tripData.details[0].estimatedInfo.estimatedTime, TripFare:tripData.details[0].estimatedInfo.estimatedCost, 
          TripCopay:tripData.details[0].estimatedInfo.coPay
        }));
        setMedID((editRowData.riderInfo.riderID ? editRowData.riderInfo.riderID : "")); //Rider ID/Medical ID
        setInsuranceName(editRowData.riderInfo.firstName.trim()); 
        setInsuranceSSN(0); 
        setAccountNumber(editRowData.riderInfo.id);
        setInsuranceAuthCode(0); 
        setCopayAmount(tripData.details[0].estimatedInfo.coPay);
        setClientJob((tripData.details[0].tripInfo.ext2 && tripData.details[0].tripInfo.ext2 !== "" ? tripData.details[0].tripInfo.ext2 : ""));
        setClientEmail(tripData.details[0].tripInfo.customerEmail);
        setRCType({phoneType:tripData.details[0].tripInfo.isRollingCallTypePhone, emailType:tripData.details[0].tripInfo.isRollingCallTypeEmail, SMSType:tripData.details[0].tripInfo.isRollingCallTypeSMS});
        setRiderName(editRowData.riderInfo.firstName);
        setPaymentAdditionalInfo(tripData.details[0].tripInfo.extraInfo);
        setPhone(("+1"+editRowData.riderInfo.phoneNo.replaceAll("-","")));
        phoneRef.current.disabled = true;
        clientNameCheckRef.current.disabled = true;
        if(tripData.details[0].tripInfo.callBackInfo !== "")
        {
          setCallBackPhone(("+1"+tripData.details[0].tripInfo.callBackInfo.replaceAll("-","")));
        }
        let ambulatoryPassCount = parseInt(tripData.details[0].passengerInfo.totalPassengers) - parseInt(tripData.details[0].passengerInfo.totalWheelChairs);
        setPassengerTypeCount({ambPass: ambulatoryPassCount, totalWC: parseInt(tripData.details[0].passengerInfo.totalWheelChairs), 
          totalSA: parseInt(tripData.details[0].passengerInfo.serviceAnimalCount), total:parseInt(tripData.details[0].passengerInfo.totalPassengers)
        });
        //Setting address data accordingly
        setPickupAddr(tripData.details[0].addressDetails.address + ", " + tripData.details[0].addressDetails.city + ", " + tripData.details[0].addressDetails.state + " " + tripData.details[0].addressDetails.zip);
        let editAddressData = tripData.details;
        let lastTripData = (tripData.details[1].stopType === "dropoff" ? tripData.details[1] : tripData.details[(editAddressData.length - 1)]);
        setDropAddr(lastTripData.addressDetails.address + ", " + lastTripData.addressDetails.city + ", " + lastTripData.addressDetails.state + " " + lastTripData.addressDetails.zip);
        dropLatLng.current = lastTripData.addressDetails.latitude && parseFloat(lastTripData.addressDetails.latitude) !== 0? lastTripData.addressDetails.latitude+","+lastTripData.addressDetails.longitude:"";
        pickLatLng.current = tripData.details[0].addressDetails.latitude && parseFloat(tripData.details[0].addressDetails.longitude) !== 0? tripData.details[0].addressDetails.latitude+","+tripData.details[0].addressDetails.longitude:"";
        
        setPickExtraInfo(tripData.details[0].addressDetails.remarks);
        setDropExtraInfo(lastTripData.addressDetails.remarks);
        setPickPOI(tripData.details[0].addressDetails.poiName); //POI set if any
        setDropPOI(lastTripData.addressDetails.poiName);
        setMobilityChecks({vehTypeCheck:tripData.details[0].vehicleInfo.onlyPreferedVType, vehNumCheck:tripData.details[0].vehicleInfo.onlyPreferedVehicle, 
          driverNumCheck:tripData.details[0].driverInfo.onlyPreferedDriver, genderCheck:tripData.details[0].driverInfo.onlyPreferedDriverGender, languageCheck:tripData.details[0].driverInfo.onlyPreferedDriverLanguage});
        setMobilityDetails({totalVeh:1, vehTypeMin:0, vehNumMin:tripData.details[0].vehicleInfo.vehicleNoTimeDiff, driverNumMin:tripData.details[0].driverInfo.driverNoTimeDiff, genderMin:tripData.details[0].driverInfo.genderTimeDiff, languageMin:tripData.details[0].driverInfo.langTimeDiff});
        setSelectedGender((tripData.details[0].driverInfo.preferedDriverGender && tripData.details[0].driverInfo.preferedDriverGender !== ""? tripData.details[0].driverInfo.preferedDriverGender:"Gender"));
        setSelectedLanguage((tripData.details[0].driverInfo.preferedLanguage && tripData.details[0].driverInfo.preferedLanguage !== ""? tripData.details[0].driverInfo.preferedLanguage:"Language"));
        let tripLatLng = []; 
        if(pickLatLng.current !== "" && dropLatLng.current !== "")
        {
          tripLatLng.push(
            {lat:parseFloat(pickLatLng.current.split(",")[0]),
              lng: parseFloat(pickLatLng.current.split(",")[1]), Type:"PU", 
              name:(editRowData.riderInfo.firstName), address: (tripData.details[0].addressDetails.address + ", " + tripData.details[0].addressDetails.city + ", " + tripData.details[0].addressDetails.state + " " + tripData.details[0].addressDetails.zip)
            },
            {lat:parseFloat(dropLatLng.current.split(",")[0]),
              lng: parseFloat(dropLatLng.current.split(",")[1]), Type:"DO", 
              name:(editRowData.riderInfo.firstName), address: (lastTripData.addressDetails.address + ", " + lastTripData.addressDetails.city + ", " + lastTripData.addressDetails.state + " " + lastTripData.addressDetails.zip)
            },
          ); //Setting details for map markers
        }
        let discoveredID = 0;
        if(editRowData.addressInfo.trips.length > 1) //In case of multi-trip, save and show correctly selected trip to user on stop order
        {
          let tripDetail = editRowData.addressInfo.trips;
          let stopOrderArr = [];
          let stopDetailsTrackerArr = [];
          for(let k = 0; k < tripDetail.length; k++)
          {
            stopDetailsTrackerArr.push(
              {
                stopNo:(k+1), 
                distance: tripDetail[k].details[0].estimatedInfo.estimatedDistance,
                duration: tripDetail[k].details[1].estimatedInfo.estimatedDistance
              }
            );
          }
          for(let i = 0; i < tripDetail.length; i++)
          {
            let pickData = tripDetail[i].details[0];
            let dropData = (tripDetail[i].details.length === 2 ? tripDetail[i].details[1] : tripDetail[i].details[(tripDetail[i].details.length - 1)]);
            let pickAddress = pickData.addressDetails.address + ", "+ pickData.addressDetails.city + ", " + pickData.addressDetails.state + " " + pickData.addressDetails.zip;
            let dropAddress = dropData.addressDetails.address + ", "+ dropData.addressDetails.city + ", " + dropData.addressDetails.state + " " + dropData.addressDetails.zip;
            let dateGiven = (pickData.dateInfo.isWillCall ? pickData.dateInfo.willCallDay.split("T")[0] : formatDate(pickData.dateInfo.pickupDate.split("T")[0]));
            let timeGiven = (pickData.dateInfo.isWillCall ? "Will Call" : pickData.dateInfo.pickupDate.split("T")[1]);
            let correctDate = (dateGiven.includes("-") ? formatDate(dateGiven) : dateGiven);
            let ambulatoryPassCount = parseInt(pickData.passengerInfo.totalPassengers) - parseInt(pickData.passengerInfo.totalWheelChairs);
            let fareEstimateDataDict = {copay: (pickData.paymentInfo.CopayPrice && pickData.paymentInfo.CopayPrice !== ""? parseInt(pickData.paymentInfo.CopayPrice) : 0), 
              walletID: (pickData.tripInfo.selfWalletID && pickData.tripInfo.selfWalletID !== ""? parseInt(pickData.tripInfo.selfWalletID) : 0), 
              promo: (pickData.tripInfo.Promocode || ""), eaasJSON: (pickData.tripInfo.EaasJSONResp || ""), displayMessage: "", verifyStatus: ""
            };
            let attributesDesc = (pickData.tripInfo.entityAttributes ? (pickData.tripInfo.entityAttributes.split(",").map((num) => parseInt(num.trim(), 10)).filter((num) => !isNaN(num)) ) : []);
            let brokerDict = {brokerMode: (pickData.tripInfo.FSBrokerMode || 0) , globalBrokerMode: (pickData.tripInfo.BrokerMode || 0)};
            let addressExtraDetailsVal = {pick: {state:pickData.addressDetails.state, city: pickData.addressDetails.city, zip: pickData.addressDetails.zip}, 
              drop: {state:dropData.addressDetails.state, city:dropData.addressDetails.city, zip:dropData.addressDetails.zip}};
            stopOrderArr.push({pickAddr: pickAddress, dropAddr: dropAddress, pickPOI: pickData.addressDetails.poiName, dropPOI: dropData.addressDetails.poiName,
                date: correctDate, email: pickData.tripInfo.customerEmail,
                time: timeGiven, distance: pickData.estimatedInfo.estimatedDistance, duration: pickData.estimatedInfo.estimatedTime, fare: pickData.estimatedInfo.estimatedCost, 
                copay: pickData.estimatedInfo.coPay, willCall: pickData.dateInfo.isWillCall, 
                apptTime: (pickData.dateInfo.isWillCall? "Will Call":(!pickData.dateInfo.apptTime.includes("1900")? pickData.dateInfo.apptTime.split("T")[1] : "")), 
                notes: pickData.tripInfo.agentInstructions, phone: editRowData.riderInfo.phoneNo, 
                puNotes: pickData.addressDetails.remarks, doNotes: dropData.addressDetails.remarks, riderName: editRowData.riderInfo.firstName, 
                passCount: {ambPass:ambulatoryPassCount,totalWC:pickData.passengerInfo.totalWheelChairs,
                  totalSA:pickData.passengerInfo.serviceAnimalCount, total:pickData.passengerInfo.totalPassengers}, callBackPhone: (pickData.tripInfo.callBackInfo.includes("-")? ("+1"+pickData.tripInfo.callBackInfo.replaceAll("-","")) : pickData.tripInfo.callBackInfo),
                waitTime: "", stops:[], isReturn: pickData.tripInfo.returnTrip, pickLatLng: (pickData.addressDetails.latitude+","+pickData.addressDetails.longitude), 
                dropLatLng: (dropData.addressDetails.latitude+","+dropData.addressDetails.longitude),
                stopsDetails: stopDetailsTrackerArr, addressExtraDetails: addressExtraDetailsVal, id: editRowData.riderInfo.id, 
                clientMedID: editRowData.riderInfo.medicalID, paymentExtraInfo: pickData.tripInfo.extraInfo, clientJob: pickData.tripInfo.ext2,
                clientAddr: editRowData.riderInfo.clientAddress, clientCity: editRowData.riderInfo.clientCity, clientState: editRowData.riderInfo.clientState, 
                clientZip: editRowData.riderInfo.clientZip, fareZones: {pickFareZone:pickData.addressDetails.fareZone, dropFareZone:dropData.addressDetails.fareZone}, 
                dispatchZones: {pickZone: pickData.addressDetails.zone, dropZone: dropData.addressDetails.zone},
                FundingSource: pickData.paymentInfo.fundingSourceID, PaymentSelected: pickData.paymentInfo.paymentTypeID, 
                AffiliateSelected: editRowData.generalInfo.requestAffiliateID, COS: pickData.tripInfo.classOfServiceID, 
                vehType: (pickData.vehicleInfo.vehicleTypeId && pickData.vehicleInfo.vehicleTypeId !== -1 ? pickData.vehicleInfo.vehicleTypeId : "VT"), 
                vehTypeCheck: pickData.vehicleInfo.onlyPreferedVType, vehTypeMins: 0,
                cardNum: (pickData.paymentInfo.ccInfo.includes(",")? pickData.paymentInfo.ccInfo.split(",")[0] : ""), 
                cardExp: (pickData.paymentInfo.ccInfo.includes(",")? pickData.paymentInfo.ccInfo.split(",")[1] : ""), 
                RC: {phoneType:pickData.tripInfo.isRollingCallTypePhone, emailType:pickData.tripInfo.isRollingCallTypeEmail, SMSType:pickData.tripInfo.isRollingCallTypeSMS}, 
                driverNum: (pickData.driverInfo.assignedDriverNo !== "" ? pickData.driverInfo.assignedDriverNo : "DN"), driverNumCheck: pickData.driverInfo.onlyPreferedDriver,
                driverMins: pickData.driverInfo.driverNoTimeDiff, gender: (pickData.driverInfo.preferedDriverGender !== "" ? pickData.driverInfo.preferedDriverGender : "Gender"), 
                genderMins: pickData.driverInfo.genderTimeDiff, vehNum: (pickData.vehicleInfo.assignedVehNo !== "" ? pickData.vehicleInfo.assignedVehNo : "VN"), 
                genderCheck: pickData.driverInfo.onlyPreferedDriverGender,
                vehNumCheck: pickData.vehicleInfo.onlyPreferedVehicle, vehMins: pickData.vehicleInfo.vehicleNoTimeDiff, 
                language: (pickData.driverInfo.preferedLanguage !== "" && pickData.driverInfo.preferedLanguage !== 0 ? pickData.driverInfo.preferedLanguage : "Language"), 
                languageMins: pickData.driverInfo.langTimeDiff, languageCheck: pickData.driverInfo.onlyPreferedDriverLanguage,
                tripAttribute: attributesDesc, insurance: {Agency: editRowData.insuranceInfo.agencyID, Type: editRowData.insuranceInfo.insuranceID, 
                CaseWorker: editRowData.insuranceInfo.caseWorkerID, AuthCode: editRowData.insuranceInfo.authID,
                ServiceCode: editRowData.insuranceInfo.serviceCodeID}, copayPayType: pickData.paymentInfo.iActualPaymentTypeID, 
                copayFS: pickData.paymentInfo.iCopayFundingSourceID, tripType: pickData.tripInfo.callType, 
                tripPriority: pickData.tripInfo.slaClassID, fareMethod: pickData.tripInfo.fareMethod, billableAmount: pickData.estimatedInfo.billableAmount, 
                additionalPassengerCost: pickData.estimatedInfo.additionalPassCost, confirmationNo: pickData.tripInfo.refID,
                fareEstimateAPIData : fareEstimateDataDict, broker: brokerDict
              }
            );
            if(parseInt(pickData.tripInfo.refID) === parseInt(selectedConfirmationNo))
            {
              discoveredID = i;
              setVerifiedInfoUpdateIndex(i);
            }
          }
          setVerifiedAddr(stopOrderArr);
          setAddLegBtnTitle("Update");
          
        }
        setTimeout(() => {
          if(editRowData.addressInfo.trips.length > 1) //Set new broker mode depending on multi/single trip
          {
            setBrokerModes(prevState=>({...prevState, brokerMode: (editRowData.addressInfo.trips[discoveredID].details[0].tripInfo.FSBrokerMode || 0)}));
          }
          else
          {
            let fsData = (FundingSourceData[parseInt(selectedAff)] && 
              FundingSourceData[parseInt(selectedAff)] !== undefined ? 
              JSON.parse(FundingSourceData[parseInt(selectedAff)]) : []
            );
            let fsSelected = (fsData.length > 0 ? fsData.find(item => parseInt(item.FID) === parseInt(tripData.details[0].paymentInfo.fundingSourceID)) : 0);
            setBrokerModes(prevState=>({...prevState, brokerMode: (fsSelected === 0 ? 0 : fsSelected.BrokerMode)}));
          }
          setIsSchTimeFieldDisabled(false);
          setFSSelected(parseInt(tripData.details[0].paymentInfo.fundingSourceID));
          setCopayFSSelected(parseInt(tripData.details[0].paymentInfo.iCopayFundingSourceID));
          setCopayPayTypeSelected(tripData.details[0].paymentInfo.iActualPaymentTypeID);
          setPaySelected(tripData.details[0].paymentInfo.paymentTypeID);
          setMapData(tripLatLng);
        }, 2500); //settimeout is required to make sure changes are correctly populated on map, rider ID, pay, and FS
        if(pickLatLng.current !== "" && dropLatLng.current !== "")
        { //Handle fare or rcz verification depending on micro / para
          if(type === "API") { handleInitialFareAPIs(tripData.details[0].paymentInfo.fundingSourceID, editRowData.generalInfo.requestAffiliateID, tripData.details[0].tripInfo.classOfServiceID, [editRowData], tripData);}
          
          if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2))
          {
            wrapperHandleRCZVerification("PU", 
              (tripData.details[0].addressDetails.address + ", " + tripData.details[0].addressDetails.city + ", " + tripData.details[0].addressDetails.state + " " + tripData.details[0].addressDetails.zip),
              (lastTripData.addressDetails.address + ", " + lastTripData.addressDetails.city + ", " + lastTripData.addressDetails.state + " " + lastTripData.addressDetails.zip));
          }
        }
      }
      else
      {
        setModalHeaderText("Edit Info Error");
        setModalBodyHTML("There is an error while editing the trip, please try again or contact administrator.");
        setModalFooterHTML(
          <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
            OK
          </Button>
        );
        setShowDynamicModal(true);
      }
    }
    catch(err){console.log(err);}
  };

  // Parsing data
  const ParseGeoCodedData = (data, Identifier, Index = 0) => {  
    try{
      let StreatNum = "", route = "", Locality = "", Admin3 = "", Admin2 = "", Admin1 = "", Country = "", PostalCode = "",
      establishment = "", neighborhood = "", park = "", premise = "", subpremise = "", sublocality = "", intersection = "", 
      FormatedAddress = "";
      let StreatNum_short = "", route_short = "", neighborhood_short = "", park_short = "", premise_short = "", 
      subpremise_short = "", intersection_short = ""; //Initializing all necessary pieces of address data to be assigned from given data
      let _mapSource = "unkwnSource";
      let isPoiLatLong = false;
      //Assigning each variable to accurate component of OSRM using switch case
      if(data.address_components){
        data.address_components.forEach((component) => {
          const componentType = component.types[0];
          const longName = component.long_name;
          const shortName = component.short_name;

          switch (componentType) {
            case 'street_number': StreatNum = longName; StreatNum_short = shortName;
              break;
            case 'route': route = longName; route_short = shortName;
              break;
            case 'locality': Locality = longName;
              break;
            case 'administrative_area_level_3': Admin3 = longName;
              break;
            case 'administrative_area_level_2': Admin2 = longName;
              break;
            case 'administrative_area_level_1': Admin1 = shortName;
              break;
            case 'country': Country = longName;
              break;
            case 'postal_code': PostalCode = longName;
              break;
            case 'establishment': establishment = longName;
              break;
            case 'neighborhood': neighborhood = longName; neighborhood_short = shortName;
              break;
            case 'park': park = longName; park_short = shortName;
              break;
            case 'premise': premise = longName; premise_short = shortName;
              break;
            case 'subpremise': subpremise = longName; subpremise_short = shortName;
              break;
            case 'sublocality': sublocality = longName;
              break;
            case 'intersection': intersection = longName; intersection_short = shortName;
              break;
            default: break;
          }
        });
      }
      FormatedAddress = data.formatted_address;
      if (Admin1.trim() === Country.trim()) {//If it sends country in state, empty the state.
        Admin1 = "";
      }
      let AggregatedStreetAdddr = "";
      AggregatedStreetAdddr = (premise.trim() === "" ? "" : premise + ", ") + 
        (subpremise.trim() === "" ? "" : subpremise + ", ") + (park.trim() === "" ? "" : park + ", ") + 
        ((neighborhood.trim() === "" || route !== "" || StreatNum !== "") ? "" : neighborhood + ", ") + 
      (intersection.trim() === "" ? "" : intersection + ", ") + StreatNum + " " + route;
      
  
      try {
        if (FormatedAddress.split(',').length > 0) {

          let StreetAdd = data.formatted_address.split(',')[0];
          if (StreetAdd != "" && StreetAdd.indexOf("&") > -1 && (StreetAdd.indexOf(route) > -1 || StreetAdd.indexOf(StreatNum) > -1
            || StreetAdd.indexOf(intersection) > -1 || StreetAdd.indexOf(neighborhood) > -1 || StreetAdd.indexOf(park) > -1
            || StreetAdd.indexOf(subpremise) > -1 || StreetAdd.indexOf(premise) > -1
            || StreetAdd.indexOf(route_short) > -1 || StreetAdd.indexOf(StreatNum_short) > -1
            || StreetAdd.indexOf(intersection_short) > -1 || StreetAdd.indexOf(neighborhood_short) > -1
            || StreetAdd.indexOf(park_short) > -1 || StreetAdd.indexOf(subpremise_short) > -1 || StreetAdd.indexOf(premise_short) > -1)) 
          {
            AggregatedStreetAdddr = StreetAdd;
          }
        }
      } catch (CrashFailSafe) { }
      
      try {
        if (typeof data.mapSource !== 'undefined') {
          _mapSource = data.mapSource;
        }
        if (typeof data.placessearchedresult !== 'undefined') {
          if (data.placessearchedresult === true) {
            isPoiLatLong = true;
          }
        }
      } catch (setMapSrcExp) { }
      let ParsedData = {
        "Street": AggregatedStreetAdddr.trim() === "" ? establishment : AggregatedStreetAdddr.trim(),
        "City": (Locality === "") ? Admin2 : Locality,
        "State": (Admin1.toString().toLowerCase() === "maryland") ? 'MD' : Admin1,
        "Zip": PostalCode,
        "Lat": (data.geometry ? data.geometry.location.lat : ""),
        "Long": (data.geometry ? data.geometry.location.lng : ""),
        "Address": FormatedAddress,
        "data": data,
        "Country": Country,
        "Identifier": Identifier,
        "isPoiLatLong": isPoiLatLong,
        "UnitNumber": (data.sUnitNumber === undefined || data.sUnitNumber === null) ? "" : data.sUnitNumber,
        "GeocodeSource": _mapSource
      };
      return ParsedData;
    }
    catch(err){console.log(err);}
  };
  // ___________________

  const handleFSSelectionChange = async (e, type, newData={}) => {
    try{

      if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2))
      { //Paratransit mode Funding Source change
        let accurateOption = (e === "" ? newData.props : e.target);
        const selectedIndex = (e !== "" ? e.target.selectedIndex : "");
        const selectedOption = (e !== "" ? e.target.options[selectedIndex] : newData);
        const virtualData = (e !== "" ? selectedOption.getAttribute('data-virtual') : newData.props["data-virtual"]);
        if(type === "fs")
        {
          let fsData = (FundingSourceData[parseInt(selectedAff)] && 
            FundingSourceData[parseInt(selectedAff)] !== undefined ? 
            JSON.parse(FundingSourceData[parseInt(selectedAff)]) : []
          );
          let fsSelected = (fsData.length > 0 ? fsData.find(item => parseInt(item.FID) === parseInt(accurateOption.value)) : 0);
          setBrokerModes(prevState=>({...prevState, brokerMode: (fsSelected === 0 ? 0 : fsSelected.BrokerMode)}));
          setFSSelected(accurateOption.value); 
          setPaySelected(parseInt(virtualData)); //Get fare estimate and fare method on funding source change
          let tempPayOption = PayDropdown.find((option)=> (option?.props && parseInt(option.props.value) === parseInt(virtualData)));
          if(tempPayOption)
          {
            if(tempPayOption.props.children.toLowerCase().includes("card"))
            {
              setShowCCBtn(true);
            }
            else
            {
              setShowCCBtn(false);
            }
          }
          await handleGetFareCalcMethod((accurateOption.value ? accurateOption.value : "-1"), selectedAff, COSSelected);
          await wrapperHandleFareCalc(clientSummary.tripDistance, clientSummary.TripDuration, 
            accurateOption.value, copayFSSelected, passengerTypeCount.totalWC, 
            passengerTypeCount.total, COSSelected, selectedAff, 
            pickLatLng.current, copayAmount, ""
          ); 
        }
        else
        {
          let textContent = (selectedOption.textContent ? selectedOption.textContent.toLowerCase() : selectedOption.props.label.toLowerCase());
          setCopayFSSelected(accurateOption.value);
          if(textContent.includes('card')) //Check if the name of Funding Source has card for credit card button
          {
            setShowCCBtn(true);
          }
          else
          {
            setShowCCBtn(false);
          }
          setCopayPayTypeSelected(parseInt(virtualData)); //Get fare estimate and fare method on copay funding source change
          await handleGetFareCalcMethod((FSSelected? FSSelected: "-1"), selectedAff, COSSelected);
          await wrapperHandleFareCalc(clientSummary.tripDistance, clientSummary.TripDuration, 
            FSSelected, accurateOption.value, passengerTypeCount.totalWC, 
            passengerTypeCount.total, COSSelected, selectedAff, 
            pickLatLng.current, copayAmount, ""
          ); 
        }
      }
      else
      { //Microtransit mode Funding Source change
        let fsData = (FundingSourceData[parseInt(selectedAff)] && 
          FundingSourceData[parseInt(selectedAff)] !== undefined ? 
          JSON.parse(FundingSourceData[parseInt(selectedAff)]) : []
        );
        let accurateOption = (e === "" ? newData.props : e.target);
        let fsSelected = (fsData.length > 0 ? fsData.find(item => parseInt(item.FID) === parseInt(accurateOption.value)) : 0);
        setBrokerModes(prevState=>({...prevState, brokerMode: (fsSelected === 0 ? 0 : fsSelected.BrokerMode)}));
        setFSSelected(accurateOption.value); 
      }
    }
    catch(err){console.log(err);}
  };

  const startAffSelectionDropDown = (selectedAffVS, uniqueAff = 0)=>{
    try{
      let updatedListofVS = [];
      let filteredSet = new Set();
      selectedAffVS.forEach(item =>{
        if(!filteredSet.has(item.ID))
        {
          updatedListofVS.push(item);
          filteredSet.add(item.ID);
        }
      }); //Removing all duplicates from virtual stop options and sorting according to name of VS
      let sortedListofVS = updatedListofVS.sort((a,b)=>{
        return a.Location.localeCompare(b.Location);
      });
      let checkingDataCompany = AffiliateData.find(item=>item.AffiliateID === parseInt(uniqueAff));
      let affiliateOptionsHTML = AffiliateData.map(function(item, index){
        if(loginData.UserAffiliateList.includes(String(item.AffiliateID)) && (checkingDataCompany ? item.vATSPGroupName === checkingDataCompany.vATSPGroupName: true))
        {
          return (
            <option key={index} value={item.AffiliateID}>{item.AffiliateCompany}</option>
          );
        }
      });
      let virtualStopOptionsHTML = sortedListofVS.map(function(item, index){
        let LatLng = String(item.vLatitude) +","+ String(item.vLongitude);
        return(
          <option key={index} value={item.ID} data-name={item.Street} data-virtual={LatLng}>{item.Location}</option>
        );
      });
      if(affiliateOptionsHTML && affiliateOptionsHTML.length === 1)
      {
        setSelectedAff(AffiliateData[0].AffiliateID); //setting the affiliate ID manually if there are no others
      }
      setVirtualStopDropDownHTML(virtualStopOptionsHTML);
      setAffiliateDropDownHTML(affiliateOptionsHTML); 
      if(updatedListofVS.length > 0)
      {
        for(let j = 0; j < updatedListofVS.length; j++)
        {
          if(rowData.current && rowData.current.length > 0 && rowData.current[0].PickupAddress.includes(updatedListofVS[j].Location))
          {
            setPickupVirtualStop({...pickupVirtualStop, value:updatedListofVS[j].ID, name:updatedListofVS[j].Location});
          }
          if(rowData.current && rowData.current.length > 0 && rowData.current[0].Destination.includes(updatedListofVS[j].Location))
          {
            setDropAddrVirtualStop({...dropAddrVirtualStop, value:updatedListofVS[j].ID, name:updatedListofVS[j].Location});
          }
        }
      }
    }
    catch(err){console.log(err);}
  };

  const handleSearchCustomerName = async (givenData = "", OpenMultipleDialog = true, clientID = 0) =>{
    try{
      if(affiliateSelRef.current.options.length !== affiliateDropDownHTML.length)
      {
        let affiliateOptionsHTML = AffiliateData.map(function(item, index){
          if(loginData.UserAffiliateList.includes(String(item.AffiliateID)))
          {
            return (
              <option key={index} value={item.AffiliateID}>{item.AffiliateCompany}</option>
            );
          }
        });
        setAffiliateDropDownHTML(affiliateOptionsHTML);  
      }
      clientNameCheckRef.current.blur();
      setSearchButtonValidation("");
      if(!clientInfoDisplay)
      {
        setClientInfoDisplay(true);
      }
      if((riderNameCheck.length > 0) || givenData !== "")
      {
        let isContainedFilter = clientNameList.length > 0 && givenData === ""? clientNameList.filter((item, index)=>{
          let nameParts = (riderNameCheck.trim().includes(" ") ? riderNameCheck.trim().split(" ") : riderNameCheck);
          let fullName = (item.FirstName === "" ? item.LastName : item.FirstName + (item.LastName === "" ? "" : " " + item.LastName));
          return ((Array.isArray(nameParts) && nameParts.every(part=> fullName.toLowerCase().includes(part.toLowerCase()))) || 
            (!Array.isArray(nameParts) && fullName.toLowerCase().includes(nameParts.trim().toLowerCase())));
        }) : [];
        let response = "";
        let clientInfo = [];
        if(isContainedFilter.length === 0)
        {
          searchClientBtnRef.current.disabled = true;
          let selectedFamilyData = AffiliateData.filter((item)=>{
            if(parseInt(item.AffiliateID) === parseInt(selectedAff))
            {
              return true;
            }
          });
  
          let data = {
            "searchCriteria": "CustomerName",
            "searchText": (givenData !== "" ? givenData : riderNameCheck),
            "bActiveRecords": true,
            "iATSPID": selectedAff ? parseInt(selectedAff) : -1,
            "iDTSPID": selectedFamilyData ? parseInt(selectedFamilyData[0].DTSPID): -1,
          };
          setModalHeaderText("Client Info Processing");
          setModalBodyHTML("Please wait...");
          setModalFooterHTML(
            <>
              <Button variant='dark' className="border-0" onClick = {()=>{setShowDynamicModal(false);}}>
                OK
              </Button>
            </>
          );
          setShowDynamicModal(true);
          setModalClass("d-none");
          setShowAPILoader(true);
          response = await APICom.fetchData("ReservationCoreURL","SearchClientData", "post", {}, data, xCancelSourceForGrid.current);
          if(response && response.error === "" && parseInt(response.data.responseCode) === 200)
          {
            searchClientBtnRef.current.disabled = false;
            clientInfo = JSON.parse(response.data.responseJSON);
            setSearchButtonValidation("");
          }
          else
          {
            setModalClass("");
            setShowDynamicModal(false);
            setShowAPILoader(false);
            searchClientBtnRef.current.disabled = false;
            if(response && response.error === "") //no client found
            {
              setSearchButtonValidation("No client record found");
              riderNameRef.current.focus();
            }
            else
            {
              setSearchButtonValidation(response.error);
            }
          }
        }
        else
        {
          clientInfo = [...isContainedFilter];
        }
        if(clientInfo.length > 1 && OpenMultipleDialog)
        {
          let sortedClientInfoList = clientInfo.sort((a,b)=>{

            const dateA = a.LastCallDate ? new Date(a.LastCallDate.split("T")[0] + " 00:00:00") : null;
            const dateB = b.LastCallDate ? new Date(b.LastCallDate.split("T")[0] + " 00:00:00") : null;

            if (!dateA && !dateB) return 0; // Both dates are empty
            if (!dateA) return 1; // Move entries with empty lastCall to the end
            if (!dateB) return -1; // Move entries with empty lastCall to the end

            return dateB - dateA; // Sort by date if both are valid (newest to oldest)
          });
          clientIndexRef.current = {index : 0, data : sortedClientInfoList[0]};
          setInputSuggestionListClientName("");
          setInputSuggestionListClientPhone("");
          setModalHeaderText("Client Info Selection");
          setModalBodyHTML(
            <>
              <p className="m-0 user-select-none">
                {"Please select the desired client from the following options with provided name: "}
                <span className="fw-bold text-center user-select-none">{"("+riderNameCheck+")"}</span> 
              </p>
              <Row className="m-0 justify-content-center">
                <select className='text-center m-1 px-1 w-100 overflow-hidden' style={{textOverflow:"ellipsis"}}
                  onChange={(e)=>{clientIndexRef.current = {index : e.target.value, data : sortedClientInfoList[parseInt(e.target.value)]};}}
                >
                  <option disabled hidden value={999}>{"Select Client"}</option>
                  {sortedClientInfoList.map(function(item, index){
                    let [year, month, day] = item.LastCallDate ?  item.LastCallDate.split("T")[0].split("-"): ["","",""];
                    let formattedName = (item.FirstName === "" ? item.LastName.trim() : (item.LastName === "" 
                      ? (item.FirstName.trim().includes(",") ? item.FirstName.split(",")[1].trim()+", "+item.FirstName.split(",")[0].trim(): item.FirstName.trim())  
                      : item.LastName.trim()+", "+item.FirstName.trim()));
                    return(
                      <option key={index} value={index}>{formattedName + (item.HomePhone.length === 0 ? (year !== "" ? " [Last Call: "+month+"/"+day+"/"+year+"]" : ""):
                        " ("+item.HomePhone+")"+(year !== "" ? " [Last Call: "+month+"/"+day+"/"+year+"]" : ""))}</option>
                    );
                  })}
                </select>
              </Row>
            </>
          );
          setModalFooterHTML(
            <>
              <Button variant='dark' className="border-0"
                onClick={()=>{handleClientInfoGeneration(sortedClientInfoList[parseInt(clientIndexRef.current.index)]);}}>
                OK
              </Button>
            </>
          );
          setShowDynamicModal(true);
          setModalClass("");
          setShowAPILoader(false);
        }
        else
        {
          const resultClient =  (clientID !== 0 ? clientInfo.find((item)=>parseInt(item.id) === parseInt(clientID)) : null);
          let validData = (clientInfo.length > 1 ? (resultClient? resultClient : clientInfo[0]) : clientInfo[0]);
          setModalClass("");
          setShowDynamicModal(false);
          setShowAPILoader(false);
          handleClientInfoGeneration(validData);
        }
       
      }
      else
      {
        setClientNameList([]);
        setSearchButtonValidation("Please enter the complete name");
      }
    }
    catch(err){console.log(err);}
  };

  const handlePhoneNumberChange = async (e) => {
    try{
      let input = "";
      if(typeof e === "string")
      {
        setPhone(e);
        input = e;
      }
      else
      {
        input = e.target.value;
      }
      if(input.trim().length >= 12)
      {
        let selectedFamilyData = AffiliateData.filter((item)=>{
          if(parseInt(item.AffiliateID) === parseInt(selectedAff))
          {
            return true;
          }
        });
        let areaCode = "";
        let firstPart = "";
        let secondPart = "";
        if(input.includes("("))
        {
          input = input.replace(/\D/g, ""); // This removes everything that is not a digit
          areaCode = input.substring(0,3);
          firstPart = input.substring(3,6);
          secondPart = input.substring(6,10);
        }
        else
        {
          areaCode = input.replace("+1","").substring(0,3);
          firstPart = input.replace("+1","").substring(3,6);
          secondPart = input.replace("+1","").substring(6,10);
        }
        let data = {
          "searchCriteria": "CustomerPhone",
          "searchText": (areaCode+"-"+firstPart+"-"+secondPart),
          "bActiveRecords": true,
          "iATSPID": selectedAff ? parseInt(selectedAff) : -1,
          "iDTSPID": selectedFamilyData ? parseInt(selectedFamilyData[0].DTSPID): -1,
        };
        let response = await APICom.fetchData("ReservationCoreURL","SearchClientData", "post", {}, data, xCancelSourceForGrid.current);
        if(response && response.error === "" && parseInt(response.data.responseCode) === 200)
        {
          let clientInfo = JSON.parse(response.data.responseJSON);
          liClientPhoneRefs.current = [];

          if(clientInfo.length > 0)
          {
            let sortedClientInfoList = clientInfo.sort((a,b)=>{

              const dateA = a.LastCallDate ? new Date(a.LastCallDate.split("T")[0] + " 00:00:00") : null;
              const dateB = b.LastCallDate ? new Date(b.LastCallDate.split("T")[0] + " 00:00:00") : null;
  
              if (!dateA && !dateB) return 0; // Both dates are empty
              if (!dateA) return 1; // Move entries with empty lastCall to the end
              if (!dateB) return -1; // Move entries with empty lastCall to the end
  
              return dateB - dateA; // Sort by date if both are valid (newest to oldest)
            });
            clientIndexRef.current = {index : 0, data : sortedClientInfoList[0]};
            setInputSuggestionListClientName("");

            let suggestionsHTML = sortedClientInfoList.map(function(item, index){
              liClientPhoneRefs.current[index] = React.createRef(); // Create a ref for each <li>
              let [year, month, day] = item.LastCallDate ?  item.LastCallDate.split("T")[0].split("-"): ["","",""]; 
              let formattedName = (item.FirstName.length === 0? (item.LastName + (year !== "" ? " [Last Call: "+month+"/"+day+"/"+year+"]" : "")) : 
                ((item.LastName === "" ? item.FirstName: item.LastName+", "+item.FirstName) + (year !== "" ? " [Last Call: "+month+"/"+day+"/"+year+"]" : "")));
              return(
                <li ref={liClientPhoneRefs.current[index]} className="border-bottom text-nowrap overflow-hidden px-1 addressSelectionRow" 
                  onFocus={()=>{focusedSuggestionCheckClientPhone.current = true;}}
                  style={{cursor:"pointer"}} tabIndex={-1} onBlur={()=>{focusedSuggestionCheckClientPhone.current = false;}} onKeyDown={(e)=>{
                      if(e.key === 'ArrowDown')
                      {
                        e.preventDefault();
                        if(liClientPhoneRefs.current.length > 0)
                        {
                          setHighlightedIndex((prevIndex) => {
                            const newIndex = (prevIndex + 1) % liClientPhoneRefs.current.length;
                            liClientPhoneRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                            return newIndex;
                          });
                        }
                      }
                      else if (e.key === 'ArrowUp') {
                        e.preventDefault();
                        if(liClientPhoneRefs.current.length > 0)
                        {
                          setHighlightedIndex((prevIndex) => {
                            const newIndex = (prevIndex - 1 + liClientPhoneRefs.current.length) % liClientPhoneRefs.current.length;
                            liClientPhoneRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                            return newIndex;
                          });
                        }
                      }
                      else if(e.key === "Enter")
                      {
                        // setInputSuggestionListClientPhone("");
                        handleClientInfoGeneration(sortedClientInfoList[index]);
                      }
                    }}
                  onClick={()=>{handleClientInfoGeneration(sortedClientInfoList[index]);}} key={index} value={formattedName}
                >
                  {formattedName}
                </li>
              );
            });
            setInputSuggestionListClientPhone(suggestionsHTML);
          }

        }
        else
        {
          setInputSuggestionListClientPhone("");
        }
      }
      else if(input.trim().length === 0)
      {
        setInputSuggestionListClientPhone("");
      }
      else
      {
        setInputSuggestionListClientPhone("");
      }
    }
    catch(err){console.log(err);}
  };

  const handleClientNameChange = async (e) => {
    try{
      setRiderNameCheck(e.target.value);
      let input = e.target.value;
      if(input.trim().length >= 3)
      {
        if(!isNaN(input.trim()))
        {
          //Don't initiate API call for rider ID numbers until keyUp event...
        }
        else
        {

          let isContainedFilter = clientNameList.length > 0 ? clientNameList.filter((item, index)=>{
            let nameParts = (input.trim().includes(" ") ? input.trim().split(" ") : input);
            let fullName = (item.FirstName === "" ? item.LastName : item.FirstName + (item.LastName === "" ? "" : " " + item.LastName));
            return ((Array.isArray(nameParts) && nameParts.every(part=> fullName.toLowerCase().includes(part.toLowerCase()))) || 
              (!Array.isArray(nameParts) && fullName.toLowerCase().includes(nameParts.trim().toLowerCase())));
          }) : [];

          let response = "";
          let clientInfo = [];
          if(isContainedFilter.length === 0)
          {
            let selectedFamilyData = AffiliateData.filter((item)=>{
              if(parseInt(item.AffiliateID) === parseInt(selectedAff))
              {
                return true;
              }
            });
    
            let data = {
              "searchCriteria": "CustomerName",
              "searchText": input,
              "bActiveRecords": true,
              "iATSPID": selectedAff ? parseInt(selectedAff) : -1,
              "iDTSPID": selectedFamilyData ? parseInt(selectedFamilyData[0].DTSPID): -1,
            };
            response = await APICom.fetchData("ReservationCoreURL","SearchClientData", "post", {}, data, xCancelSourceForGrid.current);
            if(response && response.error === "" && parseInt(response.data.responseCode) === 200)
            {
              clientInfo = JSON.parse(response.data.responseJSON);
              setClientNameList(clientInfo);
            }
            else
            {
              setInputSuggestionListClientName("");
            }
          }
          else
          {
            clientInfo = [...isContainedFilter];
          }

          liClientNameRefs.current = [];
          if(clientInfo.length > 0)
          {
            let sortedClientInfoList = clientInfo.sort((a,b)=>{

              const dateA = a.LastCallDate ? new Date(a.LastCallDate.split("T")[0] + " 00:00:00") : null;
              const dateB = b.LastCallDate ? new Date(b.LastCallDate.split("T")[0] + " 00:00:00") : null;

              if (!dateA && !dateB) return 0; // Both dates are empty
              if (!dateA) return 1; // Move entries with empty lastCall to the end
              if (!dateB) return -1; // Move entries with empty lastCall to the end

              return dateB - dateA; // Sort by date if both are valid (newest to oldest)
            });
            clientIndexRef.current = {index : 0, data : sortedClientInfoList[0]};

            setInputSuggestionListClientPhone("");
            let suggestionsHTML = sortedClientInfoList.map(function(item, index){
              liClientNameRefs.current[index] = React.createRef(); // Create a ref for each <li>
              let [year, month, day] = item.LastCallDate ?  item.LastCallDate.split("T")[0].split("-"): ["","",""]; 
              let formattedName = item.FirstName.length === 0? (item.LastName+(item.HomePhone.length === 0 ? (year !== "" ? " [Last Call: "+month+"/"+day+"/"+year+"]" : "") :" ("+item.HomePhone+")"+(year !== "" ? " [Last Call: "+month+"/"+day+"/"+year+"]" : ""))) : 
                (item.LastName === "" ? item.FirstName: item.LastName+", "+item.FirstName) + (item.HomePhone.length === 0 ? (year !== "" ? " [Last Call: "+month+"/"+day+"/"+year+"]" : "") :" ("+item.HomePhone+")"+(year !== "" ? " [Last Call: "+month+"/"+day+"/"+year+"]" : ""));
              
              return(
                <li ref={liClientNameRefs.current[index]} className="border-bottom text-nowrap overflow-hidden px-1 addressSelectionRow" 
                  onFocus={()=>{focusedSuggestionCheckClientName.current = true;}}
                  style={{cursor:"pointer"}} tabIndex={-1} onBlur={()=>{focusedSuggestionCheckClientName.current = false;}} onKeyDown={(e)=>{
                      if(e.key === 'ArrowDown')
                      {
                        e.preventDefault();
                        if(liClientNameRefs.current.length > 0)
                        {
                          setHighlightedIndex((prevIndex) => {
                            const newIndex = (prevIndex + 1) % liClientNameRefs.current.length;
                            liClientNameRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                            return newIndex;
                          });
                        }
                      }
                      else if (e.key === 'ArrowUp') {
                        e.preventDefault();
                        if(liClientNameRefs.current.length > 0)
                        {
                          setHighlightedIndex((prevIndex) => {
                            const newIndex = (prevIndex - 1 + liClientNameRefs.current.length) % liClientNameRefs.current.length;
                            liClientNameRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                            return newIndex;
                          });
                        }
                      }
                      else if(e.key === "Enter")
                      {
                        // setInputSuggestionListClientName("");
                        handleClientInfoGeneration(sortedClientInfoList[index]);
                      }
                    }}
                  onClick={()=>{handleClientInfoGeneration(sortedClientInfoList[index]);}} key={index} value={formattedName}
                >
                  {formattedName}
                </li>
              );
              
            });
            setInputSuggestionListClientName(suggestionsHTML);
          }
        }
      }
      else if(input.trim().length === 0)
      {
        setClientNameList([]);
        setInputSuggestionListClientName("");
      }
      else
      {
        setClientNameList([]);
        setInputSuggestionListClientName("");
      }
    }
    catch(err){console.log(err);}
  };

  const handleSearchCustomerPhone = async (givenData = "", OpenMultipleDialog = true, clientID = 0) => {
    try{
      if(affiliateSelRef.current.options.length !== affiliateDropDownHTML.length)
      {
        let affiliateOptionsHTML = AffiliateData.map(function(item, index){
          if(loginData.UserAffiliateList.includes(String(item.AffiliateID)))
          {
            return (
              <option key={index} value={item.AffiliateID}>{item.AffiliateCompany}</option>
            );
          }
        });
        setAffiliateDropDownHTML(affiliateOptionsHTML);  
      }
      clientNameCheckRef.current.blur();
      phoneRef.current.blur();
      if(!clientInfoDisplay)
      {
        setClientInfoDisplay(true);
      }
      setSearchButtonValidation("");
      if((phone && phone.length >= 12) || givenData !== "")
      {
        searchClientBtnRef.current.disabled = true;
        let selectedFamilyData = AffiliateData.filter((item)=>{
          if(parseInt(item.AffiliateID) === parseInt(selectedAff))
          {
            return true;
          }
        });
        let areaCode = (givenData !== "" ? "" : phone.replace("+1","").substring(0,3));
        let firstPart = (givenData !== "" ? "" : phone.replace("+1","").substring(3,6));
        let secondPart = (givenData !== "" ? "" : phone.replace("+1","").substring(6,10));
        let data = {
          "searchCriteria": "CustomerPhone",
          "searchText": (givenData !== "" ? givenData : (areaCode+"-"+firstPart+"-"+secondPart)),
          "bActiveRecords": true,
          "iATSPID": selectedAff ? parseInt(selectedAff) : -1,
          "iDTSPID": selectedFamilyData ? parseInt(selectedFamilyData[0].DTSPID): -1,
        };
        setModalHeaderText("Client Info Processing");
        setModalBodyHTML("Please wait...");
        setModalFooterHTML(
          <>
            <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
              OK
            </Button>
          </>
        );
        setShowDynamicModal(true);
        setModalClass("d-none");
        setShowAPILoader(true);
        let response = await APICom.fetchData("ReservationCoreURL","SearchClientData", "post", {}, data, xCancelSourceForGrid.current);
        if(response && response.error === "" && parseInt(response.data.responseCode) === 200)
        {
          searchClientBtnRef.current.disabled = false;
          let clientInfo = JSON.parse(response.data.responseJSON);
          setSearchButtonValidation("");
          if(clientInfo.length > 1 && OpenMultipleDialog)
          {
            let sortedClientInfoList = clientInfo.sort((a,b)=>{

              const dateA = a.LastCallDate ? new Date(a.LastCallDate.split("T")[0] + " 00:00:00") : null;
              const dateB = b.LastCallDate ? new Date(b.LastCallDate.split("T")[0] + " 00:00:00") : null;
  
              if (!dateA && !dateB) return 0; // Both dates are empty
              if (!dateA) return 1; // Move entries with empty lastCall to the end
              if (!dateB) return -1; // Move entries with empty lastCall to the end
  
              return dateB - dateA; // Sort by date if both are valid (newest to oldest)
            });
            clientIndexRef.current = {index : 0, data : sortedClientInfoList[0]};
            setInputSuggestionListClientName("");
            setInputSuggestionListClientPhone("");
            setModalHeaderText("Client Info Selection");
            setModalBodyHTML(
              <>
                <p className="m-0 user-select-none">
                  {"Please select the desired client from the following options with provided phone number: "}
                  <span className="fw-bold text-center user-select-none">{("("+areaCode+") "+firstPart+"-"+secondPart)}</span> 
                </p>
                <Row className="m-0 justify-content-center">
                  <select className='text-center m-1 px-1 w-100 overflow-hidden' style={{textOverflow:"ellipsis"}}
                    onChange={(e)=>{clientIndexRef.current = {index : e.target.value, data : sortedClientInfoList[parseInt(e.target.value)]};}}
                  >
                    <option disabled hidden value={999}>{"Select Client"}</option>
                    {sortedClientInfoList.map(function(item, index){
                      let [year, month, day] = item.LastCallDate ?  item.LastCallDate.split("T")[0].split("-"): ["","",""]; 
                      let formattedName = (item.FirstName === "" ? item.LastName.trim() : (item.LastName === "" 
                        ? (item.FirstName.trim().includes(",") ? item.FirstName.split(",")[1].trim()+", "+item.FirstName.split(",")[0].trim(): item.FirstName.trim())  
                        : item.LastName.trim()+", "+item.FirstName.trim()));
                      return(
                        <option key={index} value={index}>{formattedName + (item.HomePhone.length === 0 ? (year !== "" ? " [Last Call: "+month+"/"+day+"/"+year+"]" : "")
                          :" ("+item.HomePhone+")"+(year !== "" ? " [Last Call: "+month+"/"+day+"/"+year+"]" : ""))}</option>
                      );
                    })}
                  </select>
                </Row>
              </>
            );
            setModalFooterHTML(
              <>
                <Button variant='dark' className="border-0" onClick={()=>{handleClientInfoGeneration(sortedClientInfoList[parseInt(clientIndexRef.current.index)]);}}>
                  OK
                </Button>
              </>
            );
            setShowDynamicModal(true);
            setModalClass("");
            setShowAPILoader(false);
          }
          else
          {
            const resultClient =  (clientID !== 0 ? clientInfo.find((item)=>parseInt(item.id) === parseInt(clientID)) : null);
            let validData = (clientInfo.length > 1 ? (resultClient? resultClient : clientInfo[0]) : clientInfo[0]);
            setModalClass("");
            setShowDynamicModal(false);
            setShowAPILoader(false);
            handleClientInfoGeneration(validData);
          }
        }
        else
        {
          setModalClass("");
          setShowDynamicModal(false);
          setShowAPILoader(false);
          searchClientBtnRef.current.disabled = false;
          if(response && response.error === "") //no client found
          {
            setSearchButtonValidation("No client record found");
            riderNameRef.current.focus();
          }
          else
          {
            setSearchButtonValidation(response.error);
            setTimeout(() => {
              setSearchButtonValidation("");
            }, 5000);
          }
        }
      }
      else
      {
        setSearchButtonValidation("Please enter the complete phone number/name");
        setTimeout(() => {
          setSearchButtonValidation("");
        }, 5000);
      }
    }
    catch(err){console.log(err);}
  };

  const handleClientInfoGeneration = async (data) =>{
    try{
      if(data)
      {
        searchedClientID.current = data.Id;
      
        let checkingDataCompany = AffiliateData.find(item=>item.AffiliateID === parseInt(selectedAff));
        let affiliateOptionsHTML = AffiliateData.map(function(item, index){
          if(loginData.UserAffiliateList.includes(String(item.AffiliateID)) && item.vATSPGroupName === checkingDataCompany.vATSPGroupName)
          {
            return (
              <option key={index} value={item.AffiliateID}>{item.AffiliateCompany}</option>
            );
          }
        });
        setInputSuggestionListClientPhone("");
        setInputSuggestionListClientName("");
        setAffiliateDropDownHTML(affiliateOptionsHTML); 
        phoneRef.current.disabled = true;
        clientNameCheckRef.current.disabled = true;

        let riderNameParse = (data.FirstName && data.FirstName !== "" ? data.FirstName + (data.LastName && data.LastName !== "" ? " "+data.LastName : "")
          : (data.LastName && data.LastName !== "" ? data.LastName : ""));
        setRiderName(riderNameParse);
        setAccountNumber(data.Id);
        setAgentNotes(data.Notes);
        setMedID((data.MedicalId ? data.MedicalId : ""));

        const FSOption = (data.FS_ID && String(data.FS_ID) !== "" && String(data.FS_ID) !== "-1" ? 
          FSDropdown.find((option)=> (option?.props && parseInt(option.props.value) === parseInt(data.FS_ID))) : null
        );
        if(FSOption)
        {
          handleFSSelectionChange("", "fs", FSOption); //Change FS to client's FS
        }
        riderNameRef.current.focus();

        if(!phone || phone.length < 12)
          setPhone(("+1"+data.HomePhone.replaceAll("-","")));
        phoneRef.current.style.borderColor = "";
        phoneRef.current.style.borderWidth = "";
        riderNameRef.current.style.borderColor = "";
        riderNameRef.current.style.borderWidth = "";
        setCallBackPhone(("+1"+data.HomePhone.replaceAll("-","")));
        setClientSummary(prevState=>({...prevState, totalCancels:parseInt(data.TotalCancelled), lastCall: String(data.LastCallDate)}));
        setPassengerTypeCount({...passengerTypeCount, totalWC:parseInt(data.iWheelChairCount)});
        setModalHeaderText("Existing Client Rides Processing");
        setModalBodyHTML("Please wait...");
        setModalFooterHTML(
          <>
            <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
              OK
            </Button>
          </>
        );
        setShowDynamicModal(true);
        setModalClass("d-none");
        setShowAPILoader(true);
        setClientInfo(data);
        PersistStorage.save("clientInfo", data, 99, true); 
        let activeTripsData = {
          "searchCriteria": "CustomerID",
          "searchText": String(data.Id),
          "iATSPID": selectedAff ? parseInt(selectedAff) : -1
        };
        let response = await APICom.fetchData("ReservationCoreURL","GetExistingRides", "post", {}, activeTripsData, xCancelSourceForGrid.current);

        setShowAPILoader(false);
        if(response && response.error === "")
        {
          if(parseInt(response.data.responseCode) === 200)
          {
            setShowClientActiveTripsModal(true);
            let responseJSON = JSON.parse(response.data.responseJSON);
            setActiveTripsTableData(responseJSON);
            setShowDynamicModal(false);
            setModalClass("");
          }
          else
          {
            setModalClass("");
            setShowDynamicModal(false);
            setSearchButtonValidation("No active trips found");
            setTimeout(() => {
              setSearchButtonValidation("");
            }, 5000);
          }
        }
        else
        {
          setModalClass("");
          setShowDynamicModal(false);
          setSearchButtonValidation("An error occured when retrieving active trips");
          setTimeout(() => {
            setSearchButtonValidation("");
          }, 5000);
        }
        let ClientAddrData = {
          "clientID": String(data.Id),
          "affiliateID": selectedAff ? String(selectedAff) : -1
        };
        let recentAddresses = await APICom.fetchData("ReservationCoreURL","GetHistoricRides", "post", {}, ClientAddrData, xCancelSourceForGrid.current);
        if(recentAddresses && recentAddresses.error === "")
        {
          if(parseInt(recentAddresses.data.responseCode) === 200)
          {
            let recentAddrArray = JSON.parse(recentAddresses.data.responseJSON);
            if(recentAddrArray.length > 0)
            {
              setRecentAddresses(recentAddrArray);
            }
          }
        }
      }
      else
      {
        clientNameCheckRef.current.focus();
      }
    }
    catch(err){console.log(err);}
  };

  const handleClientInfoTableOpen = ()=>{
    try{
      console.log("table reload");
    }
    catch(Err){console.log(Err);}
  };

  const handleValidationMsg = (e) => {
    try{
      setShowDynamicModal(false); //RCZ validation for getting walk distance, validate addresses for microtransit
      if((dropAddrVirtualStop !== undefined && dropAddrVirtualStop && dropAddrVirtualStop?.value !== "" &&  dropAddrVirtualStop?.value)
        && (pickupVirtualStop !== undefined && pickupVirtualStop && pickupVirtualStop?.value !== "" &&  pickupVirtualStop?.value))
      {
        setShowAPILoader(true);
        wrapperHandleRCZVerification("DO", dropAddrVirtualStop.name);
      }
    }
    catch(err){console.log(err);}
  };

  const validateMinScheduleTimeDifference = async(_schTime = undefined, bApptTimeRemove = false, bCalculated = false, booking='', bookingCCParams = {bCallAfterCCCheck : false, iNewRefID : -1, iNewReturnRefID: -1}) => {
    try 
    {
      let tempSchTime = schTime;
      if (_schTime && _schTime !== undefined) {
        setSchTime(_schTime);
        tempSchTime = _schTime;
      }
      setShowAPILoader(true);
      let ScheduleTripMinTimeDiff = parseInt((JSON.parse(ASCSSettingData[selectedAff]).find((item) => item.SubTitle === "ScheduleTripMinTimeDiff")).value);
      let date = PersistStorage.retrieve("selectedDate", true);
      let [year, month, day] = (date && date.includes("-")? date.split("-").map(num => parseInt(num)) : ["", "", ""]);
      let newDate = "";
      if(year !== "")
      {
        month = String(month).padStart(2, "0");
        day = String(day).padStart(2, "0");
        newDate = `${year}-${month}-${day}`;
      }
      if (ScheduleTripMinTimeDiff !== undefined) {
        const options = {timeZone: 'America/New_York', month: '2-digit', day: '2-digit', year: 'numeric' };
        let data = {};
        if(bookBtnRef.current)
        {
          let currDate = (systemDateTime.date !== "" ? systemDateTime.date : newDate);
          data = {
            "PickupDateTime": currDate + " " + tempSchTime,
            "MinSchTimeDiff": ScheduleTripMinTimeDiff
          }
          if(tempSchTime === "")
          {
            setIsTimeValidated(true);
            // bookBtnRef.current.disabled = false;
            handleValidationMsg();
            setShowAPILoader(false);
            return 0;
          }
        }
        else
        {
          //Paratransit date
          data = {
            "PickupDateTime": selectedDateSchTime + " " + tempSchTime,
            "MinSchTimeDiff": ScheduleTripMinTimeDiff
          }
          const queryParams = new URLSearchParams(window.location.search);
          const tripSelected = queryParams.get('TripSelected') || activeTripSelected? true:false;
          let editRowData = (((PersistStorage.retrieve("rowDataEditTrip", true)  && tripSelected) || (PersistStorage.retrieve("rowDataEditTrip", true)))? PersistStorage.retrieve("rowDataEditTrip", true):"");
          let date = PersistStorage.retrieve("selectedDate", true);
          let [year, month, day] = (date && date.includes("-")? date.split("-").map(num => parseInt(num)) : ["", "", ""]);
          let newDate = "";
          if(year !== "")
          {
            month = String(month).padStart(2, "0");
            day = String(day).padStart(2, "0");
            newDate = `${year}-${month}-${day}`;
          }
          let currDate = (systemDateTime.date !== "" ? systemDateTime.date : newDate);
          if(editRowData !== "" && !(editRowData.addressInfo.trips[0].details[0].dateInfo.isScheduled))
          {
            if(booking === 'book')
              handleCreateUpdateParatransitTrip(true, bookingCCParams);
            else if(booking === 'leg')
            {
              timeValidateCheck.current = true;
              addLegBtnRef.current.click();
            }
            return 0;
          }
          else if(tempSchTime === "" && schTime === "" && selectedDateSchTime !== "" && currDate !== "")
          {
            let todayDate = new Date(currDate+" 00:00:00");
            let givenDate = new Date(selectedDateSchTime+" 00:00:00");
            if(givenDate >= todayDate)
            {
              setIsTimeValidated(true);
              setShowAPILoader(false);
              if(booking === 'book')
                handleCreateUpdateParatransitTrip(true, bookingCCParams);
              else if(booking === 'leg')
              {
                timeValidateCheck.current = true;
                addLegBtnRef.current.click();
              }
              
              return 0;
            }
          }
        }
        let response = await APICom.fetchData("ReservationCoreURL","ValiateMinScheduleTimeDifference", "post", {}, data, xCancelSourceForGrid.current);
        // console.log("validateTime response: ", response);
        if(response && response.error.length === 0)
        {
          if(response.data.responseCode === 400)
          {
            setIsTimeValidated(false);
            if(bookBtnRef.current)
            {
              bookBtnRef.current.disabled = true;
            }
            // else if(paratransitBookBtnRef.current)
            // {
            //   paratransitBookBtnRef.current.disabled = true;
            //   addLegBtnRef.current.disabled = true;
            // }
            setModalHeaderText("Schedule Date & Time");
            let formattedDate = (selectedDateSchTime !== "" ? formatDate(selectedDateSchTime) : formatDate(newDate));
            let pickupTimeText = (bCalculated ? "Pickup Time Calculated: " : "Pickup Time Entered: ");
            setModalBodyHTML(<><p>{pickupTimeText}<b>{formattedDate + " " + tempSchTime}</b></p><p className="m-0">{response.data.responseMessage}</p></>);
            setModalFooterHTML(
              <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                OK
              </Button>
            );
            setShowDynamicModal(true);
            setModalClass("");
          }
          else if(response.data.responseCode === 200 && pickLatLng.current !== "" && dropLatLng.current !== "")
          {
            setIsTimeValidated(true);
            if(bookBtnRef.current)
            {
              bookBtnRef.current.disabled = false;
              handleValidationMsg();
            }
            else if(paratransitBookBtnRef.current)
            {
              // if(bApptTimeRemove)
              // {
              //   setAppointmentTime("");
              // }
              paratransitBookBtnRef.current.disabled = false;
              addLegBtnRef.current.disabled = false;
              if(booking === 'book')
                handleCreateUpdateParatransitTrip(true, bookingCCParams);
              else if(booking === 'leg')
              {
                timeValidateCheck.current = true;
                addLegBtnRef.current.click();
              }
              
              // setShowDynamicModal(false);
            }
            
          }
        }
        setShowAPILoader(false);
      }
    } 
    catch (error) { 
      console.log(error);
      setIsTimeValidated(false);   
      if(bookBtnRef.current)
      {
        bookBtnRef.current.disabled = true;
      }
      else if(paratransitBookBtnRef.current)
      {
        paratransitBookBtnRef.current.disabled = true;
        addLegBtnRef.current.disabled = true;
      }
      setShowAPILoader(false);
    }
  };

  function addsubtractMinutesFromMilitaryTime(time24, minutesToSubtract, minutesToAdd = 0) {
    try{
      // Split hours and minutes from the input time
      const [hours, minutes] = time24.split(':').map(Number);
      let totalMinutes = 0;
      if(minutesToAdd !== 0)
      {
        // Calculate total minutes and add
        totalMinutes = hours * 60 + minutes + minutesToAdd;
      }
      else
      {
        // Calculate total minutes and subtract
        totalMinutes = hours * 60 + minutes - minutesToSubtract;
      }
      

      // Handle cases where total minutes are negative
      if (totalMinutes < 0) {
        totalMinutes = (24 * 60 + totalMinutes) % (24 * 60); // Wraps around to previous day
      }

      // Convert back to hours and minutes
      const newHours = Math.floor(totalMinutes / 60) % 24;
      const newMinutes = totalMinutes % 60;

      // Pad hours and minutes with leading zeros if needed
      const paddedHours = String(newHours).padStart(2, '0');
      const paddedMinutes = String(newMinutes).padStart(2, '0');

      return `${paddedHours}:${paddedMinutes}`;
    }
    catch(err){

      console.log(err); 
      return time24;
    }
  }

  const handleComputeNewPickupTime = (e) => {
    try{
      let fsSelection = (FundingSourceData && FundingSourceData[parseInt(selectedAff)] && FundingSourceData[parseInt(selectedAff)] !== undefined ? 
        JSON.parse(FundingSourceData[parseInt(selectedAff)]) : []);
      const ERSASettingsData = (MvRouteSettingData && MvRouteSettingData[parseInt(selectedAff)] && MvRouteSettingData[parseInt(selectedAff)] !== "" ? 
        JSON.parse(MvRouteSettingData[parseInt(selectedAff)]) : []);
      const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
      let fsSelectedData = fsSelection.find((item)=>parseInt(item.FID) === parseInt(FSSelected));
      let selectedDay = new Date(selectedDateSchTime+"T00:00:00");
      let ScheduleTripMinTimeDiff = parseInt((JSON.parse(ASCSSettingData[selectedAff]).find((item) => item.SubTitle === "ScheduleTripMinTimeDiff")).value);
      selectedDay = days[selectedDay.getDay()];

      // console.log(ERSASettingsData, fsSelectedData, selectedDay);

      let bIsUpdate = paratransitBookBtnRef.current.textContent.toLowerCase().includes("update");

      let FsApptTimeWindow = (fsSelectedData.dApptTimeWindow && fsSelectedData.dApptTimeWindow !== ""? fsSelectedData.dApptTimeWindow : 0);
      let FsServiceTimeAmb = (fsSelectedData.serviceTimeAmb && fsSelectedData.serviceTimeAmb !== "" ? fsSelectedData.serviceTimeAmb : 0);
      let FsSeviceTimeWC = (fsSelectedData.serviceTimeWC && fsSelectedData.serviceTimeWC !== "" ? fsSelectedData.serviceTimeWC : 0);
      let FstimeWindow = (fsSelectedData.timeWindow && fsSelectedData.timeWindow !== "" ? fsSelectedData.timeWindow : 0);
      let FsdEndTimeWindow = (fsSelectedData.dEndTimeWindow && fsSelectedData.dEndTimeWindow !== "" ? fsSelectedData.dEndTimeWindow : 0);
      let FsminRideTime = (fsSelectedData.minRideTime && fsSelectedData.minRideTime !== "" ? fsSelectedData.minRideTime : 0);
      let FsmaxRideTime = (fsSelectedData.maxRideTime && fsSelectedData.maxRideTime !== "" ? fsSelectedData.maxRideTime : 0);
      let FsadditionalSameLocAmb = (fsSelectedData.additionalSameLocAmb && fsSelectedData.additionalSameLocAmb !== "" ? fsSelectedData.additionalSameLocAmb : 0);
      let FsadditionalSameLocWC = (fsSelectedData.additionalSameLocWC && fsSelectedData.additionalSameLocWC !== "" ? fsSelectedData.additionalSameLocWC : 0); 

      let bDisableRideSharing = true;
      let MinutesToMinus = 0;
      let ApptWindow = 0;

      if(ERSASettingsData.length > 0)
      {
        let bFound = false;
        let index = 0;
        let selectedERSASetting = null;
        for(let k = 0; k < ERSASettingsData.length; k++)
        {
          if(ERSASettingsData[k].vScheduleDays && ERSASettingsData[k].vScheduleDays.trim() !== '')
          {
            let tempSettingDays = ERSASettingsData[k].vScheduleDays.trim().split('');
            bFound = (tempSettingDays.find((item)=>(item.toLowerCase()) === selectedDay.charAt(0).toLowerCase()) ? true : false);
            if(bFound)
            {
              index = k;
              break;
            }
          }
        }
        
        if(bFound)
        {
          bDisableRideSharing = ERSASettingsData[index].bDisableRideSharing;
          selectedERSASetting = ERSASettingsData[index];
        }
        else //No Setting found for current selected day
        {
          let defaultERSASettingData = ERSASettingsData.filter(item=>item.bDefault === true);
          if(defaultERSASettingData && defaultERSASettingData.length > 0)
          {
            bDisableRideSharing = ERSASettingsData[0].bDisableRideSharing;
            selectedERSASetting = ERSASettingsData[0];
          }
        }
        //PU Time = Appointment Time - Estimated Direct Ride Time from Map Source – Service Time (Amb , Wheel Chair) – Appointment Time window
        if(bDisableRideSharing)
        {
          MinutesToMinus = clientSummary.TripDuration;
        }
        else
        {
          let min = 0;
          let max = 0;

          // if(bIsUpdate && parseInt(FsminRideTime) > 0)
          // {
          //   min = parseFloat(FsminRideTime);
          // }
          // else 
          if(parseInt(FsminRideTime) > 0)
          {
            min = parseFloat(FsminRideTime);
          }
          else
          {
            min = (parseFloat(selectedERSASetting.MinimumRidTimeMin) <= 0 ? 0 : parseFloat(selectedERSASetting.MinimumRidTimeMin));
          }
          // if(bIsUpdate && parseInt(FsmaxRideTime) > 0)
          // {
          //   min = parseFloat(FsmaxRideTime);
          // }
          // else 
          if(parseInt(FsmaxRideTime) > 0)
          {
            max = parseFloat(FsmaxRideTime);
          }
          else
          {
            max = (parseFloat(selectedERSASetting.MaxRideTimePer) <= 0 ? 0 : parseFloat(selectedERSASetting.MaxRideTimePer));
          }
          let EstTime = clientSummary.TripDuration;
          let mrt = (EstTime * parseFloat(max) / 100);
          mrt = (mrt > parseFloat(min) ? mrt : parseFloat(min));
          MinutesToMinus = mrt;
        }
        
        //Wheelchair
        let serviceTime = 0;
        if(passengerTypeCount.totalWC > 0)
        {
          serviceTime = (Array.isArray(clientInfo) ? 0 : (clientInfo.serviceTimeWC && clientInfo.serviceTimeWC !== "" ? clientInfo.serviceTimeWC : 0));
          if(serviceTime > 0)
          {
            MinutesToMinus = MinutesToMinus + (serviceTime * 2);
          }
          else if(parseFloat(FsSeviceTimeWC) > 0)
          {
            MinutesToMinus = MinutesToMinus + (parseFloat(FsSeviceTimeWC) * 2);
          }
          else
          {
            MinutesToMinus = MinutesToMinus + (parseFloat(selectedERSASetting.WCServiceTime) * 2);
          }
        }
        else //Amb
        {
          serviceTime = (Array.isArray(clientInfo) ? 0 : (clientInfo.serviceTimeAmb && clientInfo.serviceTimeAmb !== "" ? clientInfo.serviceTimeAmb : 0));
          if(serviceTime > 0)
          {
            MinutesToMinus = MinutesToMinus + (serviceTime * 2);
          }
          else if(parseFloat(FsServiceTimeAmb) > 0)
          {
            MinutesToMinus = MinutesToMinus + (parseFloat(FsServiceTimeAmb) * 2);
          }
          else
          {
            MinutesToMinus = MinutesToMinus + (parseFloat(selectedERSASetting.AmbServiceTime) * 2);
          }
        }

        //Adding appointment time
        if(bIsUpdate && parseFloat(FsApptTimeWindow) > 0)
        {
          MinutesToMinus = MinutesToMinus + parseFloat(FsApptTimeWindow);
          ApptWindow = parseFloat(FsApptTimeWindow);
        }
        else
        {
          MinutesToMinus = MinutesToMinus + parseFloat(selectedERSASetting.dApptTimeWindow);
          ApptWindow = parseFloat(selectedERSASetting.dApptTimeWindow);
        }
        apptTimeCheckValsRef.current = {ServiceTime:serviceTime, ApptWindow:ApptWindow, TimeWindow: 0};
        let tempTime = "";
        let selectedApptTime = (e.target ? e.target.value : e);
        if(selectedApptTime !== "")
        {
          tempTime = addsubtractMinutesFromMilitaryTime(selectedApptTime, MinutesToMinus);
          setSchTime(tempTime);
          calculatedTimeCheck.current = MinutesToMinus;
        }
      }
    }
    catch(err){console.log(err);}
  };

  const convertMinutesToTime = (totalMinutes) => {
    try{
      const hours24 = Math.floor(totalMinutes / 60); // Get the hour in 24-hour format
      const minutes = totalMinutes % 60; // Get the remaining minutes
      const period = hours24 >= 12 ? "PM" : "AM"; // Determine AM/PM
      const hours12 = hours24 % 12 || 12; // Convert to 12-hour format (0 becomes 12)
      
      // Format the time string with leading zero for minutes if needed
      return `${hours12}:${minutes.toString().padStart(2, '0')} ${period}`;
    }
    catch(err){console.log(err); return '00:00 AM';}
  };

  const handleApptTimeCheck = (e, type = "") =>{
    try{
      if(pickLatLng.current !== "" && dropLatLng.current !== "")
      {
        let timeInput = (Array.isArray(e) ? "" : e.target.value);
        let eventObj = (Array.isArray(e) ? type : e);
        // await getCurrentSystemDateTime("time", false);
        let currentTime = systemDateTimeRef.current.time;
        let time1 = (schTime !== "" ? schTime : currentTime);
        let time2 = (type === "" ? timeInput : type);

        let currTimeUserView = "";
        if(time1 === currentTime){currTimeUserView = systemDateTimeRef.current.givenTime;}
        else{currTimeUserView = time1;}
        if(time2 !== "" && systemDateTime.date === selectedDateSchTime)
        {      
          if(parseInt(time1.split(":")[0]) < parseInt(time2.split(":")[0]))
          {
            // apptTimeRef.current.blur();
            setAppointmentTime(time2);
            handleComputeNewPickupTime(eventObj);
          }
          else if(parseInt(time1.split(":")[0]) === parseInt(time2.split(":")[0]))
          {
            if(parseInt(time1.split(":")[1]) === parseInt(time2.split(":")[1]))
            {
                
              setModalHeaderText("Invalid Appointment Time");
              setModalBodyHTML("Please provide a valid appointment time ahead of the time: "+currTimeUserView+".");
              setModalFooterHTML(
                <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                  OK
                </Button>
              );
              setShowDynamicModal(true);
              if(type !== "")
              {
                setAppointmentTime("");
              }
              else
              {
                setAppointmentTime("");
              }
            }
            else if(parseInt(time1.split(":")[1]) > parseInt(time2.split(":")[1]))
            {
              
              // apptTimeRef.current.blur();
              // handleComputeNewPickupTime(eventObj);
              setModalHeaderText("Invalid Appointment Time");
              setModalBodyHTML("Please provide a valid appointment time ahead of the time: "+currTimeUserView+".");
              setModalFooterHTML(
                <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                  OK
                </Button>
              );
              setShowDynamicModal(true);
              if(type !== "")
              {
                setAppointmentTime("");
              }
              else
              {
                setAppointmentTime("");
              }
            }
            else
            {
              setAppointmentTime(time2);
              handleComputeNewPickupTime(eventObj);
            }
          }
          else
          {
            if(parseInt(time1.split(":")[0]) > parseInt(time2.split(":")[0]))
            {
              if(time1 === currentTime)
              {
                // let ScheduleTripMinTimeDiff = parseInt((JSON.parse(ASCSSettingData[selectedAff]).find((item) => item.SubTitle === "ScheduleTripMinTimeDiff")).value);
                // ScheduleTripMinTimeDiff = (ScheduleTripMinTimeDiff === 0 ? 20:(ScheduleTripMinTimeDiff/60));
                // setModalHeaderText("Invalid Appointment Time");
                // setModalBodyHTML(
                //   <p className="m-0 user-select-none">
                //     {"The current time is "}
                //     <b>{systemDateTimeRef.current.givenDate + " " + systemDateTimeRef.current.givenTime}</b>
                //     {", please choose "}
                //     <b>{ScheduleTripMinTimeDiff}</b>
                //     {" mins ahead of current time for appointment time."}
                //   </p> 
                // );
                // setModalFooterHTML(
                //   <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                //     OK
                //   </Button>
                // );
                // setShowDynamicModal(true);
                // apptTimeRef.current.blur();
                if(systemDateTime.date === selectedDateSchTime)
                {
                  setModalHeaderText("Invalid Appointment Time");
                  setModalBodyHTML("Please provide a valid appointment time ahead of the time: "+currTimeUserView+".");
                  setModalFooterHTML(
                    <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                      OK
                    </Button>
                  );
                  setShowDynamicModal(true);
                  setAppointmentTime("");
                }
                else //selected date is in future
                {
                  setAppointmentTime(time2);
                  handleComputeNewPickupTime(eventObj);
                }
                
              }
              else
              {
                // apptTimeRef.current.blur();
                if(type !== "")
                {
                  setAppointmentTime("");
                }
                else
                {
                  setAppointmentTime(time2);
                }
                handleComputeNewPickupTime(eventObj);
              }
              
            }
            // setModalHeaderText("Invalid Appointment Time");
            // setModalBodyHTML("Please provide a valid appointment time in future.");
            // setModalFooterHTML(
            //   <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
            //     OK
            //   </Button>
            // );
            // setShowDynamicModal(true);
            
            
          }
        } 
        else
        {
          setAppointmentTime(time2);
          handleComputeNewPickupTime(eventObj);
        }
      }
      else
      {
        let timeInput = (Array.isArray(e) ? "" : e.target.value);
        let time2 = (type === "" ? timeInput : type);
        if(time2 !== "")
        {
          setModalHeaderText("Missing Required Info");
          setModalBodyHTML("Please provide valid and different addresses before changing appointment time.");
          setModalFooterHTML(
            <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
          setShowDynamicModal(true);
          setAppointmentTime("");
        }
        // apptTimeRef.current.blur();
        
      }
    }
    catch(err){console.log(err);}
  };

  // Helper to format phone numbers for paratransit
  const formatPhone = (phoneVal) => {
    try{
      const cleanedPhone = phone.replace("+1", "");
      return `${cleanedPhone.substring(0, 3)}-${cleanedPhone.substring(3, 6)}-${cleanedPhone.substring(6)}`;
    }
    catch(err){console.log(err);}
  };

  // Helper to build tempDict
  const createTempDict = () => ({
    StopType: "",
    WaitTime: 0,
    Name: "",
    tripInfo: {
      AffiliateID: 0,
      Description: "",
      OrigionalServiceId: -1,
      CallId: 0,
      ReceivingAffiliateID: -1,
      ClassOfServiceID: 0,
      EntityAttributes: "",
      ReturnTrip: false,
      AgentInstructions: "",
      OutRefID: -1,
      CustomerEmail: "",
      CallbackReq: "",
      CallBackInfo: "",
      SLAClassID: 0,
      AuthorizedBy: "",
      ServiceStatusID: 0,
      IsCheckServiceHours: true,
      IsPredictive: true,
      IsMultiTrip: false,
      ReturnRequestAffiliateID: 0,
      TripPayStatus: 0,
      IsRollingCallTypePhone: false,
      IsRollingCallTypeSMS: false,
      IsRollingCallTypeEmail: false,
      ExtraInfo: "",
      Ext1: "",
      Ext2: "0",
      CallType: 0,
      FareMethod: 0,
      ServiceID: -1,
      ScheduleID: -1,
      RefID: -1,
    },
    passengerInfo: {
      TotalPassengers: 0,
      TotalWheelChairs: 0,
      TotalUnloadPassengers: 0,
      TotalLuggage: 0,
      TotalKids: 0,
      ServiceAnimalCount: "0",
      PCACount: "0",
      PCAWCCount: "0",
    },
    addressDetails: {
      Address: "",
      Longitude: "",
      Latitude: "",
      City: "",
      State: "",
      Zip: "",
      Zone: "",
      Remarks: "",
      Phone: "",
      POIName: "",
    },
    dateInfo: {
      PickupDate: "",
      ApptTime: "",
      RetWillCallDay: "",
      IsWillCall: false,
      IsScheduled: false,
      IsMultiSchedule: false,
    },
    estimatedInfo: {
      EstimatedDistance: 0,
      EstimatedTime: 0,
      EstimatedCost: 0,
      BillableAmount: 0,
      CoPay: 0,
      AdditionalPassCost: 0,
      BillableMiles: 0,
      IsBillingRequired: false,
    },
    paymentInfo: {
      FundingSourceID: 0,
      PaymentTypeID: 0,
      iCopayFundingSourceID: 0,
      iActualPaymentTypeID: 0,
      ReturnCopay: 0,
      CCInfo: "",
      CCResults: "",
      PromoAmount: 0,
    },
    driverInfo: {
      SpecialDriverId: 0,
      AssignedDriverId: 0,
      DriverNoTimeDiff: 0,
      OnlyPreferedDriver: false,
      AssignedDriverNo: 0,
      PreferedDriverNum: "",
      PreferedDriverGender: "",
      OnlyPreferedDriverGender: false,
      OnlyPreferedDriverLanguage: false,
      GenderTimeDiff: 0,
      LangTimeDiff: 0,
      PreferedLanguage: 0,
    },
    vehicleInfo: {
      SpecialVehicleId: 0,
      AssignedVehicleId: 0,
      VehicleTypeId: -1,
      VehicleNoTimeDiff: 0,
      OnlyPreferedVType: false,
      OnlyPreferedVehicle: false,
      AssignedVehNo: "",
      PreferedVehicleNo: "",
    },
  }); 

  // Function to fill address details based on the selection
  const fillAddressDetails = (selection, extraInfo, latLng, stopType, multiTripArr = "", dataType = "", updateData = "", unloadedTotal = 0, attrList="", index = 0) => ({
    StopType: stopType,
    Name: (typeof multiTripArr === 'object' ?  multiTripArr.riderName : riderName),
    WaitTime: 0,
    tripInfo:{
      AffiliateID: (typeof multiTripArr === 'object' ?  parseInt(multiTripArr.AffiliateSelected) : parseInt(selectedAff)),
      Description: "",
      SelfWalletID: (typeof multiTripArr === 'object' ?  parseInt(multiTripArr.fareEstimateAPIData.walletID) : parseInt(fareEstimateAPISummary.walletID)),
      Promocode: (typeof multiTripArr === 'object' ?  multiTripArr.fareEstimateAPIData.promo : fareEstimateAPISummary.promo),
      BrokerMode: (typeof multiTripArr === 'object' ?  parseInt(multiTripArr.broker.globalBrokerMode) : parseInt(brokerModes.globalBrokerMode)),
      FSBrokerMode:(typeof multiTripArr === 'object' ?  parseInt(multiTripArr.broker.brokerMode) : parseInt(brokerModes.brokerMode)),
      EaasJSONResp: (typeof multiTripArr === 'object' ? multiTripArr.fareEstimateAPIData.eaasJSON : fareEstimateAPISummary.eaasJSON),
      OrigionalServiceId: -1,
      CallId: 0,
      ReceivingAffiliateID: -1,
      ClassOfServiceID: (typeof multiTripArr === 'object' ?  multiTripArr.COS : parseInt(COSSelected)),
      EntityAttributes: (typeof multiTripArr === 'object' ?  attrList : (selectedTripAttr === "TA" ? "":attrList)),
      ReturnTrip: (typeof multiTripArr === 'object' ?  multiTripArr.isReturn : returnTripCheckBox),
      AgentInstructions: (typeof multiTripArr === 'object' ?  multiTripArr.notes : agentNotes),
      OutRefID: -1,
      CustomerEmail: (typeof multiTripArr === 'object' ?  multiTripArr.email : clientEmail),
      CallbackReq: (typeof multiTripArr === 'object' ?  (multiTripArr.phone ? true:false) : (callBackPhone ? true:false)),
      CallBackInfo: (typeof multiTripArr === 'object' ?  (multiTripArr.callBackPhone && multiTripArr.callBackPhone.length >= 12 ? 
        (multiTripArr.callBackPhone.includes("-") ? multiTripArr.callBackPhone : (multiTripArr.callBackPhone.replace("+1","").substring(0,3)+"-"+
        multiTripArr.callBackPhone.replace("+1","").substring(3,6)+"-"+
        multiTripArr.callBackPhone.replace("+1","").substring(6,10))) : "") : 
        (callBackPhone ? callBackPhone.replace("+1","").substring(0,3)+"-"+callBackPhone.replace("+1","").substring(3,6)+"-"+
          callBackPhone.replace("+1","").substring(6,10) : "")
        ),
      SLAClassID: (typeof multiTripArr === 'object' ?  multiTripArr.tripPriority : selectedTripPriority),
      AuthorizedBy: "",
      ServiceStatusID: 0,
      IsCheckServiceHours: true,
      IsPredictive: true,
      IsMultiTrip: (verifiedAddr.length === 1 ? true:false),
      ReturnRequestAffiliateID: 0,
      TripPayStatus: 0,
      IsRollingCallTypePhone: (typeof multiTripArr === 'object' ?  multiTripArr.RC.phoneType : RCType.phoneType),
      IsRollingCallTypeSMS: (typeof multiTripArr === 'object' ?  multiTripArr.RC.SMSType : RCType.SMSType),
      IsRollingCallTypeEmail: (typeof multiTripArr === 'object' ?  multiTripArr.RC.emailType : RCType.emailType),
      ExtraInfo: (typeof multiTripArr === 'object' ?  multiTripArr.paymentExtraInfo : paymentAdditionalInfo),
      Ext1: "",
      Ext2: (typeof multiTripArr === 'object' ?  multiTripArr.clientJob : clientJob),
      CallType: (typeof multiTripArr === 'object' ?  multiTripArr.tripType : selectedTripType),
      FareMethod: (typeof multiTripArr === 'object' ?  parseInt(multiTripArr.fareMethod) : parseInt(fareMethod)),
      ServiceID: (dataType.toLowerCase() === "update" ?  (updateData !== "" && updateData.addressInfo.trips[index].details[0].tripInfo.serviceID && String(updateData.addressInfo.trips[index].details[0].tripInfo.serviceID) !== "" ? parseInt(updateData.addressInfo.trips[index].details[0].tripInfo.serviceID) : -1):-1),
      ScheduleID: (dataType.toLowerCase() === "update" ?  (updateData !== "" && updateData.addressInfo.trips[index].details[0].tripInfo.scheduleID && String(updateData.addressInfo.trips[index].details[0].tripInfo.scheduleID) !== "" ? parseInt(updateData.addressInfo.trips[index].details[0].tripInfo.scheduleID) : -1):-1),
      RefID: (dataType.toLowerCase() === "update" ?  
      (updateData !== "" && updateData.addressInfo.trips[index].details[0].tripInfo.refID && String(updateData.addressInfo.trips[index].details[0].tripInfo.refID) !== "" ? parseInt(updateData.addressInfo.trips[index].details[0].tripInfo.refID) : -1):-1),
      preSchedule: (scheduleJSON.mainData !== "" && scheduleJSON.mainData.vPreSch.length > 0 && verifiedAddr.length <= 1 ? scheduleJSON.mainData.vPreSch:"")
    },
    passengerInfo: {
      TotalPassengers: (typeof multiTripArr === 'object' ? (multiTripArr.passCount.total === 0 ? 1 : multiTripArr.passCount.total) : 
      (passengerTypeCount.total === 0 ? 1 : passengerTypeCount.total)),
      TotalWheelChairs: (typeof multiTripArr === 'object' ? multiTripArr.passCount.totalWC : passengerTypeCount.totalWC),
      TotalUnloadPassengers: (typeof multiTripArr === 'object' ? (unloadedTotal !== 0 ? unloadedTotal : 0)  : unloadedTotal),
      TotalLuggage: (dataType.toLowerCase() === "update" ?  parseInt(updateData !== "" && updateData.addressInfo.trips[index].details[0].passengerInfo.totalLuggage ? updateData.addressInfo.trips[index].details[0].passengerInfo.totalLuggage : 0): 0),
      TotalKids: (dataType.toLowerCase() === "update" ?  parseInt(updateData !== "" && updateData.addressInfo.trips[index].details[0].passengerInfo.totalKids ? updateData.addressInfo.trips[index].details[0].passengerInfo.totalKids : 0) : 0),
      ServiceAnimalCount: (typeof multiTripArr === 'object' ? verifiedAddr[0].passCount.totalSA.toString() : String(passengerTypeCount.totalSA)),
      PCACount: (dataType.toLowerCase() === "update" ?  (updateData !== "" && updateData.addressInfo.trips[index].details[0].passengerInfo.pcaCount ? updateData.addressInfo.trips[index].details[0].passengerInfo.pcaCount : "0") : "0"),
      PCAWCCount: (dataType.toLowerCase() === "update" ?  (updateData !== "" && updateData.addressInfo.trips[index].details[0].passengerInfo.pcawcCount ? updateData.addressInfo.trips[index].details[0].passengerInfo.pcawcCount : "0") : "0")
    },
    addressDetails: {
      Address: (typeof multiTripArr === 'object' ? (stopType === "pickup" ? (multiTripArr.pickAddr.includes(",") 
      ? multiTripArr.pickAddr.split(",")[0] : multiTripArr.pickAddr) : (multiTripArr.dropAddr.includes(",") 
      ? multiTripArr.dropAddr.split(",")[0] : multiTripArr.dropAddr)) : (dataType.toLowerCase() !== "update" ? 
      (selection?.Type === "recent"
        ? (selection.data['Address'].includes(",") ? 
          selection.data['Address'].split(",")[0] : selection.data['Address'])
        : (selection?.Type === "poi" ? (selection.data?.address) : (selection[0]?.addressParsedObject?.Address.includes(",") ? 
        selection[0]?.addressParsedObject?.Address.split(",")[0] : selection[0]?.addressParsedObject?.Address)) ?? 
        (selection.Address.includes(",") ? selection.Address.split(",")[0] : selection.Address)) : 
        (stopType ==="pickup" ? (pickupAddr.includes(",") ? pickupAddr.split(",")[0] : pickupAddr): (dropAddr.includes(",") ? dropAddr.split(",")[0] : dropAddr))
      )),
      Latitude: parseFloat(
        selection?.Type === "recent"
          ? selection.data['Lat']
          : latLng.split(",")[0]
      ),
      Longitude: parseFloat(
        selection?.Type === "recent"
          ? selection.data['Long']
          : latLng.split(",")[1]
      ),
      City: (typeof multiTripArr === 'object' ? (stopType === "pickup" ? multiTripArr.addressExtraDetails.pick.city : multiTripArr.addressExtraDetails.drop.city) : 
      (stopType === "pickup" ? addressInfoDetails.current.pick.city : addressInfoDetails.current.drop.city)),
      State: (typeof multiTripArr === 'object' ? (stopType === "pickup" ? multiTripArr.addressExtraDetails.pick.state : multiTripArr.addressExtraDetails.drop.state) : 
      (stopType === "pickup" ? addressInfoDetails.current.pick.state : addressInfoDetails.current.drop.state)),
      Zip: (typeof multiTripArr === 'object' ? (stopType === "pickup" ? multiTripArr.addressExtraDetails.pick.zip : multiTripArr.addressExtraDetails.drop.zip) : 
      (stopType === "pickup" ? addressInfoDetails.current.pick.zip : addressInfoDetails.current.drop.zip)),
      Zone: (typeof multiTripArr === 'object' ? (stopType === "pickup" ? multiTripArr.dispatchZones.pickZone : multiTripArr.dispatchZones.dropZone):(stopType === "pickup" ? dispatchZones.pickZone : dispatchZones.dropZone)), 
      FareZone: (typeof multiTripArr === 'object' ? (stopType === "pickup" ? multiTripArr.fareZones.pick : multiTripArr.fareZones.drop):(stopType === "pickup" ? fareZones.pick : fareZones.drop)),
      Remarks: extraInfo,
      Phone: (typeof multiTripArr === 'object' ? (multiTripArr.phone.includes("-") ? (multiTripArr.phone):(multiTripArr.phone.replace("+1","").substring(0,3)+"-"+
        multiTripArr.phone.replace("+1","").substring(3,6)+"-"+multiTripArr.phone.replace("+1","").substring(6,10))): 
        (phone.replace("+1","").substring(0,3)+"-"+phone.replace("+1","").substring(3,6)+"-"+phone.replace("+1","").substring(6,10))),
      POIName: (typeof multiTripArr === 'object' ? (stopType === "pickup" ? multiTripArr.pickPOI : multiTripArr.dropPOI) : 
      (stopType === "pickup" ? pickPOI : dropPOI))
    },
    dateInfo:{
      PickupDate: (typeof multiTripArr === 'object' ? 
        (multiTripArr.willCall ? systemDateTime.date : multiTripArr.date + " "+ (multiTripArr.time === "" ? systemDateTimeRef.current.timeWithSettingAdded:multiTripArr.time)): 
        (schTime === ""? (willCall ? systemDateTime.date: selectedDateSchTime +" "+systemDateTimeRef.current.timeWithSettingAdded): selectedDateSchTime + " " + schTime)),
      ApptTime: (typeof multiTripArr === 'object' ? (multiTripArr.apptTime !== "Will Call" && multiTripArr.apptTime !== "" ? multiTripArr.date + " " + multiTripArr.apptTime : "01/01/1900 00:00:00") : (appointmentTime === ""? "01/01/1900 00:00:00" : selectedDateSchTime + " " + appointmentTime)),
      WillCallDay: (typeof multiTripArr === 'object' ? (multiTripArr.willCall ? multiTripArr.date : "01/01/1900 00:00:00") : (willCall ? selectedDateSchTime : "01/01/1900 00:00:00")),
      IsWillCall:(typeof multiTripArr === 'object' ? multiTripArr.willCall: willCall),
      IsScheduled: (scheduleJSON.mainData !== "" && scheduleJSON.mainData.Schedule.ScheduleItem.length > 0 && verifiedAddr.length <= 1) ? true : (typeof multiTripArr === 'object' ? ((multiTripArr.time === "" ? false : true)): (dataType === "update" ?  (updateData !== "" ? updateData.addressInfo.trips[index].details[0].dateInfo.isScheduled : false) : ((schTime !== "" || willCall) ? true : false))),
      IsMultiSchedule:(scheduleJSON.mainData !== "" && scheduleJSON.mainData.Schedule.ScheduleItem.length > 0 && verifiedAddr.length <= 1 ? true : false)
    },
    estimatedInfo:{
      EstimatedDistance: (typeof multiTripArr === 'object' ? parseFloat(multiTripArr.distance) : parseFloat(clientSummary.tripDistance)),
      EstimatedTime: (typeof multiTripArr === 'object' ? parseFloat(multiTripArr.duration) : parseFloat(clientSummary.TripDuration)),
      EstimatedCost: (typeof multiTripArr === 'object' ? parseFloat(multiTripArr.fare) : parseFloat(clientSummary.TripFare)),
      BillableAmount: (typeof multiTripArr === 'object' ? multiTripArr.billableAmount : fareDataArr.billableAmount),
      AdditionalPassCost: (typeof multiTripArr === 'object' ? multiTripArr.additionalPassengerCost : fareDataArr.additionalPassengerCost),
      BillableMiles: 0,
      CoPay: (typeof multiTripArr === 'object' ? parseFloat(multiTripArr.copay) : parseFloat(copayAmount)),
      CopayPrice:(typeof multiTripArr === 'object' ? parseFloat(multiTripArr.fareEstimateAPIData.copay) : parseFloat(fareEstimateAPISummary.copay)),
      IsBillingRequired: false
    },
    paymentInfo:{
      FundingSourceID: (typeof multiTripArr === 'object' ? parseInt(multiTripArr.FundingSource) : parseInt(FSSelected)),
      PaymentTypeID: (typeof multiTripArr === 'object' ? parseInt(multiTripArr.PaymentSelected) : parseInt(PaySelected)), 
      iCopayFundingSourceID: (typeof multiTripArr === 'object' ? parseInt(multiTripArr.copayFS) : parseInt(copayFSSelected)),
      iActualPaymentTypeID: (typeof multiTripArr === 'object' ? parseInt(multiTripArr.copayPayType) : parseInt(copayPayTypeSelected)),
      ReturnCopay: (typeof multiTripArr === 'object' ? parseFloat(multiTripArr.copay) : (returnTripCheckBox ? copayAmount: 0)),
      CCInfo: (typeof multiTripArr === 'object' ? (multiTripArr.cardNum +","+ multiTripArr.cardExp) : (cardNumber+","+cardExpiration)),
      CCResults: "",
      PromoAmount: 0
    },
    driverInfo:{
      SpecialDriverId: (typeof multiTripArr === 'object' ? (multiTripArr.driverNum === "DN" ? 0:multiTripArr.driverNum.split("_")[0]) : 
        (selectedDriverNum === "DN" ? 0:selectedDriverNum.split("_")[0])),
      AssignedDriverId: (typeof multiTripArr === 'object' ? (multiTripArr.driverNum === "DN" ? 0:multiTripArr.driverNum.split("_")[0]) : 
        (selectedDriverNum === "DN" ? 0:selectedDriverNum.split("_")[0])),
      DriverNoTimeDiff: (typeof multiTripArr === 'object' ? multiTripArr.driverMins : mobilityDetails.driverNumMin),
      OnlyPreferedDriver: (typeof multiTripArr === 'object' ? multiTripArr.driverNumCheck : mobilityChecks.driverNumCheck),
      AssignedDriverNo: (typeof multiTripArr === 'object' ? (multiTripArr.driverNum === "DN" ? "":multiTripArr.driverNum.split("_")[1]) : 
        (selectedDriverNum === "DN" ? "":selectedDriverNum.split("_")[1])),
      PreferedDriverNum: (typeof multiTripArr === 'object' ? (multiTripArr.driverNum === "DN" ? "":multiTripArr.driverNum.split("_")[1]) : 
        (selectedDriverNum === "DN" ? "":selectedDriverNum.split("_")[1])),
      PreferedDriverGender: (typeof multiTripArr === 'object' ? (multiTripArr.gender === "Gender" ? "":multiTripArr.gender) : 
        (selectedGender === "Gender" ? "":selectedGender)),
      OnlyPreferedDriverGender: (typeof multiTripArr === 'object' ? multiTripArr.genderCheck : mobilityChecks.genderCheck),
      OnlyPreferedDriverLanguage: (typeof multiTripArr === 'object' ? multiTripArr.languageCheck : mobilityChecks.languageCheck),
      GenderTimeDiff:(typeof multiTripArr === 'object' ? multiTripArr.genderMins : mobilityDetails.genderMin),
      LangTimeDiff:(typeof multiTripArr === 'object' ? multiTripArr.languageMins : mobilityDetails.languageMin),
      PreferedLanguage:(typeof multiTripArr === 'object' ? (multiTripArr.language === "Language" ? 0 : multiTripArr.language) : 
        (selectedLanguage === "Language" ? 0:selectedLanguage)),
    },
    vehicleInfo:{
      SpecialVehicleId: (typeof multiTripArr === 'object' ? (multiTripArr.vehNum === "VN" ? 0:multiTripArr.vehNum.split("_")[0]) : 
        (selectedVehNum === "VN" ? 0:selectedVehNum.split("_")[0])),
      AssignedVehicleId: (typeof multiTripArr === 'object' ? (multiTripArr.vehNum === "VN" ? 0:multiTripArr.vehNum.split("_")[0]) : 
        (selectedVehNum === "VN" ? 0:selectedVehNum.split("_")[0])),
      VehicleTypeId: (typeof multiTripArr === 'object' ? (multiTripArr.vehType === "VT" ? -1:parseInt(multiTripArr.vehType)) : 
        (selectedVehType === "VT" ? -1:parseInt(selectedVehType))),
      VehicleNoTimeDiff: (typeof multiTripArr === 'object' ? multiTripArr.vehMins : mobilityDetails.vehNumMin),
      OnlyPreferedVType: (typeof multiTripArr === 'object' ? multiTripArr.vehTypeCheck : mobilityChecks.vehTypeCheck),
      OnlyPreferedVehicle: (typeof multiTripArr === 'object' ? multiTripArr.vehNumCheck : mobilityChecks.vehNumCheck),
      AssignedVehNo: (typeof multiTripArr === 'object' ? (multiTripArr.vehNum === "VN" ? "":multiTripArr.vehNum.split("_")[1]) : 
        (selectedVehNum === "VN" ? "":selectedVehNum.split("_")[1])),
      PreferedVehicleNo: (typeof multiTripArr === 'object' ? (multiTripArr.vehNum === "VN" ? "":multiTripArr.vehNum.split("_")[1]) : 
        (selectedVehNum === "VN" ? "":selectedVehNum.split("_")[1])),
    },
  });

  const VerifyCCAmount = (Amount, index = 0) => {
    try{
      if (Amount.Total !== "" && parseFloat(Amount.Total) > 0) 
      {
        // Call API for Checking CC Amount
        let bSchTrip = false;
        let bWillCall = false;
        let PUDate = "";
        let PUTime = "";
        let bDropInfo = true;
        let iNewRefIDForCC = -1;
        let iNewReturnRefIDForCC = -1;
        let areaCode = phone.replace("+1","").substring(0,3);
        let firstPart = phone.replace("+1","").substring(3,6);
        let secondPart = phone.replace("+1","").substring(6,10);
        try {
          bSchTrip = (schTime !== "" || willCall ? true : false);
          bWillCall = willCall;
          PUDate = formatDate(selectedDateSchTime);
          PUTime = militaryToStandardTime(schTime);
          bDropInfo = (dropLatLng.current !== "");
        } catch (ex) { }

        if (paratransitBookBtnRef.current.textContent.toLowerCase().includes("update")) {
          const queryParams = new URLSearchParams(window.location.search);
          const tripSelected = queryParams.get('TripSelected') || activeTripSelected? true:false;
          let editRowData = (PersistStorage.retrieve("rowDataEditTrip", true)  && tripSelected? PersistStorage.retrieve("rowDataEditTrip", true):"");
          iNewRefIDForCC = (editRowData !== "" && typeof editRowData === 'object'? editRowData.addressInfo.trips[index].details[0].tripInfo.refID : "");
        }

        let CheckCCParams = {
          "AffID": parseInt(selectedAff), 
          "amount": Amount.Go, 
          "pu_date": PUDate,
          "pu_time": PUTime, 
          "is_willcall": bWillCall, 
          "cc_unique_id": "", 
          "is_drop_info_available": bDropInfo,
          "phone_no": areaCode+"-"+firstPart+"-"+secondPart, 
          "app_id": iAppID, 
          "ref_id": iNewRefIDForCC,
          "is_multisch": (scheduleJSON.mainData !== "" && scheduleJSON.mainData.Schedule.ScheduleItem.length > 0 && verifiedAddr.length <= 1 ? true : false), 
          "return_trip": null
        };
        paymentCardIDInfoRef.current.uniqueID = -2;
        paymentCardIDInfoRef.current.invalidForSave = -1;
        paymentCardIDInfoRef.current.retCCUniqueID = -2;
        let stringData = JSON.stringify(CheckCCParams);
        setCheckCCParams(stringData);
        // CheckCCAmount(CheckCCParams); 
      }
    }
    catch(err){console.log(err);}
  };

  const CheckCCAmountResponseHandler = async (response) => {
    try{
      let iNewRefIDForCC = -1;
      let iNewReturnRefIDForCC = -1;
      if(!response || response === "")
      {
        setModalHeaderText("Error on CC Transaction");
        setModalBodyHTML("Invalid response while performing CC Transaction.");
        setModalFooterHTML(
            <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
            OK
            </Button>
        );
        setShowDynamicModal(true);
      }
      else if(response && response.error !== "")
      {
        let Error = response.error;
        setModalHeaderText("Error on CC Transaction");
        setModalBodyHTML("Please try with another card as following error occured while performing CC Transaction: " + Error);
        setModalFooterHTML(
            <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
            OK
            </Button>
        );
        setShowDynamicModal(true);
      }
      else
      {
        if(response.data.Trip.confNo && response.data.Trip.confNo !== ""){ iNewRefIDForCC = parseInt(response.data.Trip.confNo);}
        if(response.data.Trip.TranStatus && response.data.Trip.TranStatus !== "success")
        {
          setModalHeaderText("CC Transaction Failed");
          setModalBodyHTML("CC transaction failed for the following reason: " + response.data.Trip.Msg);
          setModalFooterHTML(
          <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
          </Button>
          );
          setShowDynamicModal(true);
          paymentCardIDInfoRef.current.uniqueID = -2;
          paymentCardIDInfoRef.current.retCCUniqueID = -2;
          paymentCardIDInfoRef.current.invalidForSave = -3;
          return;
        }
        else
        {
          paymentCardIDInfoRef.current.uniqueID = cardInfo.uniqueID;
          if(response.data.Trip.PayStausID && response.data.Trip.PayStausID !== ""){paymentCardIDInfoRef.current.payStatusID = parseInt(response.data.Trip.PayStausID);}
        }
        if (response.data.RetTrip) {
          if (response.data.RetTrip.confNo && response.data.RetTrip.confNo !== ""){ iNewReturnRefIDForCC = parseInt(response.data.RetTrip.confNo);}
          if (response.data.RetTrip.TranStatus !== "success") {
            setModalHeaderText("CC Transaction Failed");
            setModalBodyHTML("Remove return trip, system will not save this trips as CC transaction has failed for the following reason: " + response.data.Trip.Msg);
            setModalFooterHTML(
                <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                OK
                </Button>
            );
            setShowDynamicModal(true);
            paymentCardIDInfoRef.current.retCCUniqueID = -2;
            paymentCardIDInfoRef.current.invalidForSave = -2;
            return;
          }
          else paymentCardIDInfoRef.current.retCCUniqueID = paymentCardIDInfoRef.current.uniqueID;
        }
        paymentCardIDInfoRef.current.invalidForSave = 1;
        await validateMinScheduleTimeDifference(null, false, false, 'book', {bCallAfterCCCheck: true, iNewRefID: iNewRefIDForCC, iNewReturnRefID: iNewReturnRefIDForCC});
      }
    }
    catch(err) {console.log(err);}
  };
  
  const CheckIfCCRequired = () => {
    try{
      let ObjAmount = { "Total": 0.00, "Go": 0.00, "Ret": 0.00 };
      let tempTarget = PayDropdown.find((option)=> (option?.props && parseInt(option.props.value) === parseInt(PaySelected)));
      let copayTempTarget = PayDropdown.find((option)=> (option?.props && parseInt(option.props.value) === parseInt(copayPayTypeSelected)));
      if(tempTarget && tempTarget.props.children.toLowerCase().includes("card"))
      {
        ObjAmount.Go = parseFloat(clientSummary.TripFare);
        ObjAmount.Total = parseFloat(clientSummary.TripFare);
      }
      else if(copayTempTarget && copayTempTarget.props.children.toLowerCase().includes("card"))
      {
        ObjAmount.Go = parseFloat(fareEstimateAPISummary.copay);
        ObjAmount.Total = parseFloat(fareEstimateAPISummary.copay);
      }

      return ObjAmount;
    }
    catch(err){console.log(err); return { "Total": 0.00, "Go": 0.00, "Ret": 0.00 };}
  };

  function IsAppointmentTimeValid() {
    try{
      let retVal = true;

      if(appointmentTime === "" || schTime === "")
      {
        return retVal;
      }
      let DRT = parseFloat(clientSummary.TripDuration);
      let timeInMinutes = apptTimeCheckValsRef.current.ApptWindow + (2 * apptTimeCheckValsRef.current.ServiceTime) + DRT;
      const [hours, minutes] = appointmentTime.split(':').map(Number);
      const [PUhours, PUminutes] = schTime.split(':').map(Number);
      let TimeWindow = "";
      let apptTimeInMinutes = hours * 60 + minutes;
      let puTimeInMinutes = PUhours * 60 + PUminutes;

      TimeWindow = apptTimeInMinutes - timeInMinutes;

      retVal = puTimeInMinutes <= TimeWindow;

      TimeWindow = convertMinutesToTime(TimeWindow);
      apptTimeCheckValsRef.current.TimeWindow = TimeWindow;

      return retVal;
    }
    catch(err){console.log(err); return false;}
  }

  const GetCCTransInfo = async (refID, mode) => { //CC Info Update related function for future development (01/10/25)
    try{
      setShowAPILoader(true);
      let myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
      let headersObj = headersToObject(myHeaders);
      let response = await APICom.fetchData("ReservationCoreURL", "api/ParatransitCT/GetCustomerProfileByServiceID", "post", headersObj, {"RefID" : refID});
      if(response && response.data !== "")
      {
        let parsedData = JSON.parse(response.data);
        if(!parsedData.hasOwnProperty("Message"))
        {
          if(mode === 0)
            paymentCardIDInfoRef.current.CCPaidAmount = parsedData[0].Amount;
          else
            paymentCardIDInfoRef.current.CCRetPaidAmount = parsedData[0].Amount;
        }
        else
        {
          if(mode === 0)
            paymentCardIDInfoRef.current.CCPaidAmount = 0;
          else
            paymentCardIDInfoRef.current.CCRetPaidAmount = 0;
        }
      }
    }
    catch(err){console.log(err); setShowAPILoader(false);}
  };

  const handleParatransitCreateUpdateChecks = () => { //Function to automatically take care of edge case checks for paratransit reservation (optimizing efficiency)
    try{
      let schTimeCheck = IsAppointmentTimeValid();
      let isPickDropSame = sameAddrVerification(pickupAddr, dropAddr);
      let condition = true;
      if(passengerTypeCount.total === 0)
      {
        setModalHeaderText("Information Required");
        setModalBodyHTML("Total passenger count can not be 0.");
        setModalFooterHTML(
          <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
            OK
          </Button>
        );
        condition = false;
      }
      else if(!schTimeCheck)
      {
        setModalHeaderText("Stop Order Alert");
        setModalBodyHTML(<>{"Selected pickup time is violating appointment time, please select PU Time earlier than ["+apptTimeCheckValsRef.current.TimeWindow+"]."}</>);
        setModalFooterHTML(
          <>
          <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
            OK
          </Button>
          </>
        );
        condition = false;
      }
      else if(isPickDropSame)
      {
        setModalHeaderText("Duplicate Address");
        setModalBodyHTML("Please select two different and verified addresses.");
        setModalFooterHTML(
          <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
            OK
          </Button>
        );
        condition = false;
      }
      else if(parseInt(brokerModes.brokerMode) > 0 && parseInt(brokerModes.globalBrokerMode) > 0 && riderVerification.toLowerCase().includes("not"))
      {
        setModalHeaderText("Invalid Rider ID");
        setModalBodyHTML("Please provide a valid rider ID or a different funding source to continue.");
        setModalFooterHTML(
          <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
            OK
          </Button>
        );
        condition = false;
      }
      else if((verifiedAddr.length === 0 || pickLatLng.current === "" || dropLatLng.current === ""))
      {
        paratransitBookBtnRef.current.disabled = false;
        if(pickLatLng.current === "" || dropLatLng.current === "")
        {
          setModalHeaderText("Information Required");
          setModalBodyHTML("Please select pickup and dropoff addresses from the suggested dropdown.");
          setModalFooterHTML(
            <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
          condition = false;
        }
      }

      if(!condition)
      {
        setShowDynamicModal(true);
        setModalClass("");
        setShowAPILoader(false);
        paratransitBookBtnRef.current.disabled = false;
        return false;
      }
      else
      {
        return true;
      }
    }
    catch(err){console.log(err); return false;}
  };

  const handleCreateUpdateParatransitTrip = async(isTimeValid = false, bookingCCDict = {bCallAfterCCCheck : false, iNewRefID : -1, iNewReturnRefID: -1})=>{
    try{
      
      let exclusionsListArr = (scheduleJSON.mainData !== "" && scheduleJSON.mainData.Exclusions.length > 0 ? scheduleJSON.mainData.Exclusions.map((item, index)=>{
        return {
          "ExclusionDate": (item.Date.split(" - ")[0] +" "+ item.Date.split(" - ")[1]),
          "ScheduleId": 0,
          "UserId": (loginData.iUserID ? loginData.iUserID : 0),
          "IsHoliday": item.isHolidayExc
        };
      }) : []);
      let multiSchItems = (scheduleJSON.mainData !== "" && scheduleJSON.mainData.Schedule ? scheduleJSON.mainData.Schedule : {});
      if(riderName.trim().length >= 2 && phone && phone.length >= 12)
      {
        let validateConditions = handleParatransitCreateUpdateChecks();
        if(!bookingCCDict.bCallAfterCCCheck && false) //Temporarly disabled by Kamran until new payload is provided
        {
          let CCAmount = CheckIfCCRequired();
          if(paymentCardIDInfoRef.current.invalidForSave === -2)
          {
            if(CCAmount.Ret !== "" && parseFloat(CCAmount.Ret) > 0)
            {
              setModalHeaderText("CC Transaction Failed");
              setModalBodyHTML("Please remove return trip, as it does not qualifies for CC payment.");
              setModalFooterHTML(
                <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                  OK
                </Button>
              );
              setModalClass("");
              setShowDynamicModal(true);
              setShowAPILoader(false);
              paratransitBookBtnRef.current.disabled = false;
              return;
            }
            else
            {
              paymentCardIDInfoRef.current.invalidForSave = 1;
              paymentCardIDInfoRef.current.retCCUniqueID = -2;
            }
          }
          else if(paymentCardIDInfoRef.current.invalidForSave === -3)
          {
            if(CCAmount.Go !== "" && parseFloat(CCAmount.Go) > 0)
            {
              setModalHeaderText("CC Transaction Failed");
              setModalBodyHTML("Please select another card or change payment type, as trip does not qualifies for CC Payment.");
              setModalFooterHTML(
                <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                  OK
                </Button>
              );
              setModalClass("");
              setShowDynamicModal(true);
              setShowAPILoader(false);
              paratransitBookBtnRef.current.disabled = false;
              return;
            }
            else
            {
              paymentCardIDInfoRef.current.invalidForSave = 1;
              paymentCardIDInfoRef.current.uniqueID = -2;
              paymentCardIDInfoRef.current.retCCUniqueID = -2;
            }
          }
          if(paymentCardIDInfoRef.current.invalidForSave < 1 && CCAmount.Total !== "" && parseFloat(CCAmount.Total) > 0)
          {
            if(cardInfo.uniqueID === 0)
            {
              setModalHeaderText("CC Selection Alert");
              setModalBodyHTML("Credit Card is invalid, do you still want to continue saving the trip?");
              setModalFooterHTML(
                <>
                  <Button variant='dark' className="border-0" onClick={()=>
                    {setShowDynamicModal(false); handleCreateUpdateParatransitTrip(isTimeValid, {bCallAfterCCCheck: true, iNewRefID: -1, iNewReturnRefID: -1});}}
                  >
                    Yes
                  </Button>
                  <Button variant='secondary' className="border-0" onClick={()=>
                    {setShowDynamicModal(false); setShowAPILoader(false); paratransitBookBtnRef.current.disabled = false;}}
                  >
                    No
                  </Button>
                </>
              );
              setModalClass("");
              setShowDynamicModal(true);
              return;
            }
            if(submitParatransitBtnTitle !== "Update")
            {
              VerifyCCAmount(CCAmount);
              setShowAPILoader(false);
              paratransitBookBtnRef.current.disabled = false;
              return;
            }
            else
            { //For update condition ONLY (Commented by Kamran for future development 01/10/25)
              let CCPrePaymentMethod = ASCSSettingData ? (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "CCPrePaymentMethodOnTripBooking")).value : 0;
              // if(CCPrePaymentMethod !== "2")
              // {
              //   //cardInfo.uniqueID being old UniqueID while paymentCardRef constantly updates
              //   if(cardInfo.uniqueID !== 0 && cardInfo.uniqueID !== paymentCardIDInfoRef.current.uniqueID && paymentCardIDInfoRef.current.CCPaidAmount !== 0)
              //   {
              //     setModalHeaderText("CC Selection Alert");
              //     setModalBodyHTML("Trip was already paid with another credit card, you cannot change credit card.");
              //     setModalFooterHTML(
              //       <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
              //         OK
              //       </Button>
              //     );
              //     setModalClass("");
              //     setShowDynamicModal(true);
              //     setShowAPILoader(false);
              //     paratransitBookBtnRef.current.disabled = false;
              //     return;
              //   }
              //   else if(cardInfo.uniqueID !== paymentCardIDInfoRef.current.uniqueID && paymentCardIDInfoRef.current.CCPaidAmount === 0)
              //   {
              //     VerifyCCAmount(CCAmount);
              //     setShowAPILoader(false);
              //     paratransitBookBtnRef.current.disabled = false;
              //     return;
              //   }
              //   else
              //   {
              //     paymentCardIDInfoRef.current.uniqueID = cardInfo.uniqueID;
              //   }
              // }
              // else
              // {
              //   if(cardInfo.uniqueID === paymentCardIDInfoRef.current.uniqueID && 
              //     (CCAmount.Go !== "" && parseFloat(CCAmount.Go).toFixed(2) > parseFloat(paymentCardIDInfoRef.current.CCPaidAmount).toFixed(2))
              //     || (CCAmount.Ret !== "" && parseFloat(CCAmount.Ret).toFixed(2) > parseFloat(paymentCardIDInfoRef.current.CCRetPaidAmount).toFixed(2))
              //   )
              //   {
              //     if(CCAmount.Go !== "" && parseFloat(CCAmount.Go).toFixed(2) > parseFloat(paymentCardIDInfoRef.current.CCPaidAmount).toFixed(2))
              //     {
              //       CCAmount.Go = (parseFloat(CCAmount.Go) - parseFloat(paymentCardIDInfoRef.current.CCPaidAmount)).toFixed(2);
              //     }
              //     else
              //     {
              //       CCAmount.Go = 0.0;
              //     }
              //     if(CCAmount.Ret !== "" && parseFloat(CCAmount.Ret).toFixed(2) > parseFloat(paymentCardIDInfoRef.current.CCRetPaidAmount).toFixed(2))
              //     {
              //       CCAmount.Ret = (parseFloat(CCAmount.Ret) - parseFloat(paymentCardIDInfoRef.current.CCRetPaidAmount)).toFixed(2);
              //     }
              //     else
              //     {
              //       CCAmount.Ret = 0.0;
              //     }
              //     if(CCAmount.Go === "")
              //     {
              //       CCAmount.Go = 0.0;
              //     }
              //     if(CCAmount.Ret === "")
              //     {
              //       CCAmount.Ret = 0.0;
              //     }
              //     CCAmount.Total = (parseFloat(CCAmount.Go) + parseFloat(CCAmount.Ret)).toFixed(2);
              //     VerifyCCAmount(CCAmount);
              //     setShowAPILoader(false);
              //     paratransitBookBtnRef.current.disabled = false;
              //     return;
              //   }
              //   else if(cardInfo.uniqueID !== paymentCardIDInfoRef.current.uniqueID && paymentCardIDInfoRef.current.CCPaidAmount === 0)
              //   {
              //     VerifyCCAmount(CCAmount);
              //     setShowAPILoader(false);
              //     paratransitBookBtnRef.current.disabled = false;
              //     return;
              //   }
              //   else if(cardInfo.uniqueID !== 0 && cardInfo.uniqueID !== paymentCardIDInfoRef.current.uniqueID && paymentCardIDInfoRef.current.CCPaidAmount !== 0)
              //   {
              //     setModalHeaderText("CC Selection Alert");
              //     setModalBodyHTML("Trip was already paid with another credit card, you cannot change credit card.");
              //     setModalFooterHTML(
              //       <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
              //         OK
              //       </Button>
              //     );
              //     setModalClass("");
              //     setShowDynamicModal(true);
              //     setShowAPILoader(false);
              //     paratransitBookBtnRef.current.disabled = false;
              //     return;
              //   }
              //   else
              //   {
              //     paymentCardIDInfoRef.current.uniqueID = cardInfo.uniqueID;
              //   }
              // }
            }
          }
        }
        if(submitParatransitBtnTitle === "Update")
        {
          if(validateConditions)
          {
            let bIsScheduledVar = false;
            let currDate = systemDateTimeRef.current.date;
            let currTime = systemDateTimeRef.current.time;
            if(schTime !== "" || (currDate !== selectedDateSchTime))
            {
              bIsScheduledVar = true;
            }
            let stopsArr = [];
            const queryParams = new URLSearchParams(window.location.search);
            const tripSelected = queryParams.get('TripSelected') || activeTripSelected? true:false;
            let editRowData = (PersistStorage.retrieve("rowDataEditTrip", true)  && tripSelected? PersistStorage.retrieve("rowDataEditTrip", true):"");
            let combinedDataAddedTime = ASCSSettingData ? (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "Ta01")).value : 0;
            let combinedDataDefaultShowPhone = ASCSSettingData ? (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "DefaultCustomerShowPhoneNo")).value: false;
            let fsData = FundingSourceData ? JSON.parse(FundingSourceData[parseInt(selectedAff)]) : [];
            let combinedDataDefaultSkipPaymentScreen = fsData.length > 0 ? ((fsData.find((item)=> parseInt(item.FID) === parseInt(FSSelected)))?.bSkipPaymentProcessOnSD) : false;
            let combinedDataDefaultUseHTMLFormatEmail = ASCSSettingData ? (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "UseHTMLFormatEmail")).value : false;
            let combinedDataSendEmailFromSAS = ASCSSettingData ? (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "Web_Shuttle_SendEmailFromSASCode")).value : false;
            let combinedDataSRDuplicateDelay = ASCSSettingData ? (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "SRDuplicateCallDelay")).value : 0;
            let data = {}
            let attrStringList = "";
            for(let m = 0; m < selectedTripAttr.length; m++)
            {
              if(m !== (selectedTripAttr.length-1))
              {
                attrStringList += selectedTripAttr[m]+",";
              }
              else
              {
                attrStringList += selectedTripAttr[m];
              }
            }
            let firstName = riderName.trim().includes(",") ? riderName.trim().split(",")[1].trim() : (riderName.trim().includes(" ")? riderName.trim().split(" ")[0].trim(): riderName);
            let lastName = riderName.trim().includes(",") ? riderName.trim().split(",")[0].trim() : (riderName.trim().includes(" ")? riderName.replace(firstName, "").trim(): "");
            setModalHeaderText("Updating In Progress");
            setModalBodyHTML("Trip is being updated, please wait.");
            setModalFooterHTML("");
            setModalClass("d-none");
            setShowAPILoader(true);
            setShowDynamicModal(true);
            let nTotalUnloaded = 0;
            if(verifiedAddr.length === 0)
            {
              
              for(let l = 0; l < clientStops.length; l++)
              {
                if(clientStops[l].passLoadType !== "none" && clientStops[l].passLoadType === "unload")
                {
                  nTotalUnloaded += clientStops[l].stopPax.total;
                }
              }
              //Single trip update 
              let pickupStop = fillAddressDetails(
                mapPointPickupSelection.current,
                pickExtraInfo,
                pickLatLng.current,
                "pickup", 
                "",
                "update",
                editRowData,
                nTotalUnloaded, 
                attrStringList
              );
              stopsArr.push(pickupStop);

              let tempDict = {};
              
              if(clientStops.length > 0)
              {
                let myHeaders = new Headers();
                myHeaders.append("Authorization", 'Basic '+btoa(OSRM_Username + ":" + OSRM_Password));
                myHeaders.append('Content-Type', 'application/json');
                let addressAPI = ITCMapRawURL+'directionswithstoporder';
                let headersObj = headersToObject(myHeaders);
                let stopDetailsTrackerArr = [];
                let stopsDetailsArr = [{
                  "StopOrder": 1,
                  "StopLat": pickLatLng.current.split(",")[0],
                  "StopLong": pickLatLng.current.split(",")[1]
                }, ...clientStops.map((item,index)=>{
                  return {
                    "StopOrder": (index+2),
                    "StopLat": item.stopLatLng.split(",")[0],
                    "StopLong": item.stopLatLng.split(",")[1]
                  };
                }), {
                  "StopOrder": (clientStops.length + 2),
                  "StopLat": dropLatLng.current.split(",")[0],
                  "StopLong": dropLatLng.current.split(",")[1]
                }]; 
                let data = {
                  "ManifestNumber" : "",
                  "StopList": stopsDetailsArr
                }
                
                let OSRMResponse = await APICom.fetchData("full", addressAPI, "post", headersObj, data);
                const OSRM_TIME = (ASCSSettingData ? (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "OSRM_Time")).value : 1);
                if(OSRMResponse && OSRMResponse.error === "" && OSRMResponse.data.StopList.length > 0)
                {
                  for(let k = 0; k < OSRMResponse.data.StopList.length; k++)
                  {
                    if(parseInt(OSRMResponse.data.StopList[k].StopOrder) >= 2)
                    {
                      let timeCalculated = ((parseInt(OSRMResponse.data.StopList[k].TimeFromPrevStop)/60) * OSRM_TIME);
                      stopDetailsTrackerArr.push({stopNo:(parseInt(OSRMResponse.data.StopList[k].StopOrder)-1), 
                        distance: parseFloat(parseFloat(OSRMResponse.data.StopList[k].DistFromPrevStop)/1609).toFixed(1),
                        duration: Math.round(parseFloat(timeCalculated))}
                      );
                    }
                  }
                  for(let j = 0; j < stopDetailsTrackerArr.length; j++)
                  {
                    let response = await getFareDataResponse(stopDetailsTrackerArr[j].distance, stopDetailsTrackerArr[j].duration, 
                      FSSelected, copayFSSelected, passengerTypeCount.totalWC, passengerTypeCount.total, 
                      COSSelected, selectedAff, pickLatLng.current, copayAmount
                    );
    
                    stopDetailsTrackerArr[j] = {...stopDetailsTrackerArr[j], fareDetails: response };
                  }
                }
                for(let l = 0; l < clientStops.length; l++)
                {
                  tempDict = {
                    "StopType":"",
                    "Name": "",
                    "WaitTime":0,
                    "tripInfo":{
                      "AffiliateID": 0,
                      "Description": "",
                      "OrigionalServiceId": -1,
                      "CallId": 0,
                      "SelfWalletID": 0,
                      "Promocode": "",
                      "BrokerMode": 0,
                      "FSBrokerMode": 0,
                      "EaasJSONResp": "",
                      "ReceivingAffiliateID": -1,
                      "ClassOfServiceID": 0,
                      "EntityAttributes": "",
                      "ReturnTrip": false,
                      "AgentInstructions": "",
                      "OutRefID": -1,
                      "CustomerEmail": "",
                      "CallbackReq": "",
                      "CallBackInfo": "",
                      "SLAClassID": 0,
                      "AuthorizedBy": "",
                      "ServiceStatusID": 0,
                      "IsCheckServiceHours": true,
                      "IsPredictive": true,
                      "IsMultiTrip": false,
                      "ReturnRequestAffiliateID": 0,
                      "TripPayStatus": 0,
                      "IsRollingCallTypePhone": false,
                      "IsRollingCallTypeSMS": false,
                      "IsRollingCallTypeEmail": false,
                      "ExtraInfo": "",
                      "Ext1": "",
                      "Ext2": "0",
                      "CallType": 0,
                      "FareMethod": 0,
                      "ServiceID": -1,
                      "ScheduleID": -1,
                      "RefID": -1,
                    },
                    "passengerInfo":{
                      "TotalPassengers":0,
                      "TotalWheelChairs":0,
                      "TotalUnloadPassengers": 0,
                      "TotalLuggage":0,
                      "TotalKids":0,
                      "ServiceAnimalCount":"0",
                      "PCACount":"0",
                      "PCAWCCount":"0"
                    },
                    "addressDetails":{
                      "Address": "",
                      "Longitude": "",
                      "Latitude": "",
                      "City": "",
                      "State": "",
                      "Zip": "",
                      "Zone":"",
                      "FareZone":"",
                      "Remarks": "",
                      "Phone": "",
                      "POIName":""
                    },
                    "dateInfo":{
                      "PickupDate": "",
                      "ApptTime": "",
                      "WillCallDay": "",
                      "IsWillCall":false,
                      "IsScheduled": false,
                      "IsMultiSchedule":false
                    },
                    "estimatedInfo":{
                      "EstimatedDistance": 0,
                      "EstimatedTime": 0,
                      "EstimatedCost": 0,
                      "BillableAmount": 0,
                      "CoPay": 0,
                      "AdditionalPassCost": 0,
                      "BillableMiles": 0,
                      "IsBillingRequired": false
                    },
                    "paymentInfo":{
                      "FundingSourceID": 0,
                      "PaymentTypeID": 0, 
                      "iCopayFundingSourceID": 0,
                      "iActualPaymentTypeID": 0,
                      "ReturnCopay": 0,
                      "CCInfo": "",
                      "CCResults": "",
                      "PromoAmount": 0
                    },
                    "driverInfo":{
                      "SpecialDriverId": 0,
                      "AssignedDriverId": 0,
                      "DriverNoTimeDiff": 0,
                      "OnlyPreferedDriver": false,
                      "AssignedDriverNo": 0,
                      "PreferedDriverNum": "",
                      "PreferedDriverGender": "",
                      "OnlyPreferedDriverGender": false,
                      "OnlyPreferedDriverLanguage": false,
                      "GenderTimeDiff":0,
                      "LangTimeDiff":0,
                      "PreferedLanguage": 0,
                    },
                    "vehicleInfo":{
                      "SpecialVehicleId": 0,
                      "AssignedVehicleId": 0,
                      "VehicleTypeId": -1,
                      "VehicleNoTimeDiff": 0,
                      "OnlyPreferedVType": false,
                      "OnlyPreferedVehicle": false,
                      "AssignedVehNo": "",
                      "PreferedVehicleNo": "",
                    },
                  };
                  tempDict.StopType = (clientStops[l].passLoadType === "none" ? "wait" : clientStops[l].passLoadType);
                  tempDict.WaitTime = (clientStops[l].waitTime !== 0 ? clientStops[l].waitTime : 0);
                  tempDict.Name = (clientStops[l].passengerName !== "" ? clientStops[l].passengerName : riderName);
                  if(clientStops[l].passLoadType !== "none")
                  {
                    if(clientStops[l].passLoadType === "unload")
                    {
                      // nTotalUnloaded += clientStops[l].stopPax.total;
                      tempDict.passengerInfo.TotalUnloadPassengers = clientStops[l].stopPax.total;
                    }
                    tempDict.passengerCountDetails.TotalPassengers = clientStops[l].stopPax.total;
                    tempDict.passengerCountDetails.TotalWheelChairs = clientStops[l].stopPax.totalWC;
                    tempDict.passengerCountDetails.ServiceAnimalCount = parseInt(clientStops[l].stopPax.totalSA);
                  }
                  tempDict.addressDetails.Address = clientStops[l].stopAddr;
                  tempDict.addressDetails.Latitude = parseFloat(clientStops[l].stopLatLng.split(",")[0]);
                  tempDict.addressDetails.Longitude = parseFloat(clientStops[l].stopLatLng.split(",")[1]);
                  tempDict.addressDetails.City = "";
                  tempDict.addressDetails.State = "";
                  tempDict.addressDetails.Zip = "";
                  tempDict.addressDetails.Remarks = clientStops[l].notes;
                  tempDict.addressDetails.Phone = phone;
                  stopsArr.push(tempDict);
                }              
              }
              let dropoffStop = fillAddressDetails(
                mapPointDropoffSelection.current,
                dropExtraInfo,
                dropLatLng.current,
                "dropoff",
                "",
                "update",
                editRowData,
                nTotalUnloaded,
                attrStringList
              );
              stopsArr.push(dropoffStop);
              let areaCode = phone.replace("+1","").substring(0,3);
              let firstPart = phone.replace("+1","").substring(3,6);
              let secondPart = phone.replace("+1","").substring(6,10);
              let callBackAreaCode = callBackPhone? callBackPhone.replace("+1","").substring(0,3) : " ";
              let callBackFirstPart = callBackPhone? callBackPhone.replace("+1","").substring(3,6) : " ";
              let callBackSecondPart = callBackPhone? callBackPhone.replace("+1","").substring(6,10) : " ";
              
              const transformedData = {
                Details: stopsArr.map(item=>item)
              };
              const FamilyID = (AffiliateData.find((item) => {if(parseInt(item.AffiliateID) === parseInt(selectedAff)){return item}})).iPartnerAffiliateID;
              data = {
                "generalInfo": {
                  "CompleteUserName": (loginData.vUserName ? loginData.vUserName : ""),
                  "CreatedBy": loginData.vDisplayName,
                  "CreatedByAppID": iAppID,
                  "CreatedUserId": (loginData.iUserID ? loginData.iUserID : 0),
                  "RequestAffiliateID": parseInt(selectedAff),
                  "ReturnDetailID": "",
                  "FamilyID": parseInt(FamilyID)
                },
                "riderInfo":{
                  "ID": (editRowData !== "" && editRowData.riderInfo.id ? parseInt(editRowData.riderInfo.id) : -1),
                  "PhoneNo": areaCode+"-"+firstPart+"-"+secondPart,
                  "FirstName": firstName,
                  "Mid": "",
                  "LastName": lastName,
                  "DateOfBirth": (editRowData !== "" && editRowData.riderInfo.dateOfBirth ? editRowData.riderInfo.dateOfBirth : "01/01/1900"),
                  "RiderID": (medID && medID !== "" && parseInt(medID) !== 0 ? String(medID) : "0"),
                  "RiderPassword": "",
                  "MedicalID": (editRowData !== "" && editRowData.riderInfo.medicalID? clientInfo.riderInfo.medicalID : ""),
                  "ClientAddress1": (clientInfo.Address ? clientInfo.Address : ""),
                  "ClientCity": (clientInfo.City ? clientInfo.City : ""),
                  "ClientState": (clientInfo.State ? clientInfo.State : ""),
                  "ClientZip": (editRowData !== "" && editRowData.riderInfo.clientZip ? editRowData.riderInfo.clientZip : "")
                },
                "insuranceInfo":{
                  "AgencyID": (insuranceAgency === "" ? 0 : insuranceAgency),
                  "InsuranceID": (insuranceType === "" ? 0 : insuranceType),
                  "CaseWorkerID": (insuranceCaseWorker === "" ? 0 : insuranceCaseWorker),
                  "AuthID": (insuranceAuthCode === "" ? 0 : insuranceAuthCode),
                  "ServiceCodeID": (insuranceServiceCode === "" ? 0 : insuranceServiceCode),
                  "MedicalID": (clientInfo.MedicalId? clientInfo.MedicalId : "") 
                },
                "routeSettingInfo":{
                  "TimeWindow": 0,
                  "EndTimeWindow": 0,
                  "MinRideTime": 0,
                  "MaxRideTime": 0,
                  "ServiceTimeAmb": 0,
                  "ServiceTimeWC": 0,
                  "ApptTimeWindow": 0,
                  "AdditionalSameLocAm": 0,
                  "AdditionalSameLocWC": 0
                },
                "systemConfigInfo": {
                  "DefaultCustomerShowPhoneNo": combinedDataDefaultShowPhone,
                  "IsSkipPaymentProcessOnSD": combinedDataDefaultSkipPaymentScreen,
                  "Ta01": combinedDataAddedTime,
                  "UseHTMLFormatEmail": combinedDataDefaultUseHTMLFormatEmail,
                  "Web_Shuttle_SendEmailFromSASCode": combinedDataSendEmailFromSAS,
                  "SRDuplicateCallDelay": combinedDataSRDuplicateDelay
                },
                "exclusions": (scheduleJSON.mainData !== "" && scheduleJSON.mainData.Schedule.ScheduleItem.length > 0 && verifiedAddr.length <= 1 ? exclusionsListArr : []),
                "scheduleInfo": multiSchItems,  
                "addressInfo": {
                  "Trips":[transformedData],
                }
              };
              
              let response = await APICom.fetchData("ReservationCoreURL","UpdateBookedTrip", "post", {}, data, xCancelSourceForGrid.current);
              
              if(response && response.error.length === 0)
              {
                if(response.data && parseInt(response.data.responseCode) === 200)
                {
                  let tripID = response.data.iRefID;
                  setConfirmationNo(tripID);
                  let historyTripsListSaved = PersistStorage.retrieve("agentTrips", true);
                  let historyTripsList = historyTripsListSaved && historyTripsListSaved.length !== 0 ? [...historyTripsListSaved] : [];
                  historyTripsList.push({confirmation:tripID, tripData:data, type: (data.addressInfo.Trips[0].Details[0].dateInfo.IsScheduled ? "Time Call (Update)":"On Demand (Update)")});
                  setHistoryTrips(historyTripsList);
                  PersistStorage.save("agentTrips", historyTripsList, 9999, true);
                  setModalHeaderText("Trip Updated Successfully");
                  setModalBodyHTML(
                    <>
                      <p className="m-0 user-select-none">
                        {"Please use the following confirmation number to check your trip status: "} 
                      </p>
                      <p className="m-0 w-100 fw-bold text-center user-select-all">{tripID}</p>
                    </>
                  );
                  setModalFooterHTML(
                    <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                      OK
                    </Button>
                  );
                  setShowDynamicModal(true);
                  setModalClass("");
                  setShowAPILoader(false);
                  handleResetAll("none");
                  paratransitBookBtnRef.current.disabled = false;
                  
                }
                else
                {
                  setModalHeaderText("Error Occured on Updating");
                  setModalBodyHTML(response.data.responseJSON);
                  setModalFooterHTML(
                    <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                      OK
                    </Button>
                  );
                  setShowDynamicModal(true);
                  setModalClass("");
                  setShowAPILoader(false);
                }
              }
              else
              {
                setModalHeaderText("Error Occured on Updating");
                setModalBodyHTML(response.error);
                setModalFooterHTML(
                  <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                    OK
                  </Button>
                );
                setShowDynamicModal(true);
                setModalClass("");
                setShowAPILoader(false);
              }
            }
            else
            {
              //MultiTrip Update
              if(pickLatLng.current !== "" && dropLatLng.current !== "")
              {
                //Warning for stop order
                setModalHeaderText("Stop Order Alert");
                setModalBodyHTML("You have trip data on main screen which is not added to the stop order. Please press 'Add Leg' button before booking the trips." );
                setModalFooterHTML(
                  <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                    OK
                  </Button>
                );
                setShowDynamicModal(true);
                setModalClass("");
                setShowAPILoader(false);
              }
              else
              { //Addresses are verified and provided
                let tempDict = {};
                for(let k = 0; k < verifiedAddr.length; k++)
                {
                  for(let i = 0; i < verifiedAddr[k].stops.length; i++)
                  {
                    if(verifiedAddr[k].stops[i].passLoadType !== "none" && verifiedAddr[k].stops[i].passLoadType === "unload")
                    {
                      nTotalUnloaded += verifiedAddr[k].stops[i].stopPax.total;
                    }
                  }
                  let attrStringList = [];
                  for(let m = 0; m < verifiedAddr[k].tripAttribute.length; m++)
                  {
                    if (!attrStringList[k]) {
                      attrStringList[k] = ""; 
                    }
                    if(m !== (verifiedAddr[k].tripAttribute.length-1))
                    {
                      attrStringList[k] += verifiedAddr[k].tripAttribute[m]+",";
                    }
                    else
                    {
                      attrStringList[k] += verifiedAddr[k].tripAttribute[m];
                    }
                  }
                  stopsArr[k] = [];
                  let pickupStop = {};
                  if(editRowData.addressInfo.trips[k])
                  {
                    pickupStop = fillAddressDetails(
                      [],
                      verifiedAddr[k].puNotes,
                      verifiedAddr[k].pickLatLng,
                      "pickup",
                      verifiedAddr[k],
                      "update",
                      editRowData,
                      nTotalUnloaded,
                      attrStringList[k],
                      k
                    );
                  }
                  else
                  {
                    pickupStop = fillAddressDetails(
                      [],
                      verifiedAddr[k].puNotes,
                      verifiedAddr[k].pickLatLng,
                      "pickup",
                      verifiedAddr[k],
                      "",
                      "",
                      nTotalUnloaded,
                      attrStringList[k]
                    );
                  }
                  stopsArr[k].push(pickupStop);

                  for(let i = 0; i < verifiedAddr[k].stops.length; i++)
                  {
                    let areaCode = verifiedAddr[k].phone.replace("+1","").substring(0,3);
                    let firstPart = verifiedAddr[k].phone.replace("+1","").substring(3,6);
                    let secondPart = verifiedAddr[k].phone.replace("+1","").substring(6,10);
                    tempDict = {
                      "StopType":"",
                      "WaitTime":0,
                      "Name": "",
                      "tripInfo":{
                        "AffiliateID": 0,
                        "Description": "",
                        "OrigionalServiceId": -1,
                        "CallId": 0,
                        "SelfWalletID": 0,
                        "Promocode": "",
                        "BrokerMode": 0,
                        "FSBrokerMode": 0,
                        "EaasJSONResp": "",
                        "ReceivingAffiliateID": -1,
                        "ClassOfServiceID": 0,
                        "EntityAttributes": "",
                        "ReturnTrip": false,
                        "AgentInstructions": "",
                        "OutRefID": -1,
                        "CustomerEmail": "",
                        "CallbackReq": "",
                        "CallBackInfo": "",
                        "SLAClassID": 0,
                        "AuthorizedBy": "",
                        "ServiceStatusID": 0,
                        "IsCheckServiceHours": true,
                        "IsPredictive": true,
                        "IsMultiTrip": false,
                        "ReturnRequestAffiliateID": 0,
                        "TripPayStatus": 0,
                        "IsRollingCallTypePhone": false,
                        "IsRollingCallTypeSMS": false,
                        "IsRollingCallTypeEmail": false,
                        "ExtraInfo": "",
                        "Ext1": "",
                        "Ext2": "0",
                        "CallType": 0,
                        "FareMethod": 0,
                        "ServiceID": -1,
                        "ScheduleID": -1,
                        "RefID": -1,
                      },
                      "passengerInfo":{
                        "TotalPassengers":0,
                        "TotalWheelChairs":0,
                        "TotalUnloadPassengers":0,
                        "TotalLuggage":0,
                        "TotalKids":0,
                        "ServiceAnimalCount":"0",
                        "PCACount":"0",
                        "PCAWCCount":"0"
                      },
                      "addressDetails":{
                        "Address": "",
                        "Longitude": "",
                        "Latitude": "",
                        "City": "",
                        "State": "",
                        "Zip": "",
                        "Zone":"",
                        "Remarks": "",
                        "Phone": "",
                        "POIName":""
                      },
                      "dateInfo":{
                        "PickupDate": "",
                        "ApptTime": "",
                        "RetWillCallDay": "",
                        "IsWillCall":false,
                        "IsScheduled": false,
                        "IsMultiSchedule":false
                      },
                      "estimatedInfo":{
                        "EstimatedDistance": 0,
                        "EstimatedTime": 0,
                        "EstimatedCost": 0,
                        "BillableAmount": 0,
                        "CoPay": 0,
                        "AdditionalPassCost": 0,
                        "BillableMiles": 0,
                        "IsBillingRequired": false
                      },
                      "paymentInfo":{
                        "FundingSourceID": 0,
                        "PaymentTypeID": 0, 
                        "iCopayFundingSourceID": 0,
                        "iActualPaymentTypeID": 0,
                        "ReturnCopay": 0,
                        "CCInfo": "",
                        "CCResults": "",
                        "PromoAmount": 0
                      },
                      "driverInfo":{
                        "SpecialDriverId": 0,
                        "AssignedDriverId": 0,
                        "DriverNoTimeDiff": 0,
                        "OnlyPreferedDriver": false,
                        "AssignedDriverNo": 0,
                        "PreferedDriverNum": "",
                        "PreferedDriverGender": "",
                        "OnlyPreferedDriverGender": false,
                        "OnlyPreferedDriverLanguage": false,
                        "GenderTimeDiff":0,
                        "LangTimeDiff":0,
                        "PreferedLanguage": 0,
                      },
                      "vehicleInfo":{
                        "SpecialVehicleId": 0,
                        "AssignedVehicleId": 0,
                        "VehicleTypeId": -1,
                        "VehicleNoTimeDiff": 0,
                        "OnlyPreferedVType": false,
                        "OnlyPreferedVehicle": false,
                        "AssignedVehNo": "",
                        "PreferedVehicleNo": "",
                      },
                    };
                    tempDict.StopType = (verifiedAddr[k].stops[i].passLoadType === "none" ? "wait" : verifiedAddr[k].stops[i].passLoadType);
                    tempDict.WaitTime = (verifiedAddr[k].stops[i].waitTime !== 0 ? verifiedAddr[k].stops[i].waitTime : 0);
                    tempDict.Name = (verifiedAddr[k].stops[i].passengerName === "" ? verifiedAddr[k].passengerName : verifiedAddr[k].stops[i].passengerName);
                    if(verifiedAddr[k].stops[i].passLoadType !== "none")
                    {
                      if(verifiedAddr[k].stops[i].passLoadType === "unload")
                      {
                        tempDict.passengerInfo.TotalUnloadPassengers = verifiedAddr[k].stops[i].stopPax.total;
                      }
                      tempDict.passengerInfo.TotalPassengers = verifiedAddr[k].stops[i].stopPax.total;
                      tempDict.passengerInfo.TotalWheelChairs = verifiedAddr[k].stops[i].stopPax.totalWC;
                      tempDict.passengerInfo.ServiceAnimalCount = String(verifiedAddr[k].stops[i].stopPax.totalSA);
                    }
                    tempDict.addressDetails.Address = (verifiedAddr[k].stops[i].stopAddr.includes(",") ? verifiedAddr[k].stops[i].stopAddr.split(",")[0]:verifiedAddr[k].stops[i].stopAddr);
                    tempDict.addressDetails.Latitude = parseFloat(verifiedAddr[k].stops[i].stopLatLng.split(",")[0]);
                    tempDict.addressDetails.Longitude = parseFloat(verifiedAddr[k].stops[i].stopLatLng.split(",")[1]);
                    tempDict.addressDetails.City = "";
                    tempDict.addressDetails.State = "";
                    tempDict.addressDetails.Zip = "";
                    tempDict.addressDetails.Remarks = verifiedAddr[k].stops[i].notes;
                    tempDict.addressDetails.Phone = areaCode+"-"+firstPart+"-"+secondPart;
                    stopsArr[k].push(tempDict);
                  }
                  let dropoffStop = {};
                  if(editRowData.addressInfo.trips[k])
                  {
                    dropoffStop = fillAddressDetails(
                      [],
                      verifiedAddr[k].doNotes,
                      verifiedAddr[k].dropLatLng,
                      "dropoff",
                      verifiedAddr[k],
                      "update",
                      editRowData,
                      nTotalUnloaded,
                      attrStringList[k],
                      k
                    );
                  }
                  else
                  {
                    dropoffStop = fillAddressDetails(
                      [],
                      verifiedAddr[k].doNotes,
                      verifiedAddr[k].dropLatLng,
                      "dropoff",
                      verifiedAddr[k],
                      "",
                      "",
                      nTotalUnloaded,
                      attrStringList[k]
                    );
                  }
                  
                  
                  stopsArr[k].push(dropoffStop);
                }
                let responseArr = []; 
                let namesArr = [];
                let accurateDate = formatDate(currDate);
                let historyTripsListSaved = PersistStorage.retrieve("agentTrips", true);
                let historyTripsList = historyTripsListSaved && historyTripsListSaved.length !== 0 ? [...historyTripsListSaved] : [];
                bIsScheduledVar = false;
                if(accurateDate !== verifiedAddr[0].date)
                {
                  bIsScheduledVar = true;
                }
                
                let affiliateID = parseInt(verifiedAddr[0].AffiliateSelected);
                let combinedDataAddedTimeVF = ASCSSettingData ? (JSON.parse(ASCSSettingData[affiliateID]).find((item)=>item.SubTitle === "Ta01")).value : 0;
                let combinedDataDefaultShowPhoneVF = ASCSSettingData ? (JSON.parse(ASCSSettingData[affiliateID]).find((item)=>item.SubTitle === "DefaultCustomerShowPhoneNo")).value: false;
                let fsDataVF = FundingSourceData ? JSON.parse(FundingSourceData[parseInt(affiliateID)]) : [];
                let combinedDataDefaultSkipPaymentScreenVF = fsDataVF.length > 0 ? ((fsDataVF.find((item)=> parseInt(item.FID) === parseInt(verifiedAddr[0].FundingSource)))?.bSkipPaymentProcessOnSD) : false;
                let combinedDataDefaultUseHTMLFormatEmailVF = ASCSSettingData ? (JSON.parse(ASCSSettingData[affiliateID]).find((item)=>item.SubTitle === "UseHTMLFormatEmail")).value : false;
                let combinedDataSendEmailFromSASVF = ASCSSettingData ? (JSON.parse(ASCSSettingData[affiliateID]).find((item)=>item.SubTitle === "Web_Shuttle_SendEmailFromSASCode")).value : false;
                let combinedDataSRDuplicateDelayVF = ASCSSettingData ? (JSON.parse(ASCSSettingData[affiliateID]).find((item)=>item.SubTitle === "SRDuplicateCallDelay")).value : 0;
                let correctPhoneFormat = "";
                if(verifiedAddr[0].phone.includes("-"))
                {
                  correctPhoneFormat = verifiedAddr[0].phone;
                }
                else
                {
                  let areaCode = verifiedAddr[0].phone.replace("+1","").substring(0,3);
                  let firstPart = verifiedAddr[0].phone.replace("+1","").substring(3,6);
                  let secondPart = verifiedAddr[0].phone.replace("+1","").substring(6,10);
                  correctPhoneFormat = areaCode+"-"+firstPart+"-"+secondPart;
                }
                
                let inverseDate = inverseFormatDate(verifiedAddr[0].date);
                let unloadedPassengerArr = stopsArr[0].filter(item=>item.StopType.toLowerCase() === "unload");
                const transformedData = stopsArr.map(stopsGroup => {
                  return {
                    Details: stopsGroup.map(stop => ({
                      ...stop,
                    }))
                  };
                });
                
                let firstName = (verifiedAddr[0].riderName.includes(",") ? verifiedAddr[0].riderName.split(",")[1] : 
                  verifiedAddr[0].riderName.trim().includes(" ")? verifiedAddr[0].riderName.split(" ")[0] 
                : verifiedAddr[0].riderName);
                let lastName = (verifiedAddr[0].riderName.includes(",") ? verifiedAddr[0].riderName.split(",")[0] : 
                  verifiedAddr[0].riderName.trim().includes(" ")? verifiedAddr[0].riderName.replace(firstName, "").trim()
                : "");
                const FamilyID = (AffiliateData.find((item) => {if(parseInt(item.AffiliateID) === parseInt(editRowData.generalInfo.requestAffiliateID)){return item}})).iPartnerAffiliateID;
                data = {
                  "generalInfo": {
                    "CompleteUserName": (loginData.vUserName ? loginData.vUserName : ""),
                    "CreatedBy": loginData.vDisplayName,
                    "CreatedByAppID": iAppID,
                    "CreatedUserId": (loginData.iUserID ? loginData.iUserID : 0),
                    "RequestAffiliateID": parseInt(editRowData.generalInfo.requestAffiliateID),
                    "ReturnDetailID": editRowData.generalInfo.returnDetailID,
                    "FamilyID": parseInt(FamilyID)
                  },
                  "riderInfo":{
                    "ID": (verifiedAddr[0].id ? verifiedAddr[0].id : -1),
                    "PhoneNo": correctPhoneFormat,
                    "FirstName": firstName,
                    "Mid": "",
                    "LastName": lastName,
                    "DateOfBirth": "01/01/1900",
                    "RiderID": (verifiedAddr[0].clientMedID && verifiedAddr[0].clientMedID !== "" && parseInt(verifiedAddr[0].clientMedID) !== 0 ? String(verifiedAddr[0].clientMedID) : "0"),
                    "RiderPassword": "",
                    "MedicalID": (verifiedAddr[0].clientMedID ? verifiedAddr[0].clientMedID : ""),
                    "ClientAddress": (verifiedAddr[0].clientAddr && verifiedAddr[0].clientAddr !== "" ? verifiedAddr[0].clientAddr : stopsArr[0][0].addressDetails.Address),
                    "ClientCity": (verifiedAddr[0].clientCity && verifiedAddr[0].clientCity !== "" ? verifiedAddr[0].clientCity : stopsArr[0][0].addressDetails.City),
                    "ClientState": (verifiedAddr[0].clientState && verifiedAddr[0].clientState !== "" ? verifiedAddr[0].clientState : stopsArr[0][0].addressDetails.State),
                    "ClientZip": (verifiedAddr[0].clientZip && verifiedAddr[0].clientZip !== "" ? verifiedAddr[0].clientZip : stopsArr[0][0].addressDetails.Zip),
                  },
                  "insuranceInfo":{
                    "AgencyID": (verifiedAddr[0].insurance.Agency === "" ? 0 : verifiedAddr[0].insurance.Agency),
                    "InsuranceID": (verifiedAddr[0].insurance.Type === "" ? 0 : verifiedAddr[0].insurance.Type),
                    "CaseWorkerID": (verifiedAddr[0].insurance.CaseWorker === "" ? 0 : verifiedAddr[0].insurance.CaseWorker),
                    "AuthID": (verifiedAddr[0].insurance.AuthCode === "" ? 0 : verifiedAddr[0].insurance.AuthCode),
                    "ServiceCodeID": (verifiedAddr[0].insurance.ServiceCode === "" ? 0 : verifiedAddr[0].insurance.ServiceCode),
                    "MedicalID": (verifiedAddr[0].clientMedID? verifiedAddr[0].clientMedID : "") 
                  },
                  "routeSettingInfo":{
                    "TimeWindow": 0,
                    "EndTimeWindow": 0,
                    "MinRideTime": 0,
                    "MaxRideTime": 0,
                    "ServiceTimeAmb": 0,
                    "ServiceTimeWC": 0,
                    "ApptTimeWindow": 0,
                    "AdditionalSameLocAm": 0,
                    "AdditionalSameLocWC": 0
                  },
                  "systemConfigInfo":{
                    "DefaultCustomerShowPhoneNo": combinedDataDefaultShowPhoneVF,
                    "IsSkipPaymentProcessOnSD": combinedDataDefaultSkipPaymentScreenVF,
                    "Ta01": combinedDataAddedTimeVF,
                    "UseHTMLFormatEmail": combinedDataDefaultUseHTMLFormatEmailVF,
                    "Web_Shuttle_SendEmailFromSASCode": combinedDataSendEmailFromSASVF,
                    "SRDuplicateCallDelay": combinedDataSRDuplicateDelayVF
                  },
                  "exclusions": (scheduleJSON.mainData !== "" && scheduleJSON.mainData.Schedule.ScheduleItem.length > 0 && verifiedAddr.length <= 1 ? exclusionsListArr : []),
                  "scheduleInfo": multiSchItems,
                  "addressInfo":{
                    "Trips":transformedData,
                  },
                };
                let response = await APICom.fetchData("ReservationCoreURL","UpdateBookedTrip", "post", {}, data, xCancelSourceForGrid.current);
                if(response && response.error.length === 0)
                {
                  if(response.data && response.data.responseCode === 200)
                  {
                    let confirmation = response.data.iRefID+(response.data.returnLegsList && response.data.returnLegsList !== "" ? "-"+parseInt(response.data.returnLegsList) : "");
                    responseArr.push({trip:1, code:response.data.responseCode, response:response.data});
                    setModalHeaderText("Trip(s) Updated Successfully");
                    setModalBodyHTML(
                      <>
                        <p className="m-0 user-select-none">
                          {"Please use the following confirmation number to check your trip status: "} 
                        </p>
                        <p className="m-0 w-100 fw-bold text-center user-select-all">{confirmation}</p>
                      </>
                    );
                    setModalFooterHTML(
                      <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                        OK
                      </Button>
                    );
                    setShowDynamicModal(true);
                    setModalClass("");
                    setShowAPILoader(false);
                    
                    if(responseArr[0].code === 200)
                    {
                      handleResetAll("none");
                    }
                    paratransitBookBtnRef.current.disabled = false;
                    for(let j = 0; j < data.addressInfo.Trips.length; j++)
                    {
                      historyTripsList.push({confirmation:(parseInt(response.data.iRefID)+j), tripData:data, type: (data.addressInfo.Trips[j].Details[0].dateInfo.IsScheduled ? "Time Call Update (StopOrder)":"On Demand Update (StopOrder)")});
                    }
                    setConfirmationNo(confirmation);
                  }
                  else
                  {
                    setModalHeaderText("Error Occured on Booking");
                    setModalBodyHTML(response.data.responseJSON);
                    setModalFooterHTML(
                      <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                        OK
                      </Button>
                    );
                    setShowDynamicModal(true);
                    setModalClass("");
                    setShowAPILoader(false);
                    responseArr.push({trip:1, code:response.data.responseCode, response:response.data.responseJSON});
                  }
                }
                else
                {
                  setModalHeaderText("Error Occured on Booking");
                  setModalBodyHTML(response.error);
                  setModalFooterHTML(
                    <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                      OK
                    </Button>
                  );
                  setShowDynamicModal(true);
                  setModalClass("");
                  setShowAPILoader(false);
                  responseArr.push({trip:1, code:"error", response:response.error});
                }
                setHistoryTrips(historyTripsList);
                PersistStorage.save("agentTrips", historyTripsList, 9999, true);
              }
            }
          }
        }
        else if(submitParatransitBtnTitle === "Book")
        {
          if(isTimeValid && validateConditions)
          {
            let bIsScheduledVar = false;
            let currDate = systemDateTimeRef.current.date;
            let currTime = systemDateTimeRef.current.time;
            if(schTime !== "" || (currDate !== selectedDateSchTime))
            {
              bIsScheduledVar = true;
            }
            
            let stopsArr = [];
            let combinedDataAddedTime = ASCSSettingData ? (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "Ta01")).value : 0;
            let combinedDataDefaultShowPhone = ASCSSettingData ? (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "DefaultCustomerShowPhoneNo")).value: false;
            let fsData = FundingSourceData ? JSON.parse(FundingSourceData[parseInt(selectedAff)]) : [];
            let combinedDataDefaultSkipPaymentScreen = fsData.length > 0 ? ((fsData.find((item)=> parseInt(item.FID) === parseInt(FSSelected)))?.bSkipPaymentProcessOnSD) : false;
            let combinedDataDefaultUseHTMLFormatEmail = ASCSSettingData ? (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "UseHTMLFormatEmail")).value : false;
            let combinedDataSendEmailFromSAS = ASCSSettingData ? (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "Web_Shuttle_SendEmailFromSASCode")).value : false;
            let combinedDataSRDuplicateDelay = ASCSSettingData ? (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "SRDuplicateCallDelay")).value : 0;
            let attrStringList = "";
            for(let m = 0; m < selectedTripAttr.length; m++)
            {
              if(m !== (selectedTripAttr.length-1))
              {
                attrStringList += selectedTripAttr[m]+",";
              }
              else
              {
                attrStringList += selectedTripAttr[m];
              }
            }
            let data = {}
            setModalHeaderText("Booking In Progress");
            setModalBodyHTML("Trip is being booked, please wait.");
            setModalFooterHTML("");
            setModalClass("d-none");
            setShowAPILoader(true);
            setShowDynamicModal(true);
            if(verifiedAddr.length === 0)
            {
              //Single trip Book
              let pickupStop = fillAddressDetails(
                mapPointPickupSelection.current,
                pickExtraInfo,
                pickLatLng.current,
                "pickup",
                "",
                "",
                "",
                0,
                attrStringList
              );
              stopsArr.push(pickupStop);

              
              let tempDict = {}; 
              let nTotalUnloaded = 0;

              if(clientStops.length > 0)
              {
                let myHeaders = new Headers();
                myHeaders.append("Authorization", 'Basic '+btoa(OSRM_Username + ":" + OSRM_Password));
                myHeaders.append('Content-Type', 'application/json');
                let addressAPI = ITCMapRawURL+'directionswithstoporder';
                let headersObj = headersToObject(myHeaders);
                let stopDetailsTrackerArr = [];
                let stopsDetailsArr = [{
                  "StopOrder": 1,
                  "StopLat": pickLatLng.current.split(",")[0],
                  "StopLong": pickLatLng.current.split(",")[1]
                }, ...clientStops.map((item,index)=>{
                  return {
                    "StopOrder": (index+2),
                    "StopLat": item.stopLatLng.split(",")[0],
                    "StopLong": item.stopLatLng.split(",")[1]
                  };
                }), {
                  "StopOrder": (clientStops.length + 2),
                  "StopLat": dropLatLng.current.split(",")[0],
                  "StopLong": dropLatLng.current.split(",")[1]
                }]; 
                let data = {
                  "ManifestNumber" : "",
                  "StopList": stopsDetailsArr
                }
                
                let OSRMResponse = await APICom.fetchData("full", addressAPI, "post", headersObj, data);
                const OSRM_TIME = (ASCSSettingData ? (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "OSRM_Time")).value : 1);
                if(OSRMResponse && OSRMResponse.error === "" && OSRMResponse.data.StopList.length > 0)
                {
                  for(let k = 0; k < OSRMResponse.data.StopList.length; k++)
                  {
                    if(parseInt(OSRMResponse.data.StopList[k].StopOrder) >= 2)
                    {
                      let timeCalculated = ((parseInt(OSRMResponse.data.StopList[k].TimeFromPrevStop)/60) * OSRM_TIME);
                      stopDetailsTrackerArr.push({stopNo:(parseInt(OSRMResponse.data.StopList[k].StopOrder)-1), 
                        distance: parseFloat(parseFloat(OSRMResponse.data.StopList[k].DistFromPrevStop)/1609).toFixed(1),
                        duration: Math.round(parseFloat(timeCalculated))}
                      );
                    }
                  }

                  for(let j = 0; j < stopDetailsTrackerArr.length; j++)
                  {
                    let response = await getFareDataResponse(stopDetailsTrackerArr[j].distance, stopDetailsTrackerArr[j].duration, 
                      FSSelected, copayFSSelected, passengerTypeCount.totalWC, passengerTypeCount.total, 
                      COSSelected, selectedAff, pickLatLng.current, copayAmount 
                    );

                    stopDetailsTrackerArr[j] = {...stopDetailsTrackerArr[j], fareDetails: response };
                  }
                  
                }
                
                // console.log(stopDetailsTrackerArr);
                
                for(let l = 0; l < clientStops.length; l++)
                {
                  let areaCode = phone.replace("+1","").substring(0,3);
                  let firstPart = phone.replace("+1","").substring(3,6);
                  let secondPart = phone.replace("+1","").substring(6,10);
                  tempDict = {
                    "StopType":"",
                    "Name": "",
                    "WaitTime":0,
                    "tripInfo":{
                      "AffiliateID": 0,
                      "Description": "",
                      "OrigionalServiceId": -1,
                      "CallId": 0,
                      "SelfWalletID": 0,
                      "Promocode": "",
                      "BrokerMode": 0,
                      "FSBrokerMode": 0,
                      "EaasJSONResp": "",
                      "ReceivingAffiliateID": -1,
                      "ClassOfServiceID": 0,
                      "EntityAttributes": "",
                      "ReturnTrip": false,
                      "AgentInstructions": "",
                      "OutRefID": -1,
                      "CustomerEmail": "",
                      "CallbackReq": "",
                      "CallBackInfo": "",
                      "SLAClassID": 0,
                      "AuthorizedBy": "",
                      "ServiceStatusID": 0,
                      "IsCheckServiceHours": true,
                      "IsPredictive": true,
                      "IsMultiTrip": false,
                      "ReturnRequestAffiliateID": 0,
                      "TripPayStatus": 0,
                      "IsRollingCallTypePhone": false,
                      "IsRollingCallTypeSMS": false,
                      "IsRollingCallTypeEmail": false,
                      "ExtraInfo": "",
                      "Ext1": "",
                      "Ext2": "0",
                      "CallType": 0,
                      "FareMethod": 0,
                      "ServiceID": -1,
                      "ScheduleID": -1,
                      "RefID": -1,
                    },
                    "passengerInfo":{
                      "TotalPassengers":0,
                      "TotalWheelChairs":0,
                      "TotalUnloadPassengers": 0,
                      "TotalLuggage":0,
                      "TotalKids":0,
                      "ServiceAnimalCount":"0",
                      "PCACount":"0",
                      "PCAWCCount":"0"
                    },
                    "addressDetails":{
                      "Address": "",
                      "Longitude": "",
                      "Latitude": "",
                      "City": "",
                      "State": "",
                      "Zip": "",
                      "Zone":"",
                      "FareZone":"",
                      "Remarks": "",
                      "Phone": "",
                      "POIName":""
                    },
                    "dateInfo":{
                      "PickupDate": "",
                      "ApptTime": "",
                      "WillCallDay": "",
                      "IsWillCall":false,
                      "IsScheduled": false,
                      "IsMultiSchedule":false
                    },
                    "estimatedInfo":{
                      "EstimatedDistance": 0,
                      "EstimatedTime": 0,
                      "EstimatedCost": 0,
                      "BillableAmount": 0,
                      "CoPay": 0,
                      "AdditionalPassCost": 0,
                      "BillableMiles": 0,
                      "IsBillingRequired": false
                    },
                    "paymentInfo":{
                      "FundingSourceID": 0,
                      "PaymentTypeID": 0, 
                      "iCopayFundingSourceID": 0,
                      "iActualPaymentTypeID": 0,
                      "ReturnCopay": 0,
                      "CCInfo": "",
                      "CCResults": "",
                      "PromoAmount": 0
                    },
                    "driverInfo":{
                      "SpecialDriverId": 0,
                      "AssignedDriverId": 0,
                      "DriverNoTimeDiff": 0,
                      "OnlyPreferedDriver": false,
                      "AssignedDriverNo": 0,
                      "PreferedDriverNum": "",
                      "PreferedDriverGender": "",
                      "OnlyPreferedDriverGender": false,
                      "OnlyPreferedDriverLanguage": false,
                      "GenderTimeDiff":0,
                      "LangTimeDiff":0,
                      "PreferedLanguage": 0,
                    },
                    "vehicleInfo":{
                      "SpecialVehicleId": 0,
                      "AssignedVehicleId": 0,
                      "VehicleTypeId": -1,
                      "VehicleNoTimeDiff": 0,
                      "OnlyPreferedVType": false,
                      "OnlyPreferedVehicle": false,
                      "AssignedVehNo": "",
                      "PreferedVehicleNo": "",
                    },
                  };
                  tempDict.StopType = (clientStops[l].passLoadType === "none" ? "wait" : clientStops[l].passLoadType);
                  tempDict.WaitTime = (clientStops[l].waitTime !== 0 ? clientStops[l].waitTime : 0);
                  tempDict.Name = (clientStops[l].passengerName !== "" ? clientStops[l].passengerName : riderName);
                  if(clientStops[l].passLoadType !== "none")
                  {
                    if(clientStops[l].passLoadType === "unload")
                    {
                      nTotalUnloaded += clientStops[l].stopPax.total;
                      tempDict.passengerInfo.TotalUnloadPassengers = clientStops[l].stopPax.total;
                    }
                    tempDict.passengerInfo.TotalPassengers = clientStops[l].stopPax.total;
                    tempDict.passengerInfo.TotalWheelChairs = clientStops[l].stopPax.totalWC;
                    tempDict.passengerInfo.ServiceAnimalCount = String(clientStops[l].stopPax.totalSA);
                  }
                  tempDict.addressDetails.Address = (clientStops[l].stopAddr.includes(",") ? clientStops[l].stopAddr.split(",")[0] : clientStops[l].stopAddr);
                  tempDict.addressDetails.Latitude = parseFloat(clientStops[l].stopLatLng.split(",")[0]);
                  tempDict.addressDetails.Longitude = parseFloat(clientStops[l].stopLatLng.split(",")[1]);
                  tempDict.addressDetails.City = "";
                  tempDict.addressDetails.State = "";
                  tempDict.addressDetails.Zip = "";
                  tempDict.addressDetails.Remarks = clientStops[l].notes;
                  tempDict.addressDetails.Phone = areaCode+"-"+firstPart+"-"+secondPart;
                  stopsArr.push(tempDict);
                }
              }

              let dropoffStop = fillAddressDetails(
                mapPointDropoffSelection.current,
                dropExtraInfo,
                dropLatLng.current,
                "dropoff",
                "",
                "",
                "",
                0,
                attrStringList
              );
              stopsArr.push(dropoffStop);

              let areaCode = phone.replace("+1","").substring(0,3);
              let firstPart = phone.replace("+1","").substring(3,6);
              let secondPart = phone.replace("+1","").substring(6,10);
              let callBackAreaCode = callBackPhone ? callBackPhone.replace("+1","").substring(0,3) : " ";
              let callBackFirstPart = callBackPhone ? callBackPhone.replace("+1","").substring(3,6) : " ";
              let callBackSecondPart = callBackPhone ? callBackPhone.replace("+1","").substring(6,10) : " ";
              let firstName = riderName.trim().includes(",") ? riderName.trim().split(",")[1] : (riderName.trim().includes(" ")? riderName.trim().split(" ")[0]: riderName);
              let lastName = riderName.trim().includes(",") ? riderName.trim().split(",")[0] : (riderName.trim().includes(" ")? riderName.replace(firstName, "").trim(): "");
              
              const transformedData = {
                Details: stopsArr.map(item=>item)
              };
              const FamilyID = (AffiliateData.find((item) => {if(parseInt(item.AffiliateID) === parseInt(selectedAff)){return item}})).iPartnerAffiliateID;
              data = {
                "generalInfo": {
                  "CompleteUserName": (loginData.vUserName ? loginData.vUserName : ""),
                  "CreatedBy": loginData.vDisplayName,
                  "CreatedByAppID": iAppID,
                  "CreatedUserId": (loginData.iUserID ? loginData.iUserID : 0),
                  "RequestAffiliateID": parseInt(selectedAff),
                  "ReturnDetailID": "",
                  "FamilyID": parseInt(FamilyID)
                },
                "riderInfo":{
                  "ID": (clientInfo.Id ? clientInfo.Id : -1),
                  "PhoneNo": areaCode+"-"+firstPart+"-"+secondPart,
                  "FirstName": firstName,
                  "Mid": "",
                  "LastName": lastName,
                  "DateOfBirth": "01/01/1900",
                  "RiderID": (medID && medID !== "" && parseInt(medID) !== 0 ? String(medID) : "0"),
                  "RiderPassword": "",
                  "MedicalID": (clientInfo.MedicalId? clientInfo.MedicalId : ""),
                  "ClientAddress": (clientInfo.Address ? clientInfo.Address : stopsArr[0].addressDetails.Address),
                  "ClientCity": (clientInfo.City ? clientInfo.City : stopsArr[0].addressDetails.City),
                  "ClientState": (clientInfo.State ? clientInfo.State : stopsArr[0].addressDetails.State),
                  "ClientZip": (clientInfo.Zip ? clientInfo.Zip: stopsArr[0].addressDetails.Zip),
                },
                "insuranceInfo":{
                  "AgencyID": (insuranceAgency === "" ? 0 : insuranceAgency),
                  "InsuranceID": (insuranceType === "" ? 0 : insuranceType),
                  "CaseWorkerID": (insuranceCaseWorker === "" ? 0 : insuranceCaseWorker),
                  "AuthID": (insuranceAuthCode === "" ? 0 : insuranceAuthCode),
                  "ServiceCodeID": (insuranceServiceCode === "" ? 0 : insuranceServiceCode),
                  "MedicalID": (clientInfo.MedicalId? clientInfo.MedicalId : "") 
                },
                "routeSettingInfo":{
                  "TimeWindow": 0,
                  "EndTimeWindow": 0,
                  "MinRideTime": 0,
                  "MaxRideTime": 0,
                  "ServiceTimeAmb": 0,
                  "ServiceTimeWC": 0,
                  "ApptTimeWindow": 0,
                  "AdditionalSameLocAm": 0,
                  "AdditionalSameLocWC": 0
                },
                "systemConfigInfo":{
                  "DefaultCustomerShowPhoneNo": combinedDataDefaultShowPhone,
                  "IsSkipPaymentProcessOnSD": combinedDataDefaultSkipPaymentScreen,
                  "Ta01": combinedDataAddedTime,
                  "UseHTMLFormatEmail": combinedDataDefaultUseHTMLFormatEmail,
                  "Web_Shuttle_SendEmailFromSASCode": combinedDataSendEmailFromSAS,
                  "SRDuplicateCallDelay": combinedDataSRDuplicateDelay
                },
                "exclusions": (scheduleJSON.mainData !== "" && scheduleJSON.mainData.Schedule.ScheduleItem.length > 0 && verifiedAddr.length <= 1 ? exclusionsListArr : []),
                "scheduleInfo": multiSchItems,
                "addressInfo":{
                  // "returnLegsList": "",
                  "Trips":[transformedData],
                    
                },
              };
              // "returnInfo":{
              //     "ReturnDateTime": (returnTripCheckBox? (schTime === ""? selectedDateSchTime+" "+currTime: selectedDateSchTime+" "+schTime) : "01/01/1900 00:00:00"),
              //     "ReturnEstimatedDistance": (returnTripCheckBox? clientSummary.tripDistance:0),
              //     "ReturnEstimatedTime": (returnTripCheckBox? clientSummary.TripDuration:0),
              //     "ReturnEstimatedCost": (returnTripCheckBox? clientSummary.TripFare:0),
              //     "ReturnBillableAmount": (returnTripCheckBox? fareDataArr.billableAmount :0),
              //     "ReturnAdditionalPassCost": (returnTripCheckBox? fareDataArr.additionalPassengerCost :0),
              //   },
              // console.log(data, transformedData);
              let response = await APICom.fetchData("ReservationCoreURL","BookParatransitTrip", "post", {}, data, xCancelSourceForGrid.current);
              // console.log("booking response: ", response);
              if(response && response.error.length === 0)
              {
                if(response.data && parseInt(response.data.responseCode) === 200)
                {
                  if(response.data.iRefID <= 0 && response.data.responseJSON !== "")
                  {
                    setModalHeaderText("Error Occured on Booking");
                    setModalBodyHTML(response.data.responseJSON);
                    setModalFooterHTML(
                      <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                        OK
                      </Button>
                    );
                    setShowDynamicModal(true);
                    setModalClass("");
                    setShowAPILoader(false);
                  }
                  else
                  {
                    let tripID = response.data.iRefID;
                    setConfirmationNo(tripID);
                    let historyTripsListSaved = PersistStorage.retrieve("agentTrips", true);
                    let historyTripsList = historyTripsListSaved && historyTripsListSaved.length !== 0 ? [...historyTripsListSaved] : [];
                    historyTripsList.push({confirmation:tripID, tripData:data, type: (data.addressInfo.Trips[0].Details[0].dateInfo.IsScheduled ? "Time Call":"On Demand")});
                    setHistoryTrips(historyTripsList);
                    PersistStorage.save("agentTrips", historyTripsList, 9999, true);
                    setModalHeaderText("Trip Booked Successfully");
                    setModalBodyHTML(
                      <>
                        <p className="m-0 user-select-none">
                          {"Please use the following confirmation number to check your trip status: "} 
                        </p>
                        <p className="m-0 w-100 fw-bold text-center user-select-all">{tripID}</p>
                      </>
                    );
                    setModalFooterHTML(
                      <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                        OK
                      </Button>
                    );
                    setShowDynamicModal(true);
                    setModalClass("");
                    setShowAPILoader(false);
                    handleResetAll("none");
                    paratransitBookBtnRef.current.disabled = false;
                  }
                  
                }
                else
                {
                  setModalHeaderText("Error Occured on Booking");
                  setModalBodyHTML(response.data.responseJSON);
                  setModalFooterHTML(
                    <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                      OK
                    </Button>
                  );
                  setShowDynamicModal(true);
                  setModalClass("");
                  setShowAPILoader(false);
                }
              }
              else
              {
                setModalHeaderText("Error Occured on Booking");
                setModalBodyHTML(response.error);
                setModalFooterHTML(
                  <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                    OK
                  </Button>
                );
                setShowDynamicModal(true);
                setModalClass("");
                setShowAPILoader(false);
              }
            }
            else
            {
              //Multi-trip Book
              if(pickLatLng.current !== "" && dropLatLng.current !== "")
              {
                //Warning for stop order
                setModalHeaderText("Stop Order Alert");
                setModalBodyHTML("You have trip data on main screen which is not added to the stop order. Please press 'Add Leg' button before booking the trips." );
                setModalFooterHTML(
                  <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                    OK
                  </Button>
                );
                setShowDynamicModal(true);
                setModalClass("");
                setShowAPILoader(false);
              }
              else
              { //Addresses are verified and correct
                let tempDict = {};
                let nTotalUnloaded = 0;

                for(let k = 0; k < verifiedAddr.length; k++)
                {
                  for(let i = 0; i < verifiedAddr[k].stops.length; i++)
                  {
                    if(verifiedAddr[k].stops[i].passLoadType !== "none" && verifiedAddr[k].stops[i].passLoadType === "unload")
                    {
                      nTotalUnloaded += verifiedAddr[k].stops[i].stopPax.total;
                    }

                  }
                  let attrStringList = [];
                  for(let m = 0; m < verifiedAddr[k].tripAttribute.length; m++)
                  {
                    if (!attrStringList[k]) {
                      attrStringList[k] = ""; 
                    }
                    if(m !== (verifiedAddr[k].tripAttribute.length-1))
                    {
                      attrStringList[k] += verifiedAddr[k].tripAttribute[m]+",";
                    }
                    else
                    {
                      attrStringList[k] += verifiedAddr[k].tripAttribute[m];
                    }
                  }
                  stopsArr[k] = [];
                  let pickupStop = fillAddressDetails(
                    [],
                    verifiedAddr[k].puNotes,
                    verifiedAddr[k].pickLatLng,
                    "pickup",
                    verifiedAddr[k],
                    "",
                    "",
                    nTotalUnloaded,
                    attrStringList[k]
                  );
                  stopsArr[k].push(pickupStop);

                  for(let i = 0; i < verifiedAddr[k].stops.length; i++)
                  {
                    let areaCode = verifiedAddr[k].phone.replace("+1","").substring(0,3);
                    let firstPart = verifiedAddr[k].phone.replace("+1","").substring(3,6);
                    let secondPart = verifiedAddr[k].phone.replace("+1","").substring(6,10);
                    tempDict = {
                      "StopType":"",
                      "WaitTime":0,
                      "Name": "",
                      "tripInfo":{
                        "AffiliateID": 0,
                        "Description": "",
                        "OrigionalServiceId": -1,
                        "CallId": 0,
                        "SelfWalletID": 0,
                        "Promocode": "",
                        "BrokerMode": 0,
                        "FSBrokerMode": 0,
                        "EaasJSONResp": "",
                        "ReceivingAffiliateID": -1,
                        "ClassOfServiceID": 0,
                        "EntityAttributes": "",
                        "ReturnTrip": false,
                        "AgentInstructions": "",
                        "OutRefID": -1,
                        "CustomerEmail": "",
                        "CallbackReq": "",
                        "CallBackInfo": "",
                        "SLAClassID": 0,
                        "AuthorizedBy": "",
                        "ServiceStatusID": 0,
                        "IsCheckServiceHours": true,
                        "IsPredictive": true,
                        "IsMultiTrip": false,
                        "ReturnRequestAffiliateID": 0,
                        "TripPayStatus": 0,
                        "IsRollingCallTypePhone": false,
                        "IsRollingCallTypeSMS": false,
                        "IsRollingCallTypeEmail": false,
                        "ExtraInfo": "",
                        "Ext1": "",
                        "Ext2": "0",
                        "CallType": 0,
                        "FareMethod": 0,
                        "ServiceID": -1,
                        "ScheduleID": -1,
                        "RefID": -1,
                      },
                      "passengerInfo":{
                        "TotalPassengers":0,
                        "TotalWheelChairs":0,
                        "TotalUnloadPassengers":0,
                        "TotalLuggage":0,
                        "TotalKids":0,
                        "ServiceAnimalCount":"0",
                        "PCACount":"0",
                        "PCAWCCount":"0"
                      },
                      "addressDetails":{
                        "Address": "",
                        "Longitude": "",
                        "Latitude": "",
                        "City": "",
                        "State": "",
                        "Zip": "",
                        "Zone":"",
                        "Remarks": "",
                        "Phone": "",
                        "POIName":""
                      },
                      "dateInfo":{
                        "PickupDate": "",
                        "ApptTime": "",
                        "RetWillCallDay": "",
                        "IsWillCall":false,
                        "IsScheduled": false,
                        "IsMultiSchedule":false
                      },
                      "estimatedInfo":{
                        "EstimatedDistance": 0,
                        "EstimatedTime": 0,
                        "EstimatedCost": 0,
                        "BillableAmount": 0,
                        "CoPay": 0,
                        "AdditionalPassCost": 0,
                        "BillableMiles": 0,
                        "IsBillingRequired": false
                      },
                      "paymentInfo":{
                        "FundingSourceID": 0,
                        "PaymentTypeID": 0, 
                        "iCopayFundingSourceID": 0,
                        "iActualPaymentTypeID": 0,
                        "ReturnCopay": 0,
                        "CCInfo": "",
                        "CCResults": "",
                        "PromoAmount": 0
                      },
                      "driverInfo":{
                        "SpecialDriverId": 0,
                        "AssignedDriverId": 0,
                        "DriverNoTimeDiff": 0,
                        "OnlyPreferedDriver": false,
                        "AssignedDriverNo": 0,
                        "PreferedDriverNum": "",
                        "PreferedDriverGender": "",
                        "OnlyPreferedDriverGender": false,
                        "OnlyPreferedDriverLanguage": false,
                        "GenderTimeDiff":0,
                        "LangTimeDiff":0,
                        "PreferedLanguage": 0,
                      },
                      "vehicleInfo":{
                        "SpecialVehicleId": 0,
                        "AssignedVehicleId": 0,
                        "VehicleTypeId": -1,
                        "VehicleNoTimeDiff": 0,
                        "OnlyPreferedVType": false,
                        "OnlyPreferedVehicle": false,
                        "AssignedVehNo": "",
                        "PreferedVehicleNo": "",
                      },
                    };
                    tempDict.StopType = (verifiedAddr[k].stops[i].passLoadType === "none" ? "wait" : verifiedAddr[k].stops[i].passLoadType);
                    tempDict.WaitTime = (verifiedAddr[k].stops[i].waitTime !== 0 ? verifiedAddr[k].stops[i].waitTime : 0);
                    tempDict.Name = (verifiedAddr[k].stops[i].passengerName === "" ? verifiedAddr[k].passengerName : verifiedAddr[k].stops[i].passengerName);
                    if(verifiedAddr[k].stops[i].passLoadType !== "none")
                    {
                      if(verifiedAddr[k].stops[i].passLoadType === "unload")
                      {
                        tempDict.passengerInfo.TotalUnloadPassengers = verifiedAddr[k].stops[i].stopPax.total;
                      }
                      tempDict.passengerInfo.TotalPassengers = verifiedAddr[k].stops[i].stopPax.total;
                      tempDict.passengerInfo.TotalWheelChairs = verifiedAddr[k].stops[i].stopPax.totalWC;
                      tempDict.passengerInfo.ServiceAnimalCount = String(verifiedAddr[k].stops[i].stopPax.totalSA);
                    }
                    tempDict.addressDetails.Address = (verifiedAddr[k].stops[i].stopAddr.includes(",") ? verifiedAddr[k].stops[i].stopAddr.split(",")[0]:verifiedAddr[k].stops[i].stopAddr);
                    tempDict.addressDetails.Latitude = parseFloat(verifiedAddr[k].stops[i].stopLatLng.split(",")[0]);
                    tempDict.addressDetails.Longitude = parseFloat(verifiedAddr[k].stops[i].stopLatLng.split(",")[1]);
                    tempDict.addressDetails.City = "";
                    tempDict.addressDetails.State = "";
                    tempDict.addressDetails.Zip = "";
                    tempDict.addressDetails.Remarks = verifiedAddr[k].stops[i].notes;
                    tempDict.addressDetails.Phone = areaCode+"-"+firstPart+"-"+secondPart;
                    stopsArr[k].push(tempDict);
                  }
                  let dropoffStop = fillAddressDetails(
                    [],
                    verifiedAddr[k].doNotes,
                    verifiedAddr[k].dropLatLng,
                    "dropoff",
                    verifiedAddr[k],
                    "",
                    "",
                    nTotalUnloaded,
                    attrStringList[k]
                  );
                  stopsArr[k].push(dropoffStop);
                }
                let responseArr = []; 
                let namesArr = [];
                let accurateDate = formatDate(currDate);
                let historyTripsListSaved = PersistStorage.retrieve("agentTrips", true);
                let historyTripsList = historyTripsListSaved && historyTripsListSaved.length !== 0 ? [...historyTripsListSaved] : [];
                // for(let j = 0; j < verifiedAddr.length; j++)
                // {
                  bIsScheduledVar = false;
                  if(accurateDate !== verifiedAddr[0].date)
                  {
                    bIsScheduledVar = true;
                  }
                  // console.log(stopsArr);
                  
                  let affiliateID = parseInt(verifiedAddr[0].AffiliateSelected);
                  let combinedDataAddedTimeVF = ASCSSettingData ? (JSON.parse(ASCSSettingData[affiliateID]).find((item)=>item.SubTitle === "Ta01")).value : 0;
                  let combinedDataDefaultShowPhoneVF = ASCSSettingData ? (JSON.parse(ASCSSettingData[affiliateID]).find((item)=>item.SubTitle === "DefaultCustomerShowPhoneNo")).value: false;
                  let fsDataVF = FundingSourceData ? JSON.parse(FundingSourceData[parseInt(affiliateID)]) : [];
                  let combinedDataDefaultSkipPaymentScreenVF = fsDataVF.length > 0 ? ((fsDataVF.find((item)=> parseInt(item.FID) === parseInt(verifiedAddr[0].FundingSource)))?.bSkipPaymentProcessOnSD) : false;
                  let combinedDataDefaultUseHTMLFormatEmailVF = ASCSSettingData ? (JSON.parse(ASCSSettingData[affiliateID]).find((item)=>item.SubTitle === "UseHTMLFormatEmail")).value : false;
                  let combinedDataSendEmailFromSASVF = ASCSSettingData ? (JSON.parse(ASCSSettingData[affiliateID]).find((item)=>item.SubTitle === "Web_Shuttle_SendEmailFromSASCode")).value : false;
                  let combinedDataSRDuplicateDelayVF = ASCSSettingData ? (JSON.parse(ASCSSettingData[affiliateID]).find((item)=>item.SubTitle === "SRDuplicateCallDelay")).value : 0;
                  let areaCode = verifiedAddr[0].phone.replace("+1","").substring(0,3);
                  let firstPart = verifiedAddr[0].phone.replace("+1","").substring(3,6);
                  let secondPart = verifiedAddr[0].phone.replace("+1","").substring(6,10);
                  let inverseDate = inverseFormatDate(verifiedAddr[0].date);
                  
                  let unloadedPassengerArr = stopsArr[0].filter(item=>item.StopType.toLowerCase() === "unload");
                  const transformedData = stopsArr.map(stopsGroup => {
                    return {
                      Details: stopsGroup.map(stop => ({
                        ...stop,
                      }))
                    };
                  });
                  let firstName = (verifiedAddr[0].riderName.includes(",") ? verifiedAddr[0].riderName.split(",")[1] : 
                    verifiedAddr[0].riderName.trim().includes(" ")? verifiedAddr[0].riderName.split(" ")[0]: verifiedAddr[0].riderName);
                  let lastName = (verifiedAddr[0].riderName.includes(",") ? verifiedAddr[0].riderName.split(",")[0] : 
                    verifiedAddr[0].riderName.trim().includes(" ")? verifiedAddr[0].riderName.replace(firstName, "").trim(): "");
                  // console.log(transformedData);
                  const FamilyID = (AffiliateData.find((item) => {if(parseInt(item.AffiliateID) === parseInt(verifiedAddr[0].AffiliateSelected)){return item}})).iPartnerAffiliateID;
                  data = {
                    "generalInfo": {
                      "CompleteUserName": (loginData.vUserName ? loginData.vUserName : ""),
                      "CreatedBy": loginData.vDisplayName,
                      "CreatedByAppID": iAppID,
                      "CreatedUserId": (loginData.iUserID ? loginData.iUserID : 0),
                      "RequestAffiliateID": parseInt(verifiedAddr[0].AffiliateSelected),
                      "ReturnDetailID": "",
                      "FamilyID": parseInt(FamilyID)
                    },
                    "riderInfo":{
                      "ID": (verifiedAddr[0].id ? verifiedAddr[0].id : -1),
                      "PhoneNo": areaCode+"-"+firstPart+"-"+secondPart,
                      "FirstName": firstName,
                      "Mid": "",
                      "LastName": lastName,
                      "DateOfBirth": "01/01/1900",
                      "RiderID": (medID && medID !== "" && parseInt(medID) !== 0 ? String(medID) : "0"),
                      "RiderPassword": "",
                      "MedicalID": (verifiedAddr[0].clientMedID ? verifiedAddr[0].clientMedID : ""),
                      "ClientAddress": (verifiedAddr[0].clientAddr && verifiedAddr[0].clientAddr !== "" ? verifiedAddr[0].clientAddr : stopsArr[0][0].addressDetails.Address),
                      "ClientCity": (verifiedAddr[0].clientCity && verifiedAddr[0].clientCity !== "" ? verifiedAddr[0].clientCity : stopsArr[0][0].addressDetails.City),
                      "ClientState": (verifiedAddr[0].clientState && verifiedAddr[0].clientState !== "" ? verifiedAddr[0].clientState : stopsArr[0][0].addressDetails.State),
                      "ClientZip": (verifiedAddr[0].clientZip && verifiedAddr[0].clientZip !== "" ? verifiedAddr[0].clientZip : stopsArr[0][0].addressDetails.Zip),
                    },
                    "insuranceInfo":{
                      "AgencyID": (verifiedAddr[0].insurance.Agency === "" ? 0 : verifiedAddr[0].insurance.Agency),
                      "InsuranceID": (verifiedAddr[0].insurance.Type === "" ? 0 : verifiedAddr[0].insurance.Type),
                      "CaseWorkerID": (verifiedAddr[0].insurance.CaseWorker === "" ? 0 : verifiedAddr[0].insurance.CaseWorker),
                      "AuthID": (verifiedAddr[0].insurance.AuthCode === "" ? 0 : verifiedAddr[0].insurance.AuthCode),
                      "ServiceCodeID": (verifiedAddr[0].insurance.ServiceCode === "" ? 0 : verifiedAddr[0].insurance.ServiceCode),
                      "MedicalID": (verifiedAddr[0].clientMedID? verifiedAddr[0].clientMedID : "") 
                    },
                    "routeSettingInfo":{
                      "TimeWindow": 0,
                      "EndTimeWindow": 0,
                      "MinRideTime": 0,
                      "MaxRideTime": 0,
                      "ServiceTimeAmb": 0,
                      "ServiceTimeWC": 0,
                      "ApptTimeWindow": 0,
                      "AdditionalSameLocAm": 0,
                      "AdditionalSameLocWC": 0
                    },
                    "systemConfigInfo":{
                      "DefaultCustomerShowPhoneNo": combinedDataDefaultShowPhoneVF,
                      "IsSkipPaymentProcessOnSD": combinedDataDefaultSkipPaymentScreenVF,
                      "Ta01": combinedDataAddedTimeVF,
                      "UseHTMLFormatEmail": combinedDataDefaultUseHTMLFormatEmailVF,
                      "Web_Shuttle_SendEmailFromSASCode": combinedDataSendEmailFromSASVF,
                      "SRDuplicateCallDelay": combinedDataSRDuplicateDelayVF
                    },
                    "exclusions": (scheduleJSON.mainData !== "" && scheduleJSON.mainData.Schedule.ScheduleItem.length > 0 && verifiedAddr.length <= 1 ? exclusionsListArr : []),
                    "scheduleInfo": multiSchItems,
                    "addressInfo":{
                      // "returnLegsList": "",
                      "Trips":transformedData,
                      
                    },
                  };
                  // "returnInfo":{
                  //     "ReturnDateTime": (verifiedAddr[0].IsReturn? inverseDate + " " + (verifiedAddr[0].time === "" ? currTime:verifiedAddr[0].time): "01/01/1900 00:00:00"),
                  //     "ReturnEstimatedDistance": (verifiedAddr[0].IsReturn? parseFloat(verifiedAddr[0].distance):0),
                  //     "ReturnEstimatedTime": (verifiedAddr[0].IsReturn? parseFloat(verifiedAddr[0].duration):0),
                  //     "ReturnEstimatedCost": (verifiedAddr[0].IsReturn? parseFloat(verifiedAddr[0].fare):0),
                  //     "ReturnBillableAmount": 0,
                  //     "ReturnAdditionalPassCost": 0
                  //   },
                  let response = await APICom.fetchData("ReservationCoreURL","BookParatransitTrip", "post", {}, data, xCancelSourceForGrid.current);
                  if(response && response.error.length === 0)
                  {
                    if(response.data && response.data.responseCode === 200)
                    {
                      if(response.data.iRefID <= 0 && response.data.responseJSON !== "")
                      {
                        setModalHeaderText("Error Occured on Booking");
                        setModalBodyHTML(response.data.responseJSON);
                        setModalFooterHTML(
                          <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                            OK
                          </Button>
                        );
                        setShowDynamicModal(true);
                        setModalClass("");
                        setShowAPILoader(false);
                      }
                      else
                      {

                        let confirmation = response.data.iRefID+(response.data.returnLegsList && response.data.returnLegsList !== "" ? "-"+parseInt(response.data.returnLegsList) : "");
                        // responseArr.push({trip:(j+1), code:response.data.responseCode, response:response.data});
                        responseArr.push({trip:1, code:response.data.responseCode, response:response.data});
                        setModalHeaderText("Trip Booked Successfully");
                        setModalBodyHTML(
                          <>
                            <p className="m-0 user-select-none">
                              {"Please use the following confirmation number(s) to check your trip status: "} 
                            </p>
                            <p className="m-0 w-100 fw-bold text-center user-select-all">{confirmation}</p>
                          </>
                        );
                        setModalFooterHTML(
                          <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                            OK
                          </Button>
                        );
                        setShowDynamicModal(true);
                        setModalClass("");
                        setShowAPILoader(false);
                        // const multiTripError = responseArr.some(response => response.code !== 200);
                        
                        if(responseArr[0].code === 200)
                        {
                          handleResetAll("none");
                        }
                        paratransitBookBtnRef.current.disabled = false;
                        for(let j = 0; j < data.addressInfo.Trips.length; j++)
                        {
                          historyTripsList.push({confirmation:confirmation, tripData:data, type: (data.addressInfo.Trips[j].Details[0].dateInfo.IsScheduled ? "Time Call (StopOrder)":"On Demand (StopOrder)")});
                        }
                        setConfirmationNo(confirmation);
                      }
                    }
                    else
                    {
                      setModalHeaderText("Error Occured on Booking");
                      setModalBodyHTML(response.data.responseJSON);
                      setModalFooterHTML(
                        <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                          OK
                        </Button>
                      );
                      setShowDynamicModal(true);
                      setModalClass("");
                      setShowAPILoader(false);
                      responseArr.push({trip:1, code:response.data.responseCode, response:response.data.responseJSON});
                    }
                  }
                  else
                  {
                    setModalHeaderText("Error Occured on Booking");
                    setModalBodyHTML(response.error);
                    setModalFooterHTML(
                      <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                        OK
                      </Button>
                    );
                    setShowDynamicModal(true);
                    setModalClass("");
                    setShowAPILoader(false);
                    responseArr.push({trip:1, code:"error", response:response.error});
                  }
                  namesArr.push(verifiedAddr[0].riderName);
                  // responseArr.push(response);
                // }
                setHistoryTrips(historyTripsList);
                PersistStorage.save("agentTrips", historyTripsList, 9999, true);
                const lastConfirmation = response.data.iRefID;
              
              }
            }
          }
        }
      }
      else
      {
        if((riderName === "" || riderName.trim().length < 2) && (!phone || phone.length < 12))
        {
          setModalHeaderText("Information Required");
          setModalBodyHTML("Please enter the complete phone number and full name in the provided fields.");
          setModalFooterHTML(
            <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
          riderNameRef.current.style.border = "3px solid red";
          phoneRef.current.style.border = "3px solid red";
        }
        else if(riderName === "" || riderName.trim().length < 2)
        {
          riderNameRef.current.style.border = "3px solid red";
          setModalHeaderText("Information Required");
          setModalBodyHTML("Please enter the full name in the highlighted field.");
          setModalFooterHTML(
            <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
        }
        else if(!phone || phone.length < 12)
        {
          phoneRef.current.style.border = "3px solid red";
          setModalHeaderText("Information Required");
          setModalBodyHTML("Please enter the complete phone number in the highlighted field.");
          setModalFooterHTML(
            <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
        }
        setShowDynamicModal(true);
        setModalClass("");
        setShowAPILoader(false);
        paratransitBookBtnRef.current.disabled = false;
      }
    }
    catch(err){
      console.log(err);
      paratransitBookBtnRef.current.disabled = false;
      setShowDynamicModal(false);
      setModalClass("");
      setShowAPILoader(false);
    }
  };

  const prepareDataForAddress = (mapPointSelection, type) => {
    const isPickup = type === "pickup";
    const dataTemplate = {
      street: "",
      city: "",
      state: "",
      zip: "",
      zone: "",
      lat: "",
      long: "",
      stopname: ""
    };
  
    try {
      if (mapPointSelection?.current) {
        const current = mapPointSelection.current;
  
        return {
          ...dataTemplate,
          city: current.City || current[`${isPickup ? "PU" : "DO"}City`] || "",
          state: current.State || current[`${isPickup ? "PU" : "DO"}State`] || "",
          street: current.Street || current[`${isPickup ? "PU" : "DO"}Address`] || "",
          zip: current.Zip || current[`${isPickup ? "PU" : "DO"}Zip`] || "",
          lat: current.Lat || current[`${isPickup ? "PU" : "DO"}Lat`] || "",
          long: current.Long || current[`${isPickup ? "PU" : "DO"}Long`] || "",
        };
      }
    } catch (error) {console.log(error);}
  
    return dataTemplate;
  };

  const handleCreateUpdateTrip = async(e)=>{
    try{
      
      if(!isTimeValidated)
      {
        await validateMinScheduleTimeDifference();
      }
      else if(isTimeValidated)
      {
        sethandlePageProgressBar("calltaker");
        if(passengerTypeCount.total === 0)
        {
          setModalHeaderText("Information Required");
          setModalBodyHTML("Total passenger count can not be 0.");
          setModalFooterHTML(
            <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
          setModalClass("");
          setShowDynamicModal(true);
          setShowAPILoader(false);
        }
        else
        {
          if(riderName.length >= 2 && phone && phone.length >= 12 && typeof rczVerifData === 'object')
          {
            if(e.target.textContent.toLowerCase() === "update")
            {
      
            }
            else if(e.target.textContent.toLowerCase() === "book")//create
            {
              setModalHeaderText("Booking In Progress");
              setModalBodyHTML("Trip is being booked, please wait.");
              setModalFooterHTML("");
              setModalClass("d-none");
              setShowAPILoader(true);
              setShowDynamicModal(true);
              bookBtnRef.current.disabled = true;
              const options = {timeZone: 'America/New_York', month: '2-digit', day: '2-digit', year: 'numeric' };
              const currDate = new Date().toLocaleDateString('en-US', options);
              // Get the current time
              const currentTime = new Date();
              let addedMinutes = parseInt((JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "Ta01")).value)/60;
              let combinedDataAddedTime = (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "Ta01")).value;
              // Add 10 minutes to the current time
              currentTime.setMinutes(currentTime.getMinutes() + addedMinutes);

              let areaCode = phone.replace("+1","").substring(0,3);
              let firstPart = phone.replace("+1","").substring(3,6);
              let secondPart = phone.replace("+1","").substring(6,10);
      
              let userEnteredPickupAddress = prepareDataForAddress(mapPointPickupSelection, "pickup");

              if(!userEnteredPickupAddress.street || userEnteredPickupAddress.street === "")
              {
                userEnteredPickupAddress.street = pickupAddr;
              }
        
              if(pickupVirtualStop?.value && pickupVirtualStop?.value !== ""){
                try {
                  const virtualStopData = VirtualStopsData.find(p => p.ID === pickupVirtualStop.value);
                  if(virtualStopData){
                    userEnteredPickupAddress.city = userEnteredPickupAddress.city || virtualStopData.City || "";
                    userEnteredPickupAddress.state = userEnteredPickupAddress.state || virtualStopData.State || "";
                    userEnteredPickupAddress.zip = userEnteredPickupAddress.zip || virtualStopData.Zipcode || "";
                  }
                } catch (error) { }
              }

              let userEnteredDropoffAddress = prepareDataForAddress(mapPointDropoffSelection, "dropoff");

              if(!userEnteredDropoffAddress.street || userEnteredDropoffAddress.street === "")
              {
                userEnteredDropoffAddress.street = dropAddr;
              }

              if(dropAddrVirtualStop?.value && dropAddrVirtualStop?.value !== ""){
                try {
                  const virtualStopData = VirtualStopsData.find(p => p.ID === dropAddrVirtualStop.value);
                  if(virtualStopData){
                    userEnteredDropoffAddress.city = userEnteredDropoffAddress.city || virtualStopData.City || "";
                    userEnteredDropoffAddress.state = userEnteredDropoffAddress.state || virtualStopData.State || "";
                    userEnteredDropoffAddress.zip = userEnteredDropoffAddress.zip || virtualStopData.Zipcode || "";
                  }
                } catch (error) { }
              }

              let data = {
                "id": "-1",
                "Ta01": (combinedDataAddedTime? combinedDataAddedTime:0),
                "TravelMinutes": walkDistance.PUDuration,
                "referenceId": "",
                "linkedRideIds": [],
                "transportationProviderId": "1312501",
                "scheduledDate": schTime !== "" ? currDate:"01/01/1900", 
                "appointmentTime": "01/01/1900 00:00:00",
                "isPredictive" : "true",
                "bCheckServiceHours": "true",
                "iCreatedByAppID": "26",
                "iCreatedUserId": String(loginData.iUserID),
                "additionalPassengers": {
                    "attendants": 0,
                    "escorts": 0
                },
                "willCall": false,
                "billableAmount": null,
                "billableMiles": parseFloat(clientSummary.tripDistance),
                "assistanceNeeds": [],
                "billingRequired": true,
                "levelOfService": "A",
                "levelOfServiceDescription": "Ambulatory",
                "levelOfServiceGroup": "Ambulatory",
                "unableToSign": false,
                "signatureRequired": true,
                "additionalProperties": {
                  "condition": null,
                  "carseats": 0,
                  "copay": parseFloat(clientSummary.TripFare),
                  "member_number": null,
                  "ordering_medical_provider_name": null,
                  "ordering_medical_provider_npi": null,
                  "prior_auth_num": null
                },
                "rider": {
                  "id": searchedClientID.current,
                  "firstName": riderName === "" ? loginData.vDisplayName.split(", ")[1] : riderName.trim().split(" ")[0],
                  "middleName": "",
                  "lastName": riderName === "" ? loginData.vDisplayName.split(", ")[0] : riderName.trim().split(" ")[1],
                  "dateOfBirth": "1974-09-19",
                  "gender": "M",
                  "weight": 0,
                  "phone": areaCode+"-"+firstPart+"-"+secondPart,
                },
                "pickup": {
                  "address": {
                    "addressLine1": (rczVerifData.pudoNearbyVS.pvs.street.includes(",")?rczVerifData.pudoNearbyVS.pvs.street.split(", ")[0]:rczVerifData.pudoNearbyVS.pvs.street),
                    "addressLine2": "",
                    "city": rczVerifData.pudoNearbyVS.pvs.city,
                    "county": "",
                    "state": rczVerifData.pudoNearbyVS.pvs.state,
                    "zipCode": rczVerifData.pudoNearbyVS.pvs.zip,
                    "latitude": parseFloat(pickLatLng.current.split(",")[0]),
                    "longitude": parseFloat(pickLatLng.current.split(",")[1]),
                    "stopname":pickupVirtualStop.name,
                    "reqpustreet": userEnteredPickupAddress?.street != null ? userEnteredPickupAddress.street : "",
                    "reqpucity": userEnteredPickupAddress?.city != null ? userEnteredPickupAddress.city : "",
                    "reqpustate": userEnteredPickupAddress?.state != null ? userEnteredPickupAddress.state : "",
                    "reqpuzip": userEnteredPickupAddress?.zip != null ? userEnteredPickupAddress.zip : "",
                    "reqpuzone": zones,
                    "reqpulat": userEnteredPickupAddress?.lat != null ? userEnteredPickupAddress.lat : "",
                    "reqpulong": userEnteredPickupAddress?.long != null ? userEnteredPickupAddress.long : "",
                    "reqpustopname": pickupVirtualStop.name,
                  },
                  "scheduledTime": schTime !== "" ? currDate+" "+schTime:"01/01/1900 00:00:00",
                  "name": "",
                  "comments": pickExtraInfo,
                  "phone": {
                    "number": areaCode+"-"+firstPart+"-"+secondPart,
                    "ext": 1
                  }
                },
                "dropoff": {
                  "address": {
                    "addressLine1": (rczVerifData.pudoNearbyVS.dvs.street.includes(",")?rczVerifData.pudoNearbyVS.dvs.street.split(", ")[0]:rczVerifData.pudoNearbyVS.dvs.street),
                    "addressLine2": "",
                    "city": rczVerifData.pudoNearbyVS.dvs.city,
                    "county": "",
                    "state": rczVerifData.pudoNearbyVS.dvs.state,
                    "zipCode": rczVerifData.pudoNearbyVS.dvs.zip,
                    "latitude": parseFloat(dropLatLng.current.split(",")[0]),
                    "longitude": parseFloat(dropLatLng.current.split(",")[1]),
                    "stopname":dropAddrVirtualStop.name,
                    "reqdostreet": userEnteredDropoffAddress?.street != null ? userEnteredDropoffAddress.street : "",
                    "reqdocity": userEnteredDropoffAddress?.city != null ? userEnteredDropoffAddress.city : "",
                    "reqdostate": userEnteredDropoffAddress?.state != null ? userEnteredDropoffAddress.state : "",
                    "reqdozip": userEnteredDropoffAddress?.zip != null ? userEnteredDropoffAddress.zip : "",
                    "reqdozone": zones,
                    "reqdolat": userEnteredDropoffAddress?.lat != null ? userEnteredDropoffAddress.lat : "",
                    "reqdolong": userEnteredDropoffAddress?.long != null ? userEnteredDropoffAddress.long : "",
                    "reqdostopname": dropAddrVirtualStop.name,
                  },
                  "scheduledTime": schTime !== "" ? currDate+" "+schTime:"01/01/1900 00:00:00",
                  "name": "",
                  "comments": dropExtraInfo,
                  "phone": {
                    "number": areaCode+"-"+firstPart+"-"+secondPart,
                    "ext": 1
                  }
                },
                "webhookURL": "https://api.circulation.com/transit/webhook/atms/",
                "nTotalPassengers":parseInt(passengerTypeCount.total),
                "nTotalWheelChairs":parseInt(passengerTypeCount.totalWC),
                "iServiceAnimalsCount":parseInt(passengerTypeCount.totalSA)
              };
              let response = await APICom.fetchData("ReservationCoreURL","CreateRide", "post", {}, data, xCancelSourceForGrid.current);
              // console.log("booking response: ", response);
              if(response && response.error.length === 0)
              {
                if(response.data.responseCode !== 200)
                {
                  setModalHeaderText("Trip Reservation Failed");
                  setModalBodyHTML(response.data.responseMessage);
                  setModalFooterHTML(
                    <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                      OK
                    </Button>
                  );
                  setShowDynamicModal(true);
                  setModalClass("");
                  setShowAPILoader(false);
                }
                else
                {
                  //Trip Booked with response JSON
                  let tripID = response.data.id;
                  setModalHeaderText("Trip Booked Successfully");
                  setModalBodyHTML(
                    <>
                      <p className="m-0 user-select-none">
                        {"Please use the following confirmation number to check your trip status: "} 
                      </p>
                      <p className="m-0 w-100 fw-bold text-center user-select-all">{tripID}</p>
                    </>
                  );
                  setModalFooterHTML(
                    <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                      OK
                    </Button>
                  );
                  setShowDynamicModal(true);
                  setModalClass("");
                  setShowAPILoader(false);
                  handleResetAll("none");
                  setConfirmationNo(tripID);
                  let oldDataArr = PersistStorage.retrieve('confirmationsData', false);
                  let updatedArr = oldDataArr ? [...oldDataArr, {Confirmation: tripID, time: null, dropTime:null, name:riderName, creationTime: new Date(), msg:"", tripID: ""}] 
                    : [{Confirmation: tripID, time: null, dropTime:null, name:riderName, creationTime: new Date(), msg:"", tripID: ""}];
                  PersistStorage.save('confirmationsData', updatedArr, 999, false);
                  // setSubmitBtnTitle("Update");
                  setTripStatus("Routed");
                  setSchPUTime(null);
                  let MTMSNegotiationHTML = [tripID].map(function(item, index){
                    return(
                      <tr key={index} className="text-center border-bottom border-dark">
                        <td className="border border-dark user-select-none small">{item}</td>
                        <td className="border border-dark user-select-none small overflow-hidden text-nowrap" title={""} style={{textOverflow:"ellipsis"}}>
                          {""}
                        </td>
                        <td className="border border-dark user-select-none text-nowrap small overflow-hidden" 
                        style={{textOverflow:"ellipsis"}} title={riderName}
                        >{riderName}</td>
                        <td className="border border-dark user-select-none text-nowrap small overflow-hidden" title={item.msg} 
                          style={{textOverflow:"ellipsis"}}
                        >
                          {item.msg}
                        </td>
                        <td className="border-dark border-bottom user-select-none text-center justify-content-center">
                          <div className="d-flex">
                            <Button variant="secondary" className="d-inline-block p-1 py-0" disabled={item.msg === ""} title={"Remove trip from view"} 
                              onClick={handleRemoveRecord} tabIndex={-1} name={item.ID}>
                              X
                            </Button>
                            {item.time !== "N/A"?<Button variant="danger" className="mx-1 d-inline-block p-1 py-0" disabled={item.msg === ""} title={"Reject scheduled trip"} 
                              onClick={handleRejectTrip} tabIndex={-1} name={item.ID}>
                              Reject
                            </Button>:
                            <Button variant="danger" tabIndex={-1} className="mx-1 d-inline-block p-1 py-0 opacity-0" disabled={item.time === "N/A"} 
                              name={item.ID}>
                              Reject
                            </Button>}
                          </div>
                        </td>
                      </tr>
                    )
                  });
                  setMTSMTableHTML(prevState=>(
                    <>
                      {MTMSNegotiationHTML}
                      {prevState?prevState:""}
                    </>
                  ));
                }
              }
              else
              {
                setModalHeaderText("Trip Reservation Failed");
                setModalBodyHTML(response.error);
                setModalFooterHTML(
                  <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                    OK
                  </Button>
                );
                setShowDynamicModal(true);
                setModalClass("");
                setShowAPILoader(false);
                bookBtnRef.current.disabled = false;
              }
            }
          }
          else
          {
            if((riderName === "" || riderName.length < 2) && (!phone || phone.length < 12))
            {
              setModalHeaderText("Information Required");
              setModalBodyHTML("Please enter the complete phone number and full name in the provided fields.");
              setModalFooterHTML(
                <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                  OK
                </Button>
              );
              setShowDynamicModal(true);
              setModalClass("");
              setShowAPILoader(false);
              riderNameRef.current.style.border = "3px solid red";
              phoneRef.current.style.border = "3px solid red";
            }
            else if(riderName === "" || riderName.length < 2)
            {
              riderNameRef.current.style.border = "3px solid red";
              setModalHeaderText("Information Required");
              setModalBodyHTML("Please enter the full name in the highlighted field.");
              setModalFooterHTML(
                <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                  OK
                </Button>
              );
              setModalClass("");
              setShowDynamicModal(true);
              setShowAPILoader(false);
            }
            else if(!phone || phone.length < 12)
            {
              phoneRef.current.style.border = "3px solid red";
              setModalHeaderText("Information Required");
              setModalBodyHTML("Please enter the complete phone number in the highlighted field.");
              setModalFooterHTML(
                <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                  OK
                </Button>
              );
              setModalClass("");
              setShowDynamicModal(true);
              setShowAPILoader(false);
            }
            else if(rczVerifData.length === 0)
            {
              setModalHeaderText("Information Required");
              setModalBodyHTML("Please enter and verify the addresses in provided fields to continue.");
              setModalFooterHTML(
                <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                  OK
                </Button>
              );
              setModalClass("");
              setShowDynamicModal(true);
              setShowAPILoader(false);
            }
          }
        }
      }
    }
    catch(err)
    {
      console.log(err);
    }
  };

  const handlePassCountTotal = (e, type = "", count = 0)=>{
    try{
      const regex = /^[0-9\b]+$/;
      let wcCount = 0;
      let totalCount = 0;
      if(type === "" && e.target.value.length > 0)
      {
        let tempVal = e.target.value;
        if(tempVal[0] === "0" && tempVal.length > 1)
        {
          e.target.value = tempVal[1];
        }
      }
      if(type === "" && e.target.name === "ambPass")
      {
        if(!regex.test(e.target.value)){e.target.value = 0;}
        else if(parseInt(e.target.value) > 30){e.target.value = 30;}
        wcCount = parseInt(passengerTypeCount.totalWC);
        totalCount = parseInt(passengerTypeCount.totalWC) + parseInt(e.target.value);
        setPassengerTypeCount({...passengerTypeCount,ambPass:parseInt(e.target.value), 
          total:(parseInt(e.target.value) + parseInt(passengerTypeCount.totalWC))});
      }
      else if(type === "" && e.target.name === "totalWC")
      {
        if(!regex.test(e.target.value)){e.target.value = 0;}
        else if(parseInt(e.target.value) > 10){e.target.value = 0;}
        wcCount = parseInt(e.target.value);
        totalCount = parseInt(e.target.value) + parseInt(passengerTypeCount.ambPass);
        setPassengerTypeCount({...passengerTypeCount,totalWC:parseInt(e.target.value), 
          total:(parseInt(e.target.value) + parseInt(passengerTypeCount.ambPass))});
      }
      else if(type === "" && e.target.name === "totalSA")
      {
        if(!regex.test(e.target.value)){e.target.value = 0;}
        else if(parseInt(e.target.value) > 5){e.target.value = 5;}
        wcCount = parseInt(passengerTypeCount.totalWC);
        totalCount = parseInt(passengerTypeCount.totalWC) + parseInt(passengerTypeCount.ambPass);
        setPassengerTypeCount({...passengerTypeCount,totalSA:parseInt(e.target.value), 
          total:(parseInt(passengerTypeCount.ambPass)+ parseInt(passengerTypeCount.totalWC))});
      }

      if(type !== "")
      {
        wcCount = count;
        totalCount = parseInt(count);
        setPassengerTypeCount({...passengerTypeCount, ambPass:0, totalWC:parseInt(count), 
          total:(parseInt(count))});
      }

      if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2))
      {
        if(pickLatLng.current !== "" && (FSSelected && FSSelected !=="") && (copayFSSelected && copayFSSelected !== ""))
        {
          handleFareCalculation(clientSummary.tripDistance, clientSummary.TripDuration, FSSelected, copayFSSelected, wcCount, totalCount, COSSelected, selectedAff, pickLatLng.current, copayAmount);
        }
      }
      
    }
    catch(err){console.log(err);}
  };

  const handlePassCountTotalStop = (e)=>{
    try{
      const regex = /^[0-9\b]+$/;
      if(e.target.value.length > 0)
      {
        let tempVal = e.target.value;
        if(tempVal[0] === "0" && tempVal.length > 1)
        {
          e.target.value = tempVal[1];
        }
      }
      if(e.target.name === "ambPass")
      {
        if(!regex.test(e.target.value)){e.target.value = 0;}
        else if(parseInt(e.target.value) > 30){e.target.value = 30;}
        setPassengerTypeCountStop({...passengerTypeCountStop,ambPass:parseInt(e.target.value), 
          total:(parseInt(e.target.value) + parseInt(passengerTypeCountStop.totalWC))});
      }
      else if(e.target.name === "totalWC")
      {
        if(!regex.test(e.target.value)){e.target.value = 0;}
        else if(parseInt(e.target.value) > 10){e.target.value = 10;}
        setPassengerTypeCountStop({...passengerTypeCountStop,totalWC:parseInt(e.target.value), 
          total:(parseInt(e.target.value) + parseInt(passengerTypeCountStop.ambPass))});
      }
      else if(e.target.name === "totalSA")
      {
        if(!regex.test(e.target.value)){e.target.value = 0;}
        else if(parseInt(e.target.value) > 5){e.target.value = 5;}
        setPassengerTypeCountStop({...passengerTypeCountStop,totalSA:parseInt(e.target.value), 
          total:(parseInt(passengerTypeCountStop.ambPass)+ parseInt(passengerTypeCountStop.totalWC))});
      }
      else if(e.target.name === "waitTime")
      {
        if(!regex.test(e.target.value)){e.target.value = 0;}
        else if(parseInt(e.target.value) > 60){e.target.value = 60;}
        setReturnWaitTimeInput(parseInt(e.target.value));
      }
      
    }
    catch(err){console.log(err);}
  };

  const handleVehTypeChangeModal = (option, type = '', vehicle = '', driver = '', gender = '')=>{
    try{
      // console.log(option);
      if(type === 'wc')
      {
        handlePassCountTotal(option, "totalWC", 1);
      }
      setShowDynamicModal(false);
      let vehData = (DispatchVehicleData[parseInt(selectedAff)] && DispatchVehicleData[parseInt(selectedAff)] !== "" ? DispatchVehicleData[parseInt(selectedAff)] : []);
      let vehNum = (vehData.length !== 0 ? handleDuplicates(JSON.parse(vehData), "VehicleNumber") : []);
      let driverNum = DispatchDriverData[parseInt(selectedAff)] ? JSON.parse(DispatchDriverData[parseInt(selectedAff)]) : [];
      // console.log(driverNum);
      const sortedVehNum = vehNum.sort((a, b) => a.VehicleNumber - b.VehicleNumber);
      const sortedDriverNum = driverNum.sort((a, b) => a.DriverNumber - b.DriverNumber);
      // console.log(sortedVehNum);
      let newVehNumberOptions = "";
      let newDriverNumberOptions = "";
      if(option !== "VT")
      {
        newVehNumberOptions = sortedVehNum.filter(item => parseInt(item.iVTypeID) === parseInt(option)).map((item, index)=>{
          return(
            <option key={index} value={item.VehicleID+"_"+item.VehicleNumber}>{item.VehicleNumber}</option>
          ); 
        });
        newVehNumberOptions.unshift(<option key={444} value={"VN"}>{"None"}</option>);
        
        newDriverNumberOptions = sortedDriverNum.filter(item => parseInt(item.iVTypeID) === parseInt(option) || String(item.iVTypeID) === "-1").map((item, index)=>{
          
          return(
            <option key={index} value={item.DriverID+"_"+item.DriverNumber}>{item.DriverNumber}</option>
          ); 
          
        });
        newDriverNumberOptions.unshift(<option key={555} value={"DN"}>{"None"}</option>);
      }
      else
      {
        if(vehicle === "")
        {
          newVehNumberOptions = sortedVehNum.map((item, index)=>{
            return(
              <option key={index} value={item.VehicleID+"_"+item.VehicleNumber}>{item.VehicleNumber}</option>
            ); 
          });
          newVehNumberOptions.unshift(<option key={444} value={"VN"}>{"None"}</option>);
          
          newDriverNumberOptions = sortedDriverNum.map((item, index)=>{
            if(String(item.iVTypeID) === "-1")
            {
              return(
                <option key={index} value={item.DriverID+"_"+item.DriverNumber}>{item.DriverNumber}</option>
              ); 
            }
          });
          newDriverNumberOptions.unshift(<option key={555} value={"DN"}>{"None"}</option>);
          
        }
        
      }
      if(newVehNumberOptions && newVehNumberOptions !== "")
      {
        setVehNumberOptionsHTML(newVehNumberOptions);
        setDriverNumberOptionsHTML(newDriverNumberOptions);
      }
      setSelectedDriverNum((driver === '' ? "DN" : driver));
      setSelectedVehNum((vehicle === '' ? "VN" : vehicle));
      setSelectedGender((gender === '' ? "Gender" : gender));
    }
    catch(err){console.log(err);}
  };

  const handleVehTypeChanged = (e, selectedVehTypeVal = "0", maxWheelChairs = "0", vehicleData = "", driverData = "", gender = "")=>{
    try{
      const input = (typeof e === "string" ? (String(selectedVehTypeVal) === "-1" ? "VT" : selectedVehTypeVal) : e.target.value);
      if(String(selectedVehTypeVal) !== "-1")
      {
        setSelectedVehType(input);
      }
      const selectedIndex = (typeof e === "string" ? "" : e.target.selectedIndex);
      const selectedOption = (typeof e === "string" ? "" : e.target.options[selectedIndex]);
      const virtualData = (typeof selectedOption === "string" ? maxWheelChairs : selectedOption.getAttribute('data-virtual'));
      // console.log(virtualData);
      if(selectedAff !== "")
      {
        if(virtualData && parseInt(virtualData) !== 0 && passengerTypeCount.totalWC === 0)
        {
          setModalHeaderText("Vehicle Type Alert");
          setModalBodyHTML("Book as a wheelchair trip?");
          setModalFooterHTML(
            <>
              <Button variant='dark' className="border-0" onClick={(e)=>{handleVehTypeChangeModal(input, 'wc', vehicleData, driverData, gender);}}>
                Yes
              </Button>
              <Button variant='secondary' className="border-0" onClick={(e)=>{handleVehTypeChangeModal(input, '', vehicleData, driverData, gender);}}>
                No
              </Button>
            </>
          );
          setShowDynamicModal(true);
        }
        else
        {
          handleVehTypeChangeModal(input, '', vehicleData, driverData, gender);
        }
        
      }
    }
    catch(err){console.log(err);}
  };

  const handleVSChange = (e)=>{
    try{
      let correctDate = formatDate(selectedDateSchTime);
      if(bookBtnRef.current)
      {
        bookBtnRef.current.disabled = true;
      }
      const selectedIndex = e.target.selectedIndex;
      const selectedOption = e.target.options[selectedIndex];
      const virtualData = selectedOption.getAttribute('data-virtual');
      const name = selectedOption.getAttribute('data-name');
      const nm = selectedOption.textContent;
      if(e.target.title.toLowerCase().includes("pickup"))
      {
        mapPointPickupSelection.current = [];
        if(e.target.value === "PU VS")
        {
          setPickupVirtualStop({...pickupVirtualStop, value:"PU VS", name:""});
          setWalkDistance(prevWalkDistance=>({...prevWalkDistance, PUWalk:0, PUDuration:0}));
          if(pickLatLng.current === ""){
            setPickupAddr("");
          }
        }
        else
        {
          vsChangeRef.current.type = vsChangeRef.current.type.length === 0 ? "PU ": (vsChangeRef.current.type.includes("PU")
            ? vsChangeRef.current.type:vsChangeRef.current.type+"PU ");
          setPickupVirtualStop({...pickupVirtualStop, value:e.target.value, name:nm});
          if(pickLatLng.current === ""){
            setPickupAddr(name);
            // const selectedIndex = e.target.selectedIndex;
            // const selectedOption = e.target.options[selectedIndex];
            // const virtualData = selectedOption.getAttribute('data-virtual');
            // console.log(virtualData);
            pickLatLng.current = virtualData;
            // if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2)){
            //   setReturnAddr(name);
            //   returnLatLng.current = virtualData;
            // }
            if(!vsSelectedRef.current.includes("PU")){vsSelectedRef.current.push("PU")};
            let stopMarkersArr = [{lat:parseFloat(pickLatLng.current.split(",")[0]),
              lng: parseFloat(pickLatLng.current.split(",")[1]), Type:"PU", 
              name:(riderName === "" ? "N/A" : riderName.trim()), address: name
            },];
            let filteredMapMarkers = mapData.filter((item)=>{
              if(item.Type === "Stop")
              {
                stopMarkersArr.push(item);
              }
              return item.Type === "DO";
            });
            filteredMapMarkers.unshift(...stopMarkersArr);
            setMapData(filteredMapMarkers);
            setInputSuggestionListPU("");
            if(dropLatLng.current !== "")
            {
              puVSCallValidation.current = true;
              setIsSchTimeFieldDisabled(false);
              // handleAddressDetails("PU", name, name, dropAddr, correctDate, schTime);
              // if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2))
              // {
              //   handleRCZVerification("PU", name, " ");
              // }
            }
            setWalkDistance(prevWalkDistance=>({...prevWalkDistance, PUWalk:0, PUDuration:0}));
            // handleWalkDistanceCalculation("PU", pickLatLng.current);
          }
          else //if address entered is valid and VS changed
          {
            // handleWalkDistanceCalculation("PU", virtualData);
            setPickupAddr(name);
            pickLatLng.current = virtualData;
            // if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2)){
            //   setReturnAddr(name);
            //   returnLatLng.current = virtualData;
            // }
            let stopMarkersArr = [{lat:parseFloat(pickLatLng.current.split(",")[0]),
              lng: parseFloat(pickLatLng.current.split(",")[1]), Type:"PU", 
              name:(riderName === "" ? "N/A" : riderName.trim()), address: name
            }];
            let filteredMapMarkers = mapData.filter((item)=>{
              if(item.Type === "Stop")
              {
                stopMarkersArr.push(item);
              }
              return item.Type === "DO";
            });
            filteredMapMarkers.unshift(...stopMarkersArr);
            setMapData(filteredMapMarkers);
            if(dropLatLng.current !== "")
            {
              puVSCallValidation.current = true;
              setIsSchTimeFieldDisabled(false);
              // handleAddressDetails("PU", name, name, dropAddr, correctDate, schTime);
              // if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2))
              // {
              //   handleRCZVerification("PU", name, " ");
              // }
            }
          } 
        }
        
      }
      else if(e.target.title.toLowerCase().includes("drop off"))
      {
        mapPointPickupSelection.current = [];
        if(e.target.value === "DO VS")
        {
          setDropAddrVirtualStop({...dropAddrVirtualStop, value:"DO VS", name:""});
          setWalkDistance(prevWalkDistance=>({...prevWalkDistance, DOWalk:0, DODuration:0}));
          if(dropLatLng.current === ""){
            setDropAddr("");
          }
        }
        else
        {
          vsChangeRef.current.type = vsChangeRef.current.type.length === 0 ? "DO ": (vsChangeRef.current.type.includes("DO")?
           vsChangeRef.current.type:vsChangeRef.current.type+"DO ");
          setDropAddrVirtualStop({...dropAddrVirtualStop, value:e.target.value, name:nm});

          if(dropLatLng.current === ""){
            setDropAddr(name);
            dropLatLng.current = virtualData;
            if(!vsSelectedRef.current.includes("DO")){vsSelectedRef.current.push("DO")};
            let stopMarkersArr = [];
            let filteredMapMarkers = mapData.filter((item)=>{
              if(item.Type === "Stop")
              {
                stopMarkersArr.push(item);
              }
              return item.Type === "PU";
            });
            stopMarkersArr.push({lat:parseFloat(dropLatLng.current.split(",")[0]),
              lng: parseFloat(dropLatLng.current.split(",")[1]), Type:"DO", 
              name:(riderName === "" ? "N/A" : riderName.trim()), address: name
            });
            filteredMapMarkers.push(...stopMarkersArr);
            setMapData(filteredMapMarkers);
            setInputSuggestionListPU("");
            if(pickLatLng.current !== "")
            {
              doVSCallValidation.current = true;
              setIsSchTimeFieldDisabled(false);
              // handleAddressDetails("DO", name, pickupAddr, name, correctDate, schTime);
              // if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2))
              // {
              //   handleRCZVerification("DO", name, " ");
              // }
            }
            setWalkDistance(prevWalkDistance=>({...prevWalkDistance, DOWalk:0, DODuration:0}));
            // handleWalkDistanceCalculation("DO", dropLatLng.current);
          }
          else
          {
            // handleWalkDistanceCalculation("DO", virtualData);
            setDropAddr(name);
            dropLatLng.current = virtualData;
            let stopMarkersArr = [];
            let filteredMapMarkers = mapData.filter((item)=>{
              if(item.Type === "Stop")
              {
                stopMarkersArr.push(item);
              }
              return item.Type === "PU";
            });
            stopMarkersArr.push({lat:parseFloat(dropLatLng.current.split(",")[0]),
              lng: parseFloat(dropLatLng.current.split(",")[1]), Type:"DO", 
              name:(riderName === "" ? "N/A" : riderName.trim()), address: name
            });
            filteredMapMarkers.push(...stopMarkersArr);
            setMapData(filteredMapMarkers);
            if(pickLatLng.current !== "")
            {
              doVSCallValidation.current = true;
              setIsSchTimeFieldDisabled(false);
              // handleAddressDetails("DO", name, pickupAddr, name, correctDate, schTime);
              // if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2))
              // {
              //   handleRCZVerification("DO", name, " ");
              // }
            }
          }  
        }
        
      }
    }
    catch(err){console.log(err);}
  };

  const handleWalkDistanceCalculation = async(type, vsLatLng)=>{
    try
    {
      if(type === "PU")
      {
        let addressAPI = ITCMapDirections + "?origin=" + pickLatLng.current + "&destination=" + vsLatLng + "&AppType=calltaker&walking=true"; //"&bounds=" + mapBounds+ 
        let OSRMResponse = await APICom.fetchData("full", addressAPI, "get", {
          'Authorization': 'Basic '+btoa(OSRM_Username + ":" + OSRM_Password),
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'mode': 'no-cors'
        }, {});
        // console.log(OSRMResponse);
        if(OSRMResponse && OSRMResponse.data.status.toUpperCase() === "OK")
        {
          let distanceInMeters = OSRMResponse.data.routes[0].legs[0].distance.value;
          let durationInSeconds = OSRMResponse.data.routes[0].legs[0].duration.value;
          let distanceInMiles = parseFloat(parseFloat(distanceInMeters)/1609).toFixed(1);
          let duration = Math.round(parseFloat(parseInt(durationInSeconds)/60));
          setWalkDistance(prevWalkDistance=>({...prevWalkDistance, PUWalk:distanceInMiles, PUDuration:duration}));
          // console.log(walkDistance.PUWalk, distanceInMiles, duration);
        }
        else if(OSRMResponse && OSRMResponse.data.status.toUpperCase() === "ZERO_RESULTS")
        {
          setWalkDistance(prevWalkDistance =>({...prevWalkDistance, PUWalk:0, PUDuration:0}));
        }
      }
      else
      {
        let addressAPI = ITCMapDirections + "?origin=" + vsLatLng + "&destination=" + dropLatLng.current + "&AppType=calltaker&walking=true"; //"&bounds=" + mapBounds+ 
        let OSRMResponse = await APICom.fetchData("full", addressAPI, "get", {
          'Authorization': 'Basic '+btoa(OSRM_Username + ":" + OSRM_Password),
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'mode': 'no-cors'
        }, {});
        // console.log(OSRMResponse);
        if(OSRMResponse && OSRMResponse.data.status.toUpperCase() === "OK")
        {
          let distanceInMeters = OSRMResponse.data.routes[0].legs[0].distance.value;
          let durationInSeconds = OSRMResponse.data.routes[0].legs[0].duration.value;
          let distanceInMiles = parseFloat(parseFloat(distanceInMeters)/1609).toFixed(1);
          let duration = Math.round(parseFloat(parseInt(durationInSeconds)/60));
          setWalkDistance(prevWalkDistance =>({...prevWalkDistance, DOWalk:distanceInMiles, DODuration:duration}));
          // console.log(walkDistance.DOWalk, distanceInMiles, duration);
        }
        else if(OSRMResponse && OSRMResponse.data.status.toUpperCase() === "ZERO_RESULTS")
        {
          setWalkDistance(prevWalkDistance =>({...prevWalkDistance, DOWalk:0, DODuration:0}));
        }
      }
    }
    catch(err){console.log(err);}
  };

  const handleResetAll = (type)=>{
    try{
      setConditionMet(true);
      setActiveTripSelected(false);
      setIsHandleResetAll(true);
      setShowCCBtn(false);
      setBrokerModes(prevState=>({...prevState, brokerMode:0}));
      setFareEstimateAPISummary({copay: 0, walletID: 0, promo: "", eaasJSON: "", displayMessage: "", verifyStatus: ""});
      setScheduleJSON({mainData: "", multiSchData:"", range:"", neverExpire:false});
      setIsSchTimeFieldDisabled(true);
      apptTimeCheckValsRef.current = {ServiceTime:0, ApptWindow:0};
      isValidateRCZCalledFromReset.current = true;
      addStopErrorFlag.current = false;
      // PersistStorage.save("rowDataCallAgent", [], 999, true);
      PersistStorage.save("rowDataEditTrip", "", 999, true);
      PersistStorage.save("clientInfo", [], 99, true);
      fareZonesRef.current = {pickFareZone:"", dropFareZone:""};
      setSearchButtonValidation("");
      setStopLoadRiderName("");
      // setFareMethod(0);
      // fareMethodRef.current = 0;
      setFareZones({pick:"", drop:""});
      setDispatchZones({pickZone:"", dropZone:""});
      setStopUnloadRiderName("RN");
      setClientNameList([]);
      setFareDataArr([]);
      setMedID("");
      setMapData([]);
      setVerifiedAddr([]);
      setAddLegBtnTitle("Add Leg");
      setVerifiedInfoUpdateIndex(0);
      getCurrentSystemDateTime("date", true);
      setReturnApptTime(null);
      setReturnWaitTime(null);
      setReturnWaitTimeInput(0);
      setReturnTime("");
      setSchTime("");
      setAppointmentTime("");
      setWillCall(false);
      setReturnWillCall(false);
      setRecentAddresses([]);
      setWalkDistance({...walkDistance, DOWalk:0, PUWalk:0, PUDuration:0, DODuration:0});
      setManualDataOverwrite({fare:0, price: 0, miles: 0}); 
      stopPassengerLoadTrackerRef.current = 0;
      // setConfirmationNo("");
      setSchPUTime("");
      setTripStatus("");
      setShowStopsInput(true);
      riderNameRef.current.style.borderColor = "";
      riderNameRef.current.style.borderWidth = "";
      phoneRef.current.style.borderColor = "";
      phoneRef.current.style.borderWidth = "";
      setClientSummary(prevState=>({...prevState, totalCalls:0, totalNS:0, 
        totalCancels:0, lastCall:"",
        tripDistance:0.0, TripDuration:0.0, TripFare:0.0, TripCopay:0.0
      }));
      setCardNumber("");
      setCardType("");
      setCheckCCParams("");
      paymentCardIDInfoRef.current = {uniqueID: -1, payStatusID: -1, invalidForSave: 0, retCCUniqueID: -1, CCPaidAmount: 0, CCRetPaidAmount: 0};
      setCardInfo({cardNumber:"", expiry: "", selectedCard: "", selectedExpiry: "", selectedCardType: "", uniqueID: 0, gateID: "", response: ""});
      setCardExpiration("");
      setAgentNotes("");
      setReturnPhone("");
      setSelectedSummaryHeader("stopOrder");
      setAgentTripsDisplay(false);
      setStopOrderDisplay(true);
      setManifestDetailsDisplay(false);
      setManualFareDisplay(false);
      setMobilityDetails({...mobilityDetails, totalVeh:1, vehTypeMin:0, vehNumMin:0, driverNumMin:0, genderMin:0, languageMin:0});
      setMobilityChecks({...mobilityChecks, vehTypeCheck:false, vehNumCheck:false, driverNumCheck:false, genderCheck:false, languageCheck:false});
      setPassengerTypeCount({...passengerTypeCount, ambPass: 1, totalSA: 0,
        totalWC: 0, totalPass: 0, total:1
      });
      setPassengerTypeCountStop({ambPass:1,totalWC:0,totalSA:0, total:1});
      setPickPOI("");
      setDropPOI("");
      setPickupAddr("");
      setDropAddr("");
      setReturnAddr("");
      pickLatLng.current = "";
      dropLatLng.current = "";
      returnLatLng.current = "";

      addressInfoDetails.current = {pick: {state:"", city: "", zip: ""}, drop: {state:"", city:"", zip:""}};
      setPickExtraInfo("");
      setDropExtraInfo("");
      setReturnAddrExtra("");
      setSubmitBtnTitle("Book");
      const url = new URL(window.location.href);
      if(submitParatransitBtnTitle.toLowerCase() === "update")
      {
        setSubmitParatransitBtnTitle("Book");
        const cleanURL = url.origin + url.pathname; //URL without query string
        window.history.replaceState({}, '', cleanURL);
      }
      else
      {
        const cleanURL = url.origin + url.pathname; //URL without query string
        window.history.replaceState({}, '', cleanURL);
      }
      setPickupVirtualStop({...pickupVirtualStop, value:"PU VS", name:""});
      setDropAddrVirtualStop({...dropAddrVirtualStop, value:"DO VS", name:""});
      setZones("");
      setReturnAddrZone("");
      setCopayAmount(0);
      setCOSSelected(1);
      setSelectedVehType('VT');
      setSelectedVehNum('VN');
      setSelectedTripAttr([]);
      if(type !== "func")
      {
        SetAttributesFilterMultiSelect({ ...AttributesFilterMultiSelect, ...{ selectedValues: []}});
      }
      if(type !== "aff")
      {
        setClientInfo([]);
        setClientIDInfo([]);
        setRiderName("");
        setAccountNumber("");
        setCallBackPhone("");
        setPhone("");
        setRiderNameCheck("");
        if(affiliateSelRef.current.options.length !== affiliateDropDownHTML.length)
        {
          let affiliateOptionsHTML = AffiliateData.map(function(item, index){
            if(loginData.UserAffiliateList.includes(String(item.AffiliateID)))
            {
              return (
                <option key={index} value={item.AffiliateID}>{item.AffiliateCompany}</option>
              );
            }
          });
          setAffiliateDropDownHTML(affiliateOptionsHTML);  
        }
        phoneRef.current.disabled = false;
        clientNameCheckRef.current.disabled = false;
      }
      setSelectedDriverNum("DN");
      setSelectedGender("Gender");
      setSelectedLanguage("Language");
      setSelectedTripType(3);
      setSelectedTripPriority(5);
      setClientEmail("");
      setRCType({phoneType:false, emailType:false, SMSType:false});
      setStopLoadType({none:true, load:false, unload:false});
      setClientJob("");
      setInputSuggestionListClientName("");
      setInputSuggestionListClientPhone("");
      setStopSaveBtnTitle("Save");
      setClientStops([]);
      setStopEditInfo({data:{}, index:0});
      setPaymentAdditionalInfo("");
      if(type==="none"){
        let fsData = (FundingSourceData[parseInt(selectedAff)] && 
          FundingSourceData[parseInt(selectedAff)] !== undefined ? 
          JSON.parse(FundingSourceData[parseInt(selectedAff)]) : []
        );
        let fsSelected = (fsData.length > 0 ? fsData.find(item => parseInt(item.FID) === parseInt(FSTargetID)) : 0);
        setBrokerModes(prevState=>({...prevState, brokerMode: (fsSelected === 0 ? 0 : fsSelected.BrokerMode)}));
        setFSSelected(FSTargetID); setCopayFSSelected(1); setPaySelected(PayTargetID); setCopayPayTypeSelected(PayTargetID);
      
      } 
      if(bookBtnRef.current)
      {
        bookBtnRef.current.disabled = true;
      }
      else if(paratransitBookBtnRef.current)
      {
        paratransitBookBtnRef.current.disabled = false;
        addLegBtnRef.current.disabled = false;
      }
      setTimeout(() => {
        setConditionMet(false);
      }, 2000);
    }
    catch(err){console.log(err);}
  };

  const customHideFunc = () =>{
    try{
      // console.log(modalHeaderText);
      if(modalHeaderText && typeof modalHeaderText === "string" && modalHeaderText.toLowerCase() === "client info selection")
      {
        // console.log(clientIndexRef.current);
        handleClientInfoGeneration(clientIndexRef.current.data);
        setShowDynamicModal(false);
      }
      else
      {
        setShowDynamicModal(false);
      }
    }
    catch(err){console.log(err);}
  };

  const formatDate = (data) => {
    try{
      const [year, month, day] = data.split('-');
      const date = new Date(year, month-1, day);
      // Get the components of the date
      const paddedMonth = String(date.getMonth() + 1).padStart(2, "0"); // Ensure two digits
      const paddedDay = String(date.getDate()).padStart(2, "0"); // Ensure two digits
      const paddedYear = date.getFullYear(); // No padding needed for the year
      
      return `${paddedMonth}/${paddedDay}/${paddedYear}`;
    }
    catch(err){console.log(err); return data;}
  };

  const inverseFormatDate = (val) =>{
    try{
      const originalD = val;
      const date = new Date(originalD+" 00:00:00");

      const year = date.getFullYear();
      const month = String(date.getMonth()+1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');

      return `${year}-${month}-${day}`;
    }
    catch(err){console.log(err);}
  };

  const handleClearLegInfo = (e)=>{
    try{
      let dropAddressTemp = dropAddr;
      let dropPOITemp = dropPOI;
      let dropLatLngTemp = dropLatLng.current;
      let dropFareZoneTemp = fareZonesRef.current.dropFareZone;
      let tripLatLng = [];
      setPassengerTypeCount({...passengerTypeCount, ambPass: 1, totalSA: 0,
        totalWC: 0, totalPass: 0, total:1
      });
      setPassengerTypeCountStop({ambPass:1,totalWC:0,totalSA:0, total:1});
      setStopLoadRiderName("");
      setStopUnloadRiderName("RN");
      setScheduleJSON({mainData: "", multiSchData:"", range:"", neverExpire:false});
      setRCType({phoneType:false, emailType:false, SMSType:false});
      setStopLoadType({none:true, load:false, unload:false});
      setMobilityChecks({vehTypeCheck:false, vehNumCheck:false, driverNumCheck:false, genderCheck:false, languageCheck:false});
      setMobilityDetails({totalVeh:1, vehTypeMin:0, vehNumMin:0, driverNumMin:0, genderMin:0, languageMin:0});
      setClientStops([]);
      setClientNameList([]);
      setClientJob("");
      setCopayAmount(0);
      setCardNumber("");
      setCardType("");
      setCardInfo({cardNumber:"", expiry: "", selectedCard: "", selectedExpiry: "", selectedCardType: "", uniqueID: 0, gateID: "", response: ""});
      setCardExpiration("");
      setSelectedTripType(3);
      setPaymentAdditionalInfo("");
      setClientEmail("");
      setSelectedVehType('VT');
      setSelectedVehNum('VN');
      setSelectedDriverNum('DN');
      setSelectedGender('Gender');
      setSelectedLanguage('Language');
      setVerifiedInfoUpdateIndex(0);
      setShowStopBlock(false);
      setPickExtraInfo("");
      setDropExtraInfo("");
      setAgentNotes("");
      setAppointmentTime("");
      setPickupAddr(dropAddressTemp);
      setPickPOI(dropPOITemp);
      setStopPOI("");
      setFareZones({pick:fareZones.drop, drop:""});
      setDispatchZones({pickZone:dispatchZones.dropZone, dropZone:""});
      setDropAddr("");
      setDropPOI("");
      pickLatLng.current = dropLatLngTemp;
      apptTimeCheckValsRef.current = {ServiceTime:0, ApptWindow:0};
      dropLatLng.current = "";
      fareZonesRef.current = {pickFareZone: dropFareZoneTemp, dropFareZone:""};
      stopPassengerLoadTrackerRef.current = 0;
      tripLatLng.push(
        {lat:parseFloat(pickLatLng.current.split(",")[0]),
          lng: parseFloat(pickLatLng.current.split(",")[1]), Type:"PU", 
          name:(riderName), address: dropAddressTemp
        }
      );
      setMapData(tripLatLng);
      setWillCall(false);
      setSchTime("");
      setReturnTripCheckBox(false);
      setAddLegBtnTitle("Add Leg");
      setFareDataArr([]);
      setCopayAmount(0); 
      setClientSummary(prevState=>({...prevState, totalCalls:0, totalNS:0, 
        totalCancels:0, lastCall:"",
        tripDistance:0.0, TripDuration:0.0, TripFare:0.0, TripCopay:0.0
      }));

    }
    catch(err){console.log(err);}
  };

  const handleRemoveStop = (e, index) =>{
    try{
      if(clientStops[index].passLoadType === "load")
      {
        stopPassengerLoadTrackerRef.current = parseInt(stopPassengerLoadTrackerRef.current) - parseInt(clientStops[index].stopPax.total);
      }
      else if(clientStops[index].passLoadType === "unload")
      {
        stopPassengerLoadTrackerRef.current = parseInt(stopPassengerLoadTrackerRef.current) + parseInt(clientStops[index].stopPax.total);
      }

      let filteredMapMarkers = mapData.filter((item)=>{
        return parseInt(item.id) !== parseInt(index);
      });

      setMapData(filteredMapMarkers);

      setClientStops((prevClientStops) =>
        prevClientStops.filter((_, i) => i !== index)
      );

      if(clientStops.length === 1)
      {
        setShowStopBlock(false);
      }
    }
    catch(err){console.log(err);}
  };

  const handleEditStop = (e, data, index)=>{
    try{
      if(data.passLoadType === "load")
      {
        setStopLoadType({none:false, load:true, unload:false});
      }
      else if(data.passLoadType === "unload")
      {
        setStopLoadType({none:false, load:false, unload:true});
      }
      else
      {
        setStopLoadType({none:true, load:false, unload:false});
      }
      setPassengerTypeCountStop(data.stopPax);
      setShowStopsInput(true);
      setStopSaveBtnTitle("Update");
      setStopLoadRiderName(data.passengerName);
      setStopUnloadRiderName(data.passengerName);
      setReturnAddr(data.stopAddr);
      setReturnAddrExtra(data.notes);
      setReturnWaitTime(data.waitTime);
      setReturnWaitTimeInput(data.waitTime);
      setStopEditInfo({data:data, index:index});
      returnLatLng.current = data.stopLatLng;
    }
    catch(err){console.log(err);}
  };

  function headersToObject(headers) {
    try{
      let result = {};
      for (let [key, value] of headers.entries()) {
        result[key] = value;
      }
      return result;
    }
    catch(err){console.log(err); return [];}
  };

  const sameAddrVerification = (pick, drop) =>{
    try{
      const abbreviations = {
        '\\bst\\b': 'street',
        '\\bw\\b': 'west',
        '\\be\\b': 'east',
        '\\bn\\b': 'north',
        '\\bs\\b': 'south',
        // Add more abbreviations as needed
      };
      let pickAddrNormalized = (pick.includes(",") ? (pick.split(",")[0].toLowerCase().replace(/\bst\b/gi, 'street')
      .replace(/\bave\b/gi, 'avenue')
      .replace(/\brd\b/gi, 'road')
      .replace(/\bdr\b/gi, 'drive')
      .replace(/\bln\b/gi, 'lane')
      .replace(/\bblvd\b/gi, 'boulevard')) : pick.toLowerCase());
      let dropAddrNormalized = (drop.includes(",") ? (drop.split(",")[0].toLowerCase().replace(/\bst\b/gi, 'street')
      .replace(/\bave\b/gi, 'avenue')
      .replace(/\brd\b/gi, 'road')
      .replace(/\bdr\b/gi, 'drive')
      .replace(/\bln\b/gi, 'lane')
      .replace(/\bblvd\b/gi, 'boulevard')) : drop.toLowerCase());
      for (const [abbr, full] of Object.entries(abbreviations)) {
        const regex = new RegExp(abbr, 'g');
        pickAddrNormalized = pickAddrNormalized.replace(regex, full);
        dropAddrNormalized = dropAddrNormalized.replace(regex, full);
      }
      const isPickDropSame = (pickAddrNormalized === dropAddrNormalized);
      return isPickDropSame;
    }
    catch(err){console.log(err);}
  };

  const handleAddLeg = async(e)=> {
    try{
      let clientInfoData = (PersistStorage.retrieve("clientInfo", true) ? PersistStorage.retrieve("clientInfo", true) : "");
      let clientLocationDict = {id: (clientInfoData.riderInfo ? clientInfoData.riderInfo.id : (clientInfoData.Id ? clientInfoData.Id : "")), 
        city: (clientInfoData.riderInfo ? clientInfoData.riderInfo.clientCity : (clientInfoData.City ? clientInfoData.City : "")), 
        state: (clientInfoData.riderInfo? clientInfoData.riderInfo.clientState: (clientInfoData.State ? clientInfoData.State : "")), 
        zip: (clientInfoData.riderInfo ? clientInfoData.riderInfo.clientZip : (clientInfoData.Zip ? clientInfoData.Zip : "")), 
        medicalID: (clientInfoData.riderInfo ? clientInfoData.riderInfo.medicalID : (clientInfoData.MedicalId? clientInfoData.MedicalId : "")), 
        address: (clientInfoData.riderInfo ? clientInfoData.riderInfo.clientAddress : (clientInfoData.Address ? clientInfoData.Address : ""))
      };
      if((pickLatLng.current !== undefined && pickLatLng.current !== "") && (dropLatLng.current !== undefined && dropLatLng.current !== ""))
      {
        if(riderName === "")
        {
          setModalHeaderText("Stop Order Alert");
          setModalBodyHTML("Please enter the client's name in the provided field.");
          setModalFooterHTML(
            <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
          setShowDynamicModal(true);
        }
        else if(!phone || phone.length < 12)
        {
          setModalHeaderText("Stop Order Alert");
          setModalBodyHTML("Please enter the client's phone number in the provided field.");
          setModalFooterHTML(
            <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
          setShowDynamicModal(true);
        }
        else
        {
          
          if(e.target.textContent.toLowerCase().includes("leg"))
          {
            let myHeaders = new Headers();
            myHeaders.append("Authorization", 'Basic '+btoa(OSRM_Username + ":" + OSRM_Password));
            myHeaders.append('Content-Type', 'application/json');
            let addressAPI = ITCMapRawURL+'directionswithstoporder';
            let headersObj = headersToObject(myHeaders);
            let stopDetailsTrackerArr = [];
            let stopsArr = [{
              "StopOrder": 1,
              "StopLat": pickLatLng.current.split(",")[0],
              "StopLong": pickLatLng.current.split(",")[1]
            }, ...clientStops.map((item,index)=>{
              return {
                "StopOrder": (index+2),
                "StopLat": item.stopLatLng.split(",")[0],
                "StopLong": item.stopLatLng.split(",")[1]
              };
            }), {
              "StopOrder": (clientStops.length + 2),
              "StopLat": dropLatLng.current.split(",")[0],
              "StopLong": dropLatLng.current.split(",")[1]
            }]; 
            let data = {
              "ManifestNumber" : "",
              "StopList": stopsArr
            }
            
            let OSRMResponse = await APICom.fetchData("full", addressAPI, "post", headersObj, data);

            let distanceInMeters = 0;
            let durationInSeconds = 0;
            let entireTripDistance = 0;
            let entireTripDuration = 0;
            if(OSRMResponse && OSRMResponse.error === "" && OSRMResponse.data.StopList.length > 0)
            {
              let waitTime = 0;
              const OSRM_TIME = (ASCSSettingData ? (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "OSRM_Time")).value : 1);
              for(let i = 0; i < clientStops.length; i++)
              {
                waitTime += parseInt(clientStops[i].waitTime && clientStops[i].waitTime !== 0 ? clientStops[i].waitTime:0); 
              }
              for(let k = 0; k < OSRMResponse.data.StopList.length; k++)
              {
                if(parseInt(OSRMResponse.data.StopList[k].StopOrder) >= 2)
                {
                  let timeCalculated = ((parseInt(OSRMResponse.data.StopList[k].TimeFromPrevStop)/60) * OSRM_TIME);
                  stopDetailsTrackerArr.push({stopNo:(parseInt(OSRMResponse.data.StopList[k].StopOrder)-1), 
                    distance: parseFloat(parseFloat(OSRMResponse.data.StopList[k].DistFromPrevStop)/1609).toFixed(1),
                    duration: Math.round(parseFloat(timeCalculated))}
                  );
                }
                distanceInMeters += OSRMResponse.data.StopList[k].DistFromPrevStop;
                durationInSeconds += OSRMResponse.data.StopList[k].TimeFromPrevStop;
              }
              let entireTimeCalculated = ((parseInt(durationInSeconds)/60) * OSRM_TIME);
              entireTripDistance = parseFloat(parseFloat(distanceInMeters)/1609).toFixed(1);
              entireTripDuration = Math.round(parseFloat(entireTimeCalculated)) + waitTime;

              for(let j = 0; j < stopDetailsTrackerArr.length; j++)
              {
                let response = await getFareDataResponse(stopDetailsTrackerArr[j].distance, stopDetailsTrackerArr[j].duration, 
                  FSSelected, copayFSSelected, passengerTypeCount.totalWC, passengerTypeCount.total, 
                  COSSelected, selectedAff, pickLatLng.current, copayAmount
                );

                stopDetailsTrackerArr[j] = {...stopDetailsTrackerArr[j], fareDetails: response };
              }
            }
            let sameAddrFlag = false;
            let pickGeoInfo = structuredClone(pickLatLng.current);
            let dropGeoInfo = structuredClone(dropLatLng.current);
            let fareMethodInfo = structuredClone(fareMethodRef.current);
            setShowAddLegLoader(true);
            setTripDetails((prevTripDetails)=>{
              let correctDate = formatDate(selectedDateSchTime);
              const tripDetailArr = {...prevTripDetails, willCall:willCall, apptTime:appointmentTime, pickAddr:pickupAddr, dropAddr: dropAddr, pickPOI:pickPOI, dropPOI:dropPOI,
                notes:agentNotes, phone:phone, callBackPhone:callBackPhone, puNotes:pickExtraInfo, doNotes:dropExtraInfo, riderName:(riderName === ""?"Unkwn":riderName), 
                passCount:passengerTypeCount, distance: (prevTripDetails.distance),
                duration: (prevTripDetails.duration), fareZones: fareZones, email: clientEmail,
                date: correctDate, time:(schTime === "" && verifiedAddr.length === 0 ? "":schTime), waitTime: "", dispatchZones: dispatchZones,
                id: (clientInfo.Id ? clientInfo.Id : clientLocationDict.id), clientMedID: (clientInfo.MedicalId ? clientInfo.MedicalId : clientLocationDict.medicalID), 
                clientAddr: (clientInfo.Address ? clientInfo.Address : clientLocationDict.address), 
                clientCity: (clientInfo.City ? clientInfo.City : clientLocationDict.city), clientState: (clientInfo.State ? clientInfo.State : clientLocationDict.state), 
                clientZip: (clientInfo.Zip? clientInfo.Zip : clientLocationDict.zip), 
                vehType: selectedVehType, vehTypeCheck: mobilityChecks.vehTypeCheck, vehTypeMins: mobilityDetails.vehTypeMin,
                FundingSource: FSSelected, PaymentSelected: PaySelected, AffiliateSelected: selectedAff, COS: COSSelected, copay:(copayAmount === 0 || copayAmount === ""? clientSummary.TripCopay: copayAmount), 
                cardNum: cardNumber, cardExp: cardExpiration, RC: RCType, driverNum: selectedDriverNum, driverNumCheck: mobilityChecks.driverNumCheck,
                driverMins: mobilityDetails.driverNumMin, gender: selectedGender, genderMins: mobilityDetails.genderMin, vehNum: selectedVehNum, genderCheck: mobilityChecks.genderCheck,
                vehNumCheck: mobilityChecks.vehNumCheck, vehMins: mobilityDetails.vehNumMin, language: selectedLanguage, languageMins: mobilityDetails.languageMin, languageCheck: mobilityChecks.languageCheck,
                tripAttribute: selectedTripAttr, insurance: {Agency: insuranceAgency, Type: insuranceType, CaseWorker: insuranceCaseWorker, AuthCode: insuranceAuthCode, 
                  ServiceCode: insuranceServiceCode
                }, copayPayType: copayPayTypeSelected, fare: clientSummary.TripFare, copayFS: copayFSSelected, paymentExtraInfo: paymentAdditionalInfo, 
                clientJob: clientJob, tripType: selectedTripType, tripPriority: selectedTripPriority,
              };
              setVerifiedAddr((prevVerifiedAddr) => {
                const isDuplicate = prevVerifiedAddr.some(
                  (leg)=> leg.pickAddr === tripDetailArr.pickAddr && leg.dropAddr === tripDetailArr.dropAddr
                );
                let isPickDropSame = sameAddrVerification(tripDetailArr.pickAddr, tripDetailArr.dropAddr);
                
                if(isDuplicate){
                  setModalHeaderText("Stop Order Alert");
                  setModalBodyHTML("The entered addresses were entered previously, addresses must be different and verified.");
                  setModalFooterHTML(
                    <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                      OK
                    </Button>
                  );
                  setShowDynamicModal(true);
                  sameAddrFlag = true;
                  return prevVerifiedAddr;
                }
                if(isPickDropSame)
                {
                  setModalHeaderText("Stop Order Alert");
                  setModalBodyHTML("The entered addresses are duplicates. Addresses must be different and verified.");
                  setModalFooterHTML(
                    <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                      OK
                    </Button>
                  );
                  setShowDynamicModal(true);
                  sameAddrFlag = true;
                  return prevVerifiedAddr;
                }

                return [...prevVerifiedAddr, {pickAddr: tripDetailArr.pickAddr, dropAddr: tripDetailArr.dropAddr, pickPOI: tripDetailArr.pickPOI, dropPOI: tripDetailArr.dropPOI,
                date: tripDetailArr.date, email: tripDetailArr.email, confirmationNo: 0,
                time: (tripDetailArr.willCall ? "Will Call":tripDetailArr.time), distance: entireTripDistance, duration: entireTripDuration, fare: tripDetailArr.fare, copay: tripDetailArr.copay,
                willCall: tripDetailArr.willCall, apptTime: (tripDetailArr.willCall ? "Will Call":tripDetailArr.apptTime), notes:tripDetailArr.notes, phone:tripDetailArr.phone, 
                puNotes:tripDetailArr.puNotes, doNotes:tripDetailArr.doNotes, riderName:tripDetailArr.riderName, passCount:tripDetailArr.passCount, callBackPhone: tripDetailArr.callBackPhone,
                waitTime:tripDetailArr.waitTime, stops:clientStops, isReturn:returnTripCheckBox, pickLatLng: pickGeoInfo, dropLatLng: dropGeoInfo,
                stopsDetails: stopDetailsTrackerArr, addressExtraDetails: addressInfoDetails.current, id: tripDetailArr.id, clientMedID: tripDetailArr.clientMedID, paymentExtraInfo: tripDetailArr.paymentExtraInfo, clientJob: tripDetailArr.clientJob,
                clientAddr: tripDetailArr.clientAddr, clientCity: tripDetailArr.clientCity, clientState: tripDetailArr.clientState, clientZip: tripDetailArr.clientZip, fareZones: tripDetailArr.fareZones, dispatchZones: tripDetailArr.dispatchZones,
                FundingSource: tripDetailArr.FundingSource, PaymentSelected: tripDetailArr.PaymentSelected, AffiliateSelected: tripDetailArr.AffiliateSelected, 
                COS: tripDetailArr.COS, vehType: tripDetailArr.vehType, vehTypeCheck: tripDetailArr.vehTypeCheck, vehTypeMins: tripDetailArr.vehTypeMins,
                cardNum: tripDetailArr.cardNum, cardExp: tripDetailArr.cardExp, RC: tripDetailArr.RC, driverNum: tripDetailArr.driverNum, driverNumCheck: tripDetailArr.driverNumCheck,
                driverMins: tripDetailArr.driverMins, gender: tripDetailArr.gender, genderMins: tripDetailArr.genderMins, vehNum: tripDetailArr.vehNum, genderCheck: tripDetailArr.genderCheck,
                vehNumCheck: tripDetailArr.vehNumCheck, vehMins: tripDetailArr.vehMins, language: tripDetailArr.language, languageMins: tripDetailArr.languageMins, languageCheck: tripDetailArr.languageCheck,
                tripAttribute: tripDetailArr.tripAttribute, insurance: {Agency: tripDetailArr.insurance.Agency, Type: tripDetailArr.insurance.Type, 
                  CaseWorker: tripDetailArr.insurance.CaseWorker, AuthCode: tripDetailArr.insurance.AuthCode,
                  ServiceCode: tripDetailArr.insurance.ServiceCode}, copayPayType: tripDetailArr.copayPayType, copayFS: tripDetailArr.copayFS, tripType: tripDetailArr.tripType, 
                  tripPriority: tripDetailArr.tripPriority, fareMethod: fareMethodInfo, billableAmount: fareDataArr.billableAmount , additionalPassengerCost: fareDataArr.additionalPassengerCost,
                  fareEstimateAPIData : fareEstimateAPISummary, broker: brokerModes
                }];
              
              });
              return tripDetailArr;
            });
            setShowAddLegLoader(false);
            if(!sameAddrFlag)
            {
              handleClearLegInfo();
            }
          }
          else if(e.target.textContent.toLowerCase().includes("return"))
          {
            if(verifiedAddr.length === 0)
            {
              setModalHeaderText("Add Return Stop Error");
              setModalBodyHTML("Please add a start point before adding a return address");
              setModalFooterHTML(
                <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                  OK
                </Button>
              );
              setShowDynamicModal(true);
            }
            else
            {
              if(dropLatLng.current !== "" && pickLatLng.current !== "")
              {
                let myHeaders = new Headers();
                myHeaders.append("Authorization", 'Basic '+btoa(OSRM_Username + ":" + OSRM_Password));
                myHeaders.append('Content-Type', 'application/json');
                let addressAPI = ITCMapRawURL+'directionswithstoporder';
                let headersObj = headersToObject(myHeaders);
                let stopDetailsTrackerArr = [];
                let stopsArr = [{
                  "StopOrder": 1,
                  "StopLat": pickLatLng.current.split(",")[0],
                  "StopLong": pickLatLng.current.split(",")[1]
                }, ...clientStops.map((item,index)=>{
                  return {
                    "StopOrder": (index+2),
                    "StopLat": item.stopLatLng.split(",")[0],
                    "StopLong": item.stopLatLng.split(",")[1]
                  };
                }), {
                  "StopOrder": (clientStops.length + 2),
                  "StopLat": dropLatLng.current.split(",")[0],
                  "StopLong": dropLatLng.current.split(",")[1]
                }]; 
                let data = {
                  "ManifestNumber" : "",
                  "StopList": stopsArr
                }
                
                let OSRMResponse = await APICom.fetchData("full", addressAPI, "post", headersObj, data);

                let distanceInMeters = 0;
                let durationInSeconds = 0;
                let entireTripDistance = 0;
                let entireTripDuration = 0;
                const OSRM_TIME = (ASCSSettingData ? (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "OSRM_Time")).value : 1);
                if(OSRMResponse && OSRMResponse.error === "" && OSRMResponse.data.StopList.length > 0)
                {
                  let waitTime = 0;
                  for(let i = 0; i < clientStops.length; i++)
                  {
                    waitTime += parseInt(clientStops[i].waitTime && clientStops[i].waitTime !== 0 ? clientStops[i].waitTime:0); 
                  }
                  for(let k = 0; k < OSRMResponse.data.StopList.length; k++)
                  {
                    if(parseInt(OSRMResponse.data.StopList[k].StopOrder) >= 2)
                    {
                      let TimeCalculated = ((parseInt(OSRMResponse.data.StopList[k].TimeFromPrevStop)/60) * OSRM_TIME);
                      stopDetailsTrackerArr.push({stopNo:(parseInt(OSRMResponse.data.StopList[k].StopOrder)-1), 
                        distance: parseFloat(parseFloat(OSRMResponse.data.StopList[k].DistFromPrevStop)/1609).toFixed(1),
                        duration: Math.round(parseFloat(TimeCalculated))}
                      );
                    }
                    distanceInMeters += OSRMResponse.data.StopList[k].DistFromPrevStop;
                    durationInSeconds += OSRMResponse.data.StopList[k].TimeFromPrevStop;
                  }
                  let entireTimeCalculated = ((parseInt(durationInSeconds)/60) * OSRM_TIME);
                  entireTripDistance = parseFloat(parseFloat(distanceInMeters)/1609).toFixed(1);
                  entireTripDuration = Math.round(parseFloat(entireTimeCalculated)) + waitTime;

                  for(let j = 0; j < stopDetailsTrackerArr.length; j++)
                  {
                    let response = await getFareDataResponse(stopDetailsTrackerArr[j].distance, stopDetailsTrackerArr[j].duration, 
                      FSSelected, copayFSSelected, passengerTypeCount.totalWC, passengerTypeCount.total, 
                      COSSelected, selectedAff, pickLatLng.current, copayAmount
                    );

                    stopDetailsTrackerArr[j] = {...stopDetailsTrackerArr[j], fareDetails: response };
                  }
                }
                let sameAddrFlag = false;
                let pickGeoInfo = structuredClone(pickLatLng.current);
                let dropGeoInfo = structuredClone(dropLatLng.current);
                let fareMethodInfo = structuredClone(fareMethodRef.current);
                setShowAddLegLoader(true);
                setTripDetails((prevTripDetails) => {
                  let correctDate = formatDate(selectedDateSchTime);
                  const tripDetailArr = {...prevTripDetails, willCall:willCall, apptTime:appointmentTime, 
                    notes:agentNotes, phone:phone, callBackPhone:callBackPhone, puNotes:pickExtraInfo, doNotes:dropExtraInfo, riderName:(riderName === ""?"Unkwn":riderName), 
                    passCount:passengerTypeCount, pickAddr: pickupAddr, dropAddr: dropAddr, pickPOI:pickPOI, dropPOI:dropPOI,
                    distance: (clientSummary.tripDistance), 
                    duration: (clientSummary.TripDuration), fareZones: fareZones, dispatchZones: dispatchZones,
                    date: correctDate, time:(schTime === "" && verifiedAddr.length === 0? "":schTime), waitTime: "", email: clientEmail, clientZip: clientInfo.Zip,
                    id: (clientInfo.Id ? clientInfo.Id : clientLocationDict.id), clientMedID: (clientInfo.MedicalId ? clientInfo.MedicalId : clientLocationDict.medicalID), 
                    clientAddr: (clientInfo.Address ? clientInfo.Address : clientLocationDict.address), 
                    clientCity: (clientInfo.City ? clientInfo.City : clientLocationDict.city), clientState: (clientInfo.State ? clientInfo.State : clientLocationDict.state), 
                    vehType: selectedVehType, vehTypeCheck: mobilityChecks.vehTypeCheck, vehTypeMins: mobilityDetails.vehTypeMin,
                    FundingSource: FSSelected, PaymentSelected: PaySelected, AffiliateSelected: selectedAff, COS: COSSelected, 
                    copay:(copayAmount === 0 || copayAmount === ""? clientSummary.TripCopay: copayAmount),
                    cardNum: cardNumber, cardExp: cardExpiration, RC: RCType, driverNum: selectedDriverNum, driverNumCheck: mobilityChecks.driverNumCheck, 
                    genderCheck: mobilityChecks.genderCheck,
                    driverMins: mobilityDetails.driverNumMin, gender: selectedGender, genderMins: mobilityDetails.genderMin, vehNum: selectedVehNum, 
                    languageCheck: mobilityChecks.languageCheck,
                    vehNumCheck: mobilityChecks.vehNumCheck, vehMins: mobilityDetails.vehNumMin, language: selectedLanguage, 
                    languageMins: mobilityDetails.languageMin, fare: clientSummary.TripFare,
                    tripAttribute: selectedTripAttr, insurance: {Agency: insuranceAgency, Type: insuranceType, 
                      CaseWorker: insuranceCaseWorker, AuthCode: insuranceAuthCode,
                    ServiceCode: insuranceServiceCode}, copayPayType: copayPayTypeSelected, copayFS: copayFSSelected, 
                    paymentExtraInfo: paymentAdditionalInfo, clientJob: clientJob, tripType: selectedTripType, tripPriority: selectedTripPriority
                  }; 
  
                  setVerifiedAddr((prevVerifiedAddr) => {
                    const isDuplicate = prevVerifiedAddr.some(
                      (leg)=> leg.pickAddr === tripDetailArr.pickAddr && leg.dropAddr === tripDetailArr.dropAddr
                    );
                    let pickAddrNormalized = (tripDetailArr.pickAddr.includes(",") ? (tripDetailArr.pickAddr.split(",")[0].toLowerCase().replace(/\bst\b/gi, 'street')
                    .replace(/\bave\b/gi, 'avenue')
                    .replace(/\brd\b/gi, 'road')
                    .replace(/\bdr\b/gi, 'drive')
                    .replace(/\bln\b/gi, 'lane')
                    .replace(/\bblvd\b/gi, 'boulevard')) : tripDetailArr.pickAddr.toLowerCase());
                    let dropAddrNormalized = (tripDetailArr.dropAddr.includes(",") ? (tripDetailArr.dropAddr.split(",")[0].toLowerCase().replace(/\bst\b/gi, 'street')
                    .replace(/\bave\b/gi, 'avenue')
                    .replace(/\brd\b/gi, 'road')
                    .replace(/\bdr\b/gi, 'drive')
                    .replace(/\bln\b/gi, 'lane')
                    .replace(/\bblvd\b/gi, 'boulevard')) : tripDetailArr.dropAddr.toLowerCase());
                    const isPickDropSame = (pickAddrNormalized === dropAddrNormalized);
                    if(isPickDropSame)
                    {
                      setModalHeaderText("Stop Order Alert");
                      setModalBodyHTML("The entered addresses are duplicates. Addresses must be different and verified.");
                      setModalFooterHTML(
                        <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                          OK
                        </Button>
                      );
                      setShowDynamicModal(true);
                      sameAddrFlag = true;
                      return prevVerifiedAddr;
                    }
                    return [...prevVerifiedAddr, {pickAddr: tripDetailArr.pickAddr, dropAddr: tripDetailArr.dropAddr, pickPOI: tripDetailArr.pickPOI, dropPOI: tripDetailArr.dropPOI,
                      date: tripDetailArr.date, clientZip: tripDetailArr.clientZip, confirmationNo: 0,
                      time: (tripDetailArr.willCall ? "Will Call":tripDetailArr.time), distance: entireTripDistance, duration: entireTripDuration, 
                      fare: tripDetailArr.fare, copay: tripDetailArr.copay,
                      willCall: tripDetailArr.willCall, apptTime: (tripDetailArr.willCall ? "Will Call":tripDetailArr.apptTime), email: tripDetailArr.email, 
                      notes:tripDetailArr.notes, phone:tripDetailArr.phone, 
                      puNotes:tripDetailArr.puNotes, doNotes:tripDetailArr.doNotes, riderName:tripDetailArr.riderName, passCount:tripDetailArr.passCount, 
                      fareZones: tripDetailArr.fareZones, dispatchZones: tripDetailArr.dispatchZones,
                      waitTime:tripDetailArr.waitTime, stops:clientStops, isReturn:returnTripCheckBox, pickLatLng: pickGeoInfo, dropLatLng: dropGeoInfo, 
                      callBackPhone:tripDetailArr.callBackPhone,
                      stopsDetails: stopDetailsTrackerArr, addressExtraDetails: addressInfoDetails.current, id: tripDetailArr.id, clientMedID: tripDetailArr.clientMedID, 
                      paymentExtraInfo: tripDetailArr.paymentExtraInfo, clientJob: tripDetailArr.clientJob,
                      clientAddr: tripDetailArr.clientAddr, clientCity: tripDetailArr.clientCity, clientState: tripDetailArr.clientState, fareMethod: fareMethodInfo,
                      FundingSource: tripDetailArr.FundingSource, PaymentSelected: tripDetailArr.PaymentSelected, AffiliateSelected: tripDetailArr.AffiliateSelected, 
                      COS: tripDetailArr.COS, vehType: tripDetailArr.vehType, vehTypeCheck: tripDetailArr.vehTypeCheck, vehTypeMins: tripDetailArr.vehTypeMins, 
                      genderCheck: tripDetailArr.genderCheck,
                      cardNum: tripDetailArr.cardNum, cardExp: tripDetailArr.cardExp, RC: tripDetailArr.RC, driverNum: tripDetailArr.driverNum, 
                      driverNumCheck: tripDetailArr.driverNumCheck,
                      driverMins: tripDetailArr.driverMins, gender: tripDetailArr.gender, genderMins: tripDetailArr.genderMins, vehNum: tripDetailArr.vehNum, 
                      languageCheck: tripDetailArr.languageCheck,
                      vehNumCheck: tripDetailArr.vehNumCheck, vehMins: tripDetailArr.vehMins, language: tripDetailArr.language, languageMins: tripDetailArr.languageMins,
                      tripAttribute: tripDetailArr.tripAttribute, insurance: {Agency: tripDetailArr.insurance.Agency, Type: tripDetailArr.insurance.Type, 
                        CaseWorker: tripDetailArr.insurance.CaseWorker, AuthCode: tripDetailArr.insurance.AuthCode, 
                        ServiceCode: tripDetailArr.insurance.ServiceCode}, copayPayType: tripDetailArr.copayPayType, copayFS: tripDetailArr.copayFS, 
                        tripType: tripDetailArr.tripType, tripPriority: tripDetailArr.tripPriority, billableAmount: fareDataArr.billableAmount , 
                        additionalPassengerCost: fareDataArr.additionalPassengerCost, fareEstimateAPIData : fareEstimateAPISummary, broker: brokerModes
                    }];
                  
                  });
                  return tripDetailArr;
                });
                setShowAddLegLoader(false);
                if(!sameAddrFlag)
                {
                  handleClearLegInfo();
                }
              }
              else
              {
                setModalHeaderText("Stop Order Alert");
                setModalBodyHTML("Please enter a valid address for pickup and drop-off fields to make a return trip.");
                setModalFooterHTML(
                  <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                    OK
                  </Button>
                );
                setShowDynamicModal(true);
              }
            }
          } 
          else if(e.target.textContent.toLowerCase().includes("update"))
          {
            let myHeaders = new Headers();
            myHeaders.append("Authorization", 'Basic '+btoa(OSRM_Username + ":" + OSRM_Password));
            myHeaders.append('Content-Type', 'application/json');
            let addressAPI = ITCMapRawURL+'directionswithstoporder';
            let headersObj = headersToObject(myHeaders);
            let stopDetailsTrackerArr = [];
            let stopsArr = [{
              "StopOrder": 1,
              "StopLat": pickLatLng.current.split(",")[0],
              "StopLong": pickLatLng.current.split(",")[1]
            }, ...clientStops.map((item,index)=>{
              return {
                "StopOrder": (index+2),
                "StopLat": item.stopLatLng.split(",")[0],
                "StopLong": item.stopLatLng.split(",")[1]
              };
            }), {
              "StopOrder": (clientStops.length + 2),
              "StopLat": dropLatLng.current.split(",")[0],
              "StopLong": dropLatLng.current.split(",")[1]
            }]; 
            let data = {
              "ManifestNumber" : "",
              "StopList": stopsArr
            }
            
            let OSRMResponse = await APICom.fetchData("full", addressAPI, "post", headersObj, data);

            const OSRM_TIME = (ASCSSettingData ? (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "OSRM_Time")).value : 1);
            let distanceInMeters = 0;
            let durationInSeconds = 0;
            let entireTripDistance = 0;
            let entireTripDuration = 0;
            if(OSRMResponse && OSRMResponse.error === "" && OSRMResponse.data.StopList.length > 0)
            {
              let waitTime = 0;
              for(let i = 0; i < clientStops.length; i++)
              {
                waitTime += parseInt(clientStops[i].waitTime && clientStops[i].waitTime !== 0 ? clientStops[i].waitTime:0); 
              }
              for(let k = 0; k < OSRMResponse.data.StopList.length; k++)
              {
                if(parseInt(OSRMResponse.data.StopList[k].StopOrder) >= 2)
                {
                  let TimeCalculated = ((parseInt(OSRMResponse.data.StopList[k].TimeFromPrevStop)/60) * OSRM_TIME);
                  stopDetailsTrackerArr.push({stopNo:(parseInt(OSRMResponse.data.StopList[k].StopOrder)-1), 
                    distance: parseFloat(parseFloat(OSRMResponse.data.StopList[k].DistFromPrevStop)/1609).toFixed(1),
                    duration: Math.round(parseFloat(TimeCalculated))}
                  );
                }
                distanceInMeters += OSRMResponse.data.StopList[k].DistFromPrevStop;
                durationInSeconds += OSRMResponse.data.StopList[k].TimeFromPrevStop;
              }
              let entireTimeCalculated = ((parseInt(durationInSeconds)/60) * OSRM_TIME);
              entireTripDistance = parseFloat(parseFloat(distanceInMeters)/1609).toFixed(1);
              entireTripDuration = Math.round(parseFloat(entireTimeCalculated)) + waitTime;

              for(let j = 0; j < stopDetailsTrackerArr.length; j++)
              {
                let response = await getFareDataResponse(stopDetailsTrackerArr[j].distance, stopDetailsTrackerArr[j].duration, 
                  FSSelected, copayFSSelected, passengerTypeCount.totalWC, passengerTypeCount.total, 
                  COSSelected, selectedAff, pickLatLng.current, copayAmount
                );

                stopDetailsTrackerArr[j] = {...stopDetailsTrackerArr[j], fareDetails: response };
              }
            }
            let sameAddrFlag = false;
            let pickGeoInfo = structuredClone(pickLatLng.current);
            let dropGeoInfo = structuredClone(dropLatLng.current);
            let fareMethodInfo = structuredClone(fareMethodRef.current);
            setShowAddLegLoader(true);
            setTripDetails((prevTripDetails)=>{
              let correctDate = formatDate(selectedDateSchTime);
              const tripDetailArr = {...prevTripDetails, willCall:willCall, apptTime:appointmentTime, 
                notes:agentNotes, phone:phone, callBackPhone:callBackPhone, puNotes:pickExtraInfo, doNotes:dropExtraInfo, riderName:(riderName === ""?"Unkwn":riderName), 
                passCount:passengerTypeCount, pickAddr: pickupAddr, dropAddr: dropAddr, pickPOI:pickPOI, dropPOI:dropPOI,
                distance: (prevTripDetails.distance),
                duration: (prevTripDetails.duration), fareZones: fareZones, dispatchZones: dispatchZones,
                date: correctDate, time:(schTime === "" && verifiedAddr.length === 0? "":schTime), waitTime: "", email:clientEmail,
                id: (clientInfo.Id ? clientInfo.Id : clientLocationDict.id), clientMedID: (clientInfo.MedicalId ? clientInfo.MedicalId : clientLocationDict.medicalID), 
                clientAddr: (clientInfo.Address ? clientInfo.Address : clientLocationDict.address), 
                clientCity: (clientInfo.City ? clientInfo.City : clientLocationDict.city), clientState: (clientInfo.State ? clientInfo.State : clientLocationDict.state), 
                clientZip: (clientInfo.Zip? clientInfo.Zip : clientLocationDict.zip),
                vehType: selectedVehType, vehTypeCheck: mobilityChecks.vehTypeCheck, vehTypeMins: mobilityDetails.vehTypeMin,
                FundingSource: FSSelected, PaymentSelected: PaySelected, AffiliateSelected: selectedAff, COS: COSSelected, copay:(copayAmount === 0 || copayAmount === ""? clientSummary.TripCopay: copayAmount), 
                cardNum: cardNumber, cardExp: cardExpiration, RC: RCType, driverNum: selectedDriverNum, driverNumCheck: mobilityChecks.driverNumCheck, fare: clientSummary.TripFare,
                driverMins: mobilityDetails.driverNumMin, gender: selectedGender, genderMins: mobilityDetails.genderMin, vehNum: selectedVehNum, genderCheck: mobilityChecks.genderCheck,
                vehNumCheck: mobilityChecks.vehNumCheck, vehMins: mobilityDetails.vehNumMin, language: selectedLanguage, languageMins: mobilityDetails.languageMin, languageCheck: mobilityChecks.languageCheck,
                tripAttribute: selectedTripAttr, insurance: {Agency: insuranceAgency, Type: insuranceType, CaseWorker: insuranceCaseWorker, AuthCode: insuranceAuthCode,
                ServiceCode: insuranceServiceCode}, copayPayType: copayPayTypeSelected, copayFS: copayFSSelected, paymentExtraInfo: paymentAdditionalInfo, clientJob: clientJob, tripType: selectedTripType, tripPriority: selectedTripPriority,
              };
              setVerifiedAddr((prevVerifiedAddr) => {
                let isPickDropSame = sameAddrVerification(tripDetailArr.pickAddr, tripDetailArr.dropAddr);
                if(isPickDropSame)
                {
                  setModalHeaderText("Stop Order Alert");
                  setModalBodyHTML("The entered addresses are duplicates. Addresses must be different and verified.");
                  setModalFooterHTML(
                    <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                      OK
                    </Button>
                  );
                  setShowDynamicModal(true);
                  sameAddrFlag = true;
                  return prevVerifiedAddr;
                }
                const updatedVerifiedAddr = prevVerifiedAddr.map((item, index) =>
                  index === verifiedInfoUpdateIndex
                    ? {
                        ...item,
                        pickAddr: tripDetailArr.pickAddr, pickPOI: tripDetailArr.pickPOI, 
                        dropAddr: tripDetailArr.dropAddr, dropPOI: tripDetailArr.dropPOI,
                        date: tripDetailArr.date,
                        time: tripDetailArr.willCall ? "Will Call" : tripDetailArr.time,
                        distance: entireTripDistance,
                        duration: entireTripDuration,
                        fare: tripDetailArr.fare,
                        copay: tripDetailArr.copay,
                        email: tripDetailArr.email,
                        willCall: tripDetailArr.willCall,
                        apptTime: tripDetailArr.willCall ? "Will Call" : tripDetailArr.apptTime,
                        notes: tripDetailArr.notes,
                        phone: tripDetailArr.phone, callBackPhone: tripDetailArr.callBackPhone,
                        puNotes: tripDetailArr.puNotes,
                        doNotes: tripDetailArr.doNotes,
                        riderName: tripDetailArr.riderName,
                        passCount: tripDetailArr.passCount,
                        waitTime: tripDetailArr.waitTime,
                        stops: clientStops,
                        isReturn: returnTripCheckBox,
                        pickLatLng: pickGeoInfo,
                        dropLatLng: dropGeoInfo,
                        stopsDetails: stopDetailsTrackerArr, addressExtraDetails: addressInfoDetails.current,
                        id: tripDetailArr.id,
                        clientMedID: tripDetailArr.clientMedID, 
                        clientAddr: tripDetailArr.clientAddr, clientCity: tripDetailArr.clientCity, clientState: tripDetailArr.clientState, clientZip: tripDetailArr.clientZip,
                        FundingSource: tripDetailArr.FundingSource, 
                        PaymentSelected: tripDetailArr.PaymentSelected, 
                        AffiliateSelected: tripDetailArr.AffiliateSelected, 
                        COS: tripDetailArr.COS,
                        cardNum: tripDetailArr.cardNum, cardExp: tripDetailArr.cardExp, 
                        RC: tripDetailArr.RC, 
                        driverNum: tripDetailArr.driverNum, driverNumCheck: tripDetailArr.driverNumCheck, driverMins: tripDetailArr.driverMins, 
                        gender: tripDetailArr.gender, genderMins: tripDetailArr.genderMins, genderCheck: tripDetailArr.genderCheck,
                        vehNum: tripDetailArr.vehNum, vehNumCheck: tripDetailArr.vehNumCheck, vehMins: tripDetailArr.vehMins, 
                        vehType: tripDetailArr.vehType, vehTypeCheck: tripDetailArr.vehTypeCheck, vehTypeMins: tripDetailArr.vehTypeMins,
                        language: tripDetailArr.language, languageMins: tripDetailArr.languageMins, languageCheck: tripDetailArr.languageCheck,
                        tripAttribute: tripDetailArr.tripAttribute, 
                        insurance: {Agency: tripDetailArr.insurance.Agency, Type: tripDetailArr.insurance.Type, 
                          CaseWorker: tripDetailArr.insurance.CaseWorker, AuthCode: tripDetailArr.insurance.AuthCode,
                          ServiceCode: tripDetailArr.insurance.ServiceCode
                        },
                        copayPayType: tripDetailArr.copayPayType, copayFS: tripDetailArr.copayFS, fareEstimateAPIData : fareEstimateAPISummary, broker: brokerModes,
                        fareMethod: fareMethodInfo, fareZones: tripDetailArr.fareZones, dispatchZones: tripDetailArr.dispatchZones, billableAmount: fareDataArr.billableAmount , additionalPassengerCost: fareDataArr.additionalPassengerCost,
                        paymentExtraInfo: tripDetailArr.paymentExtraInfo, clientJob: tripDetailArr.clientJob, tripType: tripDetailArr.tripType, tripPriority: tripDetailArr.tripPriority
                      }
                    : item
                );
          
                return updatedVerifiedAddr;
              
              });
              return tripDetailArr;
            });
            setShowAddLegLoader(false);
            if(!sameAddrFlag)
            {
              handleClearLegInfo();
            }
          }
        }
        
      }
      else
      {
        setModalHeaderText("Stop Order Alert");
        setModalBodyHTML("Please enter a valid address for pickup and drop-off fields to add a leg.");
        setModalFooterHTML(
          <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
            OK
          </Button>
        );
        setShowDynamicModal(true);
      }
    }
    catch(err){console.log(err);}
  };

  const handleClearVerifiedAddr = (index)=>{
    try{
      if(verifiedAddr[index].confirmationNo !== 0)
      {
        setModalHeaderText("Stop Order Clear Alert");
        setModalBodyHTML("Clear action for booked trip is restricted.");
        setModalFooterHTML(
          <>
            <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
              {"OK"}
            </Button>
          </>
        );
        setShowDynamicModal(true);
      }
      else
      {
        setModalHeaderText("Stop Order Clear Confirmation");
        setModalBodyHTML("Are you sure you would like to remove this trip?");
        setModalFooterHTML(
          <>
            <Button variant='dark' className="border-0" onClick={()=>{
                let indexToRemove = index;
                if((verifiedAddr.length-1) % 2 !== 0){addReturnStopBtnRef.current.disabled = false;}
                setVerifiedAddr((prevVerifiedAddr) =>
                  prevVerifiedAddr.filter((_, i) => i !== indexToRemove)
                );
                setShowDynamicModal(false);
              }}
            >
              {"Yes"}
            </Button>
            <Button variant='secondary' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              {"No"}
            </Button>
          </>
          
        );
        setShowDynamicModal(true);
      }
    }
    catch(err){console.log(err);}
  };

  const handleEditEntireTrip = (index) =>{ //Function that populates full data for selected stop order trip as well as map markers for update before booking
    try{
      let data = verifiedAddr[index];
      let attrSelection = AttributeData ? AttributeData.filter((item,index)=> {return parseInt(item.iAttrATSPID) === parseInt(selectedAff)}) : [];
      let attrOptionsMultiSel = attrSelection && attrSelection.length > 0 ? attrSelection.map((item)=>{
        let dict = {};
        dict.id = item.ID;
        dict.name = item.Title;
        return dict;
      }).sort((a, b) => a.name.localeCompare(b.name)) : [];
      let providedAttrArray = data.tripAttribute;
      let groupSelected = [];
      let tripLatLng = [];
      const [month, day, year] = data.date.split('/');
      let dateFormatted = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
      let callbackData = (data.callBackPhone.includes("+1") ? data.callBackPhone : (data.callBackPhone && data.callBackPhone !== "" ? "+1"+data.callBackPhone : ""))
      for(let k = 0; k < attrOptionsMultiSel.length; k++)
      {
        if(providedAttrArray.includes(String(attrOptionsMultiSel[k].id)))
        {
          groupSelected.push({id:attrOptionsMultiSel[k].id, name:attrOptionsMultiSel[k].name});
        }
      }
      SetAttributesFilterMultiSelect({ ...AttributesFilterMultiSelect, ...{options: attrOptionsMultiSel,
        selectedValues:(data.tripAttribute.length !== 0 ? groupSelected : [])}}
      );
      setPickupAddr(data.pickAddr);
      setPickPOI(data.pickPOI);
      setDropAddr(data.dropAddr);
      setDropPOI(data.dropPOI);
      pickLatLng.current = data.pickLatLng;
      dropLatLng.current = data.dropLatLng;
      setFareZones({pick: data.fareZones.pick, drop: data.fareZones.drop});
      setDispatchZones({pickZone: data.dispatchZones.pickZone, dropZone: data.dispatchZones.dropZone});
      fareZonesRef.current = {pickFareZone: data.fareZones.pick, dropFareZone:data.fareZones.drop};
      fareMethodRef.current = data.fareMethod;
      setPickExtraInfo(data.puNotes);
      setDropExtraInfo(data.doNotes);
      setAppointmentTime((data.willCall ? "":data.apptTime));
      setSchTime((data.willCall ? "":data.time));
      setSelectedDateSchTime(dateFormatted);
      if(data.stops.length > 0)
      {
        setShowStopBlock(true);
        setShowStopsInput(false);
      }
      setClientStops(data.stops);
      setClientEmail(data.email);
      setPassengerTypeCount(data.passCount);
      setAccountNumber(data.id);
      setMedID(data.clientMedID);
      setCopayFSSelected(parseInt(data.copayFS));
      setCopayAmount(data.copay);
      setCopayPayTypeSelected(parseInt(data.copayPayType));
      setCardNumber(data.cardNum);
      setCardExpiration(data.cardExp);
      setSelectedVehType(data.vehType);
      setSelectedVehNum(data.vehNum);
      setSelectedDriverNum(data.driverNum);
      setSelectedGender(data.gender);
      setSelectedLanguage(data.language);
      setSelectedTripAttr(data.tripAttribute);
      setSelectedTripType(data.tripType);
      setClientJob(data.clientJob);
      setPaymentAdditionalInfo(data.paymentExtraInfo);
      setMobilityDetails({totalVeh:1, vehTypeMin:data.vehTypeMins, vehNumMin:data.vehMins, driverNumMin:data.driverMins, genderMin:data.genderMins, languageMin:data.languageMins});
      setMobilityChecks({vehTypeCheck:data.vehTypeCheck, vehNumCheck:data.vehNumCheck, driverNumCheck:data.driverNumCheck, genderCheck:data.genderCheck, languageCheck:data.languageCheck});
      setClientSummary(prevState=>({...prevState,
        tripDistance: data.distance, TripDuration:data.duration, TripFare:data.fare, TripCopay:data.copay
      }));
      setFareEstimateAPISummary(data.fareEstimateAPIData);
      setBrokerModes(data.broker);
      setFSSelected(parseInt(data.FundingSource));
      setPaySelected(parseInt(data.PaymentSelected));
      setAgentNotes(data.notes);
      setRCType({phoneType:data.RC.phoneType, emailType:data.RC.emailType, SMSType:data.RC.SMSType});
      setRiderName(data.riderName);
      setWillCall(data.willCall);
      setReturnTripCheckBox(data.isReturn);
      setAddLegBtnTitle("Update");
      setVerifiedInfoUpdateIndex(index);
      setCallBackPhone(callbackData);
      
      if(data.stops.length > 0)
      {
        let stopsInfo = data.stops;
        for(let k = 0; k < stopsInfo.length; k++)
        {
          let load = (stopsInfo[k].passLoadType === "load" ? "load" : (stopsInfo[k].passLoadType === "unload" ? "unload" : "none"));
          tripLatLng.push(
            {lat:parseFloat(stopsInfo[k].stopLatLng.split(",")[0]),
              lng: parseFloat(stopsInfo[k].stopLatLng.split(",")[1]), Type:"Stop", description: stopsInfo[k].notes,
              name:stopsInfo[k].passengerName, address: stopsInfo[k].stopAddr, stopType:load, id:(k)
            }
          );
        }
      }
      tripLatLng.push(
      {lat:parseFloat(data.dropLatLng.split(",")[0]),
        lng: parseFloat(data.dropLatLng.split(",")[1]), Type:"DO", 
        name:(data.riderName), address: data.dropAddr
      });
      tripLatLng.unshift(
        {lat:parseFloat(data.pickLatLng.split(",")[0]),
          lng: parseFloat(data.pickLatLng.split(",")[1]), Type:"PU", 
          name:(data.riderName), address: data.pickAddr
        },
      );
      setMapData(tripLatLng);
    }
    catch(err){console.log(err);}
  };

  const handleMoveClientStops = (index, location) =>{
    try{
      setClientStops((prevStops) => {
        const newStops = [...prevStops];
        if(location === "up")
        {
          if (index === 0){ return prevStops;} // No move if the element is already at the top
          else if(newStops[index - 1].passLoadType === "load" && newStops[index].passLoadType === "unload"){return prevStops;}
          [newStops[index - 1], newStops[index]] = [newStops[index], newStops[index - 1]]; // Swap elements
        }
        else
        {
          if(index === prevStops.length - 1){ return prevStops;}  // No move if the element is already at the bottom
          else if(newStops[index].passLoadType === "load" && newStops[index + 1].passLoadType === "unload"){return prevStops;}
          [newStops[index + 1], newStops[index]] = [newStops[index], newStops[index + 1]]; // Swap elements
        }
        let newStopsMapData = [];
        for(let k = 0; k < newStops.length; k++)
        {
          let load = newStops[k].passLoadType === "load" ? "load" : (newStops[k].passLoadType === "unload" ? "unload" : "none");
          newStopsMapData.push({lat:parseFloat(newStops[k].stopLatLng.split(",")[0]),
            lng: parseFloat(newStops[k].stopLatLng.split(",")[1]), Type:"Stop", description: newStops[k].notes,
            name:newStops[k].passengerName, address: newStops[k].stopAddr, stopType:load, id:(k)
          });
        }
        const updatedMapData = [
          ...mapData.slice(0,1),
          ...newStopsMapData,
          ...mapData.slice(-1)
        ];
        setMapData(updatedMapData);
        return newStops;
      });
    }
    catch(err){console.log(err);}
  };
  
  const handleMoveVerifiedAddr = (index, location)=>{
    try{
      setVerifiedAddr((prevVerifiedAddr) => {
        const newVerifiedAddr = [...prevVerifiedAddr];
        if(location === "up")
        {
          if (index === 0) return prevVerifiedAddr; // No move if the element is already at the top
          
          [newVerifiedAddr[index - 1], newVerifiedAddr[index]] = [newVerifiedAddr[index], newVerifiedAddr[index - 1]]; // Swap elements
        }
        else
        {
          if(index === prevVerifiedAddr.length - 1) return prevVerifiedAddr;  // No move if the element is already at the bottom
          [newVerifiedAddr[index + 1], newVerifiedAddr[index]] = [newVerifiedAddr[index], newVerifiedAddr[index + 1]]; // Swap elements
        }
        return newVerifiedAddr;
      });
    }
    catch(err){console.log(err);}
  };

  const handleChangeOnVehNumber = async (e) =>{
    try{

      setSelectedVehNum(e.target.value);
      let actualSelectedNum = e.target.value;
      const FamilyID = (AffiliateData.find((item) => {if(parseInt(item.AffiliateID) === parseInt(selectedAff)){return item}})).iPartnerAffiliateID;

      if(actualSelectedNum !== "VN")
      {
        let data = {
          "searchtext": actualSelectedNum.split("_")[1],
          "FamilyID": parseInt(FamilyID),
          "user_id": parseInt(loginData.iUserID)
        }
        xCancelSourceForGrid.current = APICom.GenerateSource();
        let response = await APICom.fetchData("main","GridData/GetDriverSearchGridData", "post", {}, data, xCancelSourceForGrid.current);
        if(response && response.error.length === 0)
        {
          if(response.data && response.data.length > 0)
          {
            const cleanedInput = JSON.parse(response.data.split("@$@@$@|*|")[1]);
            if(cleanedInput.length > 0)
            {
              let givenData = cleanedInput[0];
              let driverVal = (givenData.iDriverID && String(givenData.iDriverID) !== "-1" ? givenData.iDriverID + "_" + givenData["Driver#"] : "DN");
              setSelectedDriverNum(driverVal);
            }
          }
        }
      }
    }
    catch(err){console.log(err); setSelectedVehNum(e.target.value);}
  };

  const handlePUAddrChanged = async(e)=>{
    try{
      let input = e.target.value;
      if(input === pickupAddr && pickLatLng.current !== ""){return;} //check for no change in input
      setFareZones(prevState=>({...prevState, pick: ""}));
      fareZonesRef.current.pickFareZone = "";
      setDispatchZones(prevState=>({...prevState, pickZone: ""}));
      if(input === ""){
        setIsSchTimeFieldDisabled(true);
      }
      if(bookBtnRef.current)
      {
        bookBtnRef.current.disabled = true;
      }
      if(input.trim() === ""){handleClearAddr("PU");}
      setPickupAddr(input);
      setZones("");
      vsSelectedRef.current = vsSelectedRef.current.filter(item => item !== "PU");
      setClientSummary(prevState=>({...prevState, 
        tripDistance: 0, TripDuration:0, TripFare:0.0, TripCopay:0.0
      }));
      setWalkDistance({...walkDistance, DOWalk:0, PUWalk:0, PUDuration:0, DODuration:0});
      pickLatLng.current = "";
      liRefs.current = [];
      let poiSuggestionAddrHTML = null;
      let hashIndex = input.indexOf("#");

      if(hashIndex !== -1)
      {
        //run POISuggestion
        handleClearAddr("PU");
        input = input.slice(hashIndex);
        setPickupAddr(input);
        input = input.replaceAll("#","");
        if(input.length >= 3)
        {
          let data = {
            "affiliateID": parseInt(selectedAff),
            "poi": input.replaceAll("#",""),
          }
          xCancelSourceForGrid.current = APICom.GenerateSource();
          let response = await APICom.fetchData("ReservationCoreURL","api/ParatransitCT/GetPOISuggestion", "post", 
            {'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'mode': 'no-cors'}, data, xCancelSourceForGrid.current
          );

          if(response.error.length === 0 && (Array.isArray(response.data) && response.data.length > 0))
          {
            let SuggestedAddrArray = response.data;
            let filteredPOISuggestion = SuggestedAddrArray.filter(item=>{
              let formattedAddr = item.POI;
              return formattedAddr.toLowerCase().includes(input.trim().toLowerCase());
            });
            focusedSuggestionCheckPU.current = false;
            poiSuggestionAddrHTML = filteredPOISuggestion ? filteredPOISuggestion.map(function(item, index){
              let detailedData = item.City+","+item.Region+","+item.ZipCode;
              let formattedAddr = item.POI;
              let fullAddr = (item.Street + (item.City && item.City !== ""? ", "+item.City +", "+ (item.Region && item.Region !== "" ? item.Region +" "+ item.ZipCode: ""): "") );
              let LatLng = String(item.vPOILatitude)+","+String(item.vPOILongitude);
              liRefs.current[index] = React.createRef();
              return(
                <li ref={liRefs.current[index]} poisuggestion={"true"} className="small border-bottom text-nowrap overflow-hidden addressSelectionRow" 
                  title={fullAddr} onFocus={()=>{focusedSuggestionCheckPU.current = true;}}
                  style={{cursor:"pointer"}} tabIndex={-1} onBlur={()=>{focusedSuggestionCheckPU.current = false;}} onKeyDown={(e)=>{
                    if(e.key === 'ArrowDown')
                    {
                      e.preventDefault();

                      if(liRefs.current.length > 0)
                      {
                        setHighlightedIndex((prevIndex) => {
                          const newIndex = (prevIndex + 1) % liRefs.current.length;
                          liRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                          return newIndex;
                        });
                      }
                    }
                    else if (e.key === 'ArrowUp') {
                      e.preventDefault();
                      if(liRefs.current.length > 0)
                      {
                        setHighlightedIndex((prevIndex) => {
                          const newIndex = (prevIndex - 1 + liRefs.current.length) % liRefs.current.length;
                          liRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                          return newIndex;
                        });
                      }
                    }
                    else if(e.key === "Enter")
                    {
                      handlePUSuggestionClicked(e);
                    }
                  }}
                  onClick={handlePUSuggestionClicked} key={index} value={formattedAddr} data-name={detailedData} data-virtual={LatLng}
                >
                  {item.icon && item.icon !== ""? <Icon icon={item.icon} className="text-success me-1" style={{width:"20px", height:"20px"}}/> :
                    <Icon icon={"gis:search-poi"} className="text-success me-1" style={{width:"20px", height:"20px"}}/>
                  }
                  {formattedAddr}
                </li>
              );
            }) : "";
          }
        }
      }
      else
      {
        setPickupAddr(input);
      }
      
      let suggestionsRecentArr = [];
      for(let entry of recentAddresses)
      {
        if(entry.PUAddress)
        {
          suggestionsRecentArr.push({
            Address: entry.PUAddress,
            City: entry.PUCity,
            Lat: entry.PULat,
            Long: entry.PULong,
            State: entry.PUState,
            Zip: entry.PUZip,
          });
        }
        if(entry.DOAddress)
        {
          suggestionsRecentArr.push({
            Address: entry.DOAddress,
            City: entry.DOCity,
            Lat: entry.DOLat,
            Long: entry.DOLong,
            State: entry.DOState,
            Zip: entry.DOZip,
          });
        }
      }
      
      let uniqueRecentAddresses = handleDuplicates(suggestionsRecentArr, "Address");
      let filteredAddresses = uniqueRecentAddresses.length > 0 ? uniqueRecentAddresses.filter(item => { 
        let formattedAddr = item.Address + ", " + item.City + ", " + item.State + " " + item.Zip + ", USA";
        return input.trim().length === 0 || formattedAddr.toLowerCase().includes(input.trim().toLowerCase());
      }) : [];
      const sortedAddresses = filteredAddresses.sort((a, b) => (b.AddressType === 2) - (a.AddressType === 2));
      focusedSuggestionCheckPU.current = false;
      if(sortedAddresses.length > 0)
      {
        sortedAddresses.unshift({
          Address: "",
          City: "",
          State: "",
          Zip: "",
          Lat: "",
          Long: "",
          AddressType: 0,
          isStatic: true, // Add a flag to differentiate this static entry
        });
      }
      let recentAddrHTML = sortedAddresses.length > 0 ? sortedAddresses.map(function(item, index){
        
        try {
          liRefRecentPickupAddressComponenet.current[index] = item;
        } catch (error) {}
        let formattedAddr = item.Address+", "+item.City+", "+item.State+" "+item.Zip+", USA";
        let detailedData = item.City+","+item.State+","+item.Zip;
        let LatLng = String(item.Lat)+","+String(item.Long);
        if(item.isStatic)
        {
          liRefs.current[index] = React.createRef();
          return(
            <li ref={liRefs.current[index]} className="small border-bottom text-nowrap overflow-hidden addressSelectionRow" 
              onFocus={()=>{focusedSuggestionCheckPU.current = true;}}
              style={{cursor:"pointer"}} tabIndex={-1} onBlur={()=>{focusedSuggestionCheckPU.current = false;}} onKeyDown={(e)=>{
                if(e.key === 'ArrowDown')
                {
                  e.preventDefault();

                  if(liRefs.current.length > 0)
                  {
                    setHighlightedIndex((prevIndex) => {
                      const newIndex = (prevIndex + 1) % liRefs.current.length;
                      liRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                      return newIndex;
                    });
                  }
                }
                else if (e.key === 'ArrowUp') {
                  e.preventDefault();
                  if(liRefs.current.length > 0)
                  {
                    setHighlightedIndex((prevIndex) => {
                      const newIndex = (prevIndex - 1 + liRefs.current.length) % liRefs.current.length;
                      liRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                      return newIndex;
                    });
                  }
                }
              }}
              key={index} value={""}
            >
              <Icon icon="ph:info" className="text-info me-1" style={{width:"20px", height:"20px"}}/>
              {"Search POI by typing #POI Name"}
            </li>
          );
        }
        else if(input.trim().length > 0 && formattedAddr.toLowerCase().includes(input.trim().toLowerCase()))
        {
          liRefs.current[index] = React.createRef();
          return(
            <li ref={liRefs.current[index]} recentaddressindex={index} isrecentaddress="true" className="small border-bottom text-nowrap overflow-hidden addressSelectionRow" 
              title={formattedAddr} onFocus={()=>{focusedSuggestionCheckPU.current = true;}}
              style={{cursor:"pointer"}} tabIndex={-1} onBlur={()=>{focusedSuggestionCheckPU.current = false;}} onKeyDown={(e)=>{
                if(e.key === 'ArrowDown')
                {
                  e.preventDefault();

                  if(liRefs.current.length > 0)
                  {
                    setHighlightedIndex((prevIndex) => {
                      const newIndex = (prevIndex + 1) % liRefs.current.length;
                      liRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                      return newIndex;
                    });
                  }
                }
                else if (e.key === 'ArrowUp') {
                  e.preventDefault();
                  if(liRefs.current.length > 0)
                  {
                    setHighlightedIndex((prevIndex) => {
                      const newIndex = (prevIndex - 1 + liRefs.current.length) % liRefs.current.length;
                      liRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                      return newIndex;
                    });
                  }
                }
                else if(e.key === "Enter")
                {
                  handlePUSuggestionClicked(e);
                }
              }}
              onClick={handlePUSuggestionClicked} key={index} value={formattedAddr} data-name={detailedData} data-virtual={LatLng}
            >
              {item.AddressType === 2? <Icon icon="bx:heart" className="text-danger me-1" style={{width:"20px", height:"20px"}}/> : <Icon icon="bx:history" className="text-secondary me-1" style={{width:"20px", height:"20px"}}/>}
              {formattedAddr}
            </li>
          );
        }
        else if(input.trim() === "")
        {
          liRefs.current[index] = React.createRef();
          try {
            let result = ParseGeoCodedData(item, "", index);
            liRefRecentPickupAddressComponenet.current[index] = result;
          } catch (error) {}
          return(
            <li ref={liRefs.current[index]} recentaddressindex={index} isrecentaddress="true" className="small border-bottom text-nowrap overflow-hidden addressSelectionRow" 
              title={formattedAddr} onFocus={()=>{focusedSuggestionCheckPU.current = true;}}
              style={{cursor:"pointer"}} tabIndex={-1} onBlur={()=>{focusedSuggestionCheckPU.current = false;}} onKeyDown={(e)=>{
                if(e.key === 'ArrowDown')
                {
                  e.preventDefault();

                  if(liRefs.current.length > 0)
                  {
                    setHighlightedIndex((prevIndex) => {
                      const newIndex = (prevIndex + 1) % liRefs.current.length;
                      liRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                      return newIndex;
                    });
                  }
                }
                else if (e.key === 'ArrowUp') {
                  e.preventDefault();
                  if(liRefs.current.length > 0)
                  {
                    setHighlightedIndex((prevIndex) => {
                      const newIndex = (prevIndex - 1 + liRefs.current.length) % liRefs.current.length;
                      liRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                      return newIndex;
                    });
                  }
                }
                else if(e.key === "Enter")
                {
                  handlePUSuggestionClicked(e);
                }
              }}
              onClick={handlePUSuggestionClicked} key={index} value={formattedAddr} data-name={detailedData} data-virtual={LatLng}
            >
              {item.AddressType === 2? <Icon icon="bx:heart" className="text-danger me-1" style={{width:"20px", height:"20px"}}/> : <Icon icon="bx:history" className="text-secondary me-1" style={{width:"20px", height:"20px"}}/>}
              {formattedAddr}
            </li>
          );
        }
        
      }): "";
      if(input.trim().length > 8 && hashIndex === -1)
      {
        let myHeaders = new Headers();
        myHeaders.append("Authorization", 'Basic '+btoa(OSRM_Username + ":" + OSRM_Password));
        myHeaders.append('Content-Type', 'application/json');
        let mapBounds = (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "OSRMRectangleBounds")).value.replace(" ", ""); //"&bounds="+mapBounds+
        let addressAPI = ITCMapURL + encodeURIComponent(input) + "&bounds="+mapBounds+ "&AppType=Web_Reservation";
        let OSRMResponse = await APICom.fetchData("full", addressAPI, "get2", myHeaders, {});
        let SuggestedAddrArray = [];

        if(OSRMResponse && OSRMResponse.data.status.toUpperCase() === "OK")
        {
          SuggestedAddrArray = OSRMResponse.data.results.map(function(item)
          {
            return item;
          });

          liRefs.current = [];
          liRefPickupAddressComponenet.current = [];
          focusedSuggestionCheckPU.current = false;
          if(SuggestedAddrArray.length > 0)
          {
            SuggestedAddrArray.unshift({
              Address: "",
              City: "",
              State: "",
              Zip: "",
              Lat: "",
              Long: "",
              AddressType: 0,
              isStatic: true, // Add a flag to differentiate this static entry
            });
          }
          let suggestionsHTML = SuggestedAddrArray.length > 0 ? SuggestedAddrArray.map(function(item, index){
            try {
              let result = ParseGeoCodedData(item, "", index);
              liRefPickupAddressComponenet.current[index] = result;
            } catch (error) {}

            let detailedData = {
              city: "",
              state: "",
              zip: ""
            };
            if(item.isStatic)
            {
              liRefs.current[index] = React.createRef(); // Create a ref for each <li>
              return(
                <li ref={liRefs.current[index]} className="small border-bottom text-nowrap overflow-hidden addressSelectionRow" 
                  onFocus={()=>{focusedSuggestionCheckPU.current = true;}}
                  style={{cursor:"pointer"}} tabIndex={-1} onBlur={()=>{focusedSuggestionCheckPU.current = false;}} onKeyDown={(e)=>{
                    if(e.key === 'ArrowDown')
                    {
                      e.preventDefault();

                      if(liRefs.current.length > 0)
                      {
                        setHighlightedIndex((prevIndex) => {
                          const newIndex = (prevIndex + 1) % liRefs.current.length;
                          liRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                          return newIndex;
                        });
                      }
                    }
                    else if (e.key === 'ArrowUp') {
                      e.preventDefault();
                      if(liRefs.current.length > 0)
                      {
                        setHighlightedIndex((prevIndex) => {
                          const newIndex = (prevIndex - 1 + liRefs.current.length) % liRefs.current.length;
                          liRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                          return newIndex;
                        });
                      }
                    }
                  }}
                  key={index} value={""}
                >
                  <Icon icon="ph:info" className="text-info me-1" style={{width:"20px", height:"20px"}}/>
                  {"Search POI by typing #POI Name"}
                </li>
              );
            }
            
            item.address_components.forEach((component)=>{
              if(component.types.includes("locality") || component.types.includes("administrative_area_level_2"))
              {
                detailedData.city = component.long_name;
              }
              if (component.types.includes("administrative_area_level_1")) {
                detailedData.state = component.short_name;
              }
              if (component.types.includes("postal_code")) {
                detailedData.zip = component.long_name;
              }
            });

            let dataString = detailedData.city+","+detailedData.state+","+detailedData.zip;
            let LatLng = String(item.geometry.location.lat) +","+ String(item.geometry.location.lng);
            liRefs.current[index] = React.createRef(); // Create a ref for each <li>
            return(
              <li ref={liRefs.current[index]} index={index} className="border-bottom text-nowrap overflow-hidden addressSelectionRow" title={item.formatted_address} onFocus={()=>{focusedSuggestionCheckPU.current = true;}}
                style={{cursor:"pointer"}} tabIndex={-1} onBlur={()=>{focusedSuggestionCheckPU.current = false;}} onKeyDown={(e)=>{
                    if(e.key === 'ArrowDown')
                    {
                      e.preventDefault();

                      if(liRefs.current.length > 0)
                      {
                        setHighlightedIndex((prevIndex) => {
                          const newIndex = (prevIndex + 1) % liRefs.current.length;
                          liRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                          return newIndex;
                        });
                      }
                    }
                    else if (e.key === 'ArrowUp') {
                      e.preventDefault();
                      if(liRefs.current.length > 0)
                      {
                        setHighlightedIndex((prevIndex) => {
                          const newIndex = (prevIndex - 1 + liRefs.current.length) % liRefs.current.length;
                          liRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                          return newIndex;
                        });
                      }
                    }
                    else if(e.key === "Enter")
                    {
                      handlePUSuggestionClicked(e);
                    }
                }}
                onClick={handlePUSuggestionClicked} key={index} value={item.formatted_address} data-name={dataString} data-virtual={LatLng}
              >
                {item.formatted_address}
              </li>
            );
          }): "";

          if(suggestionsHTML !== "" && e.target.value !== "")
          {
            setInputSuggestionListPU(suggestionsHTML);
          }
          else if(recentAddrHTML.length > 0)
          {
            setInputSuggestionListPU(recentAddrHTML);
          }
        }
      }
      else if(input.trim().length === 0)
      {
        if(recentAddrHTML.length > 0)
        {
          setInputSuggestionListPU(recentAddrHTML);
        }
        else
        {
          setInputSuggestionListPU("");
        }
      }
      else
      {
        if(hashIndex !== -1 && poiSuggestionAddrHTML !== "")
        {
          setInputSuggestionListPU(poiSuggestionAddrHTML);
        }
        else if(recentAddrHTML.length > 0)
        {
          setInputSuggestionListPU(recentAddrHTML);
        }
        else
        {
          setInputSuggestionListPU("");
        }
      }
    }
    catch(err){console.log(err);}
  };
  const handlePUSuggestionClicked = async (e)=>{
    try{
      let correctDate = formatDate(selectedDateSchTime);
      let PULatLng = e.target.dataset.virtual;
      if(PULatLng.split(",")[0] !== "0" && PULatLng.split(",")[0] !== "")
      {
        let selectedIndex = e.target.getAttribute('index');
        let poiSelected = e.target.getAttribute('poisuggestion')
        let selectedIndexAddressComponent = "";
        let indexType = "";
        if(selectedIndex !== undefined && selectedIndex)
        {
          selectedIndex = parseInt(selectedIndex);
          if(selectedIndex >= 0 && liRefPickupAddressComponenet !== undefined)
          {
            indexType = "manual";
            selectedIndexAddressComponent = liRefPickupAddressComponenet?.current[selectedIndex];
            mapPointPickupSelection.current = selectedIndexAddressComponent;
          }
        }
        else if(poiSelected)
        {
          indexType = "poi";
          mapPointPickupSelection.current = {data: {address: e.target.title, POI: e.target.textContent}};
        }
        else 
        {
          let _IsRecentAddressSelected = e.target.getAttribute('isrecentaddress');
          let selectedIndexRecentAddressComponent = "";
          if(_IsRecentAddressSelected !== undefined && _IsRecentAddressSelected){
            let recentaddressindex = e.target.getAttribute('recentaddressindex');
            if(recentaddressindex !== undefined && recentaddressindex){
              recentaddressindex = parseInt(recentaddressindex);
              if(recentaddressindex >= 0 && liRefRecentPickupAddressComponenet !== undefined){
                indexType = "recent";
                selectedIndexRecentAddressComponent = liRefRecentPickupAddressComponenet?.current[recentaddressindex];
                mapPointPickupSelection.current = selectedIndexRecentAddressComponent;
              }
            }
          }
        }
        let selectedAddressContext = (poiSelected ? e.target.title : e.target.textContent);
        let addressDetails = e.target.getAttribute('data-name');
        setPickupAddr(selectedAddressContext);
        setPickPOI((poiSelected? e.target.textContent : ""));
        addressInfoDetails.current.pick = {state:addressDetails.split(",")[1], city: addressDetails.split(",")[0], zip: addressDetails.split(",")[2]};
        mapPointPickupSelection.current["Type"] = indexType;
        pickLatLng.current = e.target.dataset.virtual;
        if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2))
        {
          if(fareMethodRef.current === 1)
          {
            setShowAPILoader(true);
            await getFareZone(FSSelected, selectedAff, COSSelected, pickLatLng.current, "pick");
          }
          await getDispatchZone(selectedAff, pickLatLng.current, "pick");
          setShowAPILoader(false);
          addLegBtnRef.current.disabled = false;
        }
        let stopMarkersArr = [{lat:parseFloat(pickLatLng.current.split(",")[0]),
          lng: parseFloat(pickLatLng.current.split(",")[1]), Type:"PU", 
          name:(riderName === "" ? "N/A" : riderName.trim()), address: selectedAddressContext
        }];
        let filteredMapMarkers = mapData.filter((item)=>{
          if(item.Type === "Stop")
          {
            stopMarkersArr.push(item);
          }
          return item.Type === "DO";
        });
        filteredMapMarkers.unshift(...stopMarkersArr);

        setMapData(filteredMapMarkers);
        setInputSuggestionListPU("");
        if(dropLatLng.current !== "")
        {
          setIsSchTimeFieldDisabled(false);
          wrapperHandleAddressDetails("PU", selectedAddressContext, selectedAddressContext, dropAddr, correctDate, schTime);
          if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2))
          {
            wrapperHandleRCZVerification("PU", selectedAddressContext);
          }
        }
      }
      else
      {
        if(e.target.getAttribute('poisuggestion'))
        {
          let myHeaders = new Headers();
          myHeaders.append("Authorization", 'Basic '+btoa(OSRM_Username + ":" + OSRM_Password));
          myHeaders.append('Content-Type', 'application/json');
          let mapBounds = (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "OSRMRectangleBounds")).value.replace(" ", ""); //"&bounds="+mapBounds+
          let addressAPI = ITCMapURL + encodeURIComponent(e.target.title) + "&bounds="+mapBounds+ "&AppType=Web_Reservation";
          let headersObj = headersToObject(myHeaders);
          let OSRMResponse = await APICom.fetchData("full", addressAPI, "get", headersObj, {});
          if(OSRMResponse && OSRMResponse.data.status.toUpperCase() === "OK")
          {
            let addressFound = OSRMResponse.data.results[0];
            let selectedAddressContext = addressFound.formatted_address;
            let addressDetails = e.target.getAttribute('data-name');
            setPickupAddr(selectedAddressContext);
            setPickPOI(e.target.textContent);
            mapPointPickupSelection.current = {data: {address: e.target.title, POI: e.target.textContent}};
            addressInfoDetails.current.pick = {state:addressDetails.split(",")[1], city: addressDetails.split(",")[0], zip: addressDetails.split(",")[2]};
            mapPointPickupSelection.current["Type"] = "poi";
            pickLatLng.current = addressFound.geometry.location.lat+","+addressFound.geometry.location.lng;
            if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2))
            {
              if(fareMethodRef.current === 1)
              {
                setShowAPILoader(true);
                await getFareZone(FSSelected, selectedAff, COSSelected, pickLatLng.current, "pick");
              }
              await getDispatchZone(selectedAff, pickLatLng.current, "pick");
              setShowAPILoader(false);
              addLegBtnRef.current.disabled = false;
            }
            let stopMarkersArr = [{lat:parseFloat(pickLatLng.current.split(",")[0]),
              lng: parseFloat(pickLatLng.current.split(",")[1]), Type:"PU", 
              name:(riderName === "" ? "N/A" : riderName.trim()), address: selectedAddressContext
            }];
            let filteredMapMarkers = mapData.filter((item)=>{
              if(item.Type === "Stop")
              {
                stopMarkersArr.push(item);
              }
              return item.Type === "DO";
            });
            filteredMapMarkers.unshift(...stopMarkersArr);

            setMapData(filteredMapMarkers);
            setInputSuggestionListPU("");
            if(dropLatLng.current !== "")
            {
              setIsSchTimeFieldDisabled(false);
              wrapperHandleAddressDetails("PU", selectedAddressContext, selectedAddressContext, dropAddr, correctDate, schTime);
              if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2))
              {
                wrapperHandleRCZVerification("PU", selectedAddressContext);
              }
            }
          }
        }
      }
    }
    catch(er){console.log(er);}
  };

  const handleCorrectPhoneFormatDisplay = (e) =>{
    try{
      let input = (e.target.value.length === 0 ? "1":e.target.value);
      if(input.length === 1)
      {
        setCallBackActual(input);
      }
      else if(input.length === 3)
      {
        setCallBackActual("("+input+") ");
      }
      else if(input.length === 9)
      {
        let areaCode = input.replace(/[() ]/g, '').substring(0,3);
        let secondSection = input.replace(/[() ]/g, '').substring(3,6);
        setCallBackActual("("+areaCode+") "+secondSection+"-");
      }
    }
    catch(err){console.log(err);}
  };

  const handleDuplicates = (dict, title) =>
  {
    try{
      // Declare a new array
      let newArray = [];
                  
      // Declare an empty object
      let uniqueObject = {};

      for(var j in dict)
      {
        // Extract the title
        let objTitle = dict[j][title];
        
        // Use the title as the index
        uniqueObject[objTitle] = dict[j];
      }
      
      // Loop to push unique object into array
      for (var u in uniqueObject) {
        newArray.push(uniqueObject[u]);
      }

      // Display the unique objects
      return newArray;
    }
    catch(err){console.log(err);}
  };

  const handleFinishAddingStops = (e)=> {
    try{
      if(pickLatLng.current !== "" && dropLatLng.current !== "")
      {
        if(clientStops.length > 0)
        {
          if(returnLatLng.current !== "")
          {
            handleAddTripStops();
            if(!addStopErrorFlag.current)
            {
              setShowStopsInput(false);
            }
          }
          else
          {
            setShowStopsInput(false);
            
          }
        }
        else
        {
          if(returnLatLng.current !== "")
          {
            handleAddTripStops();
            if(!addStopErrorFlag.current)
            {
              setShowStopsInput(false);
            }
          }
          else
          {
            setShowStopBlock(false);
          }
        }
        if(!addStopErrorFlag.current)
        {
          setStopEditInfo({data:{}, index:0});
          setStopSaveBtnTitle("Save");
          setReturnAddr("");
          setStopLoadRiderName("");
          setStopUnloadRiderName("RN");
          setStopLoadType({none:true, load:false, unload:false});
          setPassengerTypeCountStop({ambPass:1,totalWC:0,totalSA:0, total:1});
          returnLatLng.current = "";
          setReturnAddrExtra("");
          setReturnWaitTime(null);
          setReturnWaitTimeInput(0);
        }
        
      }
      else
      {
        setModalHeaderText("Add Stop Error");
        setModalBodyHTML("Please add pickup & drop-off addresses before adding a stop.");
        setModalFooterHTML(
          <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
            OK
          </Button>
        );
        setShowDynamicModal(true);
      }
    }
    catch(err){console.log(err);}
  };

  const handleCloseStops = (e)=>{
    try{
      if(clientStops.length > 0)
      {
        setShowStopsInput(false);
      }
      else
      {
        setShowStopBlock(false);
      }
      setStopEditInfo({data:{}, index:0});
      setStopSaveBtnTitle("Save");
      setStopLoadType({none:true, load:false, unload:false});
      setPassengerTypeCountStop({ambPass:1,totalWC:0,totalSA:0, total:1});
      setStopLoadRiderName("");
      setStopUnloadRiderName("RN");
      setReturnAddr("");
      returnLatLng.current = "";
      setReturnAddrExtra("");
      setReturnWaitTime(null);
      setReturnWaitTimeInput(0);
    }
    catch(err){console.log(err);}
  };

  const handleAddTripStops = (e)=>{
    try{
      let totalCheck = Object.keys(stopEditInfo.data).length > 0 ? 
        ((stopPassengerLoadTrackerRef.current + parseInt(stopEditInfo.data.stopPax.total)) - passengerTypeCountStop.total):
        (stopPassengerLoadTrackerRef.current - passengerTypeCountStop.total);
      addStopErrorFlag.current = false;
      let unloadPassengerName = "";
      if(!(stopLoadType.none) || (stopLoadType.none && returnWaitTimeInput !== 0))
      {
        if(pickLatLng.current !== "" && dropLatLng.current !== "")
        {
          if(stopLoadType.unload && clientStops.length === 0 && parseInt(passengerTypeCount.total) === 1)
          {
            setModalHeaderText("Add Stop Error");
            setModalBodyHTML("Please add a load type trip before unload.");
            setModalFooterHTML(
              <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                OK
              </Button>
            );
            setShowDynamicModal(true);
            addStopErrorFlag.current = true;
          }
          //(parseInt(clientStops[(clientStops.length - 1)].stopPax.total) < parseInt(passengerTypeCountStop.total) [below line temporarily commented for future update]
          // else if(stopLoadType.unload && clientStops.length > 0 && totalCheck < 0)
          // {
          //   setModalHeaderText("Add Stop Error");
          //   setModalBodyHTML("Please provide either the same or fewer number of passengers for unload.");
          //   setModalFooterHTML(
          //     <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
          //       OK
          //     </Button>
          //   );
          //   setShowDynamicModal(true);
          //   addStopErrorFlag.current = true;
          // }
          else
          {
            const unloadNames = clientStops.filter(item => item.passLoadType === 'unload').map(item => item.passengerName);
            if(stopLoadType.load && stopLoadRiderName.trim() === "")
            {
              setModalHeaderText("Add Stop Error");
              setModalBodyHTML("Please enter a name before adding the stop.");
              setModalFooterHTML(
                <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                  OK
                </Button>
              );
              setShowDynamicModal(true);
              addStopErrorFlag.current = true;
            }
            else if(stopLoadType.unload && stopUnloadRiderName === "RN" && clientStops.length !== 0)
            {
              setModalHeaderText("Add Stop Error");
              setModalBodyHTML("Please select a name before adding the stop.");
              setModalFooterHTML(
                <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                  OK
                </Button>
              );
              setShowDynamicModal(true);
              addStopErrorFlag.current = true;
            }
            else if(stopLoadType.unload && stopUnloadRiderName === "RN" && clientStops.length === 0 && riderName === "")
            {
              setModalHeaderText("Add Stop Error");
              setModalBodyHTML("Please enter a name for the rider before adding unload.");
              setModalFooterHTML(
                <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                  OK
                </Button>
              );
              setShowDynamicModal(true);
              addStopErrorFlag.current = true;
            }
            else if(stopLoadType.unload && unloadNames.includes(stopUnloadRiderName))
            {
              setModalHeaderText("Add Stop Error");
              setModalBodyHTML(stopUnloadRiderName+ " is already selected, please select a different name.");
              setModalFooterHTML(
                <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                  OK
                </Button>
              );
              setShowDynamicModal(true);
              addStopErrorFlag.current = true;
            }
            else
            {
              if(returnLatLng.current !== "")
              {
                if(Object.keys(stopEditInfo.data).length > 0)
                {
                  let loadType = "";
                  let indexCheck = -1;
                  if(stopLoadType.load){
                    loadType = "load"; 
                    indexCheck = clientStops.findIndex((item)=>(item.passLoadType === 'unload' && item.passengerName === stopEditInfo.data.passengerName));

                    if(parseInt(clientStops[stopEditInfo.index].stopPax.total) > parseInt(passengerTypeCountStop.total))
                    {
                      stopPassengerLoadTrackerRef.current = stopPassengerLoadTrackerRef.current - Math.abs(passengerTypeCountStop.total - parseInt(clientStops[stopEditInfo.index].stopPax.total));
                    }
                    else
                    {
                      stopPassengerLoadTrackerRef.current = stopPassengerLoadTrackerRef.current + Math.abs(passengerTypeCountStop.total - parseInt(clientStops[stopEditInfo.index].stopPax.total));
                    }
                  }
                  else if(stopLoadType.unload){
                    loadType = "unload"; 
                    if(parseInt(clientStops[stopEditInfo.index].stopPax.total) > parseInt(passengerTypeCountStop.total))
                    {
                      stopPassengerLoadTrackerRef.current = stopPassengerLoadTrackerRef.current + Math.abs(passengerTypeCountStop.total - parseInt(clientStops[stopEditInfo.index].stopPax.total));
                    }
                    else
                    {
                      stopPassengerLoadTrackerRef.current = stopPassengerLoadTrackerRef.current - Math.abs(passengerTypeCountStop.total - parseInt(clientStops[stopEditInfo.index].stopPax.total));
                    }
                  }
                  else if(stopLoadType.none){loadType = "none";}
                  const updatedData = clientStops.map((item, i) => (i === stopEditInfo.index ? {stopAddr: returnAddr, 
                    stopLatLng: returnLatLng.current, waitTime: returnWaitTimeInput, notes: returnAddrExtra, 
                    passLoadType:loadType, stopPax: passengerTypeCountStop, 
                    passengerName: (stopLoadType.load? stopLoadRiderName: (stopLoadType.unload? stopUnloadRiderName: ""))} : 
                    (indexCheck !== -1 ? (i === (indexCheck) ? {...item, passengerName:stopLoadRiderName} : item) : item) 
                  )
                  );
                  setClientStops(updatedData);
                  setShowStopsInput(false);
                  
                  setStopSaveBtnTitle("Save");
                  setStopEditInfo({data:{}, index:0});
                }
                else
                {
                  if(stopLoadType.unload && stopUnloadRiderName === "RN" && clientStops.length === 0)
                  {
                    unloadPassengerName = riderName;
                  }

                  let clientStopsArr = [];
                  setClientStops((prevStops) => {
                    
                    let loadType = "";
                    if(stopLoadType.load){loadType = "load"; stopPassengerLoadTrackerRef.current = stopPassengerLoadTrackerRef.current + passengerTypeCountStop.total;}
                    else if(stopLoadType.unload){loadType = "unload"; stopPassengerLoadTrackerRef.current = stopPassengerLoadTrackerRef.current - passengerTypeCountStop.total;}
                    else if(stopLoadType.none){loadType = "none";}
                    clientStopsArr = [...prevStops, 
                      {stopAddr: returnAddr, stopLatLng: returnLatLng.current, 
                        waitTime: returnWaitTimeInput, notes: returnAddrExtra, passLoadType:loadType,
                        stopPax: passengerTypeCountStop, passengerName: (stopLoadType.load? stopLoadRiderName: (stopLoadType.unload? (unloadPassengerName !== ""? unloadPassengerName:stopUnloadRiderName): "")), 
                      }
                    ];
                    return [...prevStops, 
                      {stopAddr: returnAddr, stopLatLng: returnLatLng.current, 
                        waitTime: returnWaitTimeInput, notes: returnAddrExtra, passLoadType:loadType,
                        stopPax: passengerTypeCountStop, passengerName: (stopLoadType.load? stopLoadRiderName: (stopLoadType.unload? (unloadPassengerName !== ""? unloadPassengerName:stopUnloadRiderName): "")), 
                      }
                    ];
                  });
                  let load = stopLoadType.load ? "load" : (stopLoadType.unload ? "unload" : "none");
                  let clientName = stopLoadType.load ? stopLoadRiderName : (stopLoadType.unload ? stopUnloadRiderName:riderName);
                  let newStop = {lat:parseFloat(returnLatLng.current.split(",")[0]),
                    lng: parseFloat(returnLatLng.current.split(",")[1]), Type:"Stop", description: returnAddrExtra,
                    name:(clientName.trim() === "" ? "N/A":clientName), address: returnAddr, stopType:load, id:(clientStopsArr.length - 1)
                  };
                  
                  const updatedMapData = [
                    ...mapData.slice(0,-1),
                    newStop,
                    ...mapData.slice(-1)
                  ];

                  setMapData(updatedMapData);
                }

                setReturnAddr("");
                setStopLoadRiderName("");
                setStopUnloadRiderName("RN");
                returnLatLng.current = "";
                setReturnAddrExtra("");
                setReturnWaitTime(null);
                setReturnWaitTimeInput(0);
                setStopLoadType({none:true, load:false, unload:false});
                setPassengerTypeCountStop({ambPass:1,totalWC:0,totalSA:0, total:1});
              }
              else
              {
                setModalHeaderText("Add Stop Error");
                setModalBodyHTML("Please select a suggested address before adding the stop.");
                setModalFooterHTML(
                  <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                    OK
                  </Button>
                );
                setShowDynamicModal(true);
                addStopErrorFlag.current = true;
              }
            }
          }
        }
        else
        {
          setModalHeaderText("Add Stop Error");
          setModalBodyHTML("Please add pickup & drop-off addresses before adding a stop.");
          setModalFooterHTML(
            <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
          setShowDynamicModal(true);
          addStopErrorFlag.current = true;
        }
      }
      else
      {
        setModalHeaderText("Add Stop Error");
        setModalBodyHTML("Please add a wait time for the stop.");
        setModalFooterHTML(
          <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
            OK
          </Button>
        );
        setShowDynamicModal(true);
        addStopErrorFlag.current = true;
      }
      
    }
    catch(err){console.log(err);}
  };

  const handleAccountNumberChange = (e) => { //Checks to make sure the input is a number and correctly entered (Client ID)
    try{
      const regex = /^([0-9]+)?$/;
      let flag = false;
      if(e.target.value.length > 0 && e.target.value > 0)
      {
        let tempVal = e.target.value;
        if(tempVal[0] === "0")
        {
          e.target.value = tempVal[1];
        }
      }
      if(!regex.test(e.target.value)){flag = true;}
      if(!flag)
      {
        setAccountNumber(e.target.value);
      }
    }
    catch(err){console.log(err);}
  };

  const handleCopayAmountChange = (e) => { //Check and display correct amount when user enters a copay (up to 2 decimal points)
    try{
      const regex = /^(0|[1-9][0-9]*)(\.[0-9]{0,2})?$/;
      if(e.target.value.length > 0)
      {
        let tempVal = e.target.value;
        if(tempVal[0] === "0" && tempVal.length > 1 && !tempVal.includes("."))
        {
          e.target.value = tempVal[1];
        }
      }
      if(!regex.test(e.target.value)){e.target.value = 0;}
      setCopayAmount(e.target.value);
    }
    catch(err){console.log(err);}
  };

  const handleMobilityInputChange = (event, type) =>{ //Handler for changes in mobility number information for timeDiff
    try{
      const regex = /^[0-9\b]+$/;
      if(event.target.value.length > 0 && event.target.value > 0)
      {
        let tempVal = event.target.value;
        if(tempVal[0] === "0")
        {
          event.target.value = tempVal[1];
        }
      }
      if(!regex.test(event.target.value)){event.target.value = 0;}
      else if(parseInt(event.target.value) > 10) {event.target.value = 10;}
      else if(parseInt(event.target.value) > 50 && type === "totalVeh"){event.target.value = 50;}
      setMobilityDetails({...mobilityDetails, [type]:event.target.value});
      
    }
    catch(err){console.log(err);}
  };

  const handleDOAddrChanged = async(e)=>{
    try{
      let input = e.target.value;
      if(input === dropAddr && dropLatLng.current !== ""){return;} //check for no change in input
      setFareZones(prevState=>({...prevState, drop: ""}));
      fareZonesRef.current.dropFareZone = "";
      setDispatchZones(prevState=>({...prevState, dropZone: ""}));
      if(input === ""){setIsSchTimeFieldDisabled(true);}
      if(bookBtnRef.current){bookBtnRef.current.disabled = true;}
      setZones("");
      if(input.trim() === ""){handleClearAddr("DO");}
      vsSelectedRef.current = vsSelectedRef.current.filter(item => item !== "DO");

      setClientSummary(prevState=>({...prevState, 
        tripDistance: 0, TripDuration:0, TripFare:0.0, TripCopay:0.0
      }));
      setWalkDistance({...walkDistance, DOWalk:0, PUWalk:0, PUDuration:0, DODuration:0});

      dropLatLng.current = "";
      liRefsDO.current = [];
      let suggestionsRecentArr = [];
      let poiSuggestionAddrHTML = null;
      let hashIndex = input.indexOf("#");
      if(hashIndex !== -1)
      {
        //run POISuggestion
        handleClearAddr("DO");
        input = input.slice(hashIndex);
        setDropAddr(input);
        input = input.replaceAll("#","");
        if(input.length >= 3)
        {
          let data = {
            "affiliateID": parseInt(selectedAff),
            "poi": input.replaceAll("#",""),
          }
          xCancelSourceForGrid.current = APICom.GenerateSource();
          let response = await APICom.fetchData("ReservationCoreURL","api/ParatransitCT/GetPOISuggestion", "post", 
            {'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'mode': 'no-cors'}, data, xCancelSourceForGrid.current
          );

          if(response.error.length === 0 && (Array.isArray(response.data) && response.data.length > 0))
          {
            let SuggestedAddrArray = response.data;
            let filteredPOISuggestion = SuggestedAddrArray.filter(item=>{
              let formattedAddr = item.POI;
              return formattedAddr.toLowerCase().includes(input.trim().toLowerCase());
            });
            focusedSuggestionCheckDO.current = false;
            poiSuggestionAddrHTML = filteredPOISuggestion ? filteredPOISuggestion.map(function(item, index){
              let detailedData = item.City+","+item.Region+","+item.ZipCode;
              let formattedAddr = item.POI;
              let fullAddr = (item.Street + (item.City && item.City !== ""? ", "+item.City +", "+ (item.Region && item.Region !== "" ? item.Region +" "+ item.ZipCode: ""): "") );
              let LatLng = String(item.vPOILatitude)+","+String(item.vPOILongitude);
              liRefsDO.current[index] = React.createRef();
              return(
                <li ref={liRefsDO.current[index]} poisuggestion={"true"} className="small border-bottom text-nowrap overflow-hidden addressSelectionRow" 
                  title={fullAddr} onFocus={()=>{focusedSuggestionCheckDO.current = true;}}
                  style={{cursor:"pointer"}} tabIndex={-1} onBlur={()=>{focusedSuggestionCheckDO.current = false;}} onKeyDown={(e)=>{
                    if(e.key === 'ArrowDown')
                    {
                      e.preventDefault();

                      if(liRefsDO.current.length > 0)
                      {
                        setHightlightedIndexDO((prevIndex) => {
                          const newIndex = (prevIndex + 1) % liRefsDO.current.length;
                          liRefsDO.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                          return newIndex;
                        });
                      }
                    }
                    else if (e.key === 'ArrowUp') {
                      e.preventDefault();
                      if(liRefsDO.current.length > 0)
                      {
                        setHightlightedIndexDO((prevIndex) => {
                          const newIndex = (prevIndex - 1 + liRefsDO.current.length) % liRefsDO.current.length;
                          liRefsDO.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                          return newIndex;
                        });
                      }
                    }
                    else if(e.key === "Enter")
                    {
                      handleDOSuggestionClicked(e);
                    }
                  }}
                  onClick={handleDOSuggestionClicked} key={index} value={formattedAddr} data-name={detailedData} data-virtual={LatLng}
                >
                  {item.icon && item.icon !== ""? <Icon icon={item.icon} className="text-danger me-1" style={{width:"20px", height:"20px"}}/> :
                    <Icon icon={"gis:search-poi"} className="text-danger me-1" style={{width:"20px", height:"20px"}}/>
                  }
                  {formattedAddr}
                </li>
              );
            }) : "";
          }
        }
      }
      else
      {
        setDropAddr(input);
      }

      for(let entry of recentAddresses)
      {
        if(entry.PUAddress)
        {
          suggestionsRecentArr.push({
            Address: entry.PUAddress,
            City: entry.PUCity,
            Lat: entry.PULat,
            Long: entry.PULong,
            State: entry.PUState,
            Zip: entry.PUZip,
          });
        }
        if(entry.DOAddress)
        {
          suggestionsRecentArr.push({
            Address: entry.DOAddress,
            City: entry.DOCity,
            Lat: entry.DOLat,
            Long: entry.DOLong,
            State: entry.DOState,
            Zip: entry.DOZip,
          });
        }
      }
      let uniqueRecentAddresses = handleDuplicates(suggestionsRecentArr, "Address");
      let filteredAddresses = uniqueRecentAddresses.length > 0 ? uniqueRecentAddresses.filter(item => { 
        let formattedAddr = item.Address+", "+item.City+", "+item.State+" "+item.Zip+", USA";
        return input.trim().length === 0 || formattedAddr.toLowerCase().includes(input.trim().toLowerCase());
      }) : [];
      const sortedAddresses = filteredAddresses.sort((a, b) => (b.AddressType === 2) - (a.AddressType === 2));

      if(sortedAddresses.length > 0)
      {
        sortedAddresses.unshift({
          Address: "",
          City: "",
          State: "",
          Zip: "",
          Lat: "",
          Long: "",
          AddressType: 0,
          isStatic: true, // Add a flag to differentiate this static entry
        });
      }
      focusedSuggestionCheckDO.current = false;
      let recentAddrHTML = sortedAddresses.length > 0 ? sortedAddresses.map(function(item, index){

        try {
          liRefRecentDropoffAddressComponenet.current[index] = item;
        } catch (error) {}

        let formattedAddr = item.Address+", "+item.City+", "+item.State+" "+item.Zip+", USA";
        let detailedData = item.City+","+item.State+","+item.Zip;
        let LatLng = String(item.Lat)+","+String(item.Long);
        if(item.isStatic)
        {
          liRefsDO.current[index] = React.createRef();
          return(
            <li ref={liRefsDO.current[index]} className="small border-bottom text-nowrap overflow-hidden addressSelectionRow" 
              onFocus={()=>{focusedSuggestionCheckDO.current = true;}}
              style={{cursor:"pointer"}} tabIndex={-1} onBlur={()=>{focusedSuggestionCheckDO.current = false;}} onKeyDown={(e)=>{
                if(e.key === 'ArrowDown')
                {
                  e.preventDefault();

                  if(liRefsDO.current.length > 0)
                  {
                    setHightlightedIndexDO((prevIndex) => {
                      const newIndex = (prevIndex + 1) % liRefsDO.current.length;
                      liRefsDO.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                      return newIndex;
                    });
                  }
                }
                else if (e.key === 'ArrowUp') {
                  e.preventDefault();
                  if(liRefsDO.current.length > 0)
                  {
                    setHightlightedIndexDO((prevIndex) => {
                      const newIndex = (prevIndex - 1 + liRefsDO.current.length) % liRefsDO.current.length;
                      liRefsDO.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                      return newIndex;
                    });
                  }
                }
              }}
              key={index} value={""}
            >
              <Icon icon="ph:info" className="text-info me-1" style={{width:"20px", height:"20px"}}/>
              {"Search POI by typing #POI Name"}
            </li>
          );
        }
        else if(input.trim().length > 0 && formattedAddr.toLowerCase().includes(input.trim().toLowerCase()))
        {
          liRefsDO.current[index] = React.createRef();
          return(
            <li ref={liRefsDO.current[index]} recentaddressindex={index} isrecentaddress="true" className="small border-bottom text-nowrap overflow-hidden addressSelectionRow" 
              title={formattedAddr} onFocus={()=>{focusedSuggestionCheckDO.current = true;}}
              style={{cursor:"pointer"}} tabIndex={-1} onBlur={()=>{focusedSuggestionCheckDO.current = false;}} onKeyDown={(e)=>{
                if(e.key === 'ArrowDown')
                {
                  e.preventDefault();

                  if(liRefsDO.current.length > 0)
                  {
                    setHightlightedIndexDO((prevIndex) => {
                      const newIndex = (prevIndex + 1) % liRefsDO.current.length;
                      liRefsDO.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                      return newIndex;
                    });
                  }
                }
                else if (e.key === 'ArrowUp') {
                  e.preventDefault();
                  if(liRefsDO.current.length > 0)
                  {
                    setHightlightedIndexDO((prevIndex) => {
                      const newIndex = (prevIndex - 1 + liRefsDO.current.length) % liRefsDO.current.length;
                      liRefsDO.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                      return newIndex;
                    });
                  }
                }
                else if(e.key === "Enter")
                {
                  handleDOSuggestionClicked(e);
                }
              }}
              onClick={handleDOSuggestionClicked} key={index} value={formattedAddr} data-name={detailedData} data-virtual={LatLng}
            >
              {item.AddressType === 2? <Icon icon="bx:heart" className="text-danger me-1" style={{width:"20px", height:"20px"}}/> : <Icon icon="bx:history" className="text-secondary me-1" style={{width:"20px", height:"20px"}}/>}
              {formattedAddr}
            </li>
          );
        }
        else if(input.trim() === "")
        {
          liRefsDO.current[index] = React.createRef();
          try {
            let result = ParseGeoCodedData(item, "", index);
            liRefRecentDropoffAddressComponenet.current[index] = result;
          } catch (error) {}
          return(
            <li ref={liRefsDO.current[index]} recentaddressindex={index} isrecentaddress="true" className="small border-bottom text-nowrap overflow-hidden addressSelectionRow" 
              title={formattedAddr} onFocus={()=>{focusedSuggestionCheckDO.current = true;}}
              style={{cursor:"pointer"}} tabIndex={-1} onBlur={()=>{focusedSuggestionCheckDO.current = false;}} onKeyDown={(e)=>{
                if(e.key === 'ArrowDown')
                {
                  e.preventDefault();

                  if(liRefsDO.current.length > 0)
                  {
                    setHightlightedIndexDO((prevIndex) => {
                      const newIndex = (prevIndex + 1) % liRefsDO.current.length;
                      liRefsDO.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                      return newIndex;
                    });
                  }
                }
                else if (e.key === 'ArrowUp') {
                  e.preventDefault();
                  if(liRefsDO.current.length > 0)
                  {
                    setHightlightedIndexDO((prevIndex) => {
                      const newIndex = (prevIndex - 1 + liRefsDO.current.length) % liRefsDO.current.length;
                      liRefsDO.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                      return newIndex;
                    });
                  }
                }
                else if(e.key === "Enter")
                {
                  handleDOSuggestionClicked(e);
                }
              }}
              onClick={handleDOSuggestionClicked} key={index} value={formattedAddr} data-name={detailedData} data-virtual={LatLng}
            >
              {item.AddressType === 2? <Icon icon="bx:heart" className="text-danger me-1" style={{width:"20px", height:"20px"}}/> : <Icon icon="bx:history" className="text-secondary me-1" style={{width:"20px", height:"20px"}}/>}
              {formattedAddr}
            </li>
          );
        }
      }): "";
      if(input.trim().length > 8 && hashIndex === -1)
      {
        let myHeaders = new Headers();
        myHeaders.append("Authorization", 'Basic '+btoa(OSRM_Username + ":" + OSRM_Password));
        myHeaders.append('Content-Type', 'application/json');
        let mapBounds = (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "OSRMRectangleBounds")).value.replace(" ", ""); //"&bounds=" + mapBounds+
        let addressAPI = ITCMapURL + encodeURIComponent(input) + "&bounds=" + mapBounds+ "&AppType=Web_Reservation";
        let OSRMResponse = await APICom.fetchData("full", addressAPI, "get2", myHeaders, {});
        let SuggestedAddrArray = [];

        if(OSRMResponse && OSRMResponse.data.status.toUpperCase() === "OK")
        {
          SuggestedAddrArray = OSRMResponse.data.results.map(function(item)
          {
            return item;
          });

          focusedSuggestionCheckDO.current = false;
          liRefsDO.current = [];
          if(SuggestedAddrArray.length > 0)
          {
            SuggestedAddrArray.unshift({
              Address: "",
              City: "",
              State: "",
              Zip: "",
              Lat: "",
              Long: "",
              AddressType: 0,
              isStatic: true, // Add a flag to differentiate this static entry
            });
          }
          let suggestionsHTML = SuggestedAddrArray.length > 0? SuggestedAddrArray.map(function(item, index){
            try {
              let result = (item.isStatic ? "" : ParseGeoCodedData(item, "", index));
              liRefDropoffAddressComponenet.current[index] = result;
            } catch (error) {}
            let LatLng = (item.isStatic ? "" : (String(item.geometry.location.lat) +","+ String(item.geometry.location.lng)));
            let detailedData = {
              city: "",
              state: "",
              zip: ""
            };

            if(item.isStatic)
            {
              liRefsDO.current[index] = React.createRef();
              return(
                <li ref={liRefsDO.current[index]} className="small border-bottom text-nowrap overflow-hidden addressSelectionRow" 
                  onFocus={()=>{focusedSuggestionCheckDO.current = true;}}
                  style={{cursor:"pointer"}} tabIndex={-1} onBlur={()=>{focusedSuggestionCheckDO.current = false;}} onKeyDown={(e)=>{
                    if(e.key === 'ArrowDown')
                    {
                      e.preventDefault();

                      if(liRefsDO.current.length > 0)
                      {
                        setHightlightedIndexDO((prevIndex) => {
                          const newIndex = (prevIndex + 1) % liRefsDO.current.length;
                          liRefsDO.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                          return newIndex;
                        });
                      }
                    }
                    else if (e.key === 'ArrowUp') {
                      e.preventDefault();
                      if(liRefsDO.current.length > 0)
                      {
                        setHightlightedIndexDO((prevIndex) => {
                          const newIndex = (prevIndex - 1 + liRefsDO.current.length) % liRefsDO.current.length;
                          liRefsDO.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                          return newIndex;
                        });
                      }
                    }
                  }}
                  key={index} value={""}
                >
                  <Icon icon="ph:info" className="text-info me-1" style={{width:"20px", height:"20px"}}/>
                  {"Search POI by typing #POI Name"}
                </li>
              );
            }
            
            item.address_components.forEach((component)=>{
              if(component.types.includes("locality") || component.types.includes("administrative_area_level_2"))
              {
                detailedData.city = component.long_name;
              }
              if (component.types.includes("administrative_area_level_1")) {
                detailedData.state = component.short_name;
              }
              if (component.types.includes("postal_code")) {
                detailedData.zip = component.long_name;
              }
            });
            let dataString = detailedData.city+","+detailedData.state+","+detailedData.zip;
            liRefsDO.current[index] = React.createRef();
            return(
              <li ref={liRefsDO.current[index]} index={index} className="border-bottom text-nowrap overflow-hidden addressSelectionRow" title={item.formatted_address} 
                style={{cursor:"pointer"}} tabIndex={-1}
                onKeyDown={(e)=>{
                  if(e.key === 'ArrowDown')
                  {
                    e.preventDefault();

                    if(liRefsDO.current.length > 0)
                    {
                      setHightlightedIndexDO((prevIndex) => {
                        const newIndex = (prevIndex + 1) % liRefsDO.current.length;
                        liRefsDO.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                        return newIndex;
                      });
                    }
                  }
                  else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    if(liRefsDO.current.length > 0)
                    {
                      setHightlightedIndexDO((prevIndex) => {
                        const newIndex = (prevIndex - 1 + liRefsDO.current.length) % liRefsDO.current.length;
                        liRefsDO.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                        return newIndex;
                      });
                    }
                  }
                  else if(e.key === "Enter")
                  {
                    handleDOSuggestionClicked(e);
                  }
                }} onFocus={()=>{focusedSuggestionCheckDO.current = true;}} onBlur={()=>{focusedSuggestionCheckDO.current = false;}}
                onClick={handleDOSuggestionClicked} key={index} value={item.formatted_address} data-name={dataString} data-virtual={LatLng}
              >
                {item.formatted_address}
              </li>
            );
          }): "";
          if(suggestionsHTML !== "" && e.target.value !== "")
          {
            setInputSuggestionListDO(suggestionsHTML);
          }
          else if(recentAddrHTML.length > 0)
          {
            setInputSuggestionListDO(recentAddrHTML);
          }
        }
      }
      else if(input.trim().length === 0)
      {
        if(recentAddrHTML.length > 0)
        {
          setInputSuggestionListDO(recentAddrHTML);
        }
        else
        {
          setInputSuggestionListDO("");
        }
      }
      else
      {
        if(hashIndex !== -1 && poiSuggestionAddrHTML !== "")
        {
          setInputSuggestionListDO(poiSuggestionAddrHTML);
        }
        else if(recentAddrHTML.length > 0)
        {
          setInputSuggestionListDO(recentAddrHTML);
        }
        else
        {
          setInputSuggestionListDO("");
        }
      }
    }
    catch(err){console.log(err);}
  };

  const handleReturnAddrChange = async (e) => { //Get the correct address suggestions for a stop depending on user input (POI's/Recents/Suggestions)
    try{
      let input = e.target.value;
      let suggestionsRecentArr = [];
      let poiSuggestionAddrHTML = null;
      let hashIndex = input.indexOf("#");
      if(input === returnAddr && returnLatLng.current !== ""){return;} //check for no change in input
      setReturnAddrZone("");
      if(input.trim() === ""){handleClearAddr("Return");} //If user clears input, clear all suggestions and selected address lat lng
      returnLatLng.current = "";
      liRefsReturn.current = [];
      if(hashIndex !== -1)
      {
        //run POISuggestion
        handleClearAddr("Return");
        input = input.slice(hashIndex);
        setReturnAddr(input);
        input = input.replaceAll("#","");
        if(input.length >= 3)
        {
          let data = {
            "affiliateID": parseInt(selectedAff),
            "poi": input.replaceAll("#",""),
          }
          xCancelSourceForGrid.current = APICom.GenerateSource();
          let response = await APICom.fetchData("ReservationCoreURL","api/ParatransitCT/GetPOISuggestion", "post", 
            {'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'mode': 'no-cors'}, data, xCancelSourceForGrid.current
          );

          if(response.error.length === 0 && (Array.isArray(response.data) && response.data.length > 0))
          {
            let SuggestedAddrArray = response.data;
            let filteredPOISuggestion = SuggestedAddrArray.filter(item=>{
              let formattedAddr = item.POI;
              return formattedAddr.toLowerCase().includes(input.trim().toLowerCase());
            });
            focusedSuggestionCheckReturn.current = false;
            poiSuggestionAddrHTML = filteredPOISuggestion ? filteredPOISuggestion.map(function(item, index){
              let detailedData = item.City+","+item.Region+","+item.ZipCode;
              let formattedAddr = item.POI;
              let fullAddr = (item.Street + (item.City && item.City !== ""? ", "+item.City +", "+ (item.Region && item.Region !== "" ? item.Region +" "+ item.ZipCode: ""): "") );
              let LatLng = String(item.vPOILatitude)+","+String(item.vPOILongitude);
              liRefsReturn.current[index] = React.createRef();
              return(
                <li ref={liRefsReturn.current[index]} poisuggestion={"true"} className="small border-bottom text-nowrap overflow-hidden addressSelectionRow" 
                  title={fullAddr} onFocus={()=>{focusedSuggestionCheckReturn.current = true;}}
                  style={{cursor:"pointer"}} tabIndex={-1} onBlur={()=>{focusedSuggestionCheckReturn.current = false;}} onKeyDown={(e)=>{
                    if(e.key === 'ArrowDown')
                    {
                      e.preventDefault();

                      if(liRefsReturn.current.length > 0)
                      {
                        setHightlightedIndexReturn((prevIndex) => {
                          const newIndex = (prevIndex + 1) % liRefsReturn.current.length;
                          liRefsReturn.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                          return newIndex;
                        });
                      }
                    }
                    else if (e.key === 'ArrowUp') {
                      e.preventDefault();
                      if(liRefsReturn.current.length > 0)
                      {
                        setHightlightedIndexReturn((prevIndex) => {
                          const newIndex = (prevIndex - 1 + liRefsReturn.current.length) % liRefsReturn.current.length;
                          liRefsReturn.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                          return newIndex;
                        });
                      }
                    }
                    else if(e.key === "Enter")
                    {
                      handleReturnSuggestionClicked(e);
                    }
                  }}
                  onClick={handleReturnSuggestionClicked} key={index} value={formattedAddr} data-name={detailedData} data-virtual={LatLng}
                >
                  {item.icon && item.icon !== ""? <Icon icon={item.icon} className="text-danger me-1" style={{width:"20px", height:"20px"}}/> :
                    <Icon icon={"gis:search-poi"} className="text-danger me-1" style={{width:"20px", height:"20px"}}/>
                  }
                  {formattedAddr}
                </li>
              );
            }) : "";
          }
        }
      }
      else
      {
        setReturnAddr(input);
      }

      for(let entry of recentAddresses)
      {
        if(entry.PUAddress)
        {
          suggestionsRecentArr.push({
            Address: entry.PUAddress,
            City: entry.PUCity,
            Lat: entry.PULat,
            Long: entry.PULong,
            State: entry.PUState,
            Zip: entry.PUZip,
          });
        }
        if(entry.DOAddress)
        {
          suggestionsRecentArr.push({
            Address: entry.DOAddress,
            City: entry.DOCity,
            Lat: entry.DOLat,
            Long: entry.DOLong,
            State: entry.DOState,
            Zip: entry.DOZip,
          });
        }
      }
      let uniqueRecentAddresses = handleDuplicates(suggestionsRecentArr, "Address"); //Make sure there are no duplicates in given addresses then filter by input and get a formatted result
      let filteredAddresses = uniqueRecentAddresses.length > 0 ? uniqueRecentAddresses.filter(item => { 
        let formattedAddr = item.Address+", "+item.City+", "+item.State+" "+item.Zip+", USA";
        return input.trim().length === 0 || formattedAddr.toLowerCase().includes(input.trim().toLowerCase());
      }) : [];

      const sortedAddresses = filteredAddresses.sort((a, b) => (b.AddressType === 2) - (a.AddressType === 2)); //sort addresses top:favorite - bottom:historic
      if(sortedAddresses.length > 0)
      {
        sortedAddresses.unshift({
          Address: "",
          City: "",
          State: "",
          Zip: "",
          Lat: "",
          Long: "",
          AddressType: 0,
          isStatic: true, // Add a flag to differentiate this static entry
        });
      }
      focusedSuggestionCheckReturn.current = false;
      let recentAddrHTML = filteredAddresses.length > 0 ? sortedAddresses.map(function(item, index){
        let formattedAddr = item.Address+", "+item.City+", "+item.State+" "+item.Zip+", USA";
        let detailedData = item.City+","+item.State+","+item.Zip;
        let LatLng = String(item.Lat)+","+String(item.Long);
        try {
          liRefReturnAddressComponent.current[index] = item;
        } catch (error) {}
        if(item.isStatic)
        {
          liRefsReturn.current[index] = React.createRef();
          return(
            <li ref={liRefsReturn.current[index]} recentaddressindex={index} className="small border-bottom text-nowrap overflow-hidden addressSelectionRow" 
              onFocus={()=>{focusedSuggestionCheckReturn.current = true;}}
              style={{cursor:"pointer"}} tabIndex={-1} onBlur={()=>{focusedSuggestionCheckReturn.current = false;}} onKeyDown={(e)=>{
                if(e.key === 'ArrowDown')
                {
                  e.preventDefault();
  
                  if(liRefsReturn.current.length > 0)
                  {
                    setHightlightedIndexReturn((prevIndex) => {
                      const newIndex = (prevIndex + 1) % liRefsReturn.current.length;
                      liRefsReturn.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                      return newIndex;
                    });
                  }
                }
                else if (e.key === 'ArrowUp') {
                  e.preventDefault();
                  if(liRefsReturn.current.length > 0)
                  {
                    setHightlightedIndexReturn((prevIndex) => {
                      const newIndex = (prevIndex - 1 + liRefsReturn.current.length) % liRefsReturn.current.length;
                      liRefsReturn.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                      return newIndex;
                    });
                  }
                }
              }}
              key={index} value={""}
            >
              <Icon icon="ph:info" className="text-info me-1" style={{width:"20px", height:"20px"}}/>
              {"Search POI by typing #POI Name"}
            </li>
          );
        }
        else if(input.trim().length > 0 && formattedAddr.toLowerCase().includes(input.trim().toLowerCase()))
        {
          liRefsReturn.current[index] = React.createRef();
          return(
            <li ref={liRefsReturn.current[index]} recentaddressindex={index} isrecentaddress="true" 
              className="small border-bottom text-nowrap overflow-hidden addressSelectionRow" title={formattedAddr} 
              onFocus={()=>{focusedSuggestionCheckReturn.current = true;}}
              style={{cursor:"pointer"}} tabIndex={-1} onBlur={()=>{focusedSuggestionCheckReturn.current = false;}} onKeyDown={(e)=>{
                if(e.key === 'ArrowDown')
                {
                  e.preventDefault();

                  if(liRefsReturn.current.length > 0)
                  {
                    setHightlightedIndexReturn((prevIndex) => {
                      const newIndex = (prevIndex + 1) % liRefsReturn.current.length;
                      liRefsReturn.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                      return newIndex;
                    });
                  }
                }
                else if (e.key === 'ArrowUp') {
                  e.preventDefault();
                  if(liRefsReturn.current.length > 0)
                  {
                    setHightlightedIndexReturn((prevIndex) => {
                      const newIndex = (prevIndex - 1 + liRefsReturn.current.length) % liRefsReturn.current.length;
                      liRefsReturn.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                      return newIndex;
                    });
                  }
                }
                else if(e.key === "Enter")
                {
                  handleReturnSuggestionClicked(e);
                }
              }}
              onClick={handleReturnSuggestionClicked} key={index} value={formattedAddr} data-name={detailedData} data-virtual={LatLng}
            >
              {item.AddressType === 2? <Icon icon="bx:heart" className="text-danger me-1" style={{width:"20px", height:"20px"}}/> : <Icon icon="bx:history" className="text-secondary me-1" style={{width:"20px", height:"20px"}}/>}
              {formattedAddr}
            </li>
          );
        }
        else if(input.trim() === "")
        {
          liRefsReturn.current[index] = React.createRef();
          try {
            let result = ParseGeoCodedData(item, "", index);
            liRefReturnAddressComponent.current[index] = result;
          } catch (error) {}
          return(
            <li ref={liRefsReturn.current[index]} index={index} className="border-bottom text-nowrap overflow-hidden addressSelectionRow" 
              title={formattedAddr} onFocus={()=>{focusedSuggestionCheckReturn.current = true;}} onBlur={()=>{focusedSuggestionCheckReturn.current = false;}}
              style={{cursor:"pointer"}} tabIndex={-1}
              onKeyDown={(e)=>{
                if(e.key === 'ArrowDown')
                {
                  e.preventDefault();

                  if(liRefsReturn.current.length > 0)
                  {
                    setHightlightedIndexDO((prevIndex) => {
                      const newIndex = (prevIndex + 1) % liRefsReturn.current.length;
                      liRefsReturn.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                      return newIndex;
                    });
                  }
                }
                else if (e.key === 'ArrowUp') {
                  e.preventDefault();
                  if(liRefsReturn.current.length > 0)
                  {
                    setHightlightedIndexDO((prevIndex) => {
                      const newIndex = (prevIndex - 1 + liRefsReturn.current.length) % liRefsReturn.current.length;
                      liRefsReturn.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                      return newIndex;
                    });
                  }
                }
                else if(e.key === "Enter")
                {
                  handleReturnSuggestionClicked(e);
                }
              }}
              onClick={handleReturnSuggestionClicked} key={index} value={formattedAddr} data-name={detailedData} data-virtual={LatLng}
            >
              {item.AddressType === 2? <Icon icon="bx:heart" className="text-danger" style={{width:"20px", height:"20px"}}/> : <Icon icon="bx:history" className="text-secondary" style={{width:"20px", height:"20px"}}/>}
              {formattedAddr}
            </li>
          );
        }
      }): "";
      //If user enters a minimum of 8 characters, change suggestions to autoComplete address suggestions
      if(input.trim().length > 8 && hashIndex === -1)
      {
        let myHeaders = new Headers();
        myHeaders.append("Authorization", 'Basic '+btoa(OSRM_Username + ":" + OSRM_Password));
        myHeaders.append('Content-Type', 'application/json');
        let mapBounds = (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "OSRMRectangleBounds")).value.replace(" ", ""); //"&bounds=" + mapBounds+
        let addressAPI = ITCMapURL + encodeURIComponent(input) + "&bounds=" + mapBounds+ "&AppType=Web_Reservation";
        let OSRMResponse = await APICom.fetchData("full", addressAPI, "get2", myHeaders, {});
        let SuggestedAddrArray = [];
        if(OSRMResponse && OSRMResponse.data.status.toUpperCase() === "OK")
        {
          SuggestedAddrArray = OSRMResponse.data.results.map(function(item)
          {
            return item;
          });
          if(SuggestedAddrArray.length > 0)
          {
            SuggestedAddrArray.unshift({
              Address: "",
              City: "",
              State: "",
              Zip: "",
              Lat: "",
              Long: "",
              AddressType: 0,
              isStatic: true, // Add a flag to differentiate this static entry
            });
          }
          focusedSuggestionCheckReturn.current = false;
          liRefsReturn.current = [];
          liRefReturnAddressComponent.current = []; 
          let suggestionsHTML = SuggestedAddrArray.length > 0? SuggestedAddrArray.map(function(item, index){
            let LatLng = (item.isStatic ? "" : String(item.geometry.location.lat) +","+ String(item.geometry.location.lng));
            let detailedData = {
              city: "",
              state: "",
              zip: ""
            };
            
            try {
              let result = (item.isStatic ? "" : ParseGeoCodedData(item, "", index));
              liRefReturnAddressComponent.current[index] = result;
            } catch (error) {}

            if(item.isStatic)
            {
              liRefsReturn.current[index] = React.createRef();
              return(
                <li ref={liRefsReturn.current[index]} index={index} className="small border-bottom text-nowrap overflow-hidden addressSelectionRow" 
                  style={{cursor:"pointer"}} tabIndex={-1} onFocus={()=>{focusedSuggestionCheckReturn.current = true;}} 
                  onBlur={()=>{focusedSuggestionCheckReturn.current = false;}}
                  onKeyDown={(e)=>{
                    if(e.key === 'ArrowDown')
                    {
                      e.preventDefault();
  
                      if(liRefsReturn.current.length > 0)
                      {
                        setHightlightedIndexDO((prevIndex) => {
                          const newIndex = (prevIndex + 1) % liRefsReturn.current.length;
                          liRefsReturn.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                          return newIndex;
                        });
                      }
                    }
                    else if (e.key === 'ArrowUp') {
                      e.preventDefault();
                      if(liRefsReturn.current.length > 0)
                      {
                        setHightlightedIndexDO((prevIndex) => {
                          const newIndex = (prevIndex - 1 + liRefsReturn.current.length) % liRefsReturn.current.length;
                          liRefsReturn.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                          return newIndex;
                        });
                      }
                    }
                  }}
                  onClick={handleReturnSuggestionClicked} key={index} value={""}
                >
                  <Icon icon="ph:info" className="text-info me-1" style={{width:"20px", height:"20px"}}/>
                  {"Search POI by typing #POI Name"}
                </li>
              );
            }
            else
            {
              item.address_components.forEach((component)=>{
                if(component.types.includes("locality") || component.types.includes("administrative_area_level_2"))
                {
                  detailedData.city = component.long_name;
                }
                if (component.types.includes("administrative_area_level_1")) {
                  detailedData.state = component.short_name;
                }
                if (component.types.includes("postal_code")) {
                  detailedData.zip = component.long_name;
                }
              });
              let dataString = detailedData.city+","+detailedData.state+","+detailedData.zip;
              liRefsReturn.current[index] = React.createRef();
              return(
                <li ref={liRefsReturn.current[index]} index={index} className="border-bottom text-nowrap overflow-hidden addressSelectionRow" 
                  title={item.formatted_address} 
                  style={{cursor:"pointer"}} tabIndex={-1}
                  onKeyDown={(e)=>{
                    if(e.key === 'ArrowDown')
                    {
                      e.preventDefault();

                      if(liRefsReturn.current.length > 0)
                      {
                        setHightlightedIndexDO((prevIndex) => {
                          const newIndex = (prevIndex + 1) % liRefsReturn.current.length;
                          liRefsReturn.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                          return newIndex;
                        });
                      }
                    }
                    else if (e.key === 'ArrowUp') {
                      e.preventDefault();
                      if(liRefsReturn.current.length > 0)
                      {
                        setHightlightedIndexDO((prevIndex) => {
                          const newIndex = (prevIndex - 1 + liRefsReturn.current.length) % liRefsReturn.current.length;
                          liRefsReturn.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                          return newIndex;
                        });
                      }
                    }
                    else if(e.key === "Enter")
                    {
                      handleReturnSuggestionClicked(e);
                    }
                  }} onFocus={()=>{focusedSuggestionCheckReturn.current = true;}} onBlur={()=>{focusedSuggestionCheckReturn.current = false;}}
                  onClick={handleReturnSuggestionClicked} key={index} value={item.formatted_address} data-virtual={LatLng} data-name={dataString}
                >
                  {item.formatted_address}
                </li>
              );
            }
          }): "";
          if(suggestionsHTML !== "" && e.target.value !== "")
          {
            setInputSuggestionListReturn(suggestionsHTML);
          }
          else if(recentAddrHTML.length > 0)
          {
            setInputSuggestionListReturn(recentAddrHTML);
          }
        }
      }
      else if(input.trim().length === 0)
      {
        if(recentAddrHTML.length > 0)
        {
          setInputSuggestionListReturn(recentAddrHTML);
        }
        else
        {
          setInputSuggestionListReturn("");
        }
      }
      else
      {
        if(hashIndex !== -1 && poiSuggestionAddrHTML !== "")
        {
          setInputSuggestionListReturn(poiSuggestionAddrHTML);
        }
        else if(recentAddrHTML.length > 0)
        {
          setInputSuggestionListReturn(recentAddrHTML);
        }
        else
        {
          setInputSuggestionListReturn("");
        }
      }
    }
    catch(err){console.log(err);}
  };

  const handleReturnSuggestionClicked = async (e) => {
    try{
      let PULatLng = e.target.dataset.virtual;
      if(PULatLng.split(",")[0] !== "0" && PULatLng.split(",")[0] !== "")
      {
        let selectedIndex = e.target.getAttribute('index');
        let poiSelected = e.target.getAttribute('poisuggestion');
        let selectedIndexAddressComponent = "";
        let indexType = "";
        if(selectedIndex !== undefined && selectedIndex)
        {
          selectedIndex = parseInt(selectedIndex);
          if(selectedIndex >= 0 && liRefReturnAddressComponent !== undefined)
          {
            indexType = "manual";
            selectedIndexAddressComponent = liRefReturnAddressComponent?.current[selectedIndex];
            mapPointReturnSelection.current = selectedIndexAddressComponent;
          }
        }
        else if(poiSelected)
        {
          indexType = "poi";
          mapPointReturnSelection.current = {data: {address: e.target.title, POI: e.target.textContent}};
        }
        else
        {
          let _IsRecentAddressSelected = e.target.getAttribute('isrecentaddress');
          let selectedIndexRecentAddressComponent = "";
          if(_IsRecentAddressSelected !== undefined && _IsRecentAddressSelected)
          {
            let recentaddressindex = e.target.getAttribute('recentaddressindex');
            if(recentaddressindex !== undefined && recentaddressindex){
              recentaddressindex = parseInt(recentaddressindex);
              if(recentaddressindex >= 0 && liRefReturnAddressComponent !== undefined){
                indexType = "recent";
                selectedIndexRecentAddressComponent = liRefReturnAddressComponent?.current[recentaddressindex];
                mapPointReturnSelection.current = selectedIndexRecentAddressComponent;
              }
            }
          }
        }
        setReturnAddr(e.target.textContent);
        setStopPOI((poiSelected? e.target.textContent : ""));
        setInputSuggestionListReturn("");
        mapPointReturnSelection.current["Type"] = indexType;
        returnLatLng.current = e.target.dataset.virtual;
      }
      else
      {
        if(e.target.getAttribute('poisuggestion'))
        {
          let myHeaders = new Headers();
          myHeaders.append("Authorization", 'Basic '+btoa(OSRM_Username + ":" + OSRM_Password));
          myHeaders.append('Content-Type', 'application/json');
          let mapBounds = (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "OSRMRectangleBounds")).value.replace(" ", "");
          let addressAPI = ITCMapURL + encodeURIComponent(e.target.title) + "&bounds="+mapBounds+ "&AppType=Web_Reservation";
          let headersObj = headersToObject(myHeaders);
          let OSRMResponse = await APICom.fetchData("full", addressAPI, "get", headersObj, {});
          if(OSRMResponse && OSRMResponse.data.status.toUpperCase() === "OK")
          {
            let addressFound = OSRMResponse.data.results[0];
            let selectedAddressContext = addressFound.formatted_address;
            setReturnAddr(selectedAddressContext);
            setStopPOI(e.target.textContent);
            setInputSuggestionListReturn("");
            mapPointReturnSelection.current = {data: {address: e.target.title, POI: e.target.textContent}};
            mapPointReturnSelection.current["Type"] = "poi";
            returnLatLng.current = addressFound.geometry.location.lat+","+addressFound.geometry.location.lng;
          }
        }
      }
    }
    catch(err){console.log(err);}
  };

  const handleDOSuggestionClicked = async (e) => {
    try{ 
      let PULatLng = e.target.dataset.virtual;
      let correctDate = formatDate(selectedDateSchTime);
      if(PULatLng.split(",")[0] !== "0" && PULatLng.split(",")[0] !== "")
      { 
        let selectedIndex = e.target.getAttribute('index');
        let poiSelected = e.target.getAttribute('poisuggestion')
        let selectedIndexAddressComponent = "";
        let indexType = "";
        if(selectedIndex !== undefined && selectedIndex)
        {
          selectedIndex = parseInt(selectedIndex);
          if(selectedIndex >= 0 && liRefDropoffAddressComponenet !== undefined)
          {
            indexType = "manual";
            selectedIndexAddressComponent = liRefDropoffAddressComponenet?.current[selectedIndex];
            mapPointDropoffSelection.current = selectedIndexAddressComponent;
          }
        }
        else if(poiSelected)
        {
          indexType = "poi";
          mapPointDropoffSelection.current = {data: {address: e.target.title, POI: e.target.textContent}};
        }
        else
        {
          let _IsRecentAddressSelected = e.target.getAttribute('isrecentaddress');
          let selectedIndexRecentAddressComponent = "";
          if(_IsRecentAddressSelected !== undefined && _IsRecentAddressSelected){
            let recentaddressindex = e.target.getAttribute('recentaddressindex');
            if(recentaddressindex !== undefined && recentaddressindex){
              recentaddressindex = parseInt(recentaddressindex);
              if(recentaddressindex >= 0 && liRefRecentDropoffAddressComponenet !== undefined){
                indexType = "recent";
                selectedIndexRecentAddressComponent = liRefRecentDropoffAddressComponenet?.current[recentaddressindex];
                mapPointDropoffSelection.current = selectedIndexRecentAddressComponent;
              }
            }
          }
        }
        let selectedAddressContext = (poiSelected ? e.target.title : e.target.textContent);
        let addressDetails = e.target.getAttribute('data-name');
        addressInfoDetails.current.drop = {state:addressDetails.split(",")[1], city: addressDetails.split(",")[0], zip: addressDetails.split(",")[2]};
        mapPointDropoffSelection.current["Type"] = indexType;
        
        setDropAddr(selectedAddressContext);
        setDropPOI((poiSelected? e.target.textContent : ""));
        dropLatLng.current = e.target.dataset.virtual;
        if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2))
        {
          if(fareMethodRef.current === 1)
          {
            setShowAPILoader(true);
            await getFareZone(FSSelected, selectedAff, COSSelected, dropLatLng.current, "drop");
          }
          await getDispatchZone(selectedAff, dropLatLng.current, "drop");
          setShowAPILoader(false);
          addLegBtnRef.current.disabled = false;
        }
        
        let stopMarkersArr = []; //Adding correct map markers and only updating DO marker
        let filteredMapMarkers = mapData.filter((item)=>{
          if(item.Type === "Stop")
          {
            stopMarkersArr.push(item);
          }
          return item.Type === "PU";
        });
        stopMarkersArr.push({lat:parseFloat(dropLatLng.current.split(",")[0]),
          lng: parseFloat(dropLatLng.current.split(",")[1]), Type:"DO", 
          name:(riderName === "" ? "N/A" : riderName.trim()), address: selectedAddressContext
        });
        filteredMapMarkers.push(...stopMarkersArr);

        setMapData(filteredMapMarkers);
        setInputSuggestionListDO("");
        if(pickLatLng.current !== "")
        {
          setIsSchTimeFieldDisabled(false);
          wrapperHandleAddressDetails("DO", selectedAddressContext, pickupAddr, selectedAddressContext, correctDate, schTime);
          if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2))
          {
            wrapperHandleRCZVerification("DO", selectedAddressContext);
          }
        }
      }
      else
      {
        if(e.target.getAttribute('poisuggestion'))
        {
          let myHeaders = new Headers();
          myHeaders.append("Authorization", 'Basic '+btoa(OSRM_Username + ":" + OSRM_Password));
          myHeaders.append('Content-Type', 'application/json');
          let mapBounds = (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "OSRMRectangleBounds")).value.replace(" ", ""); //"&bounds="+mapBounds+
          let addressAPI = ITCMapURL + encodeURIComponent(e.target.title) + "&bounds="+mapBounds+ "&AppType=Web_Reservation";
          let headersObj = headersToObject(myHeaders);
          let OSRMResponse = await APICom.fetchData("full", addressAPI, "get", headersObj, {});
          if(OSRMResponse && OSRMResponse.data.status.toUpperCase() === "OK") 
          {
            let addressFound = OSRMResponse.data.results[0]; //Saving data for use in reservation
            let selectedAddressContext = addressFound.formatted_address;
            let addressDetails = e.target.getAttribute('data-name');
            let stopMarkersArr = []; 
            setDropAddr(selectedAddressContext);
            setDropPOI(e.target.textContent);
            addressInfoDetails.current.drop = {state:addressDetails.split(",")[1], city: addressDetails.split(",")[0], zip: addressDetails.split(",")[2]};
            mapPointDropoffSelection.current = {data: {address: e.target.title, POI: e.target.textContent}};
            mapPointDropoffSelection.current["Type"] = "poi";
            dropLatLng.current = addressFound.geometry.location.lat+","+addressFound.geometry.location.lng;
            if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2)) //Calculate fare and dispatch zone based on selected address
            {
              if(fareMethodRef.current === 1)
              {
                setShowAPILoader(true);
                await getFareZone(FSSelected, selectedAff, COSSelected, dropLatLng.current, "drop");
              }
              await getDispatchZone(selectedAff, dropLatLng.current, "drop");
              setShowAPILoader(false);
              addLegBtnRef.current.disabled = false;
            }
            
            //Adding correct map markers and only updating DO marker
            let filteredMapMarkers = mapData.filter((item)=>{
              if(item.Type === "Stop")
              {
                stopMarkersArr.push(item);
              }
              return item.Type === "PU";
            });
            stopMarkersArr.push({lat:parseFloat(dropLatLng.current.split(",")[0]),
              lng: parseFloat(dropLatLng.current.split(",")[1]), Type:"DO", 
              name:(riderName === "" ? "N/A" : riderName.trim()), address: selectedAddressContext
            });
            filteredMapMarkers.push(...stopMarkersArr);

            setMapData(filteredMapMarkers);
            setInputSuggestionListDO(""); //Making sure suggestions are reset

            if(pickLatLng.current !== "")
            {
              setIsSchTimeFieldDisabled(false);
              wrapperHandleAddressDetails("DO", selectedAddressContext, pickupAddr, selectedAddressContext, correctDate, schTime); //Get distance and time data from PU to DO
              if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2))
              {
                wrapperHandleRCZVerification("DO", selectedAddressContext); //If microtransit trip, initiate RCZ validation
              }
            }
          }
        }
      }
    }
    catch(er){console.log(er);}
  };

  const wrapperHandleFareCalc = async(tripDistance, tripDuration, FSID, CopayFSID, totalWC, totalPax, COSID, AffiliateID, pickupLatLng, Copay, type = "", riderID = "") =>{
    try{
      if(pickupLatLng && pickupLatLng !== "") //Initiate fare calculation API from wrapper. In case of no latlng for PU, set them to 0
      {
        await handleFareCalculation(tripDistance, tripDuration, FSID, CopayFSID, totalWC, totalPax, COSID, AffiliateID, pickupLatLng, Copay, type, riderID);
      }
      else
      {
        let newPickLatLng = "0,0";
        await handleFareCalculation(tripDistance, tripDuration, FSID, CopayFSID, totalWC, totalPax, COSID, AffiliateID, newPickLatLng, Copay, type, riderID);
      }
      if(addLegBtnRef.current.disabled) //Making sure add leg is not disabled
      {
        addLegBtnRef.current.disabled = false;
      }
    }
    catch(err){console.log(err);}
  };

  const wrapperHandleRCZVerification = async (type, actualAddr, addr2 = " ") => {
    try {
      await handleRCZVerification(type, actualAddr, addr2); //Initiate RCZ validation from wrapper function
    } catch(err) {console.log(err)}
  };

  const handleGetFareCalcMethod = async (FundingSourceID, AffiliateID, ClassOfServiceID) => {
    try{
      let data = {
        "FundingSourceID": parseInt(FundingSourceID),
        "AffiliateID": parseInt(AffiliateID),
        "ClassOfServiceID": parseInt(ClassOfServiceID)
      }
      xCancelSourceForGrid.current = APICom.GenerateSource(); //GetFareCalcMethod which is called on every aff, page load, FS, and class of service change
      let response = await APICom.fetchData("ReservationCoreURL","api/ParatransitCT/GetFareCalculationMethod", "post", 
        {'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
        'mode': 'no-cors'}, data, xCancelSourceForGrid.current
      );

      if(paratransitBookBtnRef.current.disabled){paratransitBookBtnRef.current.disabled = false; addLegBtnRef.current.disabled = false;}
      if(response.error.length === 0)
      {
        if(response.data.httpResponseCode === 200)
        {
          let faremethod = response.data.fareMethod;
          setFareMethod(faremethod);
          fareMethodRef.current = faremethod; //Gives a fare method value 0/1 which determines if fare zone is necessary
        }
        else
        {
          setModalHeaderText("Fare Method Calculation Failed");
          setModalBodyHTML("The following error occured for fare method calculation: " + response.data.exceptionMessage);
          setModalFooterHTML(
            <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
          setShowDynamicModal(true);
          setFareMethod(0);
          fareMethodRef.current = 0;
        }
      }
      else
      {
        setFareMethod(0);
        fareMethodRef.current = 0;
      }
    }
    catch(err){console.log(err);}
  };

  const getFareZone = async (FundingSourceID, AffiliateID, ClassOfServiceID, Latlng, type) => {
    try{
      let data = {
        "FundingSourceID": parseInt(FundingSourceID),
        "AffiliateID": parseInt(AffiliateID),
        "ClassOfServiceID": parseInt(ClassOfServiceID),
        "Latitude": parseFloat(Latlng.split(",")[0]),
        "Longitude": parseFloat(Latlng.split(",")[1])
      }
      xCancelSourceForGrid.current = APICom.GenerateSource();
      let response = await APICom.fetchData("ReservationCoreURL","api/ParatransitCT/GetFareZone", "post", 
        {'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
        'mode': 'no-cors'}, data, xCancelSourceForGrid.current
      );

      addLegBtnRef.current.disabled = true;
      if(response.error.length === 0)
      {
        if(response.data.httpResponseCode === 200)
        {
          if(type === "pick") //Depending on type of fare zone (PU/DO), map them to correct reference and useState vars
          {
            setFareZones(prevState=>({...prevState, pick:response.data.zone}));
            fareZonesRef.current.pickFareZone = response.data.zone;
          }
          else
          {
            setFareZones(prevState=>({...prevState, drop:response.data.zone}));
            fareZonesRef.current.dropFareZone = response.data.zone;
          }
        }
        else
        {
          setModalHeaderText("Fare Zone Calculation Failed");
          setModalBodyHTML("The following error occured for fare zone calculation: " + response.data.exceptionMessage);
          setModalFooterHTML(
            <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
          setShowDynamicModal(true);
          setFareZones({pick:"", drop:""});
          fareZonesRef.current = {pickFareZone:"", dropFareZone:""};
        }
      }
      else
      {
        setModalHeaderText("Fare Zone Calculation Failed");
        setModalBodyHTML(response.error);
        setModalFooterHTML(
          <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
            OK
          </Button>
        );
        setShowDynamicModal(true);
        setFareZones({pick:"", drop:""});
        fareZonesRef.current = {pickFareZone:"", dropFareZone:""};
      }
    }
    catch(err){console.log(err);}
  };

  const getDispatchZone = async (AffiliateID, Latlng, type) => { //Get dispatch zone of a selected address
    try{
      let data = {
        "AffiliateID": parseInt(AffiliateID),
        "Latitude": parseFloat(Latlng.split(",")[0]),
        "Longitude": parseFloat(Latlng.split(",")[1])
      }
      xCancelSourceForGrid.current = APICom.GenerateSource();
      let response = await APICom.fetchData("ReservationCoreURL","api/ParatransitCT/GetDispatchZone", "post", 
        {'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
        'mode': 'no-cors'}, data, xCancelSourceForGrid.current
      );

      if(response.error.length === 0)
      {
        if(response.data.httpResponseCode === 200)
        {
          if(type === "pick")
          {
            setDispatchZones(prevState=>({...prevState, pickZone:response.data.zone}));
          }
          else
          {
            setDispatchZones(prevState=>({...prevState, dropZone:response.data.zone}));
          }
        }
        else
        {
          setModalHeaderText("Dispatch Zone Calculation Failed");
          setModalBodyHTML("The following error occured for dispatch zone calculation: " + response.data.exceptionMessage);
          setModalFooterHTML(
            <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
          setShowDynamicModal(true);
          setDispatchZones({pickZone:"", dropZone:""});
        }
      }
      else
      {
        setModalHeaderText("Dispatch Zone Calculation Failed");
        setModalBodyHTML(response.error);
        setModalFooterHTML(
          <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
            OK
          </Button>
        );
        setShowDynamicModal(true);
        setDispatchZones({pickZone:"", dropZone:""});
      }
    }
    catch(err){console.log(err);}
  };

  const getFareDataResponse = async (tripDistance, tripDuration, FSID, CopayFSID, totalWC, totalPax, COSID, AffiliateID, pickupLatLng, Copay, riderID = 0) => {
    try{
      let clientID = (medID ? String(medID) : "-1");
      let tspidVal = AffiliateData.find(item=>item.AffiliateID === parseInt(AffiliateID));
      let data = {
        "distance": parseFloat(tripDistance),
        "travelTime": parseFloat(tripDuration),
        "fundingSourceID": parseInt(FSID),
        "copay": parseFloat(Copay),
        "numberOfWheelchairs": parseInt(totalWC),
        "numberOfPassengers": parseInt(totalPax),
        "classOfServiceID": parseInt(COSID),
        "affiliateID": parseInt(AffiliateID),
        "pickupLatitude": parseFloat(pickupLatLng.split(",")[0]),
        "pickupLongitude": parseFloat(pickupLatLng.split(",")[1]),
        "copayFundingSourceID": parseInt(CopayFSID),
        "riderID": (riderID !== 0 ? riderID : clientID),
        "authorizedStaff": "",
        "startFareZone": fareZonesRef.current.pickFareZone,
        "endFareZone": fareZonesRef.current.dropFareZone,
        "tspid": (tspidVal ? String(tspidVal.iOutTSPID) : ""),
        "httpResponseCode": 200
      }
      setModalHeaderText("Get Fare Estimate Processing");
      setModalBodyHTML("Please wait...");
      setModalFooterHTML(
        <>
          <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
            OK
          </Button>
        </>
      );
      setShowDynamicModal(true);
      setModalClass("d-none");
      setShowAPILoader(true);
      xCancelSourceForGrid.current = APICom.GenerateSource();
      let response = await APICom.fetchData("ReservationCoreURL","api/ParatransitCT/GetFareEstimate", "post", 
        {'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
        'mode': 'no-cors'}, data, xCancelSourceForGrid.current
      );

      if(response.error.length === 0 && response.data.httpResponseCode === 200)
      {
        let dataDict = response.data;
        setRiderVerification(dataDict.riderVerificationStatus.trim()); //Display found rider ID status (only shows if FS and Aff are brokers)
        if(dataDict.verifyStatus === "false")
          setSearchButtonValidation(dataDict.displayMessage);
        else 
          setSearchButtonValidation("");
        setFareEstimateAPISummary({copay: parseInt(dataDict.copayPrice), 
          walletID: parseInt(dataDict.eaaSWalletFSID), promo: dataDict.promoCode, eaasJSON: dataDict.vJSON, 
          displayMessage: dataDict.displayMessage, verifyStatus: dataDict.verifyStatus
        });
        setShowDynamicModal(false);
        setModalClass("");
        setShowAPILoader(false);
        return response.data;
      }
      else
      {
        setRiderVerification("");
        setSearchButtonValidation("");
        setFareEstimateAPISummary({copay: 0, walletID: 0, promo: "", eaasJSON: "", displayMessage: "", verifyStatus: ""});
        setShowDynamicModal(false);
        setModalClass("");
        setShowAPILoader(false);
        return [];
      }
    }
    catch(err){console.log(err);}
  };

  const handleFareCalculation = async (tripDistance, tripDuration, FSID, CopayFSID, totalWC, totalPax, COSID, AffiliateID, pickupLatLng, Copay, type = "", riderID = "") => {
    try{
      //Function to get the fare estimate at the end of reservation process (when addresses are entered)
      let clientID = (medID ? String(medID) : riderID); //If medical ID exists, use that, otherwise use riderID given in parameter
      let tspidVal = AffiliateData.find(item=>item.AffiliateID === parseInt(AffiliateID)); //Get the correct TSPID for estimate
      let data = {
        "distance": parseFloat(tripDistance),
        "travelTime": parseFloat(tripDuration),
        "fundingSourceID": parseInt(FSID),
        "copay": parseFloat(Copay),
        "numberOfWheelchairs": parseInt(totalWC),
        "numberOfPassengers": parseInt(totalPax),
        "classOfServiceID": parseInt(COSID),
        "affiliateID": parseInt(AffiliateID),
        "pickupLatitude": parseFloat(pickupLatLng.split(",")[0]),
        "pickupLongitude": parseFloat(pickupLatLng.split(",")[1]),
        "copayFundingSourceID": parseInt(CopayFSID),
        "riderID": (riderID !== ""? riderID : clientID),
        "authorizedStaff": "",
        "startFareZone": fareZonesRef.current.pickFareZone,
        "endFareZone": fareZonesRef.current.dropFareZone,
        "tspid": (tspidVal ? String(tspidVal.iOutTSPID) : ""),
        "httpResponseCode": 200
      }
      setModalHeaderText("Get Fare Estimate Processing");
      setModalBodyHTML("Please wait...");
      setModalFooterHTML(
        <>
          <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
            OK
          </Button>
        </>
      );
      setShowDynamicModal(true);
      setModalClass("d-none");
      setShowAPILoader(true);
      xCancelSourceForGrid.current = APICom.GenerateSource();
      let response = await APICom.fetchData("ReservationCoreURL","api/ParatransitCT/GetFareEstimate", "post", 
        {'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
        'mode': 'no-cors'}, data, xCancelSourceForGrid.current
      );

      if(response.error.length === 0)
      {
        if(response.data.httpResponseCode === 200)
        {
          let dataDict = response.data;
          setRiderVerification(dataDict.riderVerificationStatus.trim()); //Display found rider ID status (only shows if FS and Aff are brokers)
          if(dataDict.verifyStatus === "false") //Display alert message in red on top if rider ID is rejected (only shows if FS and Aff are brokers)
            setSearchButtonValidation(dataDict.displayMessage);
          else 
            setSearchButtonValidation("");
          setFareEstimateAPISummary({copay: parseInt(dataDict.copayPrice), 
            walletID: parseInt(dataDict.eaaSWalletFSID), promo: dataDict.promoCode, eaasJSON: dataDict.vJSON, 
            displayMessage: dataDict.displayMessage, verifyStatus: dataDict.verifyStatus
          }); //Save all rider ID fare details for reservation use in a useState var
          let fareData = response.data;
          setFareDataArr(fareData); //Set all fare related data on a useState var for use in reservation
          if(type === "")
          {
            setClientSummary(prevState=>({...prevState, 
              TripFare:fareData.totalCost, TripCopay:fareData.copay
            }));
            setCopayAmount(fareData.copay); //Set the copay and cost to correct values from API
          }
          setShowDynamicModal(false);
          setModalClass("");
          setShowAPILoader(false);
        }
        else
        {
          setModalClass("");
          setShowAPILoader(false);
          setModalHeaderText("Fare Calculation Failed");
          setModalBodyHTML("Error code: "+ response.data.httpResponseCode+ " Please contact the admin office for help.");
          setModalFooterHTML(
            <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
          setRiderVerification("");
          setSearchButtonValidation("");
          setFareEstimateAPISummary({copay: 0, walletID: 0, promo: "", eaasJSON: "", displayMessage: "", verifyStatus: ""});
        }
      }
      else
      {
        setModalClass("");
        setShowAPILoader(false);
        setModalHeaderText("Fare Calculation Failed");
        setModalBodyHTML(response.error);
        setModalFooterHTML(
          <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
            OK
          </Button>
        );
        setRiderVerification("");
        setSearchButtonValidation("");
        setFareEstimateAPISummary({copay: 0, walletID: 0, promo: "", eaasJSON: "", displayMessage: "", verifyStatus: ""});
      }
    }
    catch(err){console.log(err);}
  };

  const handleRCZVerification = async (type, actualAddr, addr2 = " ") => {
    try{
      let data = {};
      let verifiedDropAddr = (dropAddr === ""? "123 Main St, Annapolis, MD 21401":dropAddr);
      let verifiedPUAddr =  (pickupAddr === ""? "123 Main St, Annapolis, MD 21401":pickupAddr);
      let pickCity = "";
      let pickState = "";
      let pickZip = "";
      let pickStreet = "";
      let dropCity = "";
      let dropState = "";
      let dropZip = "";
      let dropStreet = "";
      let combinedDataAddedTime = (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "Ta01")).value;
      let userEnteredPickupAddress = prepareDataForAddress(mapPointPickupSelection, "pickup");
      let userEnteredDropoffAddress = prepareDataForAddress(mapPointDropoffSelection, "dropoff"); //Populating the info for manually entered addresses
      bookBtnRef.current.disabled = true;

      if(!userEnteredPickupAddress.street || userEnteredPickupAddress.street === "")
      {
        userEnteredPickupAddress.street = pickupAddr;
      }

      if(pickupVirtualStop?.value && pickupVirtualStop?.value !== ""){
        try {
          const virtualStopData = VirtualStopsData.find(p => p.ID === pickupVirtualStop.value);
          if(virtualStopData){
            userEnteredPickupAddress.city = userEnteredPickupAddress.city || virtualStopData.City || "";
            userEnteredPickupAddress.state = userEnteredPickupAddress.state || virtualStopData.State || "";
            userEnteredPickupAddress.zip = userEnteredPickupAddress.zip || virtualStopData.Zipcode || "";
          }
        } catch (error) { }
      }

      if(!userEnteredDropoffAddress.street || userEnteredDropoffAddress.street === "")
      {
        userEnteredDropoffAddress.street = dropAddr;
      }

      if(dropAddrVirtualStop?.value && dropAddrVirtualStop?.value !== ""){
        try {
          const virtualStopData = VirtualStopsData.find(p => p.ID === dropAddrVirtualStop.value);
          if(virtualStopData){
            userEnteredDropoffAddress.city = userEnteredDropoffAddress.city || virtualStopData.City || "";
            userEnteredDropoffAddress.state = userEnteredDropoffAddress.state || virtualStopData.State || "";
            userEnteredDropoffAddress.zip = userEnteredDropoffAddress.zip || virtualStopData.Zipcode || "";
          }
        } catch (error) { }
      }

      data = {
        "Ta01": (combinedDataAddedTime? combinedDataAddedTime:0),
        "iAffiliateID": parseInt(selectedAff),
        "vPULatitude": pickLatLng.current.split(",")[0],
        "vPULongitude": pickLatLng.current.split(",")[1],
        "vDOLatitude": dropLatLng.current.split(",")[0],
        "vDOLongitude": dropLatLng.current.split(",")[1],
        "dtPickupDateTime": "01/01/1900 00:00:00",
        "dEstimatedTime": 0.0,
        "RCZList": "",
        "ErrorMessage": "",
        "PUDONearbyVS" : {
          "userid": loginData.iUserID,
          "brandid": "3",
          "iAffiliateID": parseInt(selectedAff),
          "pulocation": "",
          "pustreet": pickStreet,
          "pucity": pickCity,
          "pustate": pickState,
          "puzip": pickZip,
          "puaddress": (type === "PU" ? actualAddr : verifiedPUAddr),
          "puinstruction": pickExtraInfo,
          "pulatitude": pickLatLng.current.split(",")[0],
          "pulongitude": pickLatLng.current.split(",")[1],
          "dolocation": "",
          "dostreet": dropStreet,
          "docity": dropCity,
          "dostate": dropState,
          "dozip": dropZip,
          "doaddress": (type === "PU"? verifiedDropAddr : actualAddr),
          "doinstruction": dropExtraInfo,
          "dolatitude": dropLatLng.current.split(",")[0],
          "dolongitude": dropLatLng.current.split(",")[1]
        },
        "vPUStreetAddress": (userEnteredPickupAddress?.street || ""), 
        "vPUCity": (userEnteredPickupAddress?.city || ""), 
        "vPUState": (userEnteredPickupAddress?.state || ""), 
        "vPUZip": (userEnteredPickupAddress?.zip || ""), 
        "vDOStreetAddress": (userEnteredDropoffAddress?.street || ""), 
        "vDOCity": (userEnteredDropoffAddress?.city || ""), 
        "vDOState": (userEnteredDropoffAddress?.state || ""),
        "vDOZip": (userEnteredDropoffAddress?.zip || ""), 
        "iAppID": iAppID, 
        "iUserID": String(loginData.iUserID),
        "vPUStopName": (pickupVirtualStop.name !== "" ? pickupVirtualStop.name : puVSValueChanged.current),
        "vDOStopName": (dropAddrVirtualStop.name !== "" ? dropAddrVirtualStop.name : doVSValueChanged.current),
        "vCustomerPhone": phone,
        "vCustomerName": riderName
      };
      setModalHeaderText("Validation");
      setModalBodyHTML("Please wait for the validation...");
      setModalFooterHTML("");
      setModalClass("d-none");
      setShowDynamicModal(true);
      xCancelSourceForGrid.current = APICom.GenerateSource(); //Validate RCZ
      setShowAPILoader(true);
      let response = await APICom.fetchData("ReservationCoreURL","ValidateRCZ", "post", 
        {'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
        'mode': 'no-cors'}, data, xCancelSourceForGrid.current
      );
      if(response.error.length === 0)
      {
        let errorMsg  = response.data.errorMessage;
        let responseMsg = response.data.responseMessage;
        if(responseMsg && responseMsg !== "")
        {
          setModalHeaderText("RCZ Verification Error");
          setModalBodyHTML(responseMsg);
          setModalFooterHTML(
            <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
          setModalClass("");
          setShowDynamicModal(true);
          setZones("");
          setShowAPILoader(false);
        }
        else if(errorMsg && errorMsg !== "")
        {
          setModalHeaderText("RCZ Verification Error");
          setModalBodyHTML(errorMsg);
          setModalFooterHTML(
            <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
          setModalClass("");
          setShowDynamicModal(true);
          setZones("");
          setShowAPILoader(false);
        }
        else
        {
          //Work after verification
          if(pickLatLng.current === dropLatLng.current) //Check for duplicate addresses
          {
            setShowAPILoader(false);
            setModalHeaderText("Identical Address Selection Error");
            setModalBodyHTML("Please select two different addresses to continue.");
            setModalFooterHTML(
              <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                OK
              </Button>
            );
            setModalClass("");
            setShowDynamicModal(true);
          }
          else
          {
            if(response.data.pudoNearbyVS.pvs && response.data.pudoNearbyVS.dvs)
            {
              let tripLatLng = []; //starts with given address, second is PU VS, third is DO VS, and final is the given destination
              let matchedDataPUVS = "";
              let matchedDataDOVS = "";
              setModalClass("");
              setShowDynamicModal(false);
              setShowAPILoader(false);
              setRczVerifData(response.data);
              bookBtnRef.current.disabled = false;
              if(response.data.rczList)
              {
                setZones(response.data.rczList); //Set zones to correct rcz after validation
              }
              //Get the markers for provided addresses along with any walk markers if needed
              tripLatLng.push(
                (response.data.pudoNearbyVS.pvs.latitude !== response.data.pudoNearbyVS.pu.latitude && response.data.pudoNearbyVS.pvs.longitude !== response.data.pudoNearbyVS.pu.longitude
                ? {lat:parseFloat((pickLatLng.current.split(",")[0])),
                  lng: parseFloat((pickLatLng.current.split(",")[1])), Type:"Walk", 
                  name:(riderName === "" ? "N/A" : riderName.trim()), 
                  address:(type === "PU"? actualAddr:(pickupAddr === ""? addr2:pickupAddr))
                }:{lat:"",
                lng: "", Type:"Walk", 
                name:(riderName === "" ? "N/A" : riderName.trim()), 
                address:(type === "PU"? actualAddr:(pickupAddr === ""? addr2:pickupAddr))
                }),
                {lat: (parseFloat(response.data.pudoNearbyVS.pvs.latitude)),
                  lng: (parseFloat(response.data.pudoNearbyVS.pvs.longitude)), Type:"PU", 
                  name:(riderName === "" ? "N/A" : riderName.trim()), 
                  address:(response.data.pudoNearbyVS.pvs.address)
                },
                {lat:(parseFloat(response.data.pudoNearbyVS.dvs.latitude)),
                  lng: (parseFloat(response.data.pudoNearbyVS.dvs.longitude)), Type:"DO", 
                  name:(riderName === "" ? "N/A" : riderName.trim()), 
                  address:(response.data.pudoNearbyVS.dvs.address)
                },
                (response.data.pudoNearbyVS.dvs.latitude !== response.data.pudoNearbyVS.do.latitude && response.data.pudoNearbyVS.dvs.longitude !== response.data.pudoNearbyVS.do.longitude
                ? {lat:parseFloat((dropLatLng.current.split(",")[0])),
                  lng: parseFloat((dropLatLng.current.split(",")[1])), Type:"Drop", 
                  name:(riderName === "" ? "N/A" : riderName.trim()), 
                  address:(type === "DO"? actualAddr:(dropAddr === ""?addr2:dropAddr))
                }:{lat:"",
                lng: "", Type:"Drop", 
                name:(riderName === "" ? "N/A" : riderName.trim()), 
                address:(type === "DO"? actualAddr:(dropAddr === ""?addr2:dropAddr))
                }),
              );
              
              //Loop to get correct virtual stops from dropdowns for selecting and distance calculation
              for(let k = 0; k < VirtualStopsData.length; k++) 
              {
                if(parseInt(selectedAff) === parseInt(VirtualStopsData[k].iSATSPID))
                {
                  if(response.data.pudoNearbyVS.pvs && String(response.data.pudoNearbyVS.pvs.id) === String(VirtualStopsData[k].ID))
                  {
                    matchedDataPUVS = VirtualStopsData[k].Location+"$"+VirtualStopsData[k].ID;
                  }
                  if(response.data.pudoNearbyVS.dvs && String(response.data.pudoNearbyVS.dvs.id) === String(VirtualStopsData[k].ID))
                  {
                    matchedDataDOVS = VirtualStopsData[k].Location+"$"+VirtualStopsData[k].ID;
                  }
                }
              }

              if(response.data.pudoNearbyVS.pvs) { //Calculate walk distance for given PU VS
                setPickupVirtualStop((matchedDataPUVS === "" ? {...pickupVirtualStop, value:"PU VS", name:""}
                :{...pickupVirtualStop, value:matchedDataPUVS.split("$")[1], name:matchedDataPUVS.split("$")[0]})); 
                let pickLatLng = response.data.pudoNearbyVS.pvs.latitude+","+response.data.pudoNearbyVS.pvs.longitude;
                await handleWalkDistanceCalculation("PU", pickLatLng);
              }
              
              if(response.data.pudoNearbyVS.dvs) { //Calculate walk distance for given DO VS
                setDropAddrVirtualStop((matchedDataDOVS === "" ? {...dropAddrVirtualStop, value:"DO VS", name:""}
                :{...dropAddrVirtualStop, value:matchedDataDOVS.split("$")[1], name:matchedDataDOVS.split("$")[0]}));
                let dropLatLng = response.data.pudoNearbyVS.dvs.latitude+","+response.data.pudoNearbyVS.dvs.longitude;
                await handleWalkDistanceCalculation("DO", dropLatLng);
              }
              vsChangeRef.current.type = "";
              setMapData(tripLatLng);
            }
            else if (response.data.pudoNearbyVS.responseCode !== 200 && response.data.pudoNearbyVS.responseMessage !== "")
            {
              setModalHeaderText("Validation");
              setModalBodyHTML(response.data.pudoNearbyVS.responseMessage);
              setModalFooterHTML(
                <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                  OK
                </Button>
              );
              setModalClass("");
              setShowDynamicModal(true);
              setZones("");
              setShowAPILoader(false);
            }
            else
            {
              setModalHeaderText("No Virtual Stop Assigned");
              setModalBodyHTML("The verification process could not provide virtual stops for the given addresses. Please try again.");
              setModalFooterHTML(
                <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                  OK
                </Button>
              );
              setModalClass("");
              setShowDynamicModal(true);
              setZones("");
              setShowAPILoader(false);
            }
          } 
        }
      }
      else
      {
        setModalHeaderText("RCZ Verification Failed");
        setModalBodyHTML(response.error);
        setModalFooterHTML(
          <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
            OK
          </Button>
        );
        setModalClass("");
        setShowDynamicModal(true);
        setShowAPILoader(false);
      }
    }
    catch(err){console.log(err);}
  };

  const handleBlurRiderID = async (e) => { //Called when rider ID is out of focus to check elgibility
    try{
      let LatLng = (pickLatLng.current === "" ? "0,0" : pickLatLng.current);
      let response = await getFareDataResponse(0, 0, 
        FSSelected, copayFSSelected, passengerTypeCount.totalWC, passengerTypeCount.total, 
        COSSelected, selectedAff, LatLng, copayAmount, e.target.value
      );
    }
    catch(err){console.log(err);}
  };

  const wrapperHandleAddressDetails = async(type, data, addrVerfPU, addrVerfDO, addrVerfDate, addrVerfTime)=>{ //wrapper for drive distance & duration API
    try {
      await handleAddressDetails(type, data, addrVerfPU, addrVerfDO, addrVerfDate, addrVerfTime);
    } catch (err) {console.log(err);}
  }

  const handleAddressDetails = async(type, data, addrVerfPU, addrVerfDO, addrVerfDate, addrVerfTime)=>{
    try{
      //OSRM API to get distance & duration of two points (PU/DO) while recalculating fare estimate and saving trip details for use in multi-trip
      const OSRM_TIME = (ASCSSettingData ? (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "OSRM_Time")).value : 1);
      if(type === "PU")
      {
        let addressAPI = ITCMapDirections + "?origin=" + pickLatLng.current + "&destination=" + dropLatLng.current + "&AppType=calltaker"; //"&bounds=" + mapBounds+ 
        let OSRMResponse = await APICom.fetchData("full", addressAPI, "get", {
          'Authorization': 'Basic '+btoa(OSRM_Username + ":" + OSRM_Password),
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'mode': 'no-cors'
        }, {});

        if(OSRMResponse && OSRMResponse.data.status.toUpperCase() === "OK")
        {
          let distanceInMeters = OSRMResponse.data.routes[0].legs[0].distance.value;
          let durationInSeconds = OSRMResponse.data.routes[0].legs[0].duration.value;
          let TimeCalculated = ((parseInt(durationInSeconds)/60) * OSRM_TIME);
          let distance = parseFloat(parseFloat(distanceInMeters)/1609).toFixed(1);
          let duration = Math.round(parseFloat(TimeCalculated));
          setClientSummary(prevState=>({...prevState, 
            tripDistance: distance, TripDuration:duration
          }));
          if(addrVerfTime === "" && verifiedAddr.length === 0){addrVerfTime = systemDateTimeRef.current.time}
          setTripDetails({...tripDetails, pickAddr: addrVerfPU, dropAddr: addrVerfDO, date: addrVerfDate, time: addrVerfTime, distance: distance, duration: duration,
            fare: 0, copay: 0, waitTime:"",
            willCall: willCall, apptTime: appointmentTime, notes:agentNotes, phone:callBackPhone, puNotes:pickExtraInfo, doNotes:dropExtraInfo, 
            riderName:riderName, passCount: passengerTypeCount
          });
          if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2))
          {
            wrapperHandleFareCalc(distance, duration, FSSelected, copayFSSelected, passengerTypeCount.totalWC, passengerTypeCount.total, COSSelected, selectedAff, pickLatLng.current, copayAmount);
          }
        }
        else if(OSRMResponse.data.status.toUpperCase().includes("EXCEEDED"))
        {
          setModalHeaderText("Directions Alert");
          setModalBodyHTML(OSRMResponse.data.status);
          setModalFooterHTML(
            <>
            <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
              OK
            </Button>
            </>
          );
          setShowDynamicModal(true);
        }
      }
      else
      {
        let addressAPI = ITCMapDirections + "?origin=" + pickLatLng.current + "&destination=" + dropLatLng.current + "&AppType=calltaker"; //"&bounds=" + mapBounds+ 
        let OSRMResponse = await APICom.fetchData("full", addressAPI, "get", {
          'Authorization': 'Basic '+btoa(OSRM_Username + ":" + OSRM_Password),
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'mode': 'no-cors'
        }, {});

        if(OSRMResponse && OSRMResponse.data.status.toUpperCase() === "OK")
        {
          let distanceInMeters = OSRMResponse.data.routes[0].legs[0].distance.value;
          let durationInSeconds = OSRMResponse.data.routes[0].legs[0].duration.value;
          let TimeCalculated = ((parseInt(durationInSeconds)/60) * OSRM_TIME);
          let distance = parseFloat(parseFloat(distanceInMeters)/1609).toFixed(1);
          let duration = Math.round(parseFloat(TimeCalculated));
          setClientSummary(prevState=>({...prevState, 
            tripDistance: distance, TripDuration:duration
          }));
          if(addrVerfTime === "" && verifiedAddr.length === 0){addrVerfTime = systemDateTimeRef.current.time}
          setTripDetails({...tripDetails, pickAddr: addrVerfPU, dropAddr: addrVerfDO, date: addrVerfDate, time: addrVerfTime, distance: distance, duration: duration,
            fare: 0, copay: 0, waitTime:"",
            willCall: willCall, apptTime: appointmentTime, notes:agentNotes, phone:callBackPhone, puNotes:pickExtraInfo, doNotes:dropExtraInfo,
            riderName:riderName, passCount: passengerTypeCount
          });
          if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2))
          {
            wrapperHandleFareCalc(distance, duration, FSSelected, copayFSSelected, passengerTypeCount.totalWC, passengerTypeCount.total, COSSelected, selectedAff, pickLatLng.current, copayAmount);
          }
        }
        else if(OSRMResponse.data.status.toUpperCase().includes("EXCEEDED"))
        {
          setModalHeaderText("Directions Alert");
          setModalBodyHTML(OSRMResponse.data.status);
          setModalFooterHTML(
            <>
            <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
              OK
            </Button>
            </>
          );
          setShowDynamicModal(true);
        }
      }
      
    }
    catch(err){console.log(err);}
  };

  const handleAffChange = (e)=>{
    try{
      setSchTime("");  //Upon affiliate change on call taker, only have client Info open, reset PU time and other parameters, get new aff data and populate it for all dropdowns
      setSchPUTimeDisplay(false);
      setReturnTripDisplay(false);
      setDriverVehInfoDisplay(false);
      setPaymentDetailsDisplay(false);
      setAdditionalDetailsDisplay(false);
      setInsuranceInfoDisplay(false);
      transitTypeRef.current = AffiliateData.filter((item,index) => {
        try{
          return parseInt(item.AffiliateID) === parseInt(e.target.value);
        }
        catch(err){console.log(err);}
      });
      const dynamicCallAgentHeight = (transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2)
        ? { height: "396px", maxHeight: "396px" }
        : { height: `calc(100vh - 125px)` }; //Creating dynamic style for main two columns on call taker to avoid repetition
      const rowContainerDynamicHeight = (transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2)
        ? { marginLeft: "10%", marginRight:"10%", boxShadow:"-2px 0px 3px #999, 2px 0px 3px #999" }
        : { height: `calc(100vh - 125px)`, marginLeft: "10%", marginRight:"10%", boxShadow:"-2px 0px 3px #999, 2px 0px 3px #999" };
      
      let vehData = (DispatchVehicleData[parseInt(e.target.value)] && DispatchVehicleData[parseInt(e.target.value)] !== ""? DispatchVehicleData[parseInt(e.target.value)]: []);
      let vehNum = (vehData.length !== 0 ? handleDuplicates(JSON.parse(vehData), "VehicleNumber") : []);
      let vehType = (vehData.length !== 0 ? handleDuplicates(JSON.parse(vehData), "VehicleType") : []);
      let driverNum = DispatchDriverData[parseInt(e.target.value)] ? JSON.parse(DispatchDriverData[parseInt(e.target.value)]) : [];
      let languageTypes = ["English", "Spanish", "Chinese", "Tagalog", "Vietnamese", "Arabic", "French", "Korean", "Russian", "Haitian Creole",
        "Hindi", "Portuguese", "Italian", "Polish", "Urdu", "Japanese", "Persian", "Gujarati", "Telugu", "Bengali", "Greek", "Punjabi", "Tamil", 
        "Armenian", "Serbo-Croatian", "Hebrew"];
      let languageOptions = languageTypes.map(function(item, index){
        return(
          <option key={index} value={(index+1)}>{item}</option>
        );
      })
      let vehicleNumOptionsHTML = vehNum.map(function(item, index){
        return(
            <option key={index} value={item.VehicleID+"_"+item.VehicleNumber}>{item.VehicleNumber}</option>
        );
      });
      let vehicleTypeOptionsHTML = vehType.map(function(item, index){
        if(item.VehicleType !== null && item.VehicleType.toUpperCase() !== "TESTTYPE")
        {
          return(
            <option key={index} value={item.iVTypeID} data-virtual={item.MaxWheelChairs}>{item.VehicleType}</option>
          );
        }
      });
      let driverNumberOptionsHTML = driverNum.map(function(item, index){
        return(
          <option key={index} value={item.DriverID+"_"+item.DriverNumber}>{item.DriverNumber}</option>
        );
      });
      vehicleTypeOptionsHTML.unshift(<option key={333} value={"VT"}>{"None"}</option>);
      vehicleNumOptionsHTML.unshift(<option key={444} value={"VN"}>{"None"}</option>);
      driverNumberOptionsHTML.unshift(<option key={555} value={"DN"}>{"None"}</option>);
      languageOptions.unshift(<option key={666} value={"Language"}>{"None"}</option>);
      let attrSelection = AttributeData ? AttributeData.filter((item,index)=> {return parseInt(item.iAttrATSPID) === parseInt(e.target.value)}) : [];
      let fsSelection = FundingSourceData[parseInt(e.target.value)] && FundingSourceData[parseInt(e.target.value)] !== undefined ? JSON.parse(FundingSourceData[parseInt(e.target.value)]) : [];
      let cosSelection = ClassOfServiceData[parseInt(e.target.value)] && ClassOfServiceData[parseInt(e.target.value)] !== undefined ? JSON.parse(ClassOfServiceData[parseInt(e.target.value)]) : [];
      let paySelection = PaymentTypesData[parseInt(e.target.value)] && PaymentTypesData[parseInt(e.target.value)] !== undefined ? JSON.parse(PaymentTypesData[parseInt(e.target.value)]) : [];
      let copayFSSetting = (ASCSSettingData[parseInt(e.target.value)] ? (JSON.parse(ASCSSettingData[parseInt(e.target.value)]).find((item) => item.SubTitle === "CopayFSID_List")).value : "");
      let ASCSGlobalBrokerMode = (ASCSSettingData[parseInt(e.target.value)] ? 
        (JSON.parse(ASCSSettingData[parseInt(e.target.value)]).find((item) => item.SubTitle === "BrokerMode")).value : 0
      );
      let fundingSourceTarget = "";
      let uniqueID = clientInfo && !Array.isArray(clientInfo) ? parseInt(e.target.value) : 0;
      let selectedAffVS = [];
      let attrOptionsMultiSelAff = attrSelection && attrSelection.length > 0 ? attrSelection.map((item)=>{
        let dict = {};
        dict.id = item.ID;
        dict.name = item.Title;
        return dict;
      }).sort((a, b) => a.name.localeCompare(b.name)) : [];
      let cosOptionsHTML = cosSelection.map((item, index)=>{
        return(
          <option key={index} value={item.iClassOfServiceID}>
            {item.vClassName}
          </option>
        );
      });
      let payOptionsHTML = paySelection.map((item, index)=>{
        if(index === 0)
        {
          setPayTargetID(item.iID);
          setCopayPayTypeSelected(item.iID);
          setPaySelected(item.iID);
        }
        if(item.vName !== "" && item.vName !== "-" && !item.vName.toLowerCase().includes("unused") && !item.vName.toLowerCase().includes("wallet") && item.bActive)
        {
          return(
            <option key={index} value={item.iID}>
              {item.vName}
            </option>
          );
        }
      });
      let fsOptionsHTML = fsSelection.map((item, index)=>{
        if((item.AccountID.toLowerCase().includes("self") || item.AccountID.toLowerCase().includes("cash")) || parseInt(item.FID) === 1)
        {
          setBrokerModes({globalBrokerMode: ASCSGlobalBrokerMode, brokerMode: item.BrokerMode}); 
          setFSSelected(item.FID);
          setFSTargetID(item.FID);
          fundingSourceTarget = item.FID;
        }
        return(
          <option key={index} value={item.FID} data-virtual={item.FPayTypeID} label={item.AccountID}>
            {item.AccountID}
          </option>
        );
      });
      let copayFSOptionsHTML = fsSelection.map((item, index)=>{
        if(copayFSSetting === "")
        {
          
          if((item.AccountID.toLowerCase().includes("self") || item.AccountID.toLowerCase().includes("cash")) || parseInt(item.FID) === 1)
          {
            setCopayFSSelected(item.FID);
          }
          
          return(
            <option key={index} value={item.FID} data-virtual={item.FPayTypeID} label={item.AccountID}>
              {item.AccountID}
            </option>
          );
        }
        else
        {
          setCopayFSSelected(1);
          let tempSettingIDs = copayFSSetting.includes(",")? copayFSSetting.split(",") : copayFSSetting;
          if(Array.isArray(tempSettingIDs))
          {
            if(tempSettingIDs.includes(String(item.FID)))
            {
              return(
                <option key={index} value={item.FID} data-virtual={item.FPayTypeID} label={item.AccountID}>
                  {item.AccountID}
                </option>
              );
            }
          }
          else
          {
            if(parseInt(tempSettingIDs) === parseInt(item.FID))
            {
              return(
                <option key={index} value={item.FID} data-virtual={item.FPayTypeID} label={item.AccountID}>
                  {item.AccountID}
                </option>
              );
            }
          }
        }
            
      });
      setDynamicModeStyle(dynamicCallAgentHeight); 
      setDynamicModeRowStyle(rowContainerDynamicHeight);
      setSelectedAff(e.target.value);
      if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2))
      {
        setClientInfoDisplay(true);
      }

      setLanguageOptionsHTML(languageOptions);
      setVehNumberOptionsHTML(vehicleNumOptionsHTML);
      setVehTypeOptionsManageHTML(vehicleTypeOptionsHTML);
      setDriverNumberOptionsHTML(driverNumberOptionsHTML);
      setCOSDropdown(cosOptionsHTML);
      setPayDropdown(payOptionsHTML);
      setFSDropdown(fsOptionsHTML);
      setCopayFSDropdown(copayFSOptionsHTML);

      SetAttributesFilterMultiSelect({...AttributesFilterMultiSelect, ...{options: attrOptionsMultiSelAff, selectedValues:[]}}); 

      setMapOptionsCallAgent(prevState=>({...prevState, mapOptions: {...prevState.mapOptions, aff:(e.target.value)}}));

      if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2))
      {
        handleGetFareCalcMethod((fundingSourceTarget? fundingSourceTarget : "-1"), e.target.value, COSSelected);
      }
      
      for(let k = 0; k < VirtualStopsData.length; k++)
      {
        if(parseInt(e.target.value) === parseInt(VirtualStopsData[k].iSATSPID))
        {
          selectedAffVS.push(VirtualStopsData[k]);
        }
      }
      handleResetAll((parseInt(uniqueID) === 0 ? "func" : "aff"));
      
    }
    catch(err){console.log(err);}
  };

  const AttributesSelectCallback = (selectedVals) => { //Multiselect attribute selection on change
    try{
      
      const stringVals = selectedVals.map((num) => num.toString());
      
      let groupSelected = [];
      for(let k = 0; k < AttributesFilterMultiSelect.options.length; k++)
      {
        if(stringVals.includes(String(AttributesFilterMultiSelect.options[k].id)))
        {
          groupSelected.push({id:AttributesFilterMultiSelect.options[k].id, name:AttributesFilterMultiSelect.options[k].name});
        }
      }
      setSelectedTripAttr(stringVals);
      SetAttributesFilterMultiSelect({ ...AttributesFilterMultiSelect, ...{ selectedValues: groupSelected}});
    }
    catch(err){console.log(err);}
  };

  const handleSummaryHeaderClick = (type)=>{ //This function takes care of clicking tabs on right column of call taker and switching between them
    try{
      if(type.toLowerCase()=== "stoporder")
      {
        setSelectedSummaryHeader(type);
        setAgentTripsDisplay(false);
        setStopOrderDisplay(true);
        setManifestDetailsDisplay(false);
        setManualFareDisplay(false);
      }
      else if(type.toLowerCase()=== "manifest")
      {
        setSelectedSummaryHeader(type);
        setAgentTripsDisplay(false);
        setStopOrderDisplay(false);
        setManifestDetailsDisplay(true);
        setManualFareDisplay(false);
      }
      else if(type.toLowerCase()=== "manualfare")
      {
        setSelectedSummaryHeader(type);
        setAgentTripsDisplay(false);
        setStopOrderDisplay(false);
        setManifestDetailsDisplay(false);
        setManualFareDisplay(true);
      }
      else if(type.toLowerCase() === "agenttrips")
      {
        setSelectedSummaryHeader(type);
        setAgentTripsDisplay(true);
        setStopOrderDisplay(false);
        setManifestDetailsDisplay(false);
        setManualFareDisplay(false);
      }
    }
    catch(err){console.log(err);}
  };

  const handleAutoBookTrip = ()=>{ //Function to automatically book a microtransit trip (FOR TEST ONLY)
    try{
      let correctDate = formatDate(selectedDateSchTime);
      setRiderName("Kamran A");
      setPhone("+16667778888");
      setPickupAddr("816 Bestgate Road, Annapolis, MD 21401, USA");
      setDropAddr("2002 Annapolis Mall Road, Annapolis, MD 21401, USA");
      pickLatLng.current = "38.994088959031814,-76.53922746079853";
      dropLatLng.current = "38.98793225777333,-76.54685231846949";
      if(pickLatLng.current !== "")
      {
        handleAddressDetails("PU", "816 Bestgate Road, Annapolis, MD 21401, USA", 
          "816 Bestgate Road, Annapolis, MD 21401, USA", "2002 Annapolis Mall Road, Annapolis, MD 21401, USA", correctDate, schTime);
        if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2))
        {
          wrapperHandleRCZVerification("PU", "816 Bestgate Road, Annapolis, MD 21401, USA");
        }
      }
    }
    catch(err){console.log(err);}
  };

  const handleSetRiderName = (e) => {
    try{ //Check to see if entered name is not using numbers and at least 2 characters to be verified
      setSearchButtonValidation("");
      const regex = /^[a-zA-Z0-9 ,.'-]+$/;
      let initialName = e.target.value;
      if(initialName.length > 0 && !regex.test(e.target.value)){e.target.value = initialName.slice(0,-1);}
      if(initialName !== "" && e.target.value.length < 2)
      {
        riderNameRef.current.style.border = "3px solid red";
      }
      else
      {
        riderNameRef.current.style.borderColor = "";
        riderNameRef.current.style.borderWidth = "";
      }
    }
    catch(err){console.log(err);}
  };

  const handleClearAddr = (type)=>{
    try{

      if(type === "PU") //Function to remove PU/DO from the map, POI removal, and virtual stop info removal (if any)
      {
        setPickupVirtualStop({...pickupVirtualStop, value:"PU VS", name:""});
        let stopMarkersArr = [];
        let filteredMapMarkers = mapData.filter((item)=>{
          if(item.Type === "Stop")
          {
            stopMarkersArr.push(item);
          }
          return item.Type === "DO";
        });
        filteredMapMarkers.unshift(...stopMarkersArr);
        setMapData(filteredMapMarkers);
        setPickPOI("");
      }
      else if(type === "DO")
      {
        setDropAddrVirtualStop({...dropAddrVirtualStop, value:"DO VS", name:""});
        let stopMarkersArr = [];
        let filteredMapMarkers = mapData.filter((item)=>{
          if(item.Type === "Stop")
          {
            stopMarkersArr.push(item);
          }
          return item.Type === "PU";
        });
        filteredMapMarkers.push(...stopMarkersArr);
        setMapData(filteredMapMarkers);
        setDropPOI("");
      }
      
    }
    catch(err){console.log(err);}
  };

  const handlePhoneCheck = ()=>{
    try{
      setSearchButtonValidation(""); //When entering phone, remove any error messages until API is called
      if(!phone) //If phone number deleted, reset client info parameters from call taker
      {
        setRecentAddresses([]);
        setRiderName("");
        setAgentNotes("");
        setAccountNumber("");
        setCallBackPhone("");
      }
      if(phone && phone.length < 12) //Highlighting phone input if it is wrong or entered incorrectly and vice versa
      {
        phoneRef.current.style.border = "3px solid red";
        setRecentAddresses([]);
      }
      else
      {
        phoneRef.current.style.borderColor = "";
        phoneRef.current.style.borderWidth = "";
      }
    }
    catch(err){console.log(err);}
  };
  const handleClientNameCheck = () => {
    try{

      if(riderNameCheck.length === 0) //If rider name is deleted from search input, reset the client Info
      {
        setRecentAddresses([]);
        setRiderName("");
        setAccountNumber("");
        setAgentNotes("");
        setCallBackPhone("");
      }
      else if(riderNameCheck.trim().length >= 3 && !isNaN(riderNameCheck.trim())) //Check added for rider ID check
      {

        if(riderIDtimeoutRef.current) //clear existing timeout in case new entry is not duplicate of old one
        {
          clearTimeout(riderIDtimeoutRef.current);
        }
        riderIDtimeoutRef.current = setTimeout(async () => {
          try{
            let givenID = riderNameCheck.trim();
            let myHeaders = new Headers();
              myHeaders.append('Content-Type', 'application/json');
            let headersObj = headersToObject(myHeaders);
            let clientResponse = await APICom.fetchData("ReservationCoreURL", "api/ParatransitCT/GetClientByID", "post", headersObj, JSON.stringify(givenID));
            console.log(clientResponse);
            if(clientResponse && clientResponse.error === "" && clientResponse.data !== "")
            {
              let clientIDData = clientResponse.data;
              let verifiedData = ((Array.isArray(clientIDData) && clientIDData.length > 0) ? clientIDData : (typeof clientIDData === 'object' ? [clientIDData] : []));
              let IDArray = (verifiedData.length > 0 ? verifiedData : []);
              let sortedClientInfoList = IDArray.sort((a,b)=>{

                const dateA = a.lastCallDate ? new Date(a.lastCallDate.split("T")[0] + " 00:00:00") : null;
                const dateB = b.lastCallDate ? new Date(b.lastCallDate.split("T")[0] + " 00:00:00") : null;
    
                if (!dateA && !dateB) return 0; // Both dates are empty
                if (!dateA) return 1; // Move entries with empty lastCall to the end
                if (!dateB) return -1; // Move entries with empty lastCall to the end
    
                return dateB - dateA; // Sort by date if both are valid (newest to oldest)
              });
              let suggestionsHTML = sortedClientInfoList.length > 0 ? sortedClientInfoList.map(function(item, index){
                liClientNameRefs.current[index] = React.createRef(); // Create a ref for each <li>
                let [year, month, day] = item.lastCallDate ?  item.lastCallDate.split("T")[0].split("-"): ["","",""]; 
                let formattedName = item.firstName.length === 0? (item.lastName+(item.homePhone.length === 0 ? (year !== "" ? " [Last Call: "+month+"/"+day+"/"+year+"]" : "") :" ("+item.homePhone+")"+(year !== "" ? " [Last Call: "+month+"/"+day+"/"+year+"]" : ""))) : 
                  (item.lastName === "" ? item.firstName: item.lastName+", "+item.firstName) + (item.homePhone.length === 0 ? (year !== "" ? " [Last Call: "+month+"/"+day+"/"+year+"]" : "") :" ("+item.homePhone+")"+(year !== "" ? " [Last Call: "+month+"/"+day+"/"+year+"]" : ""));
                
                return(
                  <li ref={liClientNameRefs.current[index]} className="border-bottom text-nowrap overflow-hidden px-1 addressSelectionRow" 
                    onFocus={()=>{focusedSuggestionCheckClientName.current = true;}}
                    style={{cursor:"pointer"}} tabIndex={-1} onBlur={()=>{focusedSuggestionCheckClientName.current = false;}} 
                    onKeyDown={(e)=>{
                        if(e.key === 'ArrowDown')
                        {
                          e.preventDefault();
                          if(liClientNameRefs.current.length > 0)
                          {
                            setHighlightedIndex((prevIndex) => {
                              const newIndex = (prevIndex + 1) % liClientNameRefs.current.length;
                              liClientNameRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                              return newIndex;
                            });
                          }
                        }
                        else if (e.key === 'ArrowUp') {
                          e.preventDefault();
                          if(liClientNameRefs.current.length > 0)
                          {
                            setHighlightedIndex((prevIndex) => {
                              const newIndex = (prevIndex - 1 + liClientNameRefs.current.length) % liClientNameRefs.current.length;
                              liClientNameRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                              return newIndex;
                            });
                          }
                        }
                        else if(e.key === "Enter")
                        {
                          // setInputSuggestionListClientName("");
                          if(item.homePhone && item.homePhone !== ""){handleSearchCustomerPhone(item.homePhone, false, (item.id ? item.id : 0));}
                          else{
                            let nameformat = item.lastName + ", " + item.firstName;
                            handleSearchCustomerName(nameformat, false, (item.id ? item.id : 0));
                          }
                        }
                      }}
                    onClick={()=>{
                      if(item.homePhone && item.homePhone !== ""){handleSearchCustomerPhone(item.homePhone, false, (item.id ? item.id : 0));}
                      else{
                        let nameformat = item.lastName + ", " + item.firstName;
                        handleSearchCustomerName(nameformat, false, (item.id ? item.id : 0));
                      }
                    }} key={index} value={formattedName}
                  >
                    {formattedName}
                  </li>
                );
              }) : "";
              setInputSuggestionListClientName(suggestionsHTML);
              setClientIDInfo(IDArray);
            }
          }
          catch(err){console.log(err);}
        }, 400);
      }
    }
    catch(err){console.log(err);}
  };

  const handleInsuranceInfoDisplay = ()=>{
    try{
      setInsuranceInfoDisplay(!insuranceInfoDisplay); //Function to display or hide insurance info section (if available)
    }
    catch(err){console.log(err);}
  };

  const handleMultischeduleOpen = (e)=>{
    try{
      setMultischModalShow(true); //Open multi-schedule dialog component
    }
    catch(err){console.log(err);}
  };

  const handleReturnCheck = async(e) =>{
    try{
      //Get OSRM time from setting to use with given time from API as in old MRMS
      const OSRM_TIME = (ASCSSettingData ? (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "OSRM_Time")).value : 1);
      if(!pickLatLng.current || pickLatLng.current.trim() === "" || !dropLatLng.current || dropLatLng.current.trim() === ""){return;}

      const swapLatLngAndAddresses = () => { //Swapping addresses and markers
        const pickInfo = { addr: pickupAddr, latlng: pickLatLng.current, POI: pickPOI };
        const dropInfo = { addr: dropAddr, latlng: dropLatLng.current, POI: dropPOI };
  
        const tripLatLng = [
          { lat: parseFloat(dropInfo.latlng.split(",")[0]), lng: parseFloat(dropInfo.latlng.split(",")[1]), Type: "PU", name: riderName, address: dropInfo.addr },
          { lat: parseFloat(pickInfo.latlng.split(",")[0]), lng: parseFloat(pickInfo.latlng.split(",")[1]), Type: "DO", name: riderName, address: pickInfo.addr },
        ];
  
        setMapData(tripLatLng);
        setDropAddr(pickInfo.addr);
        setDropPOI(pickInfo.POI);
        setPickupAddr(dropInfo.addr);
        setPickPOI(dropInfo.POI);
        pickLatLng.current = dropInfo.latlng;
        dropLatLng.current = pickInfo.latlng;
      };

      const calculateAndSetTripSummary = async () => { //Calculating new distance, time, and fare
        const addressAPI = `${ITCMapDirections}?origin=${pickLatLng.current}&destination=${dropLatLng.current}&AppType=calltaker`;
        const OSRMResponse = await APICom.fetchData("full", addressAPI, "get", {
          Authorization: `Basic ${btoa(OSRM_Username + ":" + OSRM_Password)}`,
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Headers": "*",
          mode: "no-cors",
        });
  
        if (OSRMResponse?.data.status.toUpperCase() === "OK") {
          const distanceInMeters = OSRMResponse.data.routes[0].legs[0].distance.value;
          const durationInSeconds = OSRMResponse.data.routes[0].legs[0].duration.value;
  
          const distance = (parseFloat(distanceInMeters) / 1609).toFixed(1);
          const duration = Math.round((parseInt(durationInSeconds) / 60) * OSRM_TIME);
  
          setClientSummary((prevState) => ({
            ...prevState,
            tripDistance: distance,
            TripDuration: duration,
          }));
  
          if (pickLatLng.current && dropLatLng.current) {
            setShowAPILoader(true);
            resetBtnRef.current.disabled = true;
            paratransitBookBtnRef.current.disabled = true;
  
            await handleGetFareCalcMethod(FSSelected || "-1", selectedAff, COSSelected);
  
            const tripTypes = [
              { type: "pick", mapInfo: pickLatLng.current },
              { type: "drop", mapInfo: dropLatLng.current },
            ];
  
            for (const trip of tripTypes) {
              if (fareMethodRef.current === 1) {
                await getFareZone(FSSelected, selectedAff, COSSelected, trip.mapInfo, trip.type);
              }
              await getDispatchZone(selectedAff, trip.mapInfo, trip.type);
            }
            await wrapperHandleFareCalc(distance, duration, FSSelected, copayFSSelected, passengerTypeCount.totalWC, 
              passengerTypeCount.total, COSSelected, selectedAff, pickLatLng.current, copayAmount, ""
            );
            setShowAPILoader(false);
            resetBtnRef.current.disabled = false;
            paratransitBookBtnRef.current.disabled = false;
            addLegBtnRef.current.disabled = false;
          }
        }
      };

      if(e.key && e.key === "Enter")
      {
        swapLatLngAndAddresses();
        await calculateAndSetTripSummary();
      }
      else
      {
        swapLatLngAndAddresses();
        await calculateAndSetTripSummary();
      }
    }
    catch(err){console.log(err);}
  };

  const updatePhoneNumber = (newPhone, affiliateId) => {
    try{
      // setting value to phone number input and manually triggering enter event for caller ID
      setSelectedAff(affiliateId)
      setPhone("");
      setChatBotPhone(newPhone);
      phoneRef.current.value = "";

      if (!showChatBotRef.current) {
        setTimeout(() => {
          phoneRef.current.value = newPhone; // Set the phoneRef input value
          setIsPhoneUpdateFromFunction(true); // Set the flag to signal useEffect
          setPhone(newPhone); // Update the phone, triggering useEffect
        }, 100);
      }
    }
    catch(err){console.log(err);}
  };

  const handleSSNChange = (e) => {
    try{
      const input = e.target.value;
      setInsuranceSSN(input);
      setSSNDisplayValue('•'.repeat(input.length)); //Get SSN and replace the actual value with dots for privacy
    }
    catch(err){console.log(err);}
  };

  return(
    <>
      <ARBResponseListener handlePageProgressBar={handlePageProgressBar} setAlert = {setAlert}/>
      <CallerIDNotifierListener  onUpdatePhone={updatePhoneNumber} />
      <Row className="m-0 px-1" style={{backgroundColor:"#07447b", height:"38px", maxHeight:"38px"}}>
        <Col className="d-flex my-auto align-items-center">
          <img src={ITCLogo} className='ITCLogo page-header-logo user-select-none p-0 m-0' style={{maxWidth:"200px", maxHeight:"30px"}} alt="ITCurves" />
          <p className="fw-bold text-white text-center text-nowrap callAgentTitleResponsive overflow-hidden h3 user-select-none flex-grow-1" style={{margin:"0",marginLeft:"10%"}}>
            {(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2) ?
             <>
              <span className="callAgentLabelsResponsive">Microtransit</span> Reservation
             </>
             :
             <>
              <span className="callAgentLabelsResponsive">Paratransit</span> Reservation
             </>}
          </p>

          <span className="d-inline-flex text-end callAgentTitleAffResponsive" style={{marginRight:"9%"}}>
            <Icon icon="bx:sitemap" className="text-white my-auto" style={{width:"20px", height:"20px"}}/>
            <label className='m-0 mx-1 user-select-none my-auto text-white callAgentLabelsResponsive'>Affiliate:</label>
            <select ref={affiliateSelRef} style={{textOverflow:"ellipsis", borderRadius:"5px", maxHeight:"30px", height:"30px"}} 
              value={(selectedAff? selectedAff:"")} 
              onChange={(e)=>{handleAffChange(e); if(paratransitBookBtnRef.current){paratransitBookBtnRef.current.disabled = false;}}} 
              className='text-center mx-1 overflow-hidden callAgentInputStyle callAgentAffDropdownResponsive' tabIndex={-1}
            >
              {affiliateDropDownHTML}
            </select>
          </span>
        </Col>
      </Row>
      <Row className='callAgentMainColsResponsive' style={{boxShadow:"0px 3px 6px #999"}}>
        <Col xs={6} className="my-1 overflow-auto callAgentSummaryScroller">
          <span className="d-inline-flex" style={{width:"100%"}}>
            {screenWidthSize >= 650 ? 
              <>
                <span className="d-inline-flex mx-1">
                  <PhoneInput className='text-nowrap text-center callAgentInputStyle callAgentClientPhoneResponsive' 
                    style={{maxHeight:"30px", height:"30px"}} ref={phoneRef}
                    defaultCountry="US" autoComplete="new_pass" value={phone} 
                    onClick={(e) => { if (isFirefox) { phoneRef.current.blur(); phoneRef.current.focus(); } }}
                    onKeyUp={handlePhoneCheck} onChange={(e)=>{if(e){handlePhoneNumberChange(e);}}} placeholder="(XXX) XXX-XXXX"
                    onBlur={()=>{setTimeout(() => {
                      if(!focusedSuggestionCheckClientPhone.current)
                      {
                        setInputSuggestionListClientPhone("");
                      }
                    }, 300);}} onFocus={(e)=>{if(e){handlePhoneNumberChange(e);}}}
                    onKeyDown={(e)=>
                    {
                      if(e.key === '1' && e.target.value.length === 0)
                      {
                        e.preventDefault();
                      } 
                      if(e.target.value.length >= 14 && e.key !== 'Backspace' && e.key !== "Delete" && e.key !== "Tab")
                      {
                        e.preventDefault();
                      }
                      if(e.key === "Enter" || e.key === "Tab")
                      {
                        setInputSuggestionListClientPhone("");
                        setInputSuggestionListClientName("");
                        if(Array.isArray(clientIDInfo) && clientIDInfo.length > 0)
                        {
                          let type = clientIDInfo[0].homePhone && clientIDInfo[0].homePhone !== "" ? "CustomerPhone" : "CustomerName";
                          let searchText = type === "CustomerPhone" ? clientIDInfo[0].homePhone : (clientIDInfo[0].lastName + ", "+ clientIDInfo[0].firstName);
                          if(type === "CustomerPhone"){handleSearchCustomerPhone(searchText, false, (clientIDInfo[0].id ? clientIDInfo[0].id : 0));}
                          else{handleSearchCustomerName(searchText, false, (clientIDInfo[0].id ? clientIDInfo[0].id : 0));}
                        }
                        else
                        {
                          if((!phone || phone.length < 12) && riderNameCheck.length > 0)
                          {
                            handleSearchCustomerName();
                          }
                          else
                          {
                            handleSearchCustomerPhone();
                          }
                        }
                      }
                      else if(e.key === 'ArrowDown')
                      {
                        e.preventDefault();
                        setHighlightedIndex(-1);
                        if(liClientPhoneRefs.current.length > 0)
                        {
                          if(liClientPhoneRefs.current[0]?.current) //check for empty references
                          {
                            setHighlightedIndex((prevIndex) => {
                              const newIndex = (prevIndex + 1) % liClientPhoneRefs.current.length;
                              liClientPhoneRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                              return newIndex;
                            });
                          }
                        }
                      }
                      else if (e.key === 'ArrowUp') {
                        e.preventDefault();
                        setHighlightedIndex(-1);
                        if(liClientPhoneRefs.current.length > 0)
                        {
                          if(liClientPhoneRefs.current[0]?.current)
                          {
                            setHighlightedIndex((prevIndex) => {
                              const newIndex = (prevIndex - 1 + liClientPhoneRefs.current.length) % liClientPhoneRefs.current.length;
                              liClientPhoneRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                              return newIndex;
                            });
                          }
                        }
                      }
                    }}
                    
                  />
                  {inputSuggestionListClientPhone && inputSuggestionListClientPhone !== "" ?
                    <ul tabIndex={0} className="callAgent-Suggestion-list px-1">{inputSuggestionListClientPhone}</ul>
                  :""}
                </span>
                <span className="d-inline-flex mx-1">
                  <input type={"text"} value={riderNameCheck} onChange={handleClientNameChange} ref={clientNameCheckRef} 
                    className={"callAgentInputStyle callAgentClientNameResponsive"}
                    onClick={(e) => { if (isFirefox) { clientNameCheckRef?.current.blur(); clientNameCheckRef?.current.focus(); } }}
                    placeholder={(screenWidthSize < 600 ? "Name/ID" : "Client Name/ID")} onKeyUp={handleClientNameCheck} onFocus={handleClientNameChange} 
                    onBlur={()=>{setTimeout(() => {
                      if(!focusedSuggestionCheckClientName.current)
                      {
                        setInputSuggestionListClientName("");
                      }
                    }, 300);}}
                    onKeyDown={(e)=>
                    {
                      if(e.key === "Enter" || (e.key === "Tab" && !e.shiftKey))
                      {
                        setInputSuggestionListClientPhone("");
                        setInputSuggestionListClientName("");
                        if(Array.isArray(clientIDInfo) && clientIDInfo.length > 0)
                        {
                          let type = clientIDInfo[0].homePhone && clientIDInfo[0].homePhone !== "" ? "CustomerPhone" : "CustomerName";
                          let searchText = type === "CustomerPhone" ? clientIDInfo[0].homePhone : (clientIDInfo[0].lastName + ", "+ clientIDInfo[0].firstName);
                          if(type === "CustomerPhone"){handleSearchCustomerPhone(searchText, false, (clientIDInfo[0].id ? clientIDInfo[0].id : 0));}
                          else{handleSearchCustomerName(searchText, false, (clientIDInfo[0].id ? clientIDInfo[0].id : 0));}
                        }
                        else
                        {
                          if(riderNameCheck.length === 0 && phone && phone.length >= 12)
                          {
                            handleSearchCustomerPhone();
                          }
                          else
                          {
                            handleSearchCustomerName();
                          }
                        }
                        
                      }
                      else if(e.key === 'ArrowDown')
                      {
                        e.preventDefault();
                        setHighlightedIndex(-1);
                        if(liClientNameRefs.current.length > 0)
                        {
                          if(liClientNameRefs.current[0]?.current) //check for empty references
                          {
                            setHighlightedIndex((prevIndex) => {
                              const newIndex = (prevIndex + 1) % liClientNameRefs.current.length;
                              liClientNameRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                              return newIndex;
                            });
                          }
                        }
                      }
                      else if (e.key === 'ArrowUp') {
                        e.preventDefault();
                        setHighlightedIndex(-1);
                        if(liClientNameRefs.current.length > 0)
                        {
                          if(liClientNameRefs.current[0]?.current)
                          {
                            setHighlightedIndex((prevIndex) => {
                              const newIndex = (prevIndex - 1 + liClientNameRefs.current.length) % liClientNameRefs.current.length;
                              liClientNameRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                              return newIndex;
                            });
                          }
                        }
                      }
                    }}
                  />
                  {inputSuggestionListClientName && inputSuggestionListClientName !== "" ?
                    <ul tabIndex={0} className="callAgent-Suggestion-list px-1">{inputSuggestionListClientName}</ul>
                  :""}
                </span> 
                <Button type="button" variant="success" onClick={(e)=>{
                  if(Array.isArray(clientIDInfo) && clientIDInfo.length > 0)
                  {
                    let type = clientIDInfo[0].homePhone && clientIDInfo[0].homePhone !== "" ? "CustomerPhone" : "CustomerName";
                    let searchText = type === "CustomerPhone" ? clientIDInfo[0].homePhone : (clientIDInfo[0].lastName + ", "+ clientIDInfo[0].firstName);
                    if(type === "CustomerPhone"){handleSearchCustomerPhone(searchText, false, (clientIDInfo[0].id ? clientIDInfo[0].id : 0));}
                    else{handleSearchCustomerName(searchText, false, (clientIDInfo[0].id ? clientIDInfo[0].id : 0));}
                  }
                  else{if(riderNameCheck.length > 0){handleSearchCustomerName();}else{handleSearchCustomerPhone();}}}} 
                  title={"Client Search"} style={{borderRadius: "0px", maxHeight:"30px", height:"30px"}}
                  className={`rounded border-0 p-0 px-1`} ref={searchClientBtnRef}
                > 
                  {"Search"}
                </Button>
              </> 
            : ""}
            
            {searchButtonValidation !== "" ? <p className="text-danger fw-bold small m-0 overflow-hidden user-select-none text-nowrap my-auto" 
              title={searchButtonValidation} style={{textOverflow:"ellipsis", paddingLeft:"5px"}}
            >{searchButtonValidation}</p> :""}
          </span>
          
          {microtransit ? "":
          <>
            <span className="d-inline-flex">
              <Icon icon="bx:user" className="m-1" style={{width:"20px", height:"20px"}}/>
              <label className='m-0 m-1 user-select-none fw-bold'>Name</label>
              <input type={"text"} value={riderNameCheck} onChange={(e)=>setRiderNameCheck(e.target.value)} placeholder={"Client Name"} style={{width:"120px"}}/>
            </span>
            
          </>
          }
          
        </Col>
        <Col xs={6} className="text-end my-auto">
          <div className="d-flex justify-content-end">
            <div className="d-flex flex-nowrap overflow-auto callAgentSummaryScroller">
              {screenWidthSize >= 650 ?
                <>
                  <span className="d-inline-flex mt-1 small" title={"Client Status"}>
                    <Icon icon="hugeicons:user-status" className="m-1" style={{width:"20px", height:"20px"}}/>
                    <label className='m-0 my-1 user-select-none fw-bold text-nowrap callAgentLabelsResponsive'>Client Status</label>
                    <select style={{minWidth:"110px", maxHeight:"30px", height:"30px"}} tabIndex={-1} value={clientStatus} 
                      onChange={(e)=>setClientStatus(e.target.value)} disabled className='text-center mx-1 callAgentInputStyle'
                    >
                      <option>Select...</option>
                    </select>
                  </span>
                  <span className="d-inline-flex mx-1 mt-1 small" title={"Class of Service (Vehicle Type)"}>
                    <Icon icon="bx:bus" className="m-1" style={{width:"20px", height:"20px"}}/>
                    <label className='m-0 my-1 user-select-none fw-bold callAgentLabelsResponsive'>COS</label>
                    <select style={{minWidth:"110px", maxHeight:"30px", height:"30px"}} tabIndex={-1} value={COSSelected} onChange={async(e)=>{
                      setCOSSelected(e.target.value);
                        if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2))
                        {
                          await handleGetFareCalcMethod((FSSelected? FSSelected: "-1"), selectedAff, e.target.value);
                          await wrapperHandleFareCalc(clientSummary.tripDistance, clientSummary.TripDuration, 
                            FSSelected, copayFSSelected, passengerTypeCount.totalWC, 
                            passengerTypeCount.total, e.target.value, selectedAff, 
                            pickLatLng.current, copayAmount, ""); 
                        }
                      }} 
                      className='text-center mx-1 callAgentInputStyle' 
                    >
                      {COSDropdown && COSDropdown.length > 0 ? COSDropdown:""}
                    </select>
                  </span> 
                </> 
              : 
                <>
                  {!showSideBar ? 
                    <Button type='button' variant='light' 
                      className='border-0 p-0 rounded' onClick={()=>{setShowSideBar(true);}} title="Client Search"
                    ><Icon icon="bx:menu" className='w-100' style={{color:"gray", height:"30px", cursor:"pointer", display:"block", zIndex:"999"}}/></Button>
                    :
                    <div className={`sidebarCallTaker pt-4 ${showSideBar ? 'open' : ''} bg-dark`}>
                      <Button variant="transparent"className="border-0 p-0 text-white rounded close-btn" onClick={()=>{setShowSideBar(false);}}>
                        &times;
                      </Button>
                      <ul className="list-unstyled mt-1 text-center">
                        <h5 className="my-2 text-white user-select-none text-nowrap overflow-hidden">{"Client Search"}</h5>
                        <li className="border border-white" style={{height:"2px"}}></li>
                        <li>
                          <PhoneInput className='text-nowrap text-center callAgentInputStyle my-2 callAgentClientPhoneResponsive' 
                            style={{maxHeight:"30px", height:"30px"}} ref={phoneRef}
                            defaultCountry="US" autoComplete="new_pass" value={phone} 
                            onClick={(e) => { if (isFirefox) { phoneRef.current.blur(); phoneRef.current.focus(); } }}
                            onKeyUp={handlePhoneCheck} onChange={(e)=>{if(e){handlePhoneNumberChange(e);}}} placeholder="(XXX) XXX-XXXX"
                            onBlur={()=>{setTimeout(() => {
                              if(!focusedSuggestionCheckClientPhone.current)
                              {
                                setInputSuggestionListClientPhone("");
                              }
                            }, 300);}} onFocus={(e)=>{if(e){handlePhoneNumberChange(e);}}}
                            onKeyDown={(e)=>
                            {
                              if(e.key === '1' && e.target.value.length === 0)
                              {
                                e.preventDefault();
                              } 
                              if(e.target.value.length >= 14 && e.key !== 'Backspace' && e.key !== "Delete" && e.key !== "Tab")
                              {
                                e.preventDefault();
                              }
                              if(e.key === "Enter" || e.key === "Tab")
                              {
                                setShowSideBar(false);
                                setInputSuggestionListClientPhone("");
                                setInputSuggestionListClientName("");
                                if(Array.isArray(clientIDInfo) && clientIDInfo.length > 0)
                                {
                                  let type = clientIDInfo[0].homePhone && clientIDInfo[0].homePhone !== "" ? "CustomerPhone" : "CustomerName";
                                  let searchText = type === "CustomerPhone" ? clientIDInfo[0].homePhone : (clientIDInfo[0].lastName + ", "+ clientIDInfo[0].firstName);
                                  if(type === "CustomerPhone"){handleSearchCustomerPhone(searchText, false, (clientIDInfo[0].id ? clientIDInfo[0].id : 0));}
                                  else{handleSearchCustomerName(searchText, false, (clientIDInfo[0].id ? clientIDInfo[0].id : 0));}
                                }
                                else
                                {
                                  if((!phone || phone.length < 12) && riderNameCheck.length > 0)
                                  {
                                    handleSearchCustomerName();
                                  }
                                  else
                                  {
                                    handleSearchCustomerPhone();
                                  }
                                }
                              }
                              else if(e.key === 'ArrowDown')
                              {
                                e.preventDefault();
                                setHighlightedIndex(-1);
                                if(liClientPhoneRefs.current.length > 0)
                                {
                                  if(liClientPhoneRefs.current[0]?.current) //check for empty references
                                  {
                                    setHighlightedIndex((prevIndex) => {
                                      const newIndex = (prevIndex + 1) % liClientPhoneRefs.current.length;
                                      liClientPhoneRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                                      return newIndex;
                                    });
                                  }
                                }
                              }
                              else if (e.key === 'ArrowUp') {
                                e.preventDefault();
                                setHighlightedIndex(-1);
                                if(liClientPhoneRefs.current.length > 0)
                                {
                                  if(liClientPhoneRefs.current[0]?.current)
                                  {
                                    setHighlightedIndex((prevIndex) => {
                                      const newIndex = (prevIndex - 1 + liClientPhoneRefs.current.length) % liClientPhoneRefs.current.length;
                                      liClientPhoneRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                                      return newIndex;
                                    });
                                  }
                                }
                              }
                            }}
                          />
                        </li>
                        <li>
                          <input type={"text"} value={riderNameCheck} onChange={handleClientNameChange} ref={clientNameCheckRef} 
                            className={"callAgentInputStyle callAgentClientPhoneResponsive"} style={{height:"30px", maxHeight:"30px"}}
                            onClick={(e) => { if (isFirefox) { clientNameCheckRef?.current.blur(); clientNameCheckRef?.current.focus(); } }}
                            placeholder={"Client Name/ID"} onKeyUp={handleClientNameCheck} onFocus={handleClientNameChange} 
                            onBlur={()=>{setTimeout(() => {
                              if(!focusedSuggestionCheckClientName.current)
                              {
                                setInputSuggestionListClientName("");
                              }
                            }, 300);}}
                            onKeyDown={(e)=>
                            {
                              if(e.key === "Enter" || (e.key === "Tab" && !e.shiftKey))
                              {
                                setShowSideBar(false);
                                setInputSuggestionListClientPhone("");
                                setInputSuggestionListClientName("");
                                if(Array.isArray(clientIDInfo) && clientIDInfo.length > 0)
                                {
                                  let type = clientIDInfo[0].homePhone && clientIDInfo[0].homePhone !== "" ? "CustomerPhone" : "CustomerName";
                                  let searchText = type === "CustomerPhone" ? clientIDInfo[0].homePhone : (clientIDInfo[0].lastName + ", "+ clientIDInfo[0].firstName);
                                  if(type === "CustomerPhone"){handleSearchCustomerPhone(searchText, false, (clientIDInfo[0].id ? clientIDInfo[0].id : 0));}
                                  else{handleSearchCustomerName(searchText, false, (clientIDInfo[0].id ? clientIDInfo[0].id : 0));}
                                }
                                else
                                {
                                  if(riderNameCheck.length === 0 && phone && phone.length >= 12)
                                  {
                                    handleSearchCustomerPhone();
                                  }
                                  else
                                  {
                                    handleSearchCustomerName();
                                  }
                                }
                              }
                              else if(e.key === 'ArrowDown')
                              {
                                e.preventDefault();
                                setHighlightedIndex(-1);
                                if(liClientNameRefs.current.length > 0)
                                {
                                  if(liClientNameRefs.current[0]?.current) //check for empty references
                                  {
                                    setHighlightedIndex((prevIndex) => {
                                      const newIndex = (prevIndex + 1) % liClientNameRefs.current.length;
                                      liClientNameRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                                      return newIndex;
                                    });
                                  }
                                }
                              }
                              else if (e.key === 'ArrowUp') {
                                e.preventDefault();
                                setHighlightedIndex(-1);
                                if(liClientNameRefs.current.length > 0)
                                {
                                  if(liClientNameRefs.current[0]?.current)
                                  {
                                    setHighlightedIndex((prevIndex) => {
                                      const newIndex = (prevIndex - 1 + liClientNameRefs.current.length) % liClientNameRefs.current.length;
                                      liClientNameRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                                      return newIndex;
                                    });
                                  }
                                }
                              }
                            }}
                          />
                        </li>
                        <li>
                          <Button
                            onClick={(e)=>{
                              if(Array.isArray(clientIDInfo) && clientIDInfo.length > 0)
                              {
                                setShowSideBar(false);
                                let type = clientIDInfo[0].homePhone && clientIDInfo[0].homePhone !== "" ? "CustomerPhone" : "CustomerName";
                                let searchText = type === "CustomerPhone" ? clientIDInfo[0].homePhone : (clientIDInfo[0].lastName + ", "+ clientIDInfo[0].firstName);
                                if(type === "CustomerPhone"){handleSearchCustomerPhone(searchText, false, (clientIDInfo[0].id ? clientIDInfo[0].id : 0));}
                                else{handleSearchCustomerName(searchText, false, (clientIDInfo[0].id ? clientIDInfo[0].id : 0));}
                              }
                              else{if(riderNameCheck.length > 0){setShowSideBar(false); handleSearchCustomerName();}else{setShowSideBar(false); handleSearchCustomerPhone();}}
                            }} style={{borderRadius: "0px", maxHeight:"30px", height:"30px"}}
                            className={`rounded border-0 p-0 my-2 px-1 callTakerSideBarSearchBtnStyle`} ref={searchClientBtnRef}
                          > 
                            {"Search"}
                          </Button>
                        </li>
                        <h5 className="my-2 text-white user-select-none text-nowrap overflow-hidden">{"Client Status"}</h5>
                        <li className="border border-white" style={{height:"2px"}}></li>
                        <li>
                          <select style={{width:"120px", maxWidth:"120px", maxHeight:"30px", height:"30px"}} tabIndex={-1} value={clientStatus} 
                            onChange={(e)=>setClientStatus(e.target.value)} disabled className='text-center my-2 callAgentInputStyle'
                          >
                            <option>Select...</option>
                          </select>
                        </li>
                        <h5 className="my-2 text-white user-select-none text-nowrap overflow-hidden" title="Class of Service">{"COS"}</h5>
                        <li className="border border-white" style={{height:"2px"}}></li>
                        <li>
                          <select style={{maxWidth:"120px", width:"120px", maxHeight:"30px", height:"30px"}} tabIndex={-1} value={COSSelected} 
                            onChange={async(e)=>{
                              setCOSSelected(e.target.value);
                              if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2))
                              {
                                await handleGetFareCalcMethod((FSSelected? FSSelected: "-1"), selectedAff, e.target.value);
                                await wrapperHandleFareCalc(clientSummary.tripDistance, clientSummary.TripDuration, 
                                  FSSelected, copayFSSelected, passengerTypeCount.totalWC, 
                                  passengerTypeCount.total, e.target.value, selectedAff, 
                                  pickLatLng.current, copayAmount, ""); 
                              }
                            }} 
                            className='text-center callAgentInputStyle my-2' 
                          >
                            {COSDropdown && COSDropdown.length > 0 ? COSDropdown:""}
                          </select>
                        </li>
                      </ul>
                    </div>
                  }
                </>
              }
            </div>
          </div>
        </Col>
      </Row>
      {ShowAPILoader ? <div className="loader"></div> : ""}
      <Row style={dynamicModeRowStyle} className="roundedEndsStyle callAgentMainColsResponsive">
        <Col xs={6} className="overflow-auto callAgentSummaryScroller border-end border-secondary" style={dynamicModeStyle}>
          <Row style={{height:"35px", maxHeight:"35px"}}>
            <Col className="text-start" onClick={(e)=>{setClientInfoDisplay(!clientInfoDisplay);}} style={{backgroundColor:"#07447b"}}>
              <span className="d-inline-flex my-auto w-75" title={"Client Information"}>
                <Icon icon="bx:info-circle" className="mt-1 text-white" style={{minWidth:"25px", minHeight:"25px", width:"25px", height:"25px"}}/>
                <label className='m-0 m-1 user-select-none fw-bold text-white text-nowrap overflow-hidden' style={{textOverflow:"ellipsis"}}>Client Information</label>
              </span>
              {(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2) ?  
                <span className="d-inline-flex mt-1 float-end" tabIndex={0} ref={clientInfoDisplayRef}
                  onClick={(e)=>{setClientInfoDisplay(!clientInfoDisplay);}} onKeyDown={(e)=>{
                    if(e.key === "Enter"){setClientInfoDisplay(!clientInfoDisplay);}
                    else if(e.key === 'Tab' && !e.shiftKey)
                    {
                      if(clientInfoDisplay)
                      {
                        e.preventDefault();
                        riderNameRef.current.focus();
                      }
                    }
                  }}
                >
                  {clientInfoDisplay? <Icon icon="bx:chevron-down" className="text-white" style={{width:"25px", height:"25px", cursor:"pointer"}}/>:
                    <Icon icon="bx:chevron-up" className="text-white" style={{width:"25px", height:"25px", cursor:"pointer"}}/>
                  }
                </span>
              :""}
            </Col>
          </Row>
          <Row className={`${clientInfoDisplay? '':'d-none'}`}>
            <Col className={`text-start p-0 overflow-auto overflow-y-hidden callAgentSummaryScroller`} style={{maxHeight:"580px"}}>
              <Row className="m-0 w-100">
                <Row>
                  <Col xs={2}>
                    <span className="d-block small mt-1 text-nowrap overflow-hidden" title={"Full Name"}>
                      <Icon icon="bx:user" className="m-1" style={{width:"15px", height:"15px"}}/>
                      <label className='m-0 my-1 user-select-none callAgentLabelsResponsive'>Name</label>
                    </span>
                    <span className="d-block small mt-2 text-nowrap" 
                      title={((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2) ? "Pickup" : "Pickup or Virtual Stop")}
                    >
                      <Icon icon="bx:map" className="m-1 text-success" style={{width:"15px", height:"15px"}}/>
                      <label className='m-0 user-select-none callAgentLabelsResponsive'>
                        {(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2) ?"PU":"PU/VS"}
                      </label>
                    </span>
                    <span className="d-block small mt-1 text-nowrap" title={"Pickup Route Coverage Zone"}>
                      <Icon icon="bx:map-alt" className="m-1 text-info" style={{width:"15px", height:"15px"}}/>
                      <label className='m-0 my-1 user-select-none callAgentLabelsResponsive'>Zone</label>
                    </span>
                    {(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2) ?
                      <span className="text-start mt-3 justify-content-start d-block AddressIconsResponsive" title={"Switch Addresses"}>
                        <Icon icon="bx:sort-alt-2" tabIndex={0} ref={addressSwitchBtnRef}
                          onClick={handleReturnCheck} onKeyDown={(e)=>{
                            if(e.key === "Tab" && !e.shiftKey)
                            { 
                              e.preventDefault();
                              passengerCountPassengerRef.current.focus();
                            }
                            else if(e.key === "Tab" && e.shiftKey)
                            {
                              e.preventDefault();
                              pickExtraInfoRef.current.focus();
                            }
                            else
                            {
                              handleReturnCheck(e);
                            }
                          }} className="m-1" 
                          style={{cursor:"pointer", width:"20px", height:"20px", color:"darkgreen"}}
                        />
                      </span>
                    :""}
                    
                  </Col>
                  <Col xs={10} className="p-0">
                    
                    <Row className="my-1">
                      {(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2) ? 
                      <>
                        <Col xs={6}>
                          <input type={"text"} value={riderName} autoComplete="new_pass" ref={riderNameRef} minLength={4} maxLength={35} required 
                            onChange={(e)=>{
                              let value = e.target.value;
                              const specialChar = /[^a-zA-Z0-9\s]/g;
                              const santizedValue = value.replace(specialChar, '');
                              setRiderName(santizedValue);
                            }} tabIndex={0}
                            onKeyDown={(e)=>{
                              if(e.key === "Tab" && e.shiftKey)
                              {
                                e.preventDefault();
                                clientInfoDisplayRef.current.focus();
                              }
                            }}
                            className='text-nowrap p-0 px-1 callAgentInputStyle w-100' placeholder="Full Name" onKeyUp={handleSetRiderName} 
                            style={{maxHeight:"30px", height:"30px"}}
                          /> 
                        </Col>
                        <Col xs={6}>
                          <span className="d-flex justify-content-end">
                            <input type={"text"} value={accountNumber} autoComplete="new_pass" minLength={4} required 
                              onChange={handleAccountNumberChange} tabIndex={-1} title={"Client ID"}
                              className='text-nowrap p-0 px-1 d-inline-block callAgentInputStyle w-50' placeholder="Client ID"
                              style={{maxHeight:"30px", height:"30px"}} readOnly
                            /> 
                            <input type={"text"} value={medID} autoComplete="new_pass" minLength={4} required 
                              onChange={(e)=>{setMedID(e.target.value);}} tabIndex={-1} title={"Rider/Medical ID"} onBlur={async(e)=>{await handleBlurRiderID(e);}}
                              className='text-nowrap p-0 px-1 ms-2 callAgentInputStyle d-inline-block w-50' placeholder="Rider/Medical ID"
                              style={{maxHeight:"30px", height:"30px"}} readOnly={(brokerModes.globalBrokerMode > 0 && brokerModes.brokerMode > 0 ? false : true)}
                            /> 
                            {parseInt(brokerModes.globalBrokerMode) > 0 && parseInt(brokerModes.brokerMode) > 0 && riderVerification !== ""? 
                              
                              <span title={riderVerification}>
                                <Icon icon={`${fareEstimateAPISummary.verifyStatus !== "true" ? "entypo:circle-with-cross" : "lets-icons:check-fill"}`} 
                                  className={`${fareEstimateAPISummary.verifyStatus !== "true" ? "text-danger":"text-success"} ms-1 my-auto`} style={{width:"15px", height:"15px"}}
                                />
                              </span>
                            : ""} 
                          </span>
                          
                        </Col>
                      </> :
                      <Col>
                        <input type={"text"} value={riderName} autoComplete="new_pass" ref={riderNameRef} minLength={4} maxLength={35} required 
                          onChange={(e)=>setRiderName(e.target.value)} tabIndex={0}
                          className='text-nowrap p-0 px-1 callAgentInputStyle w-100' placeholder="Full Name" onKeyUp={handleSetRiderName} 
                          style={{maxHeight:"30px", height:"30px"}}
                        /> 
                      </Col>
                      }
                    </Row>
                    <Row className="mt-1">
                      <Col xs={(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2) ? 6:12} className="">
                        <input type={"search"} autoComplete="new_pass" value={pickupAddr} placeholder="Pickup Address..." 
                          title={pickupAddr} onChange={handlePUAddrChanged} 
                          style={{ textOverflow:"ellipsis", maxHeight:"30px", height:"30px"}} className='text-nowrap d-inline-flex px-1 p-0 w-100 callAgentInputStyle' 
                          onFocus={handlePUAddrChanged} onBlur={()=>{setTimeout(() => {
                            if(!focusedSuggestionCheckPU.current)
                            {
                              setInputSuggestionListPU("");
                            }
                          }, 300);}}
                          onKeyDown={(e)=>{
                            if(e.key === 'ArrowDown')
                            {
                              e.preventDefault();
                              setHighlightedIndex(-1);
                              if(liRefs.current.length > 0)
                              {
                                if(liRefs.current[0]?.current) //check for empty references
                                {
                                  setHighlightedIndex((prevIndex) => {
                                    const newIndex = (prevIndex + 1) % liRefs.current.length;
                                    liRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                                    return newIndex;
                                  });
                                }
                              }
                            }
                            else if (e.key === 'ArrowUp') {
                              e.preventDefault();
                              setHighlightedIndex(-1);
                              if(liRefs.current.length > 0)
                              {
                                if(liRefs.current[0]?.current)
                                {
                                  setHighlightedIndex((prevIndex) => {
                                    const newIndex = (prevIndex - 1 + liRefs.current.length) % liRefs.current.length;
                                    liRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                                    return newIndex;
                                  });
                                }
                              }
                            }
                          }}
                        />
                        {inputSuggestionListPU && inputSuggestionListPU !== "" ?
                          <ul tabIndex={0} className="user-select-none border position-absolute px-1" 
                            style={{width:"auto", maxWidth:"400px", height:"80px", overflowY:"auto", zIndex:1000, backgroundColor:"#e6eef1"}} 
                          >
                            {inputSuggestionListPU}
                          </ul>
                        :""}
                        
                      </Col>
                      {(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2) ? 
                        <Col xs={6} className="d-flex my-auto">
                          <select className='text-left w-100 overflow-hidden callAgentInputStyle' value={pickupVirtualStop.value} name={pickupVirtualStop.name} onChange={handleVSChange} 
                            title={"Pickup Virtual Stop: "+pickupVirtualStop.name} style={{height:"25px", maxHeight:"25px", textOverflow:"ellipsis"}} disabled={isVSSelectionDisabled}
                          >
                            <option value={"PU VS"}>Select Virtual Stop</option>
                            {virtualStopDropDownHTML}
                          </select>
                          {walkDistance.PUWalk !== 0?<p className="m-0 d-inline-flex user-select-none text-nowrap">{"("+walkDistance.PUWalk+"mi, "+walkDistance.PUDuration+"min)"}</p>: ""}
                        </Col>
                      : ""}
                    </Row>
                    <Row className="mt-1">
                      <Col>
                        <p type={"text"} style={{textOverflow:"ellipsis", maxWidth:"260px"}} 
                          title={((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2) ? (zones!==""?zones:"Unknown Zone")
                            :(pickPOI !== ""?("POI: " +pickPOI) : dispatchZones.pickZone))} 
                          className="overflow-hidden user-select-none text-nowrap m-0 w-100 fw-bold small">
                          {(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2) ? 
                            (zones !== "" ? zones:""):(pickPOI !== ""?`${dispatchZones.pickZone}${'\u00A0'.repeat(4)}${pickPOI}` : dispatchZones.pickZone)
                          }
                        </p>
                        
                      </Col>
                      <Col className="d-inline-flex justify-content-start">
                        <p className='m-0 mx-1 user-select-none small'>Notes</p>
                        <textarea
                          name="ctl00$ctl00$ContentPlaceHolder1$ContentPlaceHolder1$txtAgentInstructionNotes"
                          rows={2}
                          cols={20} ref={pickExtraInfoRef}
                          onKeyDown={(e)=>{
                            if(e.key === "Tab" && !e.shiftKey)
                            {
                              e.preventDefault();
                              addressSwitchBtnRef.current.focus();
                            }
                          }}
                          placeholder="Pickup extra info..."
                          id="ctl00_ctl00_ContentPlaceHolder1_ContentPlaceHolder1_txtAgentInstructionNotes"
                          style={{resize:"none", minWidth:"84px"}} autoComplete="new_pass"
                          value={pickExtraInfo} onChange={(e)=>setPickExtraInfo(e.target.value)}
                          className="tripDetails-label-dataFields d-inline-flex w-100 callAgentInputStyle"
                        />
                      </Col>
                      
                    </Row>
                    {(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2) ? 
                      <>
                        <Row className="m-0">
                          <Col className={`d-inline-flex ${screenWidthSize <= 630 ? "flex-wrap justify-content-start" : ""}`}>
                            <span className={`d-inline-flex small my-1 text-nowrap ${screenWidthSize <= 630 ? "mb-0" : ""}`}>
                              <Icon icon="bx:group" className="my-auto text-secondary" style={{width:"25px", height:"25px"}}/>
                              <label className='m-0 my-2 user-select-none callAgentLabelsResponsive' title={"Ambulatory Passenger Count"}>Pass.</label>
                              <input type={"number"} maxLength={2} value={passengerTypeCount.ambPass} style={{minWidth:"25px", maxHeight:"30px", height:"30px"}} 
                                name="ambPass" onChange={handlePassCountTotal} autoComplete="new_pass" ref={passengerCountPassengerRef}
                                onKeyDown={(e)=>{
                                  if(e.key === "Tab" && e.shiftKey)
                                  {
                                    e.preventDefault();
                                    addressSwitchBtnRef.current.focus();
                                  }
                                }}
                                className='text-nowrap border-1 p-1 m-1 w-25 text-center callcenterInputNumbers callAgentInputStyle no-counter'
                              />
                              {screenWidthSize <= 630 ?
                                <>
                                  <Icon icon="bx:handicap" className="my-auto text-primary" style={{width:"25px", height:"25px"}}/>
                                  <label className='m-0 my-2 user-select-none callAgentLabelsResponsive' title={"WheelChair Passenger Count"}>WC</label>
                                  <input type={"number"} maxLength={2} value={passengerTypeCount.totalWC} 
                                    style={{minWidth:"25px", maxHeight:"30px", height:"30px"}} name="totalWC" onChange={handlePassCountTotal} autoComplete="new_pass"
                                    className='text-nowrap border-1 p-1 m-1 w-25 text-center callcenterInputNumbers callAgentInputStyle no-counter'
                                  />
                                </>
                              :""}
                            </span>
                            {screenWidthSize > 630 ?
                              <>
                                <span className={`d-inline-flex small my-1 text-nowrap`}>
                                  <Icon icon="bx:handicap" className="my-auto text-primary" style={{width:"25px", height:"25px"}}/>
                                  <label className='m-0 my-2 user-select-none callAgentLabelsResponsive' title={"WheelChair Passenger Count"}>WC</label>
                                  <input type={"number"} maxLength={2} value={passengerTypeCount.totalWC} 
                                    style={{minWidth:"25px", maxHeight:"30px", height:"30px"}} name="totalWC" onChange={handlePassCountTotal} autoComplete="new_pass"
                                    className='text-nowrap border-1 p-1 m-1 w-25 text-center callcenterInputNumbers callAgentInputStyle no-counter'
                                  />
                                </span>
                              </>
                            :""}
                            
                            <span className={`d-inline-flex small text-nowrap ${screenWidthSize <= 630 ? "my-0" : "my-1"}`}>
                              <Icon icon="material-symbols:pets" className="my-auto" style={{width:"25px", height:"25px", color: "#c3a386"}}/>
                              <label className='m-0 my-2 user-select-none callAgentLabelsResponsive' title={"Service Animal Count"}>SA</label>
                              <input type={"number"} maxLength={2} value={passengerTypeCount.totalSA} style={{minWidth:"25px", maxHeight:"30px", height:"30px"}} name="totalSA" onChange={handlePassCountTotal} 
                                className='text-nowrap border-1 p-1 m-1 w-25 text-center callcenterInputNumbers callAgentInputStyle no-counter' autoComplete="new_pass"
                              />
                              {screenWidthSize <= 630 ?
                                <>
                                  <Icon icon="ph:stack-plus-fill" className="my-auto" style={{width:"25px", height:"25px", color: "#ffcc00"}}/>
                                  <label className='m-0 my-2 user-select-none callAgentLabelsResponsive' title={"Total Passengers Count"}>Total</label>
                                  <input type={"text"} value={passengerTypeCount.total} style={{minWidth:"25px", maxHeight:"30px", height:"30px"}} name="total"  autoComplete="new_pass"
                                    disabled  className='text-nowrap border-1 p-1 m-1 w-25 text-center callAgentInputStyle' title={"Total Passengers Count: "+passengerTypeCount.total}
                                  />
                                </>
                              :""}
                            </span>
                            {screenWidthSize > 630 ?
                              <>
                                <span className={`d-inline-flex small my-1 text-nowrap`}>
                                  <label className='m-0 my-2 user-select-none' title={"Total Passengers Count"}>Total</label>
                                  <input type={"text"} value={passengerTypeCount.total} style={{minWidth:"25px", maxHeight:"30px", height:"30px"}} name="total"  autoComplete="new_pass"
                                    disabled  className='text-nowrap border-1 p-1 m-1 w-25 text-center callAgentInputStyle' title={"Total Passengers Count: "+passengerTypeCount.total}
                                  />
                                </span>
                              </>
                            : ""}
                          </Col>
                        </Row>
                      </>
                    :""}
                  </Col>
                </Row>
                {(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2) ?
                  <Row>
                    <Col xs={2} className="d-flex flex-column">
                      
                      <span className="d-block small text-start AddressIconsResponsive text-nowrap my-auto" title={"Add a stop to the trip"}>
                        <Icon icon="bx:plus-circle" tabIndex={0} onKeyDown={(e)=>
                            {
                              // if(e.key === "Enter")
                              // {
                              //   setShowStopBlock(true);
                              //   setShowStopsInput(true);
                              //   if(returnLatLng.current !== "")
                              //   {
                              //     handleAddTripStops(e);
                              //   }
                              // }
                            }
                          } className="m-1 text-secondary" style={{width:"15px", height:"15px", cursor:"not-allowed"}} onClick={(e)=>{
                            // setShowStopBlock(true); 
                            // setShowStopsInput(true);
                            // if(returnLatLng.current !== "")
                            // {
                            //   handleAddTripStops(e);
                            // }
                          }}
                        />
                      </span>
                      <span className="d-block small text-start dottedLineResponsive mb-0 text-nowrap user-select-none">
                        <label>⋮</label>
                      </span>
                    </Col>
                    {showStopBlock ? 
                      <Col xs={10} className="p-0 mt-1 border rounded my-auto overflow-auto callAgentSummaryScroller" style={{maxHeight:"150px"}}>
                        {clientStops && clientStops.length > 0 ? clientStops.map((item, index)=>{
                          let waitTime = (item.waitTime && item.waitTime !== 0 ? item.waitTime:0);
                          return(
                            <Row className="m-0 my-1" key={index}>
                              <Col className="mx-3 px-1 rounded callAgentInputStyle overflow-auto callAgentSummaryScroller">
                                <span className="d-block small justify-content-between my-auto mt-1 text-nowrap overflow-hidden">
                                  <Button tabIndex={0} variant="light" className="p-0 px-1 small rounded" style={{ borderRadius: "0px"}} 
                                    title={"Edit Stop"} onClick={(e)=>{handleEditStop(e, item, index)}} 
                                    onKeyDown={(e)=>{if(e.key === "Enter"){handleEditStop(e, item, index)}}}
                                  >
                                    {"Edit"}
                                  </Button>
                                  <Button tabIndex={0} variant="light" className="p-0 ms-1 px-1 small rounded" style={{ borderRadius: "0px"}} 
                                    title={"Remove Stop"} onClick={(e)=>{handleRemoveStop(e, index)}} 
                                    onKeyDown={(e)=>{if(e.key === "Enter"){handleRemoveStop(e, index)}}}
                                  >
                                    {"Remove"}
                                  </Button>
                                  <span title={"Move Stop Up"} onClick={(e)=>{handleMoveClientStops(index, "up");}}>
                                    <Icon icon="bx:chevrons-up" title={"Move Stop Up"} className="my-auto text-dark" style={{width:"20px", height:"20px", cursor:"pointer"}}/>
                                  </span>
                                  <span title={"Move Stop Down"} className="ms-2" onClick={(e)=>{handleMoveClientStops(index, "down");}}>
                                    <Icon icon="bx:chevrons-down" title={"Move Stop Down"} className="my-auto text-dark" style={{width:"20px", height:"20px", cursor:"pointer"}}/>
                                  </span>
                                  <label className='m-0 d-inline-block user-select-none text-end float-end'>
                                    {"Stop: "+(index+1)}
                                  </label>
                                </span>
                                <span className="d-flex small text-nowrap overflow-hidden">
                                  <Icon icon="bx:map" className="my-auto mx-1 text-dark" style={{width:"15px", height:"15px"}}/>
                                  <label className='m-0 user-select-none text-nowrap overflow-hidden' 
                                    style={{textOverflow:"ellipsis", whiteSpace: "nowrap", minWidth:"150px", maxWidth:"250px"}}
                                    title={item.stopAddr}
                                  >
                                    {item.stopAddr}
                                  </label>
                                </span>
                                <span className="small text-nowrap overflow-hidden">
                                  <span className="d-inline-flex">
                                    <Icon icon="bx:pen" className="my-auto mx-1 text-dark" style={{width:"15px", height:"15px"}}/>
                                    <label className='m-0 user-select-none text-nowrap overflow-hidden' title={(item.notes === ""? "":"Notes: "+item.notes)}  
                                      style={{textOverflow:"ellipsis", whiteSpace: "nowrap", minWidth:"80px", maxWidth:"100px"}}>
                                      {(item.notes === "" ? "No Notes":item.notes)}
                                    </label>
                                  </span>
                                  <span className="d-inline-flex ms-2">
                                    <Icon icon="bx:alarm" className="my-auto mx-1 text-dark" style={{width:"15px", height:"15px"}}/>
                                    <label className='m-0 user-select-none text-nowrap overflow-hidden' 
                                      title={(parseInt(waitTime) === 0  ? "": " Wait: "+ (parseInt(waitTime) > 9 ? parseInt(waitTime) + " mins": parseInt(waitTime) + " min"))}  
                                      style={{textOverflow:"ellipsis", whiteSpace: "nowrap", minWidth:"80px", maxWidth:"100px"}}
                                    >
                                      {(parseInt(waitTime) === 0  ? "No Wait": (parseInt(waitTime) > 9 ? parseInt(waitTime) + " mins": parseInt(waitTime) + " min"))}
                                    </label>
                                  </span>
                                  <span className="d-inline-flex ms-2">
                                    <Icon icon="bx:walk" className="my-auto mx-1 text-dark" style={{width:"15px", height:"15px"}}/>
                                    <label className='m-0 user-select-none text-nowrap overflow-hidden' 
                                      title={"Load Type: "+ item.passLoadType.charAt(0).toUpperCase() + item.passLoadType.slice(1)}  
                                      style={{textOverflow:"ellipsis", whiteSpace: "nowrap", minWidth:"80px", maxWidth:"100px"}}
                                    >
                                      {(item.passLoadType === "none"? item.passLoadType.charAt(0).toUpperCase() + item.passLoadType.slice(1): item.passLoadType.charAt(0).toUpperCase() + item.passLoadType.slice(1) + " ("+item.stopPax.total+")")}
                                    </label>
                                  </span>
                                  {item.passengerName !== ""?
                                    <span className="ms-2 d-inline-flex my-auto">
                                      <Icon icon="bx:user" className="my-auto mx-1 text-dark" style={{width:"15px", height:"15px"}}/>
                                      <label className='m-0 user-select-none text-nowrap overflow-hidden' title={(item.passengerName)}  
                                        style={{textOverflow:"ellipsis", minWidth:"60px", maxWidth:"80px"}}>
                                        {item.passengerName}
                                      </label>
                                    </span>
                                  :""}
                                </span>
                              </Col>
                            </Row>
                          );
                          
                        }):""}
                        {showStopsInput ? 
                          <>
                            <Row className={`m-0 ${clientStops.length > 0 ? "":"mt-1"} mx-1`}>
                              <Col xs={8} className="position-relative my-auto">
                                <input type={"search"} autoComplete="new_pass" value={returnAddr} placeholder="Stop Address..." title={returnAddr}
                                  style={{ textOverflow:"ellipsis", maxHeight:"28px", minWidth:"200px", height:"28px"}} onFocus={handleReturnAddrChange}
                                  className='text-nowrap px-1 p-0 w-100 callAgentInputStyle' onChange={handleReturnAddrChange}
                                  onBlur={()=>{setTimeout(() => {
                                    if(!focusedSuggestionCheckReturn.current)
                                    {
                                      setInputSuggestionListReturn("");
                                    }
                                  }, 300);}} onKeyDown={(e) => {
                                    if(e.key === 'ArrowDown')
                                    {
                                      e.preventDefault();
                                      setHightlightedIndexReturn(-1);
                                      if(liRefsReturn.current.length > 0)
                                      {
                                        if(liRefsReturn.current[0]?.current) //check for empty references
                                        {
                                          setHightlightedIndexReturn((prevIndex) => {
                                            const newIndex = (prevIndex + 1) % liRefsReturn.current.length;
                                            liRefsReturn.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                                            return newIndex;
                                          });
                                        }
                                      }
                                    }
                                    else if (e.key === 'ArrowUp') {
                                      e.preventDefault();
                                      setHightlightedIndexReturn(-1);
                                      if(liRefsReturn.current.length > 0)
                                      {
                                        if(liRefsReturn.current[0]?.current)
                                        {
                                          setHightlightedIndexReturn((prevIndex) => {
                                            const newIndex = (prevIndex - 1 + liRefsReturn.current.length) % liRefsReturn.current.length;
                                            liRefsReturn.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                                            return newIndex;
                                          });
                                        }
                                      }
                                    }
                                  }}
                                />
                                {inputSuggestionListReturn && inputSuggestionListReturn !== "" ?
                                <ul tabIndex={0} className="user-select-none border position-absolute px-1 w-100" 
                                  style={{width:"auto", height:"80px", overflowY:"auto", zIndex:1000, backgroundColor:"#e6eef1"}} 
                                >
                                  {inputSuggestionListReturn}
                                </ul>
                                :""}
                              </Col>
                              <Col xs={4} className="my-auto text-end">
                                {stopLoadType.none ?
                                  <span className="d-block my-auto small" style={{borderRadius:"4px", maxHeight:"28px"}}>
                                    <p className="m-0 my-auto d-inline-flex user-select-none text-nowrap" title={"Wait Time (minutes)"}>{"Wait"}</p>
                                    <input type={"number"} maxLength={2} value={returnWaitTimeInput} style={{width:"25px", maxWidth:"25px", maxHeight:"28px", height:"28px"}} 
                                      name="waitTime" onChange={handlePassCountTotalStop} autoComplete="new_pass"
                                      className='text-nowrap border-1 my-auto mx-1 w-25 text-center callcenterInputNumbers callAgentInputStyle no-counter'
                                    />
                                  </span>
                                :
                                stopLoadType.load ? 
                                  (
                                    <span className="d-block my-auto small" style={{borderRadius:"4px", maxHeight:"28px"}}>
                                      <input type={"text"} value={stopLoadRiderName} autoComplete="new_pass" minLength={4} maxLength={35} required 
                                        onChange={(e)=>{setStopLoadRiderName(e.target.value)}} tabIndex={0}
                                        className='text-nowrap p-0 px-1 callAgentInputStyle w-100' placeholder="Full Name"
                                        style={{maxHeight:"28px", height:"28px"}}
                                      /> 
                                    </span>
                                  )
                                  :(
                                    <span className="d-block my-auto small" style={{borderRadius:"4px", maxHeight:"28px"}}>
                                      <select className='text-center w-100 overflow-hidden callAgentInputStyle' value={stopUnloadRiderName} ref={StopNameSelectionRef}
                                        onChange={(e)=>{setStopUnloadRiderName(e.target.value)}} title={(stopUnloadRiderName === "RN" ? "Select Rider Name":stopUnloadRiderName)}
                                        style={{minWidth:"58px", maxHeight:"28px", height:"28px", textOverflow:"ellipsis"}}
                                      >
                                        <option value={"RN"} disabled hidden>{"Rider Name"}</option>
                                        {clientStops.length > 0 ? clientStops.map((item,index)=>{
                                          if(item.passengerName !== "" && item.passLoadType === "load")
                                          {
                                            return(
                                              <option key={index} value={item.passengerName}>{item.passengerName}</option>
                                            );
                                          }
                                        }):""}
                                      </select>
                                    </span>
                                  )
                                }
                              </Col>
                            </Row>
                            <Row className="m-0 mt-1 mx-1">
                              <Col className="text-start d-flex small">
                                <span className="d-inline-flex my-auto" style={{borderRadius:"4px", maxHeight:"28px"}}>
                                  <p className="m-0 small d-inline-block user-select-none text-nowrap">{"Load"}</p>
                                  <input type="checkbox" className="mx-1" style={{cursor:"pointer"}} checked={stopLoadType.load} 
                                    onChange={(e)=>{
                                      let noneChecked = false;
                                      if(!(e.target.checked)){noneChecked = true;}
                                      else{setReturnWaitTimeInput(0);}
                                      setStopLoadType({none:noneChecked, load:e.target.checked, unload:false});}
                                    }
                                    onKeyDown={(e)=>{if(e.key === "Enter"){
                                      let noneChecked = false;
                                      if(e.target.checked){noneChecked = true;}
                                      else{setReturnWaitTimeInput(0);}
                                      setStopLoadType({none:noneChecked, load:!(e.target.checked), unload:false});
                                    }}}
                                  />
                                </span>
                                <span className="d-inline-flex my-auto" style={{borderRadius:"4px", maxHeight:"28px"}}>
                                  <p className="m-0 small d-inline-block user-select-none text-nowrap">{"Unload"}</p>
                                  <input type="checkbox" className="mx-1" style={{cursor:"pointer"}} checked={stopLoadType.unload} 
                                    onChange={(e)=>{
                                      let noneChecked = false;
                                      if(!(e.target.checked)){noneChecked = true;}
                                      else{setReturnWaitTimeInput(0);}
                                      setStopLoadType({none:noneChecked, load:false, unload:e.target.checked});}
                                    }
                                    onKeyDown={(e)=>{if(e.key === "Enter"){
                                      let noneChecked = false;
                                      if(e.target.checked){noneChecked = true;}
                                      else{setReturnWaitTimeInput(0);}
                                      setStopLoadType({none:noneChecked, load:false, unload:!(e.target.checked)});
                                    }}}
                                  />
                                </span>
                              </Col>
                              {stopLoadType.load || stopLoadType.unload ? 
                                <Col className="d-flex justify-content-end small text-end my-auto">
                                  <span className="d-inline-flex small my-auto text-nowrap">
                                    <Icon icon="bx:group" className="my-auto text-secondary" style={{width:"25px", height:"25px"}}/>
                                    <label className='m-0 my-auto user-select-none' title={"Ambulatory Passenger Count"}>Pax</label>
                                    <input type={"number"} maxLength={2} value={passengerTypeCountStop.ambPass} style={{minWidth:"25px", maxHeight:"28px", height:"28px"}} 
                                      name="ambPass" onChange={handlePassCountTotalStop} autoComplete="new_pass"
                                      className='text-nowrap border-1 m-1 w-25 text-center callcenterInputNumbers callAgentInputStyle no-counter'
                                    />
                                  </span>
                                  <span className="d-inline-flex small my-auto text-nowrap">
                                    <Icon icon="bx:handicap" className="my-auto text-primary" style={{width:"25px", height:"25px"}}/>
                                    <label className='m-0 my-auto user-select-none' title={"WheelChair Passenger Count"}>WC</label>
                                    <input type={"number"} maxLength={2} value={passengerTypeCountStop.totalWC} style={{minWidth:"25px", maxHeight:"28px", height:"28px"}} 
                                      name="totalWC" onChange={handlePassCountTotalStop} autoComplete="new_pass"
                                      className='text-nowrap border-1 m-1 w-25 text-center callcenterInputNumbers callAgentInputStyle no-counter'
                                    />
                                  </span>
                                  <span className="d-inline-flex small my-auto text-nowrap">
                                    <Icon icon="material-symbols:pets" className="my-auto" style={{width:"25px", height:"25px", color: "#c3a386"}}/>
                                    <label className='m-0 my-auto user-select-none' title={"Service Animal Count"}>SA</label>
                                    <input type={"number"} maxLength={2} value={passengerTypeCountStop.totalSA} style={{minWidth:"25px", maxHeight:"28px", height:"28px"}} 
                                      name="totalSA" onChange={handlePassCountTotalStop} autoComplete="new_pass"
                                      className='text-nowrap border-1 m-1 w-25 text-center callcenterInputNumbers callAgentInputStyle no-counter'
                                    />
                                  </span>
                                </Col>
                              :""}
                            </Row>
                            <Row className="m-0 mt-1 mx-1">
                              <Col className="text-start">
                                <textarea
                                  name="ctl00$ctl00$ContentPlaceHolder1$ContentPlaceHolder1$txtAgentInstructionNotes"
                                  rows={2}
                                  cols={20}
                                  placeholder="Stop extra info..." autoComplete="new_pass"
                                  id="ctl00_ctl00_ContentPlaceHolder1_ContentPlaceHolder1_txtAgentInstructionNotes"
                                  style={{resize:"none"}} value={returnAddrExtra} onChange={(e)=>setReturnAddrExtra(e.target.value)}
                                  className="tripDetails-label-dataFields d-inline-flex w-100 callAgentInputStyle"
                                />           
                              </Col>
                              <Col className="d-flex justify-content-end text-end my-auto">
                                <Button tabIndex={0} variant="success" className="p-0 p-1 mx-1 rounded" style={{ borderRadius: "0px"}} 
                                  title={"Finish adding the stops"} onClick={handleFinishAddingStops}
                                >
                                  {stopSaveBtnTitle}
                                </Button>
                                <Button tabIndex={0} variant="secondary" className="p-0 p-1 rounded" style={{ borderRadius: "0px"}} 
                                  title={"Close stop view"} onClick={handleCloseStops}
                                >
                                  {"Discard"}
                                </Button>
                              </Col>
                            </Row>
                          </>
                          
                        :""}
                      </Col> 
                    : ""}
                  </Row>
                :""}
                <Row className="">
                  <Col xs={2}>
                    <span className="d-block small mt-2 text-nowrap" 
                      title={((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2) ? "Drop Off" : "Drop Off or Virtual Stop")}
                    >
                      <Icon icon="bx:map" className="m-1 text-danger" style={{width:"15px", height:"15px"}}/>
                      <label className='m-0 user-select-none callAgentLabelsResponsive'>
                        {(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2) ?"DO":"DO/VS"}
                      </label>
                    </span>
                    <span className="d-block small mt-1 text-nowrap" title={"Drop Off Route Coverage Zone"}>
                      <Icon icon="bx:map-alt" className="m-1 text-info" style={{width:"15px", height:"15px"}}/>
                      <label className='m-0 my-1 user-select-none callAgentLabelsResponsive'>Zone</label>
                    </span>
                  </Col>
                  <Col xs={10} className="p-0">
                    <Row className="my-1">
                      <Col xs={(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2) ? 6:12} className="">
                        <input type={"search"} placeholder="Drop Off Address..." value={dropAddr} 
                          title={dropAddr} style={{textOverflow:"ellipsis", maxHeight:"30px", height:"30px"}} 
                          onChange={handleDOAddrChanged} autoComplete="new_pass" className='text-nowrap px-1 w-100 callAgentInputStyle' onFocus={handleDOAddrChanged} 
                          onBlur={()=>{setTimeout(() => {
                            if(!focusedSuggestionCheckDO.current)
                            {
                              setInputSuggestionListDO("");
                            }
                          }, 300);}} 
                          onKeyDown={(e)=>{
                            if(e.key === 'ArrowDown')
                            {
                              e.preventDefault();
                              setHightlightedIndexDO(-1);
                              if(liRefsDO.current.length > 0)
                              {
                                if(liRefsDO.current[0]?.current) //check for empty references
                                {
                                  setHightlightedIndexDO((prevIndex) => {
                                    const newIndex = (prevIndex + 1) % liRefsDO.current.length;
                                    liRefsDO.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                                    return newIndex;
                                  });
                                }
                              }
                            }
                            else if (e.key === 'ArrowUp') {
                              e.preventDefault();
                              setHightlightedIndexDO(-1);
                              if(liRefsDO.current.length > 0)
                              {
                                if(liRefsDO.current[0]?.current)
                                {
                                  setHightlightedIndexDO((prevIndex) => {
                                    const newIndex = (prevIndex - 1 + liRefsDO.current.length) % liRefsDO.current.length;
                                    liRefsDO.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                                    return newIndex;
                                  });
                                }
                              }
                            }
                          }}
                        />
                        {inputSuggestionListDO && inputSuggestionListDO !== "" ?
                          <ul tabIndex={0} className="user-select-none border position-absolute px-1" 
                            style={{width:"auto", maxWidth:"400px", height:"80px", overflowY:"auto", zIndex:1000, backgroundColor:"#e6eef1"}} 
                          >
                            {inputSuggestionListDO}
                          </ul>
                        :""}
                      </Col>
                      {(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2) ? 
                        <Col xs={6} className="d-flex my-auto">
                          <select className='text-left w-100 overflow-hidden callAgentInputStyle' value={dropAddrVirtualStop.value} name={dropAddrVirtualStop.name} 
                            onChange={handleVSChange} title={"Drop Off Virtual Stop: "+dropAddrVirtualStop.name} disabled={isVSSelectionDisabled}
                            style={{minWidth:"58px", maxHeight:"25px", height:"25px", textOverflow:"ellipsis"}}
                          >
                            <option value={"DO VS"}>Select Virtual Stop</option>
                            {virtualStopDropDownHTML}
                          </select>
                          {walkDistance.DOWalk !== 0?<p className="m-0 d-inline-flex user-select-none text-nowrap">{"("+walkDistance.DOWalk+"mi, "+walkDistance.DODuration+"min)"}</p>: ""}
                        </Col>
                      : ""}
                    </Row>
                    <Row className="mt-1">
                      <Col>
                        <p type={"text"} style={{textOverflow:"ellipsis", maxWidth:"260px"}} 
                          title={((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2) ?
                            (zones!==""?zones:"Unknown Zone") : (dropPOI !== ""?("POI: " + dropPOI) : dispatchZones.dropZone))} 
                          className="overflow-hidden user-select-none text-nowrap m-0 w-100 fw-bold small">
                          {(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2) ? 
                            (zones !== "" ? zones:""):(dropPOI !== ""?`${dispatchZones.dropZone}${'\u00A0'.repeat(4)}${dropPOI}` : dispatchZones.dropZone)
                          }
                        </p>
                        
                      </Col>
                      <Col className="d-inline-flex justify-content-start">
                        <p className='m-0 mx-1 user-select-none small'>Notes</p>
                        <textarea
                          name="ctl00$ctl00$ContentPlaceHolder1$ContentPlaceHolder1$txtAgentInstructionNotes"
                          rows={2}
                          cols={20}
                          placeholder="Drop off extra info..." autoComplete="new_pass" onFocus={(e)=>{setInputSuggestionListDO("")}}
                          id="ctl00_ctl00_ContentPlaceHolder1_ContentPlaceHolder1_txtAgentInstructionNotes"
                          style={{resize:"none", minWidth:"84px"}} value={dropExtraInfo} onChange={(e)=>setDropExtraInfo(e.target.value)}
                          className="tripDetails-label-dataFields d-inline-flex w-100 callAgentInputStyle"
                        />                   
                      </Col>
                    </Row>
                  </Col>
                </Row> {/* Equipment & total passengers row*/}
                { (transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2) ?
                  <Row className="m-0">
                    <Col xs={2}>

                    </Col>
                    <Col xs={8} className="d-inline-flex">
                      <span className="d-inline-flex small my-1 text-nowrap">
                        <Icon icon="bx:group" className="my-2 text-secondary" style={{width:"25px", height:"25px"}}/>
                        <label className='m-0 my-2 user-select-none callAgentLabelsResponsive' title={"Ambulatory Passenger Count"}>Pass.</label>
                        <input type={"number"} maxLength={2} value={passengerTypeCount.ambPass} style={{minWidth:"25px", maxHeight:"30px", height:"30px"}} 
                          name="ambPass" onChange={handlePassCountTotal} autoComplete="new_pass"
                          className='text-nowrap border-1 p-1 m-1 w-25 text-center callcenterInputNumbers callAgentInputStyle no-counter'
                        />
                      </span>
                      <span className="d-inline-flex small my-1 text-nowrap">
                        <Icon icon="bx:handicap" className="my-2 text-primary" style={{width:"25px", height:"25px"}}/>
                        <label className='m-0 my-2 user-select-none callAgentLabelsResponsive' title={"WheelChair Passenger Count"}>WC</label>
                        <input type={"number"} maxLength={2} value={passengerTypeCount.totalWC} 
                          style={{minWidth:"25px", maxHeight:"30px", height:"30px"}} name="totalWC" onChange={handlePassCountTotal} autoComplete="new_pass"
                          className='text-nowrap border-1 p-1 m-1 w-25 text-center callcenterInputNumbers callAgentInputStyle no-counter'
                        />
                      </span>
                      <span className="d-inline-flex small my-1 text-nowrap">
                        <Icon icon="material-symbols:pets" className="my-auto" style={{width:"25px", height:"25px", color: "#c3a386"}}/>
                        <label className='m-0 my-2 user-select-none callAgentLabelsResponsive' title={"Service Animal Count"}>SA</label>
                        <input type={"number"} maxLength={2} value={passengerTypeCount.totalSA} style={{minWidth:"25px", maxHeight:"30px", height:"30px"}} name="totalSA" onChange={handlePassCountTotal} 
                          className='text-nowrap border-1 p-1 m-1 w-25 text-center callcenterInputNumbers callAgentInputStyle no-counter' autoComplete="new_pass"
                        />
                      </span>
                      <span className="d-inline-flex small my-1 text-nowrap">
                        <label className='m-0 my-2 user-select-none' title={"Total Passengers Count"}>Total</label>
                        <input type={"text"} value={passengerTypeCount.total} style={{minWidth:"25px", maxHeight:"30px", height:"30px"}} name="total"  autoComplete="new_pass"
                          disabled  className='text-nowrap border-1 p-1 m-1 w-25 text-center callAgentInputStyle' title={"Total Passengers Count: "+passengerTypeCount.total}
                        />
                      </span>
                    </Col>
                  </Row> 
                :""}
                {(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2) ?
                  <>
                    <Row className={""}>
                      <Col xs={2} className="text-start">
                        <span className="d-block small mt-1 text-nowrap overflow-hidden" title={"Schedule Date"}>
                          <Icon icon="bx:calendar" className="mb-1 mx-1" style={{width:"15px", height:"15px"}}/>
                          <label className='m-0 user-select-none callAgentLabelsResponsive'>Date</label>
                        </span>
                        <span className="d-block small mt-2 text-nowrap overflow-hidden" title={"Appointment Time"}>
                          <Icon icon="bx:time" className="mb-1 mx-1" style={{width:"15px", height:"15px"}}/>
                          <label className='m-0 user-select-none callAgentLabelsResponsive'>Appt</label>
                        </span>
                      </Col>
                      <Col xs={10} className=" p-0">
                        <Row className="m-0">
                          <Col xs={6} className="" style={{padding:0, paddingLeft:"0.25rem", paddingRight:"0.8rem"}}>
                            <input type="date" name="dateGiven" autoComplete="new_pass" value={selectedDateSchTime} 
                              onChange={(e)=>{setSelectedDateSchTime(e.target.value); setIsTimeValidated(false);}} 
                              className="m-0 px-1 w-100 text-center callAgentInputStyle" style={{minWidth:"120px", maxHeight:"30px", height:"30px"}} 
                              min={systemDateTimeRef.current.date}
                            />
                            <input type="time" ref={apptTimeRef} autoComplete="new_pass" disabled={willCall} value={appointmentTime} 
                              onChange={(e)=>{setAppointmentTime(e.target.value);}} onBlur={(e)=>{handleApptTimeCheck(e);}}
                              className="m-0 px-1 w-100 mt-1 text-center callAgentInputStyle" style={{minWidth:"120px", maxHeight:"30px", height:"30px"}}
                            />
                          </Col>
                          <Col xs={6} className="p-0 ps-3">
                            {screenWidthSize >= 880 ? 
                              <>
                                {renderMultiScheduleComponent()}
                                <span className="justify-content-start d-flex mt-2">
                                  <p className='m-0 mx-1 d-inline-flex user-select-none my-auto small text-start' style={{minWidth:"40px"}} title={"Reservation Time"}>{"Time"}</p>
                                  <input type="time" value={schTime} disabled={(willCall? true : isSchTimeFieldDisabled)} onChange={(e)=>{setSchTime(e.target.value); setIsTimeValidated(false);}}
                                    className="m-0 px-1 w-100 text-center callAgentInputStyle" style={{minWidth:"90px", maxHeight:"28px", height:"28px"}} 
                                  />
                                  <span title={"Clear Time"} onClick={(e)=>{if(!willCall && !isSchTimeFieldDisabled){clearSchTime(e);}}}>
                                    <Icon icon="bx:reset" className="m-0" style={{width:"20px", height:"20px", cursor:"pointer", color:"black"}}/>
                                  </span>
                                </span>
                              </> 
                            :""}
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    {screenWidthSize < 880 ? 
                      <Row className={""}>
                        <Col xs={2} className="text-start">
                          <span className="d-block small mt-1 text-nowrap overflow-hidden" title={"Reservation Time"}>
                            <Icon icon="flat-color-icons:overtime" className="mb-1 mx-1" style={{width:"15px", height:"15px"}}/>
                            <label className='m-0 user-select-none callAgentLabelsResponsive'>{"Time"}</label>
                          </span>
                          
                        </Col>
                        <Col xs={10} className="p-0">
                          <Row className="m-0">
                            <Col xs={6} className="" style={{padding:0, paddingLeft:"0.25rem", paddingRight:"0.8rem"}}>
                              <span className="justify-content-start d-flex mt-1">
                                <input type="time" value={schTime} disabled={(willCall? true : isSchTimeFieldDisabled)} 
                                  onChange={(e)=>{setSchTime(e.target.value); setIsTimeValidated(false);}} 
                                  className="m-0 px-1 w-100 text-center callAgentInputStyle" style={{minWidth:"90px", maxHeight:"28px", height:"28px"}} 
                                />
                                <span title={"Clear Time"} onClick={(e)=>{if(!willCall && !isSchTimeFieldDisabled){clearSchTime(e);}}}>
                                  <Icon icon="bx:reset" className="m-0" style={{width:"20px", height:"20px", cursor:"pointer", color:"black"}}/>
                                </span>
                              </span>
                            </Col>
                            <Col xs={6} className="p-0 my-auto ps-3">
                              {renderMultiScheduleComponent()}
                            </Col>
                          </Row>
                          
                        </Col>
                      </Row>
                    :""}
                  </>
                :
                  <Row className="mt-1">
                    <Col xs={2}>
                      <span className="d-block mt-1 small text-nowrap" title={"Callback phone number"}>
                        <Icon icon="bx:phone" className="m-1" style={{width:"15px", height:"15px"}}/>
                        <label className='m-0 user-select-none callAgentLabelsResponsive'>Callback</label>
                      </span>
                    </Col>
                    <Col xs={10} className="p-0">
                      <Row className="m-0">
                        <Col className="p-0 px-1 my-auto">
                          <Form>
                            <PhoneInput className='text-nowrap text-center w-100 callAgentInputStyle p-1' style={{minWidth:"120px", maxHeight:"30px", height:"30px"}}
                              defaultCountry="US" value={(callBackActual !== "" ? callBackActual : callBackPhone)} onChange={setCallBackPhone} placeholder="(XXX) XXX-XXXX" autoComplete="new_pass"
                              onKeyDown={(e)=>{
                                let input = e.target.value;
                                if(e.key === '1' && (input.length === 0 || (input.length > 0 && input.charAt(0) === "1")))
                                {
                                  e.preventDefault();
                                } 
                                if(e.target.value.length >= 14 && e.key !== 'Backspace' && e.key !== "Delete" && e.key !== "Tab")
                                {e.preventDefault();}
                              }}
                            /> 
                          </Form>
                        </Col>
                        <Col className="d-inline-flex justify-content-start ms-4 p-0">
                          <p className='m-0 mx-1 user-select-none my-auto small text-start' style={{minWidth:"40px"}} title={"Reservation Time"}>{"Time"}</p>
                          <input type="time" value={schTime} onChange={(e) => {setSchTime(e.target.value);}} onBlur={handleSchTimeBlur} onClick={schTimeOnClick}
                            onFocus={schTimeOnFocus} disabled={isSchTimeFieldDisabled}
                            className="m-0 px-1 float-end w-100 text-center callAgentInputStyle" style={{minWidth:"110px", maxHeight:"30px", height:"30px"}}
                          />
                          <span title={"Clear Time"} onClick={clearSchTime}><Icon icon="bx:reset" className="m-0" style={{width:"20px", height:"20px", cursor:"pointer", color:"black"}}/></span>
                        </Col>
                      </Row>
                    </Col>
                  </Row> 
                }
                <Row className="mb-1"> {/*Remaining payment, callback, and Rider ID row */}
                  <Col xs={2}>
                    <span className="d-block small mt-2 text-nowrap" title={"Funding Source"}>
                      <Icon icon="bx:money" className="m-1 text-success" style={{width:"15px", height:"15px"}}/>
                      <label className='m-0 user-select-none callAgentLabelsResponsive'>FS</label>
                    </span>
                    <span className="d-block small mt-2 text-nowrap" title={"Payment Type Selection"}>
                      <Icon icon="bx:credit-card" className="m-1 text-warning" style={{width:"15px", height:"15px"}}/>
                      <label className='m-0 user-select-none callAgentLabelsResponsive'>Pay</label>
                    </span>
                  </Col>
                  <Col xs={10} className="p-0">
                    <Row className="m-0">
                      <Col className="p-0 px-1">
                        
                        <Row className="m-0">
                          <Col className="p-0">
                            <select className='text-center mt-1 p-1 d-inline-flex w-100 callAgentInputStyle' value={FSSelected} 
                              onChange={(e)=>{handleFSSelectionChange(e, "fs");}} style={{minWidth:"120px", maxHeight:"30px", height:"30px"}}
                            >
                              {FSDropdown && FSDropdown.length > 0 ? FSDropdown:""}
                            </select>
                          </Col>
                          <select className='d-block mt-1 text-center p-1 w-100 callAgentInputStyle' style={{minWidth:"120px", maxHeight:"30px", height:"30px"}}
                            value={PaySelected} 
                            onChange={(e)=>{setPaySelected(e.target.value); 
                              const selectedIndex = e.target.selectedIndex;
                              const selectedOption = e.target.options[selectedIndex];
                              if(selectedOption.textContent.toLowerCase().includes("card")){setShowCCBtn(true);}else{setShowCCBtn(false);}
                            }}
                          >
                            {PayDropdown && PayDropdown.length > 0 ? PayDropdown:""}
                          </select>
                        </Row>
                      </Col>
                      <Col className="d-inline-flex justify-content-start ms-4 p-0">
                        <p className='m-0 mx-1 user-select-none small' style={{maxWidth:"40px"}} title={"Agent Notes"}>{"Agent Notes"}</p>
                          <textarea
                            name="ctl00$ctl00$ContentPlaceHolder1$ContentPlaceHolder1$txtAgentInstructionNotes"
                            rows={2}
                            cols={20}
                            ref={agentNotesBtnRef}
                            placeholder={(screenWidthSize >= 650 ? "Extra Comments..." : "Comments...")}
                            id="ctl00_ctl00_ContentPlaceHolder1_ContentPlaceHolder1_txtAgentInstructionNotes"
                            style={{resize:"none", minWidth:"84px"}}
                            value={agentNotes} autoComplete="new_pass"
                            onChange={(e)=>setAgentNotes(e.target.value)}
                            className={`tripDetails-label-dataFields w-100 d-inline-flex mt-1 ${screenWidthSize >= 650 ? "" : "me-1"} px-1 callAgentInputStyle`}
                            onKeyDown={(e)=>
                            { 
                              try{
                                if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2))
                                {
                                  if(e.key === "Tab" && !e.shiftKey)
                                  {
                                    e.preventDefault();
                                    if(!bookBtnRef.current.disabled)
                                    {
                                      bookBtnRef.current.focus();
                                    }
                                    else
                                    {
                                      resetBtnRef.current.focus();
                                    }
                                  }
                                }
                              }
                              catch(err){console.log(err);}
                            }
                            }
                          />
                        
                      </Col>
                    </Row>
                  </Col>
                </Row>
                {(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2) ?
                  <Row className="mb-1">
                    <Col className="" xs={7}>

                    </Col>
                    <Col className={`${screenWidthSize < 650 ? "pe-0" : ""}`} xs={5}>
                      <span className="d-block my-auto text-nowrap">
                        {screenWidthSize >= 650 ? 
                          <p className='m-0 mx-1 user-select-none my-auto d-inline-flex text-start' style={{minWidth:"40px"}} title={"Add Leg/Return"}>{"Leg(s)"}</p>
                        :""}
                        <Button variant="dark" className={`${screenWidthSize < 650 ? 'w-100 justify-content-end':''}, p-0 p-1`} style={{maxHeight:"34px"}} ref={addLegBtnRef} onClick={(e)=>{
                          const isSameTime = verifiedAddr.some(
                            (leg)=> leg.time === schTime && leg.date === selectedDateSchTime && leg.time !== ""
                          );
                          let schTimeCheck = IsAppointmentTimeValid();

                          if(!timeValidateCheck.current)
                          {
                            validateMinScheduleTimeDifference(null, false, false, 'leg');
                          }
                          else if(!schTimeCheck)
                          {
                            setModalHeaderText("Stop Order Alert");
                            setModalBodyHTML("Selected pickup time is violating appointment time, please select PU Time earlier than ["+apptTimeCheckValsRef.current.TimeWindow+"].");
                            setModalFooterHTML(
                              <>
                              <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
                                OK
                              </Button>
                              </>
                            );
                            setShowDynamicModal(true);
                          }
                          else if(scheduleJSON.mainData !== "" && scheduleJSON.mainData.Schedule.ScheduleItem.length > 0)
                          {
                            setModalHeaderText("Stop Order Alert");
                            setModalBodyHTML("Multischedule is applied, please clear multischedule if you want to book multileg trips.");
                            setModalFooterHTML(
                              <>
                              <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
                                OK
                              </Button>
                              </>
                            );
                            setShowDynamicModal(true);
                          }
                          else if(isSameTime && addLegBtnTitle.toLowerCase().includes("leg"))
                          {
                            setModalHeaderText("Stop Order Alert");
                            setModalBodyHTML("Are you sure, you want to enter the time that is equal to last leg time? (" +schTime+")");
                            setModalFooterHTML(
                              <>
                              <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false); timeValidateCheck.current = false; handleAddLeg(e);}}>
                                Yes
                              </Button>
                              <Button variant='secondary' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                                No
                              </Button>
                              </>
                            );
                            setShowDynamicModal(true);
                          
                          }
                          else
                          {
                            timeValidateCheck.current = false;
                            handleAddLeg(e);
                          }
                          
                          }} title={"Add trip to stop order"}>
                          {showAddLegLoader ? <span role='status' aria-hidden='true' className='spinner-border spinner-border-sm'></span> : addLegBtnTitle}
                        </Button>
                        <Button variant="dark" className="p-0 ms-1 p-1 d-none" style={{minWidth:"92px", maxHeight:"34px"}} disabled={(addLegBtnTitle.toLowerCase()==="update")} 
                          onClick={handleAddLeg} title={"Add a return trip to stop order"}>
                          {"Add Return"}
                        </Button>
                      </span>
                      
                    </Col>
                  </Row> 
                : ""}
              </Row>
            </Col>
          </Row>
          {(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2) ?
          <>
            <Row>
              <Col className="text-start border-top" onClick={(e)=>{setAdditionalDetailsDisplay(!additionalDetailsDisplay);}} style={{backgroundColor:"#07447b"}}>
                <span className="d-inline-flex w-75" title={"Additional Details & Communication Methods"}>
                  <Icon icon="bx:chat" className="mt-1 text-white" style={{minWidth:"25px", minHeight:"25px", width:"25px", height:"25px"}}/>
                  <label className='m-0 m-1 user-select-none fw-bold text-white text-nowrap overflow-hidden' style={{textOverflow:"ellipsis"}}>Additional Details & Comm. Methods</label>
                </span>
                <span className="d-inline-flex mt-1 float-end"
                  onClick={(e)=>{setAdditionalDetailsDisplay(!additionalDetailsDisplay);}} tabIndex={0}
                  onKeyDown={(e)=>{if(e.key === "Enter"){setAdditionalDetailsDisplay(!additionalDetailsDisplay);}}}>
                  {additionalDetailsDisplay? <Icon icon="bx:chevron-down" className="text-white" style={{width:"25px", height:"25px", cursor:"pointer"}}/>:
                    <Icon icon="bx:chevron-up" className="text-white" style={{width:"25px", height:"25px", cursor:"pointer"}}/>
                  }
                </span>
              </Col>
            </Row>
            <Row className={`${additionalDetailsDisplay? '':'d-none'} m-0 mt-1 overflow-auto callAgentSummaryScroller`}>
              <Col className="text-start p-0">
                <Row className="m-0">
                  <Col className="p-0 rounded border border-dark overflow-auto callAgentSummaryScroller">
                    <Row className="m-0 px-1 mt-2">
                      <Col className="small" xs={(screenWidthSize >= 820 ? 6: 12)}>
                        <span className="d-flex small my-auto text-nowrap" title={"Client email address"}>
                          <Icon icon="bx:mail-send" className="my-auto mx-1 text-secondary" style={{minWidth:"15px", minHeight:"15px", width:"15px", height:"15px"}}/>
                          <label className='m-0 my-auto user-select-none callAgentLabelsResponsive'>Email</label>
                          <input type="text" value={clientEmail} onChange={(e)=>{setClientEmail(e.target.value);}}
                            className="m-0 ms-2 px-1 w-100 text-start callAgentInputStyle" style={{minWidth:"120px", maxHeight:"30px", height:"30px"}} autoComplete="new_pass"
                          /> 
                        </span>
                      </Col>
                      <Col className={`${(screenWidthSize >= 820 ? '':'d-none')} small`} xs={6}>
                        {screenWidthSize >= 820 ? 
                          <span className="d-flex my-auto small text-nowrap w-100" title={"Callback phone number"}>
                            <Icon icon="bx:phone" className="my-auto mx-1" style={{minWidth:"15px", minHeight:"15px", width:"15px", height:"15px"}}/>
                            <label className='m-0 my-auto user-select-none callAgentLabelsResponsive'>Callback</label>
                            
                            <Form className="d-flex w-100 ms-2">
                              <PhoneInput className='text-nowrap text-center m-0 w-100 callAgentInputStyle' style={{maxHeight:"30px", height:"30px"}}
                                defaultCountry="US" value={callBackPhone} onChange={setCallBackPhone} placeholder="(XXX) XXX-XXXX" autoComplete="new_pass"
                                onKeyDown={(e)=>{
                                  let input = e.target.value;
                                  if(e.key === '1' && (input.length === 0 || (input.length > 0 && input.charAt(0) === "1")))
                                  {
                                    e.preventDefault();
                                    // handleCorrectPhoneFormatDisplay(e);
                                    //e.target.value === "(111) 111-1111";
                                  } 
                                  if(e.target.value.length >= 14 && e.key !== 'Backspace' && e.key !== "Delete" && e.key !== "Tab")
                                  {e.preventDefault();}
                                
                                }}
                              /> 
                            </Form>
                          </span>
                        :""}
                      </Col>
                    </Row>
                    {screenWidthSize < 820 ?
                      <Row className="m-0 px-1 mt-1">
                        <Col className="small w-100" xs={12}>
                          <span className="d-flex my-auto small text-nowrap" title={"Callback phone number"}>
                            <Icon icon="bx:phone" className="my-auto mx-1" style={{minWidth:"15px", minHeight:"15px", width:"15px", height:"15px"}}/>
                            <label className='m-0 my-auto user-select-none callAgentLabelsResponsive'>Callback</label>
                            
                            <Form className="d-flex w-100 ms-2">
                              <PhoneInput className='text-nowrap text-center m-0 w-100 callAgentInputStyle' 
                                style={{minWidth:"120px", width:"120px", maxHeight:"30px", height:"30px"}}
                                defaultCountry="US" value={(callBackActual !== "" ? callBackActual : callBackPhone)} onChange={setCallBackPhone} 
                                placeholder="(XXX) XXX-XXXX" autoComplete="new_pass"
                                onKeyDown={(e)=>{
                                  let input = e.target.value;
                                  if(e.key === '1' && (input.length === 0 || (input.length > 0 && input.charAt(0) === "1")))
                                  {
                                    e.preventDefault();
                                    // handleCorrectPhoneFormatDisplay(e);
                                    //e.target.value === "(111) 111-1111";
                                  } 
                                  if(e.target.value.length >= 14 && e.key !== 'Backspace' && e.key !== "Delete" && e.key !== "Tab")
                                  {e.preventDefault();}
                                
                                }}
                              /> 
                            </Form>
                          </span>
                        </Col>
                      </Row>
                    :""}
                    <Row className="m-0 px-1">
                      <Col className="mb-1">
                        <span className="d-inline-flex" style={{borderRadius:"4px", minWidth:"80px", maxHeight:"28px"}}>
                          <input type="checkbox" className="mx-1" style={{cursor:"pointer"}} checked={RCType.phoneType} onChange={(e)=>{setRCType({...RCType, phoneType:e.target.checked});}}/>
                          <p className="m-0 small d-inline-block user-select-none text-nowrap">{"Call"}</p>
                        </span>
                        <span className="d-inline-flex" style={{borderRadius:"4px", minWidth:"80px", maxHeight:"28px"}}>
                          <input type="checkbox" className="mx-1" style={{cursor:"pointer"}} checked={RCType.emailType} onChange={(e)=>{setRCType({...RCType, emailType:e.target.checked});}}/>
                          <p className="m-0 small d-inline-block user-select-none text-nowrap">{"Email"}</p>
                        </span>
                        <span className="d-inline-flex" style={{borderRadius:"4px", minWidth:"80px", maxHeight:"28px"}}>
                          <input type="checkbox" className="mx-1" style={{cursor:"pointer"}} 
                            checked={RCType.SMSType} onChange={(e)=>{setRCType({...RCType, SMSType:e.target.checked});}}
                          />
                          <p className="m-0 small d-inline-block user-select-none text-nowrap">{"SMS"}</p>
                        </span>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row className="m-0 my-1">
                  <Col className="p-0 rounded border border-dark overflow-auto callAgentSummaryScroller">
                    <Row className="m-0 px-1 mt-2">
                      <Col className="small">
                        <table className="w-100 mb-2 callAgentInputStyle">
                          <thead className="" style={{borderTop:"5px"}}>
                            <tr className="text-center text-nowrap text-white">
                              <th className="p-1 border-right border-secondary user-select-none" style={{backgroundColor:"#35738a", fontWeight:"500", borderTopLeftRadius:"5px", borderRight:"1px solid #ccc"}}>{"Trip Priority"}</th>
                              <th className="p-1 border-right border-secondary user-select-none" style={{backgroundColor:"#35738a", fontWeight:"500",borderRight:"1px solid #ccc"}}>{"Job"}</th>
                              <th className="p-1 border-right border-secondary user-select-none" style={{backgroundColor:"#35738a", fontWeight:"500", borderTopRightRadius:"5px"}}>{"Trip Type"}</th>
                            </tr>
                          </thead>
                          <tbody className="">
                            <tr className="text-center">
                              <td className="text-nowrap small overflow-hidden p-1" style={{borderRight:"1px solid #ccc"}}>
                                <select className='text-center d-inline-block p-1 w-100 callAgentInputStyle' style={{minWidth:"120px", height:"30px", maxHeight:"30px"}}
                                  value={selectedTripPriority} onChange={(e)=>{setSelectedTripPriority(e.target.value);}} disabled
                                > 
                                  <option value={1}>{"P1"}</option>
                                  <option value={2}>{"P2"}</option>
                                  <option value={3}>{"P3"}</option>
                                  <option value={4}>{"P4"}</option>
                                  <option value={5}>{"P5"}</option>
                                </select>
                              </td>
                              <td className="text-nowrap small overflow-hidden px-1" style={{borderRight:"1px solid #ccc"}}>
                                <input type="text" className="w-100 callAgentInputStyle text-center" autoComplete="new_pass" style={{minWidth:"100px", border:"1px solid black", height:"30px", maxHeight:"30px"}} 
                                  value={clientJob} onChange={(e)=>{setClientJob(e.target.value);}}
                                />
                              </td>
                              <td className="text-nowrap small overflow-hidden p-1" style={{}}>
                                <select className='text-center d-inline-block p-1 w-100 callAgentInputStyle' style={{minWidth:"120px", height:"30px", maxHeight:"30px", border:"1px solid black"}}
                                  value={selectedTripType} onChange={(e)=>{setSelectedTripType(e.target.value);}}
                                >
                                  {tripTypeOptionsHTML}
                                </select>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <textarea
                          name="ctl00$ctl00$ContentPlaceHolder1$ContentPlaceHolder1$txtAgentInstructionNotes"
                          rows={2}
                          cols={20}
                          placeholder="Additional Information..."
                          id="ctl00_ctl00_ContentPlaceHolder1_ContentPlaceHolder1_txtAgentInstructionNotes"
                          style={{resize:"none"}} autoComplete="new_pass"
                          value={paymentAdditionalInfo} onChange={(e)=>setPaymentAdditionalInfo(e.target.value)}
                          className="tripDetails-label-dataFields px-1 d-inline-flex w-100 callAgentInputStyle small"
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col className="text-start border-top" onClick={(e)=>{setPaymentDetailsDisplay(!paymentDetailsDisplay);}} style={{backgroundColor:"#07447b"}}>
                <span className="d-inline-flex w-75 my-auto" title={"Payment Details"}>
                  <Icon icon="bx:credit-card" className="mt-1 text-white" style={{minWidth:"25px", minHeight:"25px", width:"25px", height:"25px"}}/>
                  <label className='m-0 m-1 user-select-none fw-bold text-white text-nowrap overflow-hidden' style={{textOverflow:"ellipsis"}}>Payment Details</label>
                </span>
                <span className="d-inline-flex mt-1 float-end"
                  onClick={(e)=>{setPaymentDetailsDisplay(!paymentDetailsDisplay);}} tabIndex={0}
                  onKeyDown={(e)=>{if(e.key === "Enter"){setPaymentDetailsDisplay(!paymentDetailsDisplay);}}}>
                  {paymentDetailsDisplay? <Icon icon="bx:chevron-down" className="text-white" style={{width:"25px", height:"25px", cursor:"pointer"}}/>:
                    <Icon icon="bx:chevron-up" className="text-white" style={{width:"25px", height:"25px", cursor:"pointer"}}/>
                  }
                </span>
              </Col>
            </Row>
            <Row className={`${paymentDetailsDisplay? '':'d-none'} m-0 mt-1 overflow-auto callAgentSummaryScroller`}>
              <Col className="text-start p-0">
                <Row className="m-0 my-1">
                  <Col className="p-0 rounded border border-dark overflow-auto callAgentSummaryScroller">
                    <span className="d-block small fw-bold mt-1 text-nowrap overflow-hidden">
                      <Icon icon="bx:receipt" className="mb-1 mx-1 text-warning" style={{width:"15px", height:"15px"}}/>
                      <label className='m-0 user-select-none'>Copay Info</label>
                    </span>
                    <Row className="m-0 px-1">
                      <Col className="d-flex small">
                        <select className='text-center d-inline-block p-1 w-100 callAgentInputStyle' style={{minWidth:"120px", maxHeight:"30px"}}
                          value={copayFSSelected} onChange={(e)=>{handleFSSelectionChange(e, "copay");}} title={"Copay FS"}
                        >
                          {/* <option disabled hidden value={"CFS"}>{"Copay FS"}</option> */}
                          {CopayFSDropdown && CopayFSDropdown.length > 0 ? CopayFSDropdown:""}
                        </select>
                        <select className='text-center p-1 ms-1 w-100 callAgentInputStyle' style={{minWidth:"120px", maxHeight:"30px"}}
                          value={copayPayTypeSelected} 
                          onChange={(e)=>{setCopayPayTypeSelected(e.target.value); 
                            const selectedIndex = e.target.selectedIndex;
                            const selectedOption = e.target.options[selectedIndex];
                            if(selectedOption.textContent.toLowerCase().includes("card")){setShowCCBtn(true);}else{setShowCCBtn(false);}
                          }} title={"Copay Pay Type"}
                        >
                          <option disabled hidden value={"CPT"}>{"Copay Pay Type"}</option>
                          {PayDropdown && PayDropdown.length > 0 ? PayDropdown:""}
                        </select>
                        
                      </Col>
                    </Row>
                    {/* <Row className="m-0 mt-1">
                      <Col xs={6}>
                        <span className="d-flex small my-auto text-nowrap" title={"Card Number"}>
                          <Icon icon="bx:credit-card-front" className="my-auto mx-1" style={{minWidth:"15px", minHeight:"15px", width:"15px", height:"15px"}}/>
                          <label className='m-0 user-select-none callAgentLabelsResponsive'>Card#</label>
                          <input type="text" value={cardNumber} maxLength={19}
                            onChange={handleCardNumberChange}
                            className="m-0 ms-2 px-1 text-center overflow-hidden callAgentInputStyle" style={{minWidth:"60px", maxWidth:"100%", boxSizing:"border-box"}} autoComplete="new_pass" 
                            title={cardNumber}
                          />  
                        </span>
                      </Col>
                      <Col xs={6} className="pe-3 ps-0">
                        <span className="d-flex small my-auto text-nowrap" title={"Card Expiration Date"}>
                          <Icon icon="bx:calendar-exclamation" className="my-auto mx-1" style={{minWidth:"15px", minHeight:"15px", width:"15px", height:"15px"}}/>
                          <label className='m-0 user-select-none callAgentLabelsResponsive'>Expiry</label>
                          <input type="month" value={cardExpiration} min={minMonth} max={maxMonth}
                            onChange={handleCardExpiryValidation}
                            className="m-0 ms-2 px-1 text-center overflow-hidden callAgentInputStyle" 
                            style={{minWidth:"60px", maxWidth:"100%", boxSizing:"border-box"}} autoComplete="new_pass" 
                            title={cardExpiration}
                          />  
                        </span>
                      </Col>
                    </Row> */}
                    <Row className="m-0 pe-3">
                      <Col className="d-flex small text-start" xs={6}>
                        <span className="d-inline-block small my-auto text-nowrap overflow-hidden" title={"Copay Amount"}>
                          <Icon icon="bx:dollar" className="mb-1 mx-1 text-success" style={{minWidth:"15px", minHeight:"15px", width:"15px", height:"15px"}}/>
                          <label className='m-0 user-select-none callAgentLabelsResponsive'>Copay/Promo</label>
                        </span>
                        <input type="number" value={copayAmount} 
                          onChange={handleCopayAmountChange} maxLength={7}
                          className="m-0 ms-2 m-1 px-1 w-100 text-center callAgentInputStyle no-counter callcenterInputNumbers" style={{minWidth:"60px", maxWidth:"100px"}} autoComplete="new_pass" 
                          title={"$"+copayAmount}
                        />  
                      </Col>
                      <Col className="d-flex small text-start p-0 ps-2" xs={6}>
                        {showCCBtn ?
                          <>
                            <span className="d-flex small my-auto text-nowrap overflow-hidden" title={"Card Info"}>
                              <Icon icon="bx:credit-card-front" className="my-auto mx-1" style={{minWidth:"15px", minHeight:"15px", width:"15px", height:"15px"}}/>
                              <label className='m-0 user-select-none callAgentLabelsResponsive'>Card Info:</label>
                              <p type={"text"} style={{textOverflow:"ellipsis"}} 
                                title={(cardType !== "" ? cardNumber + " " + cardType:"NONE")} 
                                className="overflow-hidden user-select-none text-nowrap m-0 ms-2 my-auto w-100 fw-normal"
                              >
                                {(cardType !== "" ? cardNumber + " " + cardType:"NONE")}
                              </p>
                            </span>
                          
                            <Button variant="dark"
                              className="ms-1 p-0 px-1 rounded small my-auto fw-normal text-nowrap" onClick={(e)=>{
                                if(clientInfo && !Array.isArray(clientInfo))
                                  setShowCCInfoDialog(true);
                                else
                                {
                                  setModalHeaderText("Card Info Alert");
                                  setModalBodyHTML("Customer profile must exist before adding cards in profile.");
                                  setModalFooterHTML(
                                    <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                                      OK
                                    </Button>
                                  );
                                  setShowDynamicModal(true);
                                }
                              }}  
                              style={{borderRadius:"0px", height:"25px", maxHeight:"25px"}} disabled
                            >
                              {"CC Info"}
                            </Button>
                          </> 
                        :""}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className="">
              <Col className={`${driverVehInfoDisplay? "" : "headerRoundedCornerStyle"} text-start border-top`} 
                onClick={(e)=>{setDriverVehInfoDisplay(!driverVehInfoDisplay);}} style={{backgroundColor:"#07447b"}}
              >
                <span className="d-inline-flex w-75 my-auto" title={"Mobility Information"}>
                  <Icon icon="bx:taxi" className="mt-1 text-white" style={{minWidth:"25px", minHeight:"25px", width:"25px", height:"25px"}}/>
                  <label className='m-0 m-1 user-select-none fw-bold text-white text-nowrap overflow-hidden' style={{textOverflow:"ellipsis"}}>Mobility Information</label>
                </span>
                <span className="d-inline-flex mt-1 float-end" tabIndex={0} ref={mobilityInfoDisplayRef}
                  onClick={(e)=>{setDriverVehInfoDisplay(!driverVehInfoDisplay);}} onKeyDown={(e)=>{
                    if(e.key === "Enter"){setDriverVehInfoDisplay(!driverVehInfoDisplay);}
                    else if(e.key === "Tab" && !e.shiftKey && !driverVehInfoDisplay && !insuranceInfoDisplayRef.current){
                      e.preventDefault();
                      if(paratransitBookBtnRef.current.disabled)
                      {
                        resetBtnRef.current.focus();
                      }
                      else
                      {
                        paratransitBookBtnRef.current.focus();
                      }
                    }
                  }}>
                  {driverVehInfoDisplay? <Icon icon="bx:chevron-down" className="text-white" style={{width:"25px", height:"25px", cursor:"pointer"}}/>:
                    <Icon icon="bx:chevron-up" className="text-white" style={{width:"25px", height:"25px", cursor:"pointer"}}/>
                  }
                </span>
              </Col>
            </Row>
            <Row className={`${driverVehInfoDisplay? '':'d-none'} mt-1 overflow-auto callAgentSummaryScroller`}>
              <Row className="m-0 mb-1">
                <Col xs={6} className="text-start small">
                  <span className="user-select-none d-flex my-auto small" title={"Trip Attributes Selection"} style={{height:"30px", maxHeight:"30px"}}>
                    <Icon icon="bx:customize" className="my-auto" style={{width:"25px", height:"25px"}}/>
                    <MultiSelectDropdown options={AttributesFilterMultiSelect} disablePreSelectedValues={true} 
                      SelectionChangeCallback={AttributesSelectCallback} FireSelectEventOnEveryItemChange={true}
                      />
                  </span>
                  <span className="user-select-none d-flex mt-1 small" title={"Preferred Vehicle Type Selection"} style={{height:"30px", maxHeight:"30px"}}>
                    <Icon icon="tdesign:vehicle" className="my-auto" style={{width:"25px", height:"25px"}}/>
                    <select className='text-center ms-2 p-1 w-100 callAgentInputStyle' style={{minWidth:"120px", maxHeight:"30px", height:"30px"}} value={selectedVehType}
                      onChange={handleVehTypeChanged} title={(selectedVehType === "VT"? "":"Vehicle Type: "+ selectedVehType)}
                    >
                      <option value={"VT"} disabled hidden>{"Vehicle Type"}</option>
                      {vehTypeOptionsHTML}
                    </select>
                  </span>
                  <span className="user-select-none d-flex mt-1 small text-center" title={"Preferred Vehicle Number Selection"} style={{height:"30px", maxHeight:"30px"}}>
                    <Icon icon="bx:taxi" className="my-auto" style={{width:"25px", height:"25px"}}/>
                    <select className='text-center ms-2 p-1 w-100 callAgentInputStyle' style={{minWidth:"120px", maxHeight:"30px", height:"30px"}} value={selectedVehNum}
                      onChange={handleChangeOnVehNumber} title={(selectedVehNum === "VN"? "":"Vehicle #: "+ selectedVehNum.split("_")[1])}
                    >
                      <option value={"VN"} disabled hidden>{"Vehicle #"}</option>
                      {vehNumberOptionsHTML}
                    </select>
                  </span>

                  <span className="user-select-none d-flex mt-1 small text-center" title={"Preferred Driver Number Selection"} style={{height:"30px", maxHeight:"30px"}}>
                    <Icon icon="healthicons:truck-driver" className="my-auto" style={{width:"25px", height:"25px"}}/>
                    <select className='text-center ms-2 p-1 w-100 callAgentInputStyle' style={{minWidth:"120px", maxHeight:"30px", height:"30px"}} value={selectedDriverNum}
                      onChange={(e)=>{setSelectedDriverNum(e.target.value)}} title={(selectedDriverNum === "DN"? "":"Driver #: "+ selectedDriverNum.split("_")[1])}
                    >
                      <option value={"DN"} disabled hidden>{"Driver #"}</option>
                      {driverNumberOptionsHTML}
                    </select>
                  </span>
                  <span className="user-select-none d-flex mt-1 small text-center" title={"Preferred Driver Gender Selection"} style={{height:"30px", maxHeight:"30px"}}>
                    <Icon icon="bx:male-female" className="my-auto" style={{width:"25px", height:"25px"}}/>
                    <select className='text-center ms-2 p-1 w-100 callAgentInputStyle' style={{minWidth:"120px", maxHeight:"30px", height:"30px"}} value={selectedGender}
                      onChange={(e)=>{setSelectedGender(e.target.value);}}
                    >
                      <option value={"Gender"} disabled hidden>{"Gender"}</option>
                      <option value={"Gender"}>{"None"}</option>
                      <option value={"Male"}>{"Male"}</option>
                      <option value={"Female"}>{"Female"}</option>
                    </select>
                  </span>
                  <span className="user-select-none d-flex mt-1 small text-center" title={"Preferred Driver Language Selection"} style={{height:"30px", maxHeight:"30px"}}>
                    <Icon icon="bx:chat" className="my-auto" style={{width:"25px", height:"25px"}}/>
                    <select className='text-center ms-2 p-1 w-100 callAgentInputStyle' style={{minWidth:"120px", maxHeight:"30px", height:"30px"}} value={selectedLanguage}
                      onChange={(e)=>{setSelectedLanguage(e.target.value);}} ref={languageOptionsSelRef}
                    >
                      <option value={"Language"} disabled hidden>{"Language"}</option>
                      {languageOptionsHTML}
                    </select>
                  </span>
                  
                </Col>
                <Col xs={6} className="text-start small">
                  <span className="user-select-none d-flex my-auto small" style={{height:"30px", maxHeight:"30px"}}>
                  </span>
                  <span className="user-select-none d-flex mt-1 my-auto small" style={{height:"30px", maxHeight:"30px"}}>
                    <input type="checkbox" style={{cursor:"pointer"}} className="p-1" checked={mobilityChecks.vehTypeCheck}
                      onChange={(e)=>{if(!e.target.checked){setMobilityDetails({...mobilityDetails, vehTypeMin:0});}
                        setMobilityChecks({...mobilityChecks, vehTypeCheck:e.target.checked});
                      }} 
                      onKeyDown={(e)=>{if(e.key === "Enter"){
                        if(e.target.checked)
                        {
                          setMobilityDetails({...mobilityDetails, vehTypeMin:0});
                        }
                        setMobilityChecks({...mobilityChecks, vehTypeCheck:!e.target.checked});
                      }
                      }}
                    />
                  </span>
                  <span className="user-select-none d-flex mt-1 my-auto small" style={{height:"30px", maxHeight:"30px"}}>
                    <input type="checkbox" style={{cursor:"pointer"}} className="p-1" checked={mobilityChecks.vehNumCheck}
                      onChange={(e)=>{
                        if(!e.target.checked){setMobilityDetails({...mobilityDetails, vehNumMin:0});}
                        setMobilityChecks({...mobilityChecks, vehNumCheck:e.target.checked});
                      }} 
                      onKeyDown={(e)=>{if(e.key === "Enter"){
                        if(e.target.checked)
                        {
                          setMobilityDetails({...mobilityDetails, vehNumMin:0});
                        }
                        setMobilityChecks({...mobilityChecks, vehNumCheck:!e.target.checked});
                      }}}
                    />
                    <input type="number" maxLength={2} disabled={!mobilityChecks.vehNumCheck} value={mobilityDetails.vehNumMin} 
                      onChange={(e)=>{handleMobilityInputChange(e,"vehNumMin");}} title={mobilityDetails.vehNumMin+" min"}
                      className="m-0 px-1 ms-2 w-100 text-center callAgentInputStyle no-counter" 
                      style={{minWidth:"80px", maxHeight:"30px", height:"30px"}} autoComplete="new_pass"
                    />
                  </span>
                  <span className="user-select-none d-flex mt-1 my-auto small" style={{height:"30px", maxHeight:"30px"}}>
                    <input type="checkbox" style={{cursor:"pointer"}} className="p-1" checked={mobilityChecks.driverNumCheck} 
                      onChange={(e)=>{
                        if(!e.target.checked){setMobilityDetails({...mobilityDetails, driverNumMin:0});}
                        setMobilityChecks({...mobilityChecks, driverNumCheck:e.target.checked});
                      }} onKeyDown={(e)=>{if(e.key === "Enter"){
                        if(e.target.checked){setMobilityDetails({...mobilityDetails, driverNumMin:0});}
                        setMobilityChecks({...mobilityChecks, driverNumCheck:!e.target.checked});
                      }}}
                    />
                    <input type="number" disabled={!mobilityChecks.driverNumCheck} maxLength={2} value={mobilityDetails.driverNumMin} 
                      onChange={(e)=>{handleMobilityInputChange(e,"driverNumMin");}}
                      className="m-0 px-1 ms-2 w-100 text-center callAgentInputStyle no-counter" 
                      style={{minWidth:"80px", maxHeight:"30px", height:"30px"}} 
                      autoComplete="new_pass" title={mobilityDetails.driverNumMin+" min"}
                    />
                  </span>
                  <span className="user-select-none d-flex mt-1 my-auto small" style={{height:"30px", maxHeight:"30px"}}>
                    <input type="checkbox" style={{cursor:"pointer"}} className="p-1" checked={mobilityChecks.genderCheck} 
                      onChange={(e)=>{
                        if(!e.target.checked){setMobilityDetails({...mobilityDetails, genderMin:0});}
                        setMobilityChecks({...mobilityChecks, genderCheck:e.target.checked});
                      }} onKeyDown={(e)=>{if(e.key === "Enter"){
                        if(e.target.checked){setMobilityDetails({...mobilityDetails, genderMin:0});}
                        setMobilityChecks({...mobilityChecks, genderCheck:!e.target.checked});
                      }}}
                    />
                    <input type="number" disabled={!mobilityChecks.genderCheck} maxLength={2} value={mobilityDetails.genderMin} 
                      onChange={(e)=>{handleMobilityInputChange(e,"genderMin");}}
                      className="m-0 px-1 ms-2 w-100 text-center callAgentInputStyle no-counter" 
                      style={{minWidth:"80px", maxHeight:"30px", height:"30px"}} 
                      autoComplete="new_pass" title={mobilityDetails.genderMin+" min"}
                    />
                  </span>
                  <span className="user-select-none d-flex mt-1 my-auto small" style={{height:"30px", maxHeight:"30px"}}>
                    <input type="checkbox" style={{cursor:"pointer"}} className="p-1" checked={mobilityChecks.languageCheck} 
                      onChange={(e)=>{
                        if(!e.target.checked){setMobilityDetails({...mobilityDetails, languageMin:0});}
                        setMobilityChecks({...mobilityChecks, languageCheck:e.target.checked});
                      }} onKeyDown={(e)=>{if(e.key === "Enter"){
                          if(e.target.checked){setMobilityDetails({...mobilityDetails, languageMin:0});}
                          setMobilityChecks({...mobilityChecks, languageCheck:!e.target.checked});
                        }
                        else if(e.key === "Tab" && !e.shiftKey)
                        {
                          if(!mobilityChecks.vehNumCheck && !mobilityChecks.driverNumCheck && !mobilityChecks.genderCheck && !mobilityChecks.languageCheck)
                          {
                            e.preventDefault();
                            if(paratransitBookBtnRef.current.disabled)
                            {
                              resetBtnRef.current.focus();
                            }
                            else
                            {
                              paratransitBookBtnRef.current.focus();
                            }
                          }
                        }
                      
                      }}
                    />
                    <input type="number" disabled={!mobilityChecks.languageCheck} maxLength={2} value={mobilityDetails.languageMin} 
                      onChange={(e)=>{handleMobilityInputChange(e,"languageMin");}}
                      onKeyDown={(e)=>{
                        if(e.key === 'Tab' && !e.shiftKey)
                        {
                          e.preventDefault();
                          if(paratransitBookBtnRef.current.disabled)
                          {
                            resetBtnRef.current.focus();
                          }
                          else
                          {
                            paratransitBookBtnRef.current.focus();
                          }
                        }
                      }}
                      className="m-0 px-1 ms-2 w-100 text-center callAgentInputStyle no-counter" 
                      style={{minWidth:"80px", maxHeight:"30px", height:"30px"}} 
                      autoComplete="new_pass" title={mobilityDetails.languageMin+" min"}
                    />
                  </span>
                </Col>
              </Row>
            </Row>
            {/* <Row>
              <Col className="text-start border-top" style={{backgroundColor:"#07447b"}}>
                <span className="d-inline-flex">
                  <Icon icon="bx:shield" className="mt-1 text-white" style={{width:"25px", height:"25px"}}/>
                  <label className='m-0 m-1 user-select-none fw-bold text-white'>Insurance Information</label>
                </span>
                <span className="d-inline-flex mt-1 float-end" ref={insuranceInfoDisplayRef} tabIndex={0}
                  onClick={handleInsuranceInfoDisplay} onKeyDown={(e)=>{
                    if(e.key === "Enter"){handleInsuranceInfoDisplay(e);}
                    else if(e.key === "Tab" && !e.shiftKey && !insuranceInfoDisplay)
                    {
                      e.preventDefault();
                      if(paratransitBookBtnRef.current.disabled)
                      {
                        resetBtnRef.current.focus();
                      }
                      else
                      {
                        paratransitBookBtnRef.current.focus();
                      }
                    }
                  }}>
                  {insuranceInfoDisplay? <Icon icon="bx:chevron-down" className="text-white" style={{width:"25px", height:"25px", cursor:"pointer"}}/>:
                    <Icon icon="bx:chevron-up" className="text-white" style={{width:"25px", height:"25px", cursor:"pointer"}}/>
                  }
                </span>
              </Col>
            </Row> */}
            <Row className={`${insuranceInfoDisplay? 'd-none':'d-none'} mt-1 overflow-auto callAgentSummaryScroller`}>
              <Row className="">
                <Col xs={2} className="text-start">
                  <span className="d-block small mt-1 text-nowrap overflow-hidden" title={"Medical ID number"}>
                    <Icon icon="bx:id-card" className="mb-1 mx-1" style={{width:"15px", height:"15px"}}/>
                    <label className='m-0 user-select-none'>MedID</label>
                  </span>
                  <span className="d-block small mt-2 pt-1 text-nowrap overflow-hidden" title={"Policyholder's name"}>
                    <Icon icon="bx:user" className="mb-1 mx-1" style={{width:"15px", height:"15px"}}/>
                    <label className='m-0 user-select-none'>Name</label>
                  </span>
                  <span className="d-block small mt-2 pt-1 text-nowrap overflow-hidden" title={"Policyholder's date of birth"}>
                    <Icon icon="bx:cake" className="mb-1 mx-1" style={{width:"15px", height:"15px"}}/>
                    <label className='m-0 user-select-none'>DOB</label>
                  </span>
                  <span className="d-block small mt-2 pt-1 text-nowrap overflow-hidden" title={"Social Security number"}>
                    <Icon icon="bx:credit-card-front" className="mb-1 mx-1" style={{width:"15px", height:"15px"}}/>
                    <label className='m-0 user-select-none'>SSN</label>
                  </span>
                  <span className="d-block small mt-2 pt-1 text-nowrap overflow-hidden" title={"Authorization number"}>
                    <Icon icon="bx:hash" className="mb-1 mx-1" style={{width:"15px", height:"15px"}}/>
                    <label className='m-0 user-select-none'>Auth</label>
                  </span>
                </Col>
                <Col xs={10} className="p-0 text-start">
                  <Row>
                    <Col xs={6}>
                      <input type="text" className="w-100 callAgentInputStyle text-center small" autoComplete="new_pass" 
                        style={{minWidth:"110px", height:"30px", maxHeight:"30px"}} 
                        value={medID} 
                        onChange={(e)=>{setMedID(e.target.value);}}
                      />
                      <input type="text" className="d-block mt-1 w-100 callAgentInputStyle small" autoComplete="new_pass" value={insuranceName} 
                        onChange={(e)=>{setInsuranceName(e.target.value);}} 
                        style={{minWidth:"110px", height:"30px", maxHeight:"30px"}}
                      />
                      <input type="date" autoComplete="new_pass" value={insuranceDOB} onChange={(e)=>{setInsuranceDOB(e.target.value);}}
                        className="m-0 px-1 mt-1 w-100 text-center small callAgentInputStyle" style={{minWidth:"110px", height:"30px", maxHeight:"30px"}}
                      />
                      <input type="text" maxLength={9} className="d-block mt-1 w-100 small callAgentInputStyle" 
                        autoComplete="new_pass" style={{minWidth:"110px", height:"30px", maxHeight:"30px"}} value={SSNDisplayValue} 
                        onChange={handleSSNChange}
                      />
                      <input type="text" className="d-block mt-1 w-100 small callAgentInputStyle" 
                        autoComplete="new_pass" style={{minWidth:"110px", height:"30px", maxHeight:"30px"}} value={insuranceAuthCode} 
                        onChange={(e)=>{setInsuranceAuthCode(e.target.value);}}
                      />
                    </Col>
                    <Col xs={6} className="p-0">
                      <Row>
                        <Col xs={2} className="text-end">
                          <span className="d-block small mt-1 text-nowrap overflow-hidden" style={{minWidth:"30px"}} title={"Insurance Type"}>
                            <label className='m-0 user-select-none'>INS</label>
                          </span>
                          <span className="d-block small mt-2 pt-1 text-nowrap overflow-hidden" style={{minWidth:"30px"}} title={"Service Code"}>
                            <label className='m-0 user-select-none'>SC</label>
                          </span>
                          <span className="d-block small mt-2 pt-1 text-nowrap overflow-hidden" style={{minWidth:"30px"}} title={"Agency Name"}>
                            <label className='m-0 user-select-none'>Ag</label>
                          </span>
                          <span className="d-block small mt-2 pt-1 text-nowrap overflow-hidden" style={{minWidth:"30px"}} title={"Case Worker name"}>
                            <label className='m-0 user-select-none'>CW</label>
                          </span>
                          <span className="d-block small mt-2 pt-1 text-nowrap overflow-hidden" style={{minWidth:"30px"}} title={"Ride type"}>
                            <label className='m-0 user-select-none'>Ride</label>
                          </span>
                        </Col>
                        <Col xs={10} className="p-0 pe-4 ps-2">
                          <select className='text-center p-1 w-100 small callAgentInputStyle' style={{minWidth:"120px", maxHeight:"30px", height:"30px"}}
                            value={insuranceType} onChange={(e)=>{setInsuranceType(e.target.value);}}
                          >
                            
                          </select>
                          <select className='text-center mt-1 p-1 w-100 small callAgentInputStyle' style={{minWidth:"120px", maxHeight:"30px", height:"30px"}}
                            value={insuranceServiceCode} onChange={(e)=>{setInsuranceServiceCode(e.target.value);}}
                          >
                            
                          </select>
                          <select className='text-center mt-1 p-1 w-100 small callAgentInputStyle' style={{minWidth:"120px", maxHeight:"30px", height:"30px"}}
                            value={insuranceAgency} onChange={(e)=>{setInsuranceAgency(e.target.value);}}
                          >
                            
                          </select>
                          <select className='text-center mt-1 p-1 w-100 small callAgentInputStyle' style={{minWidth:"120px", maxHeight:"30px", height:"30px"}}
                            value={insuranceCaseWorker} onChange={(e)=>{setInsuranceCaseWorker(e.target.value);}}
                          >
                            
                          </select>
                          <select className='text-center mb-1 mt-1 p-1 w-100 small callAgentInputStyle' style={{minWidth:"120px", maxHeight:"30px", height:"30px"}}
                            value={insuranceRide} onChange={(e)=>{setInsuranceRide(e.target.value);}} ref={insuranceRideSelRef}
                            onKeyDown={(e)=>{
                              try{  
                                if(e.key === "Tab" && !e.shiftKey)
                                {
                                  e.preventDefault();
                                  if(!paratransitBookBtnRef.current.disabled)
                                  {
                                    paratransitBookBtnRef.current.focus();
                                  }
                                  else
                                  {
                                    resetBtnRef.current.focus();
                                  }
                                }
                              }
                              catch(err){console.log(err);}
                            }}
                          >
                            
                          </select>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  
                </Col>
              </Row>
            </Row>
          </>:""}
        </Col>
        <Col xs={6} className="overflow-auto callAgentSummaryScroller" style={dynamicModeStyle}>
          {(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2) ? 
          <>
            <Row>
              <Col className="text-center" style={{backgroundColor:"#51677c"}}>
                <span className="d-inline-flex">
                  <Icon icon="bx:list-check" className="mt-1 text-white" style={{width:"25px", height:"25px"}}/>
                  <label className='m-0 m-1 user-select-none fw-bold text-white'>Summary</label>
                </span>
              </Col>
            </Row>
          
            <Row>
              <Col className={`text-start callAgentSummaryScroller`} style={{maxHeight:"361px"}}> {/* Summary row*/}
                <Row className="overflow-auto">
                  <Col className="text-white overflow-auto callAgentSummaryScroller" style={{backgroundColor:"#346492"}}>
                    <Row>
                      <p className="m-0 w-50 fw-bold text-start user-select-none text-nowrap">MTSM Negotiation</p>
                      <span className="w-50"  style={{float:"right", display:"inline-flex", justifyContent: "flex-end", alignItems:"center"}}>
                        <label style={{fontSize:"14px"}} className="user-select-none">Records:</label>
                        <label style={{paddingLeft:"5px", fontSize:"14px"}} className="user-select-none">{TotalMTSMRecords}</label>
                      </span>
                    </Row>
                    <Row className="m-0 overflow-auto callAgentSummaryScroller" style={{maxHeight:"150px", minHeight:"140px"}}>
                      <table className="w-100 border border-dark my-1" >
                        <thead>
                            <tr className="text-center text-nowrap" style={{background:"rgb(37 82 125)", height:"30px"}}>
                              <th className="border border-dark p-1 user-select-none" style={{fontWeight:"500", width:"19%"}}>{"Confirmation"}</th>
                              <th className="border border-dark p-1 user-select-none" style={{fontWeight:"500", width:"18%"}}>{"Sch PickTime"}</th>
                              <th className="border border-dark p-1 user-select-none" style={{fontWeight:"500", width:"18%"}}>{"Sch DropTime"}</th>
                              <th className="border border-dark p-1 user-select-none" style={{fontWeight:"500", width:"19%"}}>{"Name"}</th>
                              <th className="border border-dark p-1 user-select-none" style={{fontWeight:"500", width:"35%"}}>{"Msg"}</th>
                              <th className="border border-dark p-1 user-select-none" style={{fontWeight:"500"}}>{"Actions"}</th>
                            </tr>
                        </thead>
                        <tbody>
                          {MTSMTableHTML ? MTSMTableHTML
                          : 
                          <tr className="text-center">
                            <td className="border border-dark user-select-none">{""}</td>
                            <td className="border border-dark user-select-none">{""}</td>
                            <td className="border border-dark user-select-none">{""}</td>
                            <td className="border border-dark user-select-none text-nowrap small overflow-hidden" title={""}
                              style={{textOverflow:"ellipsis"}}
                            >{""}</td>
                            <td className="border border-dark user-select-none text-nowrap small overflow-hidden" title={""} 
                              style={{textOverflow:"ellipsis"}}
                            >{""}</td>
                            <td className="user-select-none text-center justify-content-center">
                              {""}
                            </td>
                          </tr>
                          } 
                        </tbody>
                      </table>
                    </Row>
                    
                  </Col>
                </Row>
                <Row className="" style={{height:"197px"}}>
                  <Col xs={6} className="text-white overflow-auto callAgentSummaryScroller" style={{backgroundColor:"#07447b", maxHeight:"200px"}}>
                    <Row className="mt-1">
                      <p className="m-0 fw-bold text-start user-select-none text-nowrap">Client Summary</p>
                    </Row>
                    <table className="m-1">
                      <tbody>
                        <tr className="text-start">
                          <td className="user-select-none small text-nowrap">{"Total Calls"}</td>
                          <td className="user-select-none">
                            <input type={"text"} disabled style={{minWidth:"45px", marginLeft:"10px", borderRadius:"5px"}} value={clientSummary.totalCalls} title={clientSummary.totalCalls} 
                              className='text-nowrap border-1 p-1 mt-1 w-100 text-center text-white'
                            />
                          </td>
                        </tr>
                        <tr className="text-start">
                          <td className="user-select-none small text-nowrap" title={"Total No-Shows"}>{"Total NS"}</td>
                          <td className="user-select-none">
                            <input type={"text"} disabled style={{minWidth:"45px", marginLeft:"10px", borderRadius:"5px"}} value={clientSummary.totalNS} title={clientSummary.totalNS} 
                              className='text-nowrap border-1   p-1 my-1 w-100 text-center text-white'
                            />
                          </td>
                        </tr>
                        <tr className="text-start">
                          <td className="user-select-none small text-nowrap">{"Total Cancelled"}</td>
                          <td className="user-select-none">
                            <input type={"text"} disabled style={{minWidth:"45px", marginLeft:"10px", borderRadius:"5px"}} value={clientSummary.totalCancels} title={clientSummary.totalCancels} 
                              className='text-nowrap border-1   p-1 my-1 mt-0 w-100 text-center text-white'
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </Col>
                  <Col xs={6} className="text-white overflow-auto callAgentSummaryScroller" style={{backgroundColor:"#415f7b", borderBottomRightRadius:"5px"}}>
                    <Row className="mt-1">
                      <p className="m-0 fw-bold text-start user-select-none text-nowrap">Trip Estimates</p>
                    </Row>
                    <table className="m-1">
                        <tbody>
                          <tr className="text-start">
                            <td className="user-select-none small" title={"Distance (miles)"}>{"Distance"}</td>
                            <td className="user-select-none">
                              <input type={"text"} disabled value={clientSummary.tripDistance} style={{minWidth:"45px", borderRadius:"5px"}}
                                title={"Distance: "+clientSummary.tripDistance+" miles"} className='text-nowrap border-1 p-1 mt-1 mx-1 w-100 text-center text-white'
                              />
                            </td>
                          </tr>
                          <tr className="text-start">
                            <td className="user-select-none small" title={"Time (min)"}>{"Time"}</td>
                            <td className="user-select-none">
                              <input type={"text"} disabled value={clientSummary.TripDuration} style={{minWidth:"45px", borderRadius:"5px"}}
                                title={"Duration: "+clientSummary.TripDuration+" min"} className='text-nowrap border-1 p-1 my-1 mx-1 w-100 text-center text-white'
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                  </Col>
                </Row>
              </Col>
            </Row>
          </>
          :
          <>
            <Row className="p-0">
              <Col className="text-start" style={{backgroundColor:"#07447b", height:"35px", maxHeight:"35px"}}>
                <span className={`${selectedSummaryHeader === "stopOrder"? 'callAgentHeaderStyleSelected':'callAgentHeaderStyle'} justify-content-center 
                  d-inline-flex small mt-2 h-100 border-white`}
                  onClick={()=>{handleSummaryHeaderClick("stopOrder");}} style={{minWidth:"40px"}}
                >
                  <Icon icon="bx:trip" className="mt-1" style={{ width:"20px", height:"20px"}}/>
                  <label className='m-0 m-1 user-select-none fw-bold callAgentLabelsResponsive' style={{cursor:"pointer"}}>Stop Order</label>
                </span>
                {false ? <span className={`${selectedSummaryHeader === "manifest"? 'callAgentHeaderStyleSelected':'callAgentHeaderStyle'} justify-content-center 
                  d-inline-flex small mt-2 ms-1 h-100 border-light`}
                  onClick={()=>{handleSummaryHeaderClick("manifest");}} style={{minWidth:"40px"}}
                >
                  <Icon icon="bx:list-check" className="mt-1" style={{width:"20px", height:"20px"}}/>
                  <label className='m-0 m-1 user-select-none fw-bold callAgentLabelsResponsive' style={{cursor:"pointer"}}>Manifest Details</label>
                </span>
                :""}
                <span className={`${selectedSummaryHeader === "agentTrips"? 'callAgentHeaderStyleSelected':'callAgentHeaderStyle'} justify-content-center 
                  d-inline-flex small mt-2 ms-1 h-100 border-light`}
                  onClick={()=>{handleSummaryHeaderClick("agentTrips");}} style={{minWidth:"40px"}}
                >
                  <Icon icon="bx:history" className="mt-1" style={{width:"20px", height:"20px"}}/>
                  <label className='m-0 m-1 user-select-none fw-bold callAgentLabelsResponsive' style={{cursor:"pointer"}}>Booked Trips</label>
                </span>
                <span className={`${selectedSummaryHeader === "manualFare"? 'callAgentHeaderStyleSelected':'callAgentHeaderStyle'} justify-content-center 
                  d-inline-flex small mt-2 ms-1 h-100 border-light`}
                  onClick={()=>{handleSummaryHeaderClick("manualFare");}} style={{minWidth:"40px"}}
                >
                  <Icon icon="mdi:checkbook" className="mt-1" style={{width:"20px", height:"20px"}}/>
                  <label className='m-0 m-1 user-select-none fw-bold callAgentLabelsResponsive' style={{cursor:"pointer"}}>Manual Fare</label>
                </span>
                
              </Col>
            </Row>
            <Row className={`${stopOrderDisplay? '':'d-none'} m-0 overflow-auto callAgentSummaryScroller`} style={{height:`${summaryViewScreenHeightSize}px`, maxHeight:`${summaryViewScreenHeightSize}px`}}>
              <Col className="callAgentInputStyle" style={{borderTopLeftRadius:0, borderTopRightRadius:0}}> 
                <Row>
                  <Col className="p-0">
                    {verifiedAddr.length > 0 ? 
                      verifiedAddr.map((item, index)=>{
                        let time = item.waitTime;
                        const selectedFSOption = FSDropdown.find(option => parseInt(option.props.value) === parseInt(item.FundingSource));
                        let FSText = selectedFSOption ? selectedFSOption.props.children : item.FundingSource;
                        let [hours, minutes] = (item.time !== "" && item.time !== "Will Call" ? item.time.split(":") : ["",""]);
                        let [apptHours, apptMins] = (item.apptTime !== "" && item.apptTime !== "Will Call"? item.apptTime.split(":") : ["",""]);
                        // console.log(item.time, hours, minutes);
                        let meridiem = hours !== "" ? (hours >= 12 ? 'PM' : 'AM'):"";
                        let meridiemAppt = apptHours !== "" ? (apptHours >= 12 ? 'PM' : 'AM'):"";
                        apptHours = (apptHours !== "" ? (parseInt(apptHours) % 12 || 12) : ""); //24 to 12 hour format
                        apptMins = (apptMins !== "" ? (parseInt(apptMins) < 10 ? '0' + parseInt(apptMins) : apptMins) : "");
                        hours = (hours !== "" ? (parseInt(hours) % 12 || 12) : ""); //24 to 12 hour format
                        minutes = (minutes !== "" ? (parseInt(minutes) < 10 ? '0' + parseInt(minutes) : minutes) : "");
                        let waitTime = (time && time !== "" ? time.split(":")[0]+(parseInt(time.split(":")[0]) > 9 ? " mins" : " min"): "");
                        const queryParams = new URLSearchParams(window.location.search);
                        const tripSelected = queryParams.get('TripSelected') || activeTripSelected? true:false;
                        let editRowData = (PersistStorage.retrieve("rowDataEditTrip", true)  && tripSelected? PersistStorage.retrieve("rowDataEditTrip", true):"");
                        let showMoveUpDown = (editRowData && editRowData !== "" && editRowData !== "No data found" && typeof editRowData === 'object' ? false : true);
                        return(
                          <Row className="m-0 mt-1 mx-1" style={{border:"1px solid gray", borderRadius:"5px"}} key={index} >
                            <Col className="p-0 overflow-auto callAgentSummaryScroller">
                              <span className="d-flex small text-nowrap overflow-hidden" style={{minWidth:"500px"}}>
                                <Icon icon="bx:map" className="my-auto mx-1 text-success" style={{width:"15px", height:"15px"}}/>
                                <label className='m-0 user-select-none text-nowrap overflow-hidden' 
                                  style={{textOverflow:"ellipsis", whiteSpace: "nowrap", minWidth:"100px", maxWidth:"350px"}} 
                                  title={item.pickAddr}
                                >
                                  {item.pickAddr}
                                </label>
                                <label className='m-0 ms-1 px-1 user-select-none text-nowrap overflow-hidden bg-light text-start rounded' 
                                  style={{textOverflow:"ellipsis", whiteSpace: "nowrap" , minWidth:"100px", maxWidth:"150px"}}
                                  title={"Name: "+ item.riderName}
                                >
                                  {"Name: "+ item.riderName}
                                </label>
                                <label className='m-0 ms-1 px-1 user-select-none text-nowrap overflow-hidden bg-light text-start rounded' 
                                  style={{textOverflow:"ellipsis", whiteSpace: "nowrap" , minWidth:"100px", maxWidth:"150px"}}
                                  title={"Funding Source: "+ FSText}
                                >
                                  {"FS: "+ (FSText)}
                                </label>
                              </span>
                              <span className="d-flex mt-1 small mx-2 text-nowrap" style={{maxWidth:"480px", maxHeight:"25px"}}>
                                <p className="m-0 ms-3 text-center user-select-none d-inlin-block text-nowrap bg-light callAgentInputStyle" style={{minWidth:"100px"}}
                                  title={"Date"}
                                >
                                  {item.date}
                                </p>
                                <p className="m-0 ms-1 text-center user-select-none d-inlin-block text-nowrap bg-light callAgentInputStyle" style={{minWidth:"60px"}}
                                  title={"Scheduled Time"}
                                >
                                  {(hours !== "" ? hours+":"+minutes+" "+meridiem : (item.time === "Will Call"? item.time: ""))}
                                </p>
                                <p className="m-0 ms-1 text-center user-select-none d-inlin-block text-nowrap bg-light callAgentInputStyle" style={{minWidth:"80px"}}
                                  title={"Appointment Time"}
                                >
                                  {(apptHours !== "" ? apptHours+":"+apptMins+" "+meridiemAppt : (item.time === "Will Call"? "Will Call": ""))}
                                </p>
                                <p className="m-0 ms-1 text-center user-select-none d-inlin-block text-nowrap bg-light callAgentInputStyle" style={{minWidth:"80px"}}
                                  title={"Distance"}
                                >
                                  {item.distance+(parseFloat(item.distance) > 1 ?" miles":" mile")}
                                </p>
                                <p className="m-0 ms-1 text-center user-select-none d-inlin-block text-nowrap bg-light callAgentInputStyle" style={{minWidth:"80px"}}
                                  title={"Duration"}
                                >
                                  {item.duration+(parseFloat(item.duration) > 1 ?" mins":" min")}
                                </p>
                                <span className="ms-1">
                                  <span title={"Clear Trip"} onClick={(e)=>{handleClearVerifiedAddr(index);}}>
                                    <Icon icon="bx:eraser" className="my-auto text-danger" style={{width:"20px", height:"20px", cursor:"pointer"}}/>
                                  </span>
                                  <span title={(addLegBtnTitle === "Update" ? "Cancel Edit":"Edit Trip")} className="mx-2" 
                                    onClick={(e)=>{
                                      if(addLegBtnTitle === "Update"){handleClearLegInfo();} 
                                      else{handleEditEntireTrip(index);}
                                    }}
                                  >
                                    <Icon icon={(addLegBtnTitle === "Update" ? "bx:task-x":"bx:edit")} title={(addLegBtnTitle === "Update" ? "Cancel Edit":"Edit Trip")} 
                                      className="my-auto text-warning" style={{width:"20px", height:"20px", cursor:"pointer"}}
                                    />
                                  </span>
                                  {showMoveUpDown ? 
                                    <>
                                      <span title={"Move Trip Up"} onClick={(e)=>{handleMoveVerifiedAddr(index, "up");}}>
                                        <Icon icon="bx:chevrons-up" title={"Move Trip Up"} className="my-auto text-dark" style={{width:"20px", height:"20px", cursor:"pointer"}}/>
                                      </span>
                                      <span title={"Move Trip Down"} className="ms-2" onClick={(e)=>{handleMoveVerifiedAddr(index, "down");}}>
                                        <Icon icon="bx:chevrons-down" title={"Move Trip Down"} className="my-auto text-dark" style={{width:"20px", height:"20px", cursor:"pointer"}}/>
                                      </span>
                                    </> 
                                  : ""}
                                </span>
                                
                              </span>
                              {item.stops && item.stops.length > 0 ? item.stops.map((item,index) =>{
                                let waitTime = (item.waitTime && item.waitTime !== 0 ? item.waitTime:0);
                                return(
                                  <Row className="m-0 mt-1" key={index}>
                                    <Col className="mx-4 p-0 px-1 border rounded border-secondary overflow-auto callAgentSummaryScroller">
                                      <span className="d-flex mt-1 small text-nowrap overflow-hidden" style={{minWidth:"300px"}}>
                                        <Icon icon="bx:map" 
                                          className={`${item.passLoadType === "load" ? "text-success" : (item.passLoadType === "unload" ? "text-danger" : "text-secondary")} my-auto mx-1 `} 
                                          style={{width:"15px", height:"15px"}}
                                        />
                                        <label className='m-0 px-1 user-select-none text-nowrap overflow-hidden bg-light rounded' 
                                          style={{textOverflow:"ellipsis", whiteSpace: "nowrap", minWidth:"100px", maxWidth:"200px"}} title={item.stopAddr}
                                        >
                                          {item.stopAddr}
                                        </label>
                                        {item.passengerName !== "" ?
                                          <label className='m-0 px-1 ms-1 user-select-none text-nowrap overflow-hidden bg-light text-center rounded' 
                                            style={{textOverflow:"ellipsis", whiteSpace: "nowrap", width:"100px", maxWidth:"100px"}}
                                            title={"Name: "+item.passengerName}
                                          >
                                            {"Name: "+item.passengerName}
                                          </label> 
                                        :""}
                                        {parseInt(waitTime) !== 0  ?
                                          <label className='m-0 ms-1 user-select-none text-nowrap overflow-hidden bg-light text-center rounded' 
                                            style={{textOverflow:"ellipsis", whiteSpace: "nowrap" , minWidth:"100px"}}
                                            title={(parseInt(waitTime) === 0  ? "No wait": " Wait: "+ (parseInt(waitTime) > 9 ? parseInt(waitTime) + " mins": parseInt(waitTime) + " min"))}
                                          >
                                            {" Wait: "+ (parseInt(waitTime) > 9 ? parseInt(waitTime) + " mins": parseInt(waitTime) + " min")}
                                          </label> 
                                        :""}
                                      </span>
                                      <span className="d-flex small my-1 text-nowrap overflow-hidden">
                                        <Icon icon="bx:pen" className="mx-1 my-auto text-dark" style={{width:"15px", height:"15px"}}/>
                                        <label className='m-0 px-1 user-select-none text-nowrap overflow-hidden bg-light rounded' 
                                          style={{textOverflow:"ellipsis", whiteSpace: "nowrap", minWidth:"100px", maxWidth:"300px"}} 
                                          title={item.notes}
                                        >
                                          {(item.notes !== "" ? item.notes : "No notes provided.")}
                                        </label>
                                        {item.passLoadType !== "none" ?
                                          <label className='m-0 ms-1 user-select-none text-nowrap overflow-hidden bg-light text-center rounded' 
                                            style={{textOverflow:"ellipsis", whiteSpace: "nowrap" , minWidth:"100px"}}
                                            title={"Load Type"}
                                          >
                                            
                                            {(item.passLoadType.charAt(0).toUpperCase() + item.passLoadType.slice(1)+" ("+item.stopPax.total+")")}
                                            
                                          </label>
                                        :""}
                                      </span>
                                    </Col>
                                    
                                  </Row>
                                );
                              })
                              : ""}
                              <span className="d-flex mt-1 small text-nowrap overflow-hidden" style={{minWidth:"500px"}}>
                                <Icon icon="bx:map" className="my-auto mx-1 text-danger" style={{width:"15px", height:"15px"}}/>
                                <label className='m-0 user-select-none text-nowrap overflow-hidden' title={item.dropAddr}
                                  style={{textOverflow:"ellipsis", whiteSpace: "nowrap", minWidth:"100px", maxWidth:"350px"}} 
                                >
                                  {item.dropAddr}
                                </label>
                              </span>
                            </Col>
                          </Row>
                        ); 
                      })
                    :""}
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className={`${manifestDetailsDisplay? '':'d-none'} m-0`} style={{height:`${summaryViewScreenHeightSize}px`, maxHeight:`${summaryViewScreenHeightSize}px`}}>
              <Col className="callAgentInputStyle" style={{borderTopLeftRadius:0, borderTopRightRadius:0}}> 
              
              </Col>
            </Row>
            <Row className={`${agentTripsDisplay? '':'d-none'} m-0`} style={{height:`${summaryViewScreenHeightSize}px`, maxHeight:`${summaryViewScreenHeightSize}px`}}>
              <Col className="callAgentInputStyle" style={{borderTopLeftRadius:0, borderTopRightRadius:0}}> 
                <Row className="m-0 mt-3 px-1 overflow-auto callAgentSummaryScroller" style={{maxHeight:"200px", minHeight:"100px"}}>
                  <Col className="small p-0">
                    <table className="w-100 mb-2 callAgentInputStyle" style={{minHeight:"100px"}}>
                      <thead className="" style={{borderTop:"5px"}}>
                        <tr className="text-center text-nowrap text-white">
                          <th className="p-1 border-right border-secondary user-select-none" 
                            style={{backgroundColor:"#35738a", fontWeight:"500", borderTopLeftRadius:"5px", borderRight:"1px solid #ccc"}}
                          >
                            {"Confirmation"}
                          </th>
                          <th className="p-1 border-right border-secondary user-select-none" 
                            style={{backgroundColor:"#35738a", fontWeight:"500",borderRight:"1px solid #ccc"}}
                          >{"Type"}</th>
                          <th className="p-1 border-right border-secondary user-select-none" title={"Cost (USD)"}
                            style={{backgroundColor:"#35738a", fontWeight:"500",borderRight:"1px solid #ccc"}}
                          >{"Cost"}</th>
                          <th className="p-1 border-right border-secondary user-select-none" title={"Distance (mi)"}
                            style={{backgroundColor:"#35738a", fontWeight:"500",borderRight:"1px solid #ccc"}}
                          >{"Distance"}</th>
                          <th className="p-1 border-right border-secondary user-select-none" title={"Duration (min)"}
                            style={{backgroundColor:"#35738a", fontWeight:"500", borderTopRightRadius:"5px"}}
                          >{"Duration"}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {AgentTripRecordsTableHTML ? AgentTripRecordsTableHTML 
                        : 
                          <tr className="text-center">
                            <td className="text-nowrap small overflow-hidden bg-light p-1" style={{borderRight:"1px solid #ccc", borderBottomLeftRadius:"5px"}}>
                              {""}
                            </td>
                            <td className="text-nowrap small overflow-hidden bg-light px-1" style={{borderRight:"1px solid #ccc"}}>
                              {""}
                            </td>
                            <td className="text-nowrap small overflow-hidden bg-light px-1" style={{borderRight:"1px solid #ccc"}}>
                              {""}
                            </td>
                            <td className="text-nowrap small overflow-hidden bg-light px-1" style={{borderRight:"1px solid #ccc"}}>
                              {""}
                            </td>
                            <td className="text-nowrap small overflow-hidden bg-light p-1" style={{ borderBottomRightRadius:"5px"}}>
                              {""}
                            </td>
                          </tr>
                        } 
                      </tbody>
                    </table>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className={`${manualFareDisplay? '':'d-none'} m-0`} style={{height:`${summaryViewScreenHeightSize}px`, maxHeight:`${summaryViewScreenHeightSize}px`}}>
              <Col className="callAgentInputStyle" style={{borderTopLeftRadius:0, borderTopRightRadius:0}}> 
                <Row className="m-0 mt-3 px-1 overflow-auto callAgentSummaryScroller">
                  <Col className="small p-0">
                    <table className="w-100 mb-2 callAgentInputStyle">
                      <thead className="" style={{borderTop:"5px"}}>
                        <tr className="text-center text-nowrap text-white">
                          <th className="p-1 border-right border-secondary user-select-none" 
                            style={{backgroundColor:"#35738a", fontWeight:"500", borderTopLeftRadius:"5px", borderRight:"1px solid #ccc"}}
                          >
                            {"Manual Fare"}
                          </th>
                          <th className="p-1 border-right border-secondary user-select-none" 
                            style={{backgroundColor:"#35738a", fontWeight:"500",borderRight:"1px solid #ccc"}}
                          >{"Manual Price"}</th>
                          <th className="p-1 border-right border-secondary user-select-none" 
                            style={{backgroundColor:"#35738a", fontWeight:"500", borderTopRightRadius:"5px"}}
                          >{"Manual Miles"}</th>
                        </tr>
                      </thead>
                      <tbody className="">
                        <tr className="text-center" >
                          <td className="text-nowrap small overflow-hidden bg-light p-1" style={{borderRight:"1px solid #ccc", borderBottomLeftRadius:"5px"}}>
                            <input type="text" className="w-100 text-center callAgentInputStyle" autoComplete="new_pass" style={{minWidth:"100px", border:"1px solid black", height:"30px", maxHeight:"30px"}} 
                              value={manualDataOverwrite.fare} onChange={(e)=>{setManualDataOverwrite({...manualDataOverwrite, fare: e.target.value})}}
                            />
                          </td>
                          <td className="text-nowrap small overflow-hidden bg-light px-1" style={{borderRight:"1px solid #ccc"}}>
                            <input type="text" className="w-100 text-center callAgentInputStyle" autoComplete="new_pass" style={{minWidth:"100px", border:"1px solid black", height:"30px", maxHeight:"30px"}} 
                              value={manualDataOverwrite.price} onChange={(e)=>{setManualDataOverwrite({...manualDataOverwrite, price: e.target.value})}}
                            />
                          </td>
                          <td className="text-nowrap small overflow-hidden bg-light p-1" style={{ borderBottomRightRadius:"5px"}}>
                            <input type="text" className="w-100 text-center callAgentInputStyle" autoComplete="new_pass" style={{minWidth:"100px", border:"1px solid black", height:"30px", maxHeight:"30px"}} 
                              value={manualDataOverwrite.miles} onChange={(e)=>{setManualDataOverwrite({...manualDataOverwrite, miles: e.target.value})}}
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className="" style={{height:"115px", maxHeight:"115px"}}>
              <Col className="">
                <span className="d-inline-flex">
                  <Icon icon="bx:receipt" className="mt-1" style={{width:"25px", height:"25px"}}/>
                  <label className='m-0 m-1 user-select-none fw-bold'>Ride Estimates</label>
                </span>
                  <Row className="m-0 overflow-auto callAgentSummaryScroller px-1 text-center" style={{maxHeight:"100px", minHeight:"80px"}}>
                    <table className="my-1 callAgentInputStyle">
                      <thead className="" style={{borderTop:"5px"}}>
                        <tr className="text-center text-nowrap text-white">
                          <th className="p-1 border-right border-secondary user-select-none" style={{backgroundColor:"#35738a", fontWeight:"500", borderTopLeftRadius:"5px", borderRight:"1px solid #ccc"}}>{"Fare"}</th>
                          <th className="p-1 border-right border-secondary user-select-none" style={{backgroundColor:"#35738a", fontWeight:"500",borderRight:"1px solid #ccc"}}>{"Copay"}</th>
                          <th className="p-1 border-right border-secondary user-select-none" style={{backgroundColor:"#35738a", fontWeight:"500", borderRight:"1px solid #ccc"}}>{"Distance"}</th>
                          <th className="p-1 user-select-none" style={{backgroundColor:"#35738a", fontWeight:"500", borderTopRightRadius:"5px"}}>{"Time"}</th>
                        </tr>
                      </thead>
                      <tbody className="">
                        <tr className="text-center">
                          <td className="user-select-none text-nowrap small overflow-hidden" style={{borderRight:"1px solid #ccc"}}>{"$"+clientSummary.TripFare}</td>
                          <td className="user-select-none text-nowrap small overflow-hidden" style={{borderRight:"1px solid #ccc"}}>{"$"+clientSummary.TripCopay}</td>
                          <td className="user-select-none text-nowrap small overflow-hidden" style={{borderRight:"1px solid #ccc"}} title={"Distance (Miles)"}
                          >{clientSummary.tripDistance+ (parseFloat(clientSummary.tripDistance) > 1 ?" miles": " mile")}</td>
                          <td className="user-select-none text-nowrap small overflow-hidden" title={"Duration (Minutes)"}
                          >{clientSummary.TripDuration+ (parseFloat(clientSummary.TripDuration) > 1 ?" mins": " min")}</td>
                        </tr>
                      </tbody>
                    </table>
                  </Row>
              </Col>
            </Row>
            <Row className="m-0" style={{height:`${mapScreenHeightSize}px`, minHeight:`${mapScreenHeightSize}px`, marginLeft: "10%", marginRight:"10%"}}>
              <Col className="p-0 my-1 border-0" style={{boxShadow:"0px 3px 6px #999"}}>
                <MapControlSkeleton
                  setIsSchTimeFieldDisabled={setIsSchTimeFieldDisabled}
                  setIsVSSelectionDisabled={setIsVSSelectionDisabled}
                  vsSelection={handleMapVSSelected}
                  mapPointSelection={handleMapPointSelection}
                  zones={((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2) ? 
                    ((RCZZoneVerticesData && RCZZoneVerticesData.Table.length > 0) ? RCZZoneVerticesData.Table : ZoneVerticesData.Table) : ZoneVerticesData.Table)
                  }
                  MapDetailData={mapData} 
                  options={mapOptionsCallAgent}
                  DispatchVehicleData={DispatchVehicleData}
                  CurrentAff = {selectedAff}
                  onConditionMet={null}
                />
                {/* !showChatBot && (!Array.isArray(specificLinkRequirement)) */}
                {!showChatBot && (!Array.isArray(specificLinkRequirement)) && specificLinkRequirement !== ""? 
                <div style={{ position: 'absolute', cursor:"pointer", bottom:"50px", right:"10px", zIndex: 9999, backgroundColor:"#07447b" }} 
                  onClick={(e)=>{setShowChatBot(true); showChatBotRef.current = true;}} 
                  title={"Click to open chatbot"} className={`rounded-circle p-2 text-center border`}
                >
                  <Icon icon="bx:chat" className="text-white my-auto" style={{ width: "25px", height: "25px", zIndex: 9999 }} />
                </div> : ""}
              </Col>
            </Row>
            {showChatBot && (!Array.isArray(specificLinkRequirement)) && specificLinkRequirement !== ""? 
                <>
                  <Button variant="dark" className="position-fixed p-0" 
                    style={{right:"50px", bottom:"662px", zIndex: 2}} 
                    onClick={(e)=>{setShowChatBot(false); showChatBotRef.current = false;}}
                  >
                    <Icon icon="maki:cross" className="text-white my-auto" style={{ width: "20px", height: "20px"}} />
                  </Button>
                    
                  {tempArr.map((item, index)=>{
                    let manualPhone = "";
                    if(phone && phone.length >= 12)
                    {
                      let areaCode = phone.replace("+1","").substring(0,3);
                      let firstPart = phone.replace("+1","").substring(3,6);
                      let secondPart = phone.replace("+1","").substring(6,10);
                      manualPhone = areaCode + "-" + firstPart + "-" + secondPart;
                    }
                    
                    const PhoneNo = typeof clientInfo === 'object' && clientInfo.HomePhone ? clientInfo.HomePhone : (manualPhone !== "" ? manualPhone : "") ;
                    const AffiliateID = parseInt(selectedAff);
                    const FamilyID = (AffiliateData.find((item) => {if(parseInt(item.AffiliateID) === parseInt(selectedAff)){return item}})).iPartnerAffiliateID;
                    const UserID = parseInt(loginData.iUserIDActual);
                    const clientID = typeof clientInfo === 'object' && clientInfo.Id && String(clientInfo.Id) !== "-1"? clientInfo.Id : "-1";

                    if(srcUrl.includes("clientID=-1") && (typeof clientInfo === 'object' && clientInfo.Id && String(clientInfo.Id) !== "-1"))
                    {
                      setSrcUrl(`${specificLinkRequirement}?PhoneNo=${PhoneNo}&iAffiliateID=${AffiliateID}&iFamilyID=${FamilyID}&iUserID=${UserID}&clientID=${clientID}`);
                    }
                    
                    return(
                      
                      <iframe
                        id="chatbotiFrame"
                        title="Chatbot"
                        allow="microphone"
                        src={srcUrl}
                        ref={iframeRef}
                        key={index}
                        className="text-center justify-content-center position-fixed bg-transparent"
                        style={{
                          bottom: "30px",
                          right: "10px",
                          width: '480px',
                          minWidth:"480px",
                          height: '700px',
                          border: 'none',
                          zIndex: 1
                        }}
                      />
                      
                    );
                  })}
                </>
            : ""}
              
          </>
          }
        </Col>
      </Row>
      {(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2) ?
        <Row className="callAgentMainColsResponsive" style={{height:`calc(100vh - 520px)`}}>
          <Col className="p-0 my-1 border-0" style={{boxShadow:"0px 3px 6px #999"}}>
            <MapControlSkeleton
              vsSelection={handleMapVSSelected}
              mapPointSelection={handleMapPointSelection}
              setIsSchTimeFieldDisabled={setIsSchTimeFieldDisabled}
              setIsVSSelectionDisabled={setIsVSSelectionDisabled}
              zones={((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2) ? 
                ((RCZZoneVerticesData && RCZZoneVerticesData.Table.length > 0) ? RCZZoneVerticesData.Table : ZoneVerticesData.Table) : ZoneVerticesData.Table)
              }
              MapDetailData={mapData} 
              options={mapOptionsCallAgent}
              DispatchVehicleData={DispatchVehicleData}
              CurrentAff = {selectedAff}
              onConditionMet={null}
            />
          </Col>
        </Row>
      :""}
      <Row className="m-0 p-1 page-footer fixed-bottom" style={{backgroundColor:"#07447b", height:'45px', maxHeight:'45px'}}>
        <Col className="text-start callAgentTitleResponsive">
          <Row>
            <Col xs={4}>
              <span className="d-inline-flex small text-nowrap text-white">
                <label className='m-0 my-1 user-select-none' title={"Last Confirmation Number"}>Last Confirmation#</label>
                <input type={"text"} disabled value={confirmationNo} onChange={(e)=>setConfirmationNo(e.target.value)}  title={confirmationNo}
                  className='d-inline-flex text-nowrap text-center text-white border-1 mx-1 p-1' style={{borderRadius:"5px"}}
                />
              </span>
            </Col>
            
          </Row>
        </Col>
        <Col className="text-end callAgentTitleAffResponsive">
          {/* <Button variant="dark" className="mx-1" onClick={handleAutoBookTrip}>{"Auto"}</Button> */}
          {(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2) ?
            <Button tabIndex={0} variant="success" className="mx-1 rounded" style={{ borderRadius: "0px"}} ref={bookBtnRef} onClick={handleCreateUpdateTrip}
              onKeyDown={(e)=>
                { 
                  try{
                    
                    if(e.key === "Tab" && e.shiftKey)
                    {
                      e.preventDefault();
                      agentNotesBtnRef.current.focus();
                    }
                    
                  }
                  catch(err){console.log(err);}
                }
              }
            >
              {submitBtnTitle}
            </Button>
          :
            <Button tabIndex={0} variant="success" className="mx-1 rounded" style={{ borderRadius: "0px"}} ref={paratransitBookBtnRef} 
              onClick={(e)=>{ validateMinScheduleTimeDifference(null, false, false, 'book');}}
              onKeyDown={(e)=>
                { 
                  try{
                    
                    if(e.key === "Tab" && e.shiftKey)
                    {
                      e.preventDefault();
                      if(insuranceInfoDisplay)
                      {
                        insuranceRideSelRef.current.focus();
                      }
                      else
                      {
                        if(insuranceInfoDisplayRef.current)
                        {
                          insuranceInfoDisplayRef.current.focus();
                        }
                        else
                        {
                          if(driverVehInfoDisplay)
                          {
                            languageOptionsSelRef.current.focus();
                          }
                          else
                          {
                            mobilityInfoDisplayRef.current.focus();
                          }
                        }
                      }
                    }
                    else if(e.key === "Enter")
                    {
                      validateMinScheduleTimeDifference(null, false, false, 'book'); 
                    }
                  }
                  catch(err){console.log(err);}
                }
              }
            >
              {submitParatransitBtnTitle}
            </Button>
          }
          <Button tabIndex={0} variant="info" className="mx-1 rounded" ref={resetBtnRef} style={{ borderRadius: "0px"}} 
            title={"Reset Parameters"} onClick={()=>{handleResetAll("none")}}
            onKeyDown={(e)=>
              { 
                try{
                  if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2))
                  {
                    if(e.key === "Tab" && e.shiftKey)
                    {
                      e.preventDefault();
                      if(bookBtnRef.current.disabled)
                      {
                        agentNotesBtnRef.current.focus();
                      }
                      else
                      {
                        bookBtnRef.current.focus();
                      }
                    }
                    else if(e.key === "Tab" && !e.shiftKey)
                    {
                      e.preventDefault();
                      phoneRef.current.focus();
                    }
                  }
                  else if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2))
                  {
                    if(e.key === "Tab" && e.shiftKey)
                    {
                      e.preventDefault();
                      if(paratransitBookBtnRef.current.disabled)
                      {
                        if(driverVehInfoDisplay)
                        { 
                          languageOptionsSelRef.current.focus();
                        }
                        else
                        {
                          mobilityInfoDisplayRef.current.focus();
                        }
                      }
                      else
                      {
                        paratransitBookBtnRef.current.focus();
                      }
                    }
                    else if(e.key === "Tab" && !e.shiftKey)
                    {
                      e.preventDefault();
                      phoneRef.current.focus();
                    }
                  }
                }
                catch(err){console.log(err);}
              }
            }
          >
            {"Reset"}
          </Button>
        </Col>
      </Row>
      
      {showClientActiveTripsModal ? 
        <Modal centered backdrop="static" keyboard={true} onHide={()=>setShowClientActiveTripsModal(false)} size={"xl"} show={showClientActiveTripsModal} animation={true}>
          <Modal.Header className='text-white callAgent-modal-header user-select-none p-0 py-1 px-2' closeButton>
              <Modal.Title style={{fontSize:"20px"}}>
                {"Client Active Trips"}
              </Modal.Title>
          </Modal.Header>
          <Modal.Body className='fw-normal user-select-none'>
            {clientInfo?<Row className="m-0 d-flex">
              <Col xs={3} className="p-0">
                <p className="m-0">{"Name: "}<span className="fw-normal">{clientInfo.FirstName + " " + clientInfo.LastName}</span></p>
                <p className="m-0">{"Home Phone: "}<span className="fw-normal">{clientInfo.HomePhone? clientInfo.HomePhone:"N/A"}</span></p>
              </Col>
              <Col xs={9} className="p-0">
                <p className="m-0">{"Last Call: "}
                  <span className="fw-normal">{clientInfo.LastCallDate? clientInfo.LastCallDate.split("T")[0]+" "+clientInfo.LastCallDate.split("T")[1].split(".")[0]:"N/A"}</span>
                </p>
                <p className="m-0">{"Phone: "}<span className="fw-normal">{clientInfo.OfficePhone? clientInfo.OfficePhone:"N/A"}</span></p>
              </Col>
            </Row>:""}
            <Row className="m-0 mt-4">
              <GridControl ShowLoader={showLoader} ReloadDataFunction={handleClientInfoTableOpen} setActiveTripConfirmation={setActiveTripConfirmation} Data={ActiveTripsTableData} options={activeTripsGridOptions}/>
            </Row>
          </Modal.Body>
          <Modal.Footer className='p-0 px-2 py-1'>
            <Button variant="secondary" className="mx-1" onClick={()=>setShowClientActiveTripsModal(false)} title={"Close client info table"}>Close</Button>
          </Modal.Footer>
        </Modal>
      : ""}
      {showDynamicModal ? 
        <Modal centered className={modalClass} backdrop="static" keyboard={true} onKeyDown={(e)=>{
            if(e.key === "Enter")
            {
              e.preventDefault();
              customHideFunc();
            }
          }} 
          onHide={()=>{customHideFunc();}} show={showDynamicModal} animation={true}>
            <Modal.Header className='text-white user-select-none p-0 py-1 px-2 callAgent-modal-header' closeButton>
                <Modal.Title style={{fontSize:"20px"}}>{modalHeaderText}</Modal.Title>
            </Modal.Header>
            <Modal.Body className='fw-normal user-select-none'>{modalBodyHTML}</Modal.Body>
            {modalFooterHTML === ""? "":
              <Modal.Footer className='p-0 px-2 py-1'>
                {modalFooterHTML}
              </Modal.Footer>
            }
        </Modal>
      : ""}
      {showCCInfoDialog || CheckCCParams !== "" ? 
        <CCProfile bCCInfoDialogOpen={showCCInfoDialog} setCCInfoDialog={setShowCCInfoDialog} minimumMonth={minMonth} maximumMonth={maxMonth} CardDetails={cardInfo} 
          AffID={selectedAff} FSID={FSSelected} clientInfoData={clientInfo} setCardDetails={setCardInfo} checkCCParams={CheckCCParams} pageLoader={setShowAPILoader}
        />
      : ""}
      {multischModalShow ? 
        <MultiSchedule setShowMultiSchedule={setMultischModalShow} scheduleJSONData={scheduleJSON} setScheduleJSON={setScheduleJSON} date={selectedDateSchTime}
          bMultiScheduleShow={multischModalShow} AffID={selectedAff} FSID={FSSelected} clientInfoData={clientInfo} paxCount={passengerTypeCount}
        />
      :""}
    </>
  );
};

export default CallTaker;